webpackJsonp([114276838955818,60335399758886],{

/***/ 132:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Expedición vorágine: un recorrido sonodo por la obra de José Eustasio Rivera"}},"allMarkdownRemark":{"edges":[{"node":{"frontmatter":{"part":"Prólogo","title":"","slug":"prologo","date":"2018-09-03 09:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 1","title":"","slug":"capitulo-1","date":"2018-10-03 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 2","title":"","slug":"capitulo-2","date":"2018-10-04 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 3","title":"","slug":"capitulo-3","date":"2018-10-05 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 4","title":"","slug":"capitulo-4","date":"2018-10-08 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 5","title":"","slug":"capitulo-5","date":"2018-10-09 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 6","title":"","slug":"capitulo-6","date":"2018-10-10 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 7","title":"","slug":"capitulo-7","date":"2018-10-11 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 8","title":"","slug":"capitulo-8","date":"2018-10-12 10:00:00"}}},{"node":{"frontmatter":{"part":"Capítulo 9","title":"","slug":"capitulo-9","date":"2018-10-16 10:00:00"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(280);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(132);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
		pathPrefix: "/", //develop
		// pathPrefix: "/la-voragine", //production
		siteUrl: "https://voragine.radionacional.co",
		siteTitle: "Expedición vorágine: un recorrido sonodo por la obra de José Eustasio Rivera",
		siteTitleAlt: "Expedición vorágine",
		metaTitle: "Expedición Vorágine - Un recorrido sonoro por la obra de José Eustasio Rivera",
		metaDescription: "La vorágine es uno de los libros más emblemáticos de la literatura colombiana y, también, de los más leídos en los colegios. Sin embargo, no de los más apreciados. 'Expedición vorágine' emprende una búsqueda por reencontrar al libro con sus lectores, en un recorrido que nos llevó por 8 regiones.",
		metaKeywords: "Vorágine, libros, mapa, literatura, Huila, Neiva, Boyacá, Meta, Caquetá, Casanare, Putumayo, Guainía",
		siteLogo: "/logos/logo-1024.png",
		siteCover: "/cover.jpg",
		siteCreator: "Radnalco",
		copyright: "Copyright © 2018. RTVC Sistema de Medios Públicos",
		social: [{
			name: "Twitter",
			icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAFWUlEQVR4AdWbeWxU1RfHT8uvLZQfiwIuGgQFcUESUINWTVyMxiXR4JIIGlA0GBc0BqNRgzFoNMYYTIwEhbgEDVHEPwgQozGRRQXSd1+n7bSFQim01EJpbelOZ+bjm7kZSUOn85Y3rzOf5JtJmt7b+51z3733nPsqgQB5UkuRlFIsNYyzPidImP9LA2OklALJYbS5ENeI4iVLP1oKW+oXA4ZRuyj2WlonJoukigsl64mbNPlQFI1igGcp9llaLvuZLFlFGXeLYocYkBEp+i2tF4OZI210vhjssURAiojJl6KYIoFSy3hRrLUUFQMCl6JNDJ6VQKhghiiqxIARl8kGOczoTC5Kd4iiVQzIIu3JzIpu8oIYDFgi66R3hevENxTviwFZrh4p43Y/IrtEDMgJKVoTa4xrFCWW+sSAHDIdTuwijqlgqiiaxYAc1FaBfCf7bJEYKEvkrBQfOJnKb4sBOW44KiGulbSUc5kY9AY9wCsq4d0m2NoOuzv15xuNML0idZtzy9Ka3iuQly66G+0McE4Y8j0b1YPecJKU9EZh5TEoUvr3Ryt4rA5Ku2HBQVuRXjhcMjDLzvm4UEFjP3zfBgUezF4QgppebLGvCza3QVeEBHu7YJS9v1OROso6BSOd7jwASba1wxjl3Gy+pT1duKJlAGZWwlgTJpbZivIDchbxcouiy85gl9YziB2nYFKZM8PLjuCKviisPQEbW+FgH5wXsmV4y1DRXWx3sE/VD/Wt65/n2ezD6MYD2viN1ba/4NNn59CK7XYNP3yIlOzshNnh4duPN/FEZwTuOuBsRg3On6HA3nTWmmBCf5SUxGLw2yl4vG7o5/uqMK5pj8C8Klf78ib5D5ObnXawtd3+ANe3wJOHtdE8A6ZV4Jpdna53hZYzq7XJq047mFWptwindETgry5cs+UfT6eviySBYp2ThpdXwpQQLD6sp2+QfH3Sg+F40TGBwU4nDV9pgIEY/NwB4R4CZfVxT4YXJCNc56RhSQ0jxooGT0W/Z5IRbnHScJSh992RoKTGU4SXSxw3VY3njxA4vVEoVJ4i/Foywqct4TTK1l4bKDs7PefIr0sct7XmYgW/dBAYq5o8Gi7l5aThered5FlaWAfVvWQQvStMLfecfy+TOF4uxD5q1rlqZQ9EY2SMb1t9uZp5NBnhb9x2Mr86mMPH3CpfDN8kCUze9NLRFy1klO3tvhX2pp250PbQUb6lzzNk+lREJxs+mO0UGCUJmihOvoPhRffV6sTeTxbV+RbdbZJk8Hnau2aH/Znmbx3ztU69QgahWO5Hx4UKnjsCbQN4YqW/ZmNiMl0GsZ/Jzk9cWkUKbqmBj5vhxGnvtaqFdb7fQuyQITH4KV3jhw7pvfeT47DmhK5Y9kbxhV0p6mGeZbJkmLdy0q/IT9dDeQ8+ocutS5MVT/91VKBAUqL41V5Hukz61UnojrrJfPT++uDBNFc23vWiDIvieqevI40z42VTvapubtPXIPV90BHReXNjv54Rm9rgvSa4vxaKVSA3iLWJq9+0KNboRjmve8QW5ZwTn/s5fj/8nTiijHli0J2jhlXi9OgYxSOWYjkW2ebE+ymuMXgnh8z2WSrx/rK34occMBuztFh8Af4nik+z2HB34vHzHYNlyfN2FumomMyVjKG4NVm4H3Ep/pAKzpeME+JSUfw+gmYjllZLmEIJFIMnLP0dcFT/9D6FvdDAGP3vOjRk2OhuS/dK1hCfXvqgssW3hU3fiHwmIW6QrKaaSYmit2KNpUoHX0CHpV2iWCUmt+lnNBeBfDGZKGEusTRTFFdLKXOknCutzxlSxsUSYqwExL+NOU3gcOz6vgAAAABJRU5ErkJggg==",
			link: "https://twitter.com/Radnalco"
		}, {
			name: "Facebook",
			icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAACTFBMVEUAAAD///+AgICAgP9Vqv9AgL8zZswrgKokbbZJbbZAYJ85caozZrMuXaIraqonYp0kW6QzZpkwYJ8tWqUoXqEmZqYkYZ4sZKYpXKMxYp0mXqEsYZ4rXqIpY5woYJ8nXaImWp4kX6AsX6ArXKMoXqEmYJ8kW54pXZwoYJ8lWp8kXpwpXJ4oWqAnXZ0mXqElXZ4oXp0oXJ4nW6AkXZ4oXJ8nWp0nXZ4kW50nXJ8mW50nXJ0mW50kW54kWpwnXZ8lXJ4lW58kW54mXJ0mW54mXJ4mWp4mXZ4lXJ4mW50mXJ4lW50lW58lWp4lXJ8mW50lWpwlW54nXJwmXJ0kW54mXJ0lWp0kW5wmW50lW5wlW50kWpwmW50lWpwlW5wkWpwmXJ0lWp0kWp0mW5wlW5wlWp0kWpwlW50lWp0lW50lWpwlW50lWpwkW50lWp0lWp0lW50lW5wlWp0kW5wkW50kWp0lW50lWpwlW50lWp0kW50kWpwlW50lW5wkW5wlW5wkW50kWp0lW5wlW50kW50kWpwlWpwlWpwkWpwkWpwlW50lWpwlW50kW5wkWp0kW50lWpwlWp0lW5wlWpwkWp0kW5wkWp0kWpwlW5wuYaAzZaI3aKQ4aaU8bKc9bac/bqhGc6tIdaxJdq1Pe69TfbFUfrFagrRbhLVli7lpjrtqj7trj7xwk752mMF4mcJ6m8OBoMaRrM2Trs6Vr8+huNSjutW2yN63yd7B0OPC0ePJ1ubS3erY4e3a4+7f5/Du8vfy9fnz9vn4+vz+/v7///+SX5vHAAAAlnRSTlMAAQICAwQFBgcHCAkKCwwNDg8QERMUFRcZGhsdHh8gISIjIyQmKCosLTAxMjM0Njc5Ojs/QEFCRkhJTlFUVVVZWlxeX2RmZmdrbG1tbm9zdHZ3en6AgoaHiY+TlZaYm5yeoaOlp6qrrK6ytLW2u8DBwsPExcbIycrO09TV1tve4OLj5Ofo6+3u8PHz9PX29/j5+vv8/f4ZDbEiAAACSUlEQVR4AZ3S90OMcQDH8c8ZFSUZJTIkJCMZZGQoRLI3KZsMZZTISOqMok7XR7js0dl7j7h/zLmhu+f5Ps997/v6/f3bG4Ys3WJ69oqNjkCYLKn5eyob6XWxvHBuImSlbqim1vG8eEjILKFQY1EKQkgvo6GmrQkwEbfFTjMXcmEo+RRD2d4dYlOtDK0sESKLrlFG9VjoraOkK1OglUNp1mQEy2igyM3Hzqf/PGKgyjgESqqhwO1Pf1xevxhkX2d0iKqgwLN2l187g61Hh9UUuPvbZRjbx8Bv6FUKfHUZxyy3wGcnBR66zGLOgddwOwVeBcY/qXXCAo8iirzxdZ/vORyOG9SZ4Wlj6yjy1hffoVixJ86maXyLYrYEuB1Qi5kLIKJOMd4NYCL1Wtqczo+++IXT7QH1ai3Acuq1uTS+U6A/UEg9pzb+QoF0oFQm/kCBmcAZmfg9BeYDtTLxawosARqo90Qbv6TACsBGAUdr6ztfd7/V7ToFVgJWKk7CpcBZ5XghUKYczwa2KccTgFXK8SAgUzW+3AWIaVSM98OtVDFeBrc8tbh5MNzibUpxCTz2KsU58EhXiasi4HVQIV4Mn3H2sOPTUfArCDuehv/6VIUZ70CA0fVhxRUxCJTVTI3nPzy+tVCnJgnB1lBaQwY0LLsoqTkbOl03UUp9FkQW2BhaVRrEJtUylKP9YGTIIZpq2hgJE/PO09ixNJiLzj9HsSPTEVpkVrGNWtbN4yGp76yCkzb6XTq8dnIkwtKp98CUkaNGDBvQA4b+AtFacap9PUWJAAAAAElFTkSuQmCC",
			link: "https://www.facebook.com/RadioNacionalDeColombia"
		}, {
			name: "Instagram",
			icon: "data:image/png;base64,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",
			link: "https://instagram.com/radionacionalco"
		}],
		pages: [{
			name: 'capitulo',
			template: 'src/templates/chapter.js',
			pictureTemplate: 'src/templates/picture.js',
			query: '{allMarkdownRemark(filter:{frontmatter:{createPage:{ne:false}}}){edges{node{frontmatter{title,description,part,place,keywords,slug,pictureBgImage{relativePath},pictures{title,description,slug,src{relativePath}}}}}}}',
			key: 'allMarkdownRemark'
		}]
	};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(36);
	var isArguments = __webpack_require__(35);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// ┌────────────────────────────────────────────────────────────┐ \\
	// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
	// ├────────────────────────────────────────────────────────────┤ \\
	// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
	// └────────────────────────────────────────────────────────────┘ \\
	
	(function (glob) {
	    var version = "0.5.4",
	        has = "hasOwnProperty",
	        separator = /[\.\/]/,
	        comaseparator = /\s*,\s*/,
	        wildcard = "*",
	        numsort = function (a, b) {
	            return a - b;
	        },
	        current_event,
	        stop,
	        events = {n: {}},
	        firstDefined = function () {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        lastDefined = function () {
	            var i = this.length;
	            while (--i) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        objtos = Object.prototype.toString,
	        Str = String,
	        isArray = Array.isArray || function (ar) {
	            return ar instanceof Array || objtos.call(ar) == "[object Array]";
	        },
	    /*\
	     * eve
	     [ method ]
	
	     * Fires event with given `name`, given scope and other parameters.
	
	     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
	     - scope (object) context for the event handlers
	     - varargs (...) the rest of arguments will be sent to event handlers
	
	     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
	    \*/
	        eve = function (name, scope) {
	            var oldstop = stop,
	                args = Array.prototype.slice.call(arguments, 2),
	                listeners = eve.listeners(name),
	                z = 0,
	                l,
	                indexed = [],
	                queue = {},
	                out = [],
	                ce = current_event;
	            out.firstDefined = firstDefined;
	            out.lastDefined = lastDefined;
	            current_event = name;
	            stop = 0;
	            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
	                indexed.push(listeners[i].zIndex);
	                if (listeners[i].zIndex < 0) {
	                    queue[listeners[i].zIndex] = listeners[i];
	                }
	            }
	            indexed.sort(numsort);
	            while (indexed[z] < 0) {
	                l = queue[indexed[z++]];
	                out.push(l.apply(scope, args));
	                if (stop) {
	                    stop = oldstop;
	                    return out;
	                }
	            }
	            for (i = 0; i < ii; i++) {
	                l = listeners[i];
	                if ("zIndex" in l) {
	                    if (l.zIndex == indexed[z]) {
	                        out.push(l.apply(scope, args));
	                        if (stop) {
	                            break;
	                        }
	                        do {
	                            z++;
	                            l = queue[indexed[z]];
	                            l && out.push(l.apply(scope, args));
	                            if (stop) {
	                                break;
	                            }
	                        } while (l)
	                    } else {
	                        queue[l.zIndex] = l;
	                    }
	                } else {
	                    out.push(l.apply(scope, args));
	                    if (stop) {
	                        break;
	                    }
	                }
	            }
	            stop = oldstop;
	            current_event = ce;
	            return out;
	        };
	    // Undocumented. Debug only.
	    eve._events = events;
	    /*\
	     * eve.listeners
	     [ method ]
	
	     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.
	
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated
	
	     = (array) array of event handlers
	    \*/
	    eve.listeners = function (name) {
	        var names = isArray(name) ? name : name.split(separator),
	            e = events,
	            item,
	            items,
	            k,
	            i,
	            ii,
	            j,
	            jj,
	            nes,
	            es = [e],
	            out = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            nes = [];
	            for (j = 0, jj = es.length; j < jj; j++) {
	                e = es[j].n;
	                items = [e[names[i]], e[wildcard]];
	                k = 2;
	                while (k--) {
	                    item = items[k];
	                    if (item) {
	                        nes.push(item);
	                        out = out.concat(item.f || []);
	                    }
	                }
	            }
	            es = nes;
	        }
	        return out;
	    };
	    /*\
	     * eve.separator
	     [ method ]
	
	     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
	     * here. Be aware that if you pass a string longer than one character it will be treated as
	     * a list of characters.
	
	     - separator (string) new separator. Empty string resets to default: `.` or `/`.
	    \*/
	    eve.separator = function (sep) {
	        if (sep) {
	            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
	            sep = "[" + sep + "]";
	            separator = new RegExp(sep);
	        } else {
	            separator = /[\.\/]/;
	        }
	    };
	    /*\
	     * eve.on
	     [ method ]
	     **
	     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
	     | eve.on("*.under.*", f);
	     | eve("mouse.under.floor"); // triggers f
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     - name (array) if you don’t want to use separators, you can use array of strings
	     - f (function) event handler function
	     **
	     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
	     > Example:
	     | eve.on("mouse", eatIt)(2);
	     | eve.on("mouse", scream);
	     | eve.on("mouse", catchIt)(1);
	     * This will ensure that `catchIt` function will be called before `eatIt`.
	     *
	     * If you want to put your handler before non-indexed handlers, specify a negative value.
	     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
	    \*/
	    eve.on = function (name, f) {
	        if (typeof f != "function") {
	            return function () {};
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        for (var i = 0, ii = names.length; i < ii; i++) {
	            (function (name) {
	                var names = isArray(name) ? name : Str(name).split(separator),
	                    e = events,
	                    exist;
	                for (var i = 0, ii = names.length; i < ii; i++) {
	                    e = e.n;
	                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
	                }
	                e.f = e.f || [];
	                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
	                    exist = true;
	                    break;
	                }
	                !exist && e.f.push(f);
	            }(names[i]));
	        }
	        return function (zIndex) {
	            if (+zIndex == +zIndex) {
	                f.zIndex = +zIndex;
	            }
	        };
	    };
	    /*\
	     * eve.f
	     [ method ]
	     **
	     * Returns function that will fire given event with optional arguments.
	     * Arguments that will be passed to the result function will be also
	     * concated to the list of final arguments.
	     | el.onclick = eve.f("click", 1, 2);
	     | eve.on("click", function (a, b, c) {
	     |     console.log(a, b, c); // 1, 2, [event object]
	     | });
	     - event (string) event name
	     - varargs (…) and any other arguments
	     = (function) possible event handler function
	    \*/
	    eve.f = function (event) {
	        var attrs = [].slice.call(arguments, 1);
	        return function () {
	            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
	        };
	    };
	    /*\
	     * eve.stop
	     [ method ]
	     **
	     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
	    \*/
	    eve.stop = function () {
	        stop = 1;
	    };
	    /*\
	     * eve.nt
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     - subname (string) #optional subname of the event
	     **
	     = (string) name of the event, if `subname` is not specified
	     * or
	     = (boolean) `true`, if current event’s name contains `subname`
	    \*/
	    eve.nt = function (subname) {
	        var cur = isArray(current_event) ? current_event.join(".") : current_event;
	        if (subname) {
	            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
	        }
	        return cur;
	    };
	    /*\
	     * eve.nts
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     **
	     = (array) names of the event
	    \*/
	    eve.nts = function () {
	        return isArray(current_event) ? current_event : current_event.split(separator);
	    };
	    /*\
	     * eve.off
	     [ method ]
	     **
	     * Removes given function from the list of event listeners assigned to given name.
	     * If no arguments specified all the events will be cleared.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	    \*/
	    /*\
	     * eve.unbind
	     [ method ]
	     **
	     * See @eve.off
	    \*/
	    eve.off = eve.unbind = function (name, f) {
	        if (!name) {
	            eve._events = events = {n: {}};
	            return;
	        }
	        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
	        if (names.length > 1) {
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                eve.off(names[i], f);
	            }
	            return;
	        }
	        names = isArray(name) ? name : Str(name).split(separator);
	        var e,
	            key,
	            splice,
	            i, ii, j, jj,
	            cur = [events],
	            inodes = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            for (j = 0; j < cur.length; j += splice.length - 2) {
	                splice = [j, 1];
	                e = cur[j].n;
	                if (names[i] != wildcard) {
	                    if (e[names[i]]) {
	                        splice.push(e[names[i]]);
	                        inodes.unshift({
	                            n: e,
	                            name: names[i]
	                        });
	                    }
	                } else {
	                    for (key in e) if (e[has](key)) {
	                        splice.push(e[key]);
	                        inodes.unshift({
	                            n: e,
	                            name: key
	                        });
	                    }
	                }
	                cur.splice.apply(cur, splice);
	            }
	        }
	        for (i = 0, ii = cur.length; i < ii; i++) {
	            e = cur[i];
	            while (e.n) {
	                if (f) {
	                    if (e.f) {
	                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
	                            e.f.splice(j, 1);
	                            break;
	                        }
	                        !e.f.length && delete e.f;
	                    }
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        var funcs = e.n[key].f;
	                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
	                            funcs.splice(j, 1);
	                            break;
	                        }
	                        !funcs.length && delete e.n[key].f;
	                    }
	                } else {
	                    delete e.f;
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        delete e.n[key].f;
	                    }
	                }
	                e = e.n;
	            }
	        }
	        // prune inner nodes in path
	        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
	            e = inodes[i];
	            for (key in e.n[e.name].f) {
	                // not empty (has listeners)
	                continue prune;
	            }
	            for (key in e.n[e.name].n) {
	                // not empty (has children)
	                continue prune;
	            }
	            // is empty
	            delete e.n[e.name];
	        }
	    };
	    /*\
	     * eve.once
	     [ method ]
	     **
	     * Binds given event handler with a given name to only run once then unbind itself.
	     | eve.once("login", f);
	     | eve("login"); // triggers f
	     | eve("login"); // no listeners
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     = (function) same return function as @eve.on
	    \*/
	    eve.once = function (name, f) {
	        var f2 = function () {
	            eve.off(name, f2);
	            return f.apply(this, arguments);
	        };
	        return eve.on(name, f2);
	    };
	    /*\
	     * eve.version
	     [ property (string) ]
	     **
	     * Current version of the library.
	    \*/
	    eve.version = version;
	    eve.toString = function () {
	        return "You are running Eve " + version;
	    };
	    glob.eve = eve;
	    typeof module != "undefined" && module.exports ? module.exports = eve :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : glob.eve = eve;
	})(typeof window != "undefined" ? window : this);


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var BurgerIcon = (function (_Component) {
	  _inherits(BurgerIcon, _Component);
	
	  function BurgerIcon(props) {
	    _classCallCheck(this, BurgerIcon);
	
	    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      hover: false
	    };
	  }
	
	  _createClass(BurgerIcon, [{
	    key: 'getLineStyle',
	    value: function getLineStyle(index) {
	      return {
	        position: 'absolute',
	        height: '20%',
	        left: 0,
	        right: 0,
	        top: 20 * (index * 2) + '%',
	        opacity: this.state.hover ? 0.6 : 1
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon = undefined;
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        opacity: 0,
	        fontSize: 8,
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-icon',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          null,
	          [0, 1, 2].map(function (bar) {
	            return _react2['default'].createElement('span', {
	              key: bar,
	              className: ('bm-burger-bars ' + _this.props.barClassName).trim(),
	              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-burger-button ' + this.props.className).trim(),
	          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          {
	            onClick: this.props.onClick,
	            onMouseOver: function () {
	              return _this.setState({ hover: true });
	            },
	            onMouseOut: function () {
	              return _this.setState({ hover: false });
	            },
	            style: buttonStyle
	          },
	          'Open Menu'
	        )
	      );
	    }
	  }]);
	
	  return BurgerIcon;
	})(_react.Component);
	
	exports['default'] = BurgerIcon;
	
	BurgerIcon.propTypes = {
	  barClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	BurgerIcon.defaultProps = {
	  barClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  slide: __webpack_require__(642),
	  stack: __webpack_require__(643),
	  elastic: __webpack_require__(635),
	  bubble: __webpack_require__(634),
	  push: __webpack_require__(637),
	  pushRotate: __webpack_require__(638),
	  scaleDown: __webpack_require__(640),
	  scaleRotate: __webpack_require__(641),
	  fallDown: __webpack_require__(636),
	  reveal: __webpack_require__(639)
	};
	module.exports = exports['default'];

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var CrossIcon = (function (_Component) {
	  _inherits(CrossIcon, _Component);
	
	  function CrossIcon() {
	    _classCallCheck(this, CrossIcon);
	
	    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CrossIcon, [{
	    key: 'getCrossStyle',
	    value: function getCrossStyle(type) {
	      return {
	        position: 'absolute',
	        width: 3,
	        height: 14,
	        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var icon;
	      var buttonWrapperStyle = {
	        position: 'absolute',
	        width: 24,
	        height: 24,
	        right: 8,
	        top: 8
	      };
	      var buttonStyle = {
	        position: 'absolute',
	        left: 0,
	        top: 0,
	        width: '100%',
	        height: '100%',
	        margin: 0,
	        padding: 0,
	        border: 'none',
	        textIndent: -9999,
	        background: 'transparent',
	        outline: 'none',
	        cursor: 'pointer'
	      };
	
	      if (this.props.customIcon) {
	        var extraProps = {
	          className: 'bm-cross',
	          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
	        };
	        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
	      } else {
	        icon = _react2['default'].createElement(
	          'span',
	          { style: { position: 'absolute', top: '6px', right: '14px' } },
	          ['before', 'after'].map(function (type, i) {
	            return _react2['default'].createElement('span', {
	              key: i,
	              className: ('bm-cross ' + _this.props.crossClassName).trim(),
	              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
	            });
	          })
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: ('bm-cross-button ' + this.props.className).trim(),
	          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
	        },
	        icon,
	        _react2['default'].createElement(
	          'button',
	          { onClick: this.props.onClick, style: buttonStyle },
	          'Close Menu'
	        )
	      );
	    }
	  }]);
	
	  return CrossIcon;
	})(_react.Component);
	
	exports['default'] = CrossIcon;
	
	CrossIcon.propTypes = {
	  crossClassName: _propTypes2['default'].string,
	  customIcon: _propTypes2['default'].element,
	  styles: _propTypes2['default'].object
	};
	
	CrossIcon.defaultProps = {
	  crossClassName: '',
	  className: '',
	  styles: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var styles = {
	  overlay: function overlay(isOpen) {
	    return {
	      position: 'fixed',
	      zIndex: 1000,
	      width: '100%',
	      height: '100%',
	      background: 'rgba(0, 0, 0, 0.3)',
	      opacity: isOpen ? 1 : 0,
	      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
	      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      zIndex: 1100,
	      width: width,
	      height: '100%',
	      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  menu: function menu() {
	    return {
	      height: '100%',
	      boxSizing: 'border-box',
	      overflow: 'auto'
	    };
	  },
	
	  itemList: function itemList() {
	    return {
	      height: '100%'
	    };
	  },
	
	  item: function item() {
	    return {
	      display: 'block',
	      outline: 'none'
	    };
	  }
	};
	
	exports['default'] = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(24);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _baseStyles = __webpack_require__(633);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _BurgerIcon = __webpack_require__(630);
	
	var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);
	
	var _CrossIcon = __webpack_require__(632);
	
	var _CrossIcon2 = _interopRequireDefault(_CrossIcon);
	
	exports['default'] = function (styles) {
	  var Menu = (function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
	      this.state = {
	        isOpen: false
	      };
	    }
	
	    _createClass(Menu, [{
	      key: 'toggleMenu',
	      value: function toggleMenu() {
	        var _this = this;
	
	        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	        var isOpen = options.isOpen;
	        var noStateChange = options.noStateChange;
	
	        var newState = {
	          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
	        };
	
	        this.applyWrapperStyles();
	
	        this.setState(newState, function () {
	          !noStateChange && _this.props.onStateChange(newState);
	
	          // Timeout ensures wrappers are cleared after animation finishes.
	          _this.timeoutId && clearTimeout(_this.timeoutId);
	          _this.timeoutId = setTimeout(function () {
	            _this.timeoutId = null;
	            if (!newState.isOpen) {
	              _this.applyWrapperStyles(false);
	            }
	          }, 500);
	        });
	      }
	
	      // Applies component-specific styles to external wrapper elements.
	    }, {
	      key: 'applyWrapperStyles',
	      value: function applyWrapperStyles() {
	        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	        if (this.props.bodyClassName) {
	          var body = document.querySelector('body');
	          body.classList[set ? 'add' : 'remove'](this.props.bodyClassName);
	        }
	
	        if (styles.pageWrap && this.props.pageWrapId) {
	          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
	        }
	
	        if (styles.outerContainer && this.props.outerContainerId) {
	          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
	        }
	      }
	
	      // Sets or unsets styles on DOM elements outside the menu component.
	      // This is necessary for correct page interaction with some of the menus.
	      // Throws and returns if the required external elements don't exist,
	      // which means any external page animations won't be applied.
	    }, {
	      key: 'handleExternalWrapper',
	      value: function handleExternalWrapper(id, wrapperStyles, set) {
	        var html = document.querySelector('html');
	        var body = document.querySelector('body');
	        var wrapper = document.getElementById(id);
	
	        if (!wrapper) {
	          console.error("Element with ID '" + id + "' not found");
	          return;
	        }
	
	        var builtStyles = this.getStyle(wrapperStyles);
	
	        for (var prop in builtStyles) {
	          if (builtStyles.hasOwnProperty(prop)) {
	            wrapper.style[prop] = set ? builtStyles[prop] : '';
	          }
	        }
	
	        // Prevent any horizontal scroll.
	        [html, body].forEach(function (element) {
	          element.style['overflow-x'] = set ? 'hidden' : '';
	        });
	      }
	
	      // Builds styles incrementally for a given element.
	    }, {
	      key: 'getStyles',
	      value: function getStyles(el, index, inline) {
	        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
	
	        // Set base styles.
	        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};
	
	        // Add animation-specific styles.
	        if (styles[el]) {
	          output = _extends({}, output, this.getStyle(styles[el], index + 1));
	        }
	
	        // Add custom styles.
	        if (this.props.styles[propName]) {
	          output = _extends({}, output, this.props.styles[propName]);
	        }
	
	        // Add element inline styles.
	        if (inline) {
	          output = _extends({}, output, inline);
	        }
	
	        return output;
	      }
	    }, {
	      key: 'getStyle',
	      value: function getStyle(style, index) {
	        var width = this.props.width;
	
	        var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
	        return style(this.state.isOpen, formattedWidth, this.props.right, index);
	      }
	    }, {
	      key: 'listenForClose',
	      value: function listenForClose(e) {
	        e = e || window.event;
	
	        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'shouldDisableOverlayClick',
	      value: function shouldDisableOverlayClick() {
	        if (typeof this.props.disableOverlayClick === 'function') {
	          return this.props.disableOverlayClick();
	        } else {
	          return this.props.disableOverlayClick;
	        }
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (!styles) {
	          throw new Error('No styles supplied');
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // Bind ESC key handler (unless disabled or custom function supplied).
	        if (this.props.customOnKeyDown) {
	          window.onkeydown = this.props.customOnKeyDown;
	        } else if (!this.props.disableCloseOnEsc) {
	          window.onkeydown = this.listenForClose.bind(this);
	        }
	
	        // Allow initial open state to be set by props.
	        if (this.props.isOpen) {
	          this.toggleMenu({ isOpen: true, noStateChange: true });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.onkeydown = null;
	
	        this.applyWrapperStyles(false);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        var _this2 = this;
	
	        if (styles.svg) {
	          (function () {
	            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
	            var path = styles.svg.lib(morphShape).select('path');
	
	            if (_this2.state.isOpen) {
	              // Animate SVG path.
	              styles.svg.animate(path);
	            } else {
	              // Reset path (timeout ensures animation happens off screen).
	              setTimeout(function () {
	                path.attr('d', styles.svg.pathInitial);
	              }, 300);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
	          this.toggleMenu();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          !this.props.noOverlay && _react2['default'].createElement('div', {
	            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
	            onClick: function () {
	              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
	            },
	            style: this.getStyles('overlay')
	          }),
	          _react2['default'].createElement(
	            'div',
	            {
	              id: this.props.id,
	              className: ('bm-menu-wrap ' + this.props.className).trim(),
	              style: this.getStyles('menuWrap')
	            },
	            styles.svg && _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
	                style: this.getStyles('morphShape')
	              },
	              _react2['default'].createElement(
	                'svg',
	                {
	                  width: '100%',
	                  height: '100%',
	                  viewBox: '0 0 100 800',
	                  preserveAspectRatio: 'none'
	                },
	                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              {
	                className: ('bm-menu ' + this.props.menuClassName).trim(),
	                style: this.getStyles('menu')
	              },
	              _react2['default'].createElement(
	                'nav',
	                {
	                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
	                  style: this.getStyles('itemList')
	                },
	                _react2['default'].Children.map(this.props.children, function (item, index) {
	                  if (item) {
	                    var classList = ['bm-item', _this3.props.itemClassName, item.props.className].filter(function (className) {
	                      return !!className;
	                    }).join(' ');
	                    var extraProps = {
	                      key: index,
	                      className: classList,
	                      style: _this3.getStyles('item', index, item.props.style)
	                    };
	                    return _react2['default'].cloneElement(item, extraProps);
	                  }
	                })
	              )
	            ),
	            this.props.customCrossIcon !== false && _react2['default'].createElement(
	              'div',
	              { style: this.getStyles('closeButton') },
	              _react2['default'].createElement(_CrossIcon2['default'], {
	                onClick: function () {
	                  return _this3.toggleMenu();
	                },
	                styles: this.props.styles,
	                customIcon: this.props.customCrossIcon,
	                className: this.props.crossButtonClassName,
	                crossClassName: this.props.crossClassName
	              })
	            )
	          ),
	          this.props.customBurgerIcon !== false && _react2['default'].createElement(
	            'div',
	            { style: this.getStyles('burgerIcon') },
	            _react2['default'].createElement(_BurgerIcon2['default'], {
	              onClick: function () {
	                return _this3.toggleMenu();
	              },
	              styles: this.props.styles,
	              customIcon: this.props.customBurgerIcon,
	              className: this.props.burgerButtonClassName,
	              barClassName: this.props.burgerBarClassName
	            })
	          )
	        );
	      }
	    }]);
	
	    return Menu;
	  })(_react.Component);
	
	  Menu.propTypes = {
	    bodyClassName: _propTypes2['default'].string,
	    burgerBarClassName: _propTypes2['default'].string,
	    burgerButtonClassName: _propTypes2['default'].string,
	    crossButtonClassName: _propTypes2['default'].string,
	    crossClassName: _propTypes2['default'].string,
	    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
	    customOnKeyDown: _propTypes2['default'].func,
	    disableCloseOnEsc: _propTypes2['default'].bool,
	    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
	    id: _propTypes2['default'].string,
	    isOpen: _propTypes2['default'].bool,
	    itemClassName: _propTypes2['default'].string,
	    itemListClassName: _propTypes2['default'].string,
	    menuClassName: _propTypes2['default'].string,
	    morphShapeClassName: _propTypes2['default'].string,
	    noOverlay: _propTypes2['default'].bool,
	    onStateChange: _propTypes2['default'].func,
	    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    overlayClassName: _propTypes2['default'].string,
	    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
	    right: _propTypes2['default'].bool,
	    styles: _propTypes2['default'].object,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	  };
	
	  Menu.defaultProps = {
	    bodyClassName: '',
	    burgerBarClassName: '',
	    burgerButtonClassName: '',
	    className: '',
	    crossButtonClassName: '',
	    crossClassName: '',
	    disableCloseOnEsc: false,
	    id: '',
	    itemClassName: '',
	    itemListClassName: '',
	    menuClassName: '',
	    morphShapeClassName: '',
	    noOverlay: false,
	    onStateChange: function onStateChange() {},
	    outerContainerId: '',
	    overlayClassName: '',
	    pageWrapId: '',
	    styles: {},
	    width: 300
	  };
	
	  return Menu;
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(229);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
	    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
	    animate: function animate(path) {
	      var pos = 0;
	      var steps = this.pathOpen.split(';');
	      var stepsTotal = steps.length;
	      var mina = window.mina;
	
	      var nextStep = function nextStep() {
	        if (pos > stepsTotal - 1) return;
	
	        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
	          nextStep();
	        });
	
	        pos++;
	      };
	
	      nextStep();
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: '100%',
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
	      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    width -= 140;
	    return {
	      position: 'fixed',
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  },
	
	  closeButton: function closeButton(isOpen, width, right) {
	    width -= 140;
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
	      opacity: isOpen ? 1 : 0
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _snapsvgImporter = __webpack_require__(229);
	
	var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  svg: {
	    lib: _snapsvgImporter2['default'],
	    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
	    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
	    animate: function animate(path) {
	      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
	    }
	  },
	
	  morphShape: function morphShape(isOpen, width, right) {
	    return {
	      position: 'absolute',
	      width: 120,
	      height: '100%',
	      right: right ? 'inherit' : 0,
	      left: right ? 0 : 'inherit',
	      MozTransform: right ? 'rotateY(180deg)' : '',
	      MsTransform: right ? 'rotateY(180deg)' : '',
	      OTransform: right ? 'rotateY(180deg)' : '',
	      WebkitTransform: right ? 'rotateY(180deg)' : '',
	      transform: right ? 'rotateY(180deg)' : ''
	    };
	  },
	
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
	      transition: 'all 0.3s'
	    };
	  },
	
	  menu: function menu(isOpen, width, right) {
	    return {
	      position: 'fixed',
	      right: right ? 0 : 'inherit',
	      width: 180,
	      whiteSpace: 'nowrap',
	      boxSizing: 'border-box',
	      overflow: 'visible'
	    };
	  },
	
	  itemList: function itemList(isOpen, width, right) {
	    if (right) {
	      return {
	        position: 'relative',
	        left: '-110px',
	        width: '170%',
	        overflow: 'auto'
	      };
	    }
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
	      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
	      transition: 'all 0.5s ease-in-out'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      perspectiveOrigin: '0% 50%',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
	      transformOrigin: right ? '100% 50%' : '0% 50%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      visibility: isOpen ? 'visible' : 'hidden',
	      MozTransform: 'translate3d(0, 0, 0)',
	      MsTransform: 'translate3d(0, 0, 0)',
	      OTransform: 'translate3d(0, 0, 0)',
	      WebkitTransform: 'translate3d(0, 0, 0)',
	      transform: 'translate3d(0, 0, 0)',
	      zIndex: 1000
	    };
	  },
	
	  overlay: function overlay(isOpen, width, right) {
	    return {
	      zIndex: 1400,
	      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.5s',
	      visibility: isOpen ? 'visible' : 'hidden'
	    };
	  },
	
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
	      transition: 'all 0.5s',
	      zIndex: 1200,
	      position: 'relative'
	    };
	  },
	
	  burgerIcon: function burgerIcon(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
	      transition: 'all 0.1s',
	      position: 'relative',
	      zIndex: 1300
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
	      transformOrigin: '100%',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s'
	    };
	  },
	
	  outerContainer: function outerContainer() {
	    return {
	      perspective: '1500px'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  pageWrap: function pageWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
	      transformStyle: 'preserve-3d',
	      transition: 'all 0.5s',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  },
	
	  outerContainer: function outerContainer(isOpen) {
	    return {
	      perspective: '1500px',
	      overflow: isOpen ? '' : 'hidden'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _menuFactory = __webpack_require__(20);
	
	var _menuFactory2 = _interopRequireDefault(_menuFactory);
	
	var styles = {
	  menuWrap: function menuWrap(isOpen, width, right) {
	    return {
	      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  },
	
	  item: function item(isOpen, width, right, nthChild) {
	    return {
	      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
	      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
	    };
	  }
	};
	
	exports['default'] = (0, _menuFactory2['default'])(styles);
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function () {
	  var Snap = undefined;
	  try {
	    Snap = __webpack_require__(680);
	  } finally {
	    return Snap;
	  }
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(41);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(34);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(40);
	
	var _HelmetConstants = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(53);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(37));
	var shallowEqual = _interopDefault(__webpack_require__(42));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	window.eve = __webpack_require__(373)
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	var mina = (function (eve) {
	    var animations = {},
	    requestAnimFrame = window.requestAnimationFrame       ||
	                       window.webkitRequestAnimationFrame ||
	                       window.mozRequestAnimationFrame    ||
	                       window.oRequestAnimationFrame      ||
	                       window.msRequestAnimationFrame     ||
	                       function (callback) {
	                           setTimeout(callback, 16, new Date().getTime());
	                           return true;
	                       },
	    requestID,
	    isArray = Array.isArray || function (a) {
	        return a instanceof Array ||
	            Object.prototype.toString.call(a) == "[object Array]";
	    },
	    idgen = 0,
	    idprefix = "M" + (+new Date).toString(36),
	    ID = function () {
	        return idprefix + (idgen++).toString(36);
	    },
	    diff = function (a, b, A, B) {
	        if (isArray(a)) {
	            res = [];
	            for (var i = 0, ii = a.length; i < ii; i++) {
	                res[i] = diff(a[i], b, A[i], B);
	            }
	            return res;
	        }
	        var dif = (A - a) / (B - b);
	        return function (bb) {
	            return a + dif * (bb - b);
	        };
	    },
	    timer = Date.now || function () {
	        return +new Date;
	    },
	    sta = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.s;
	        }
	        var ds = a.s - val;
	        a.b += a.dur * ds;
	        a.B += a.dur * ds;
	        a.s = val;
	    },
	    speed = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.spd;
	        }
	        a.spd = val;
	    },
	    duration = function (val) {
	        var a = this;
	        if (val == null) {
	            return a.dur;
	        }
	        a.s = a.s * val / a.dur;
	        a.dur = val;
	    },
	    stopit = function () {
	        var a = this;
	        delete animations[a.id];
	        a.update();
	        eve("mina.stop." + a.id, a);
	    },
	    pause = function () {
	        var a = this;
	        if (a.pdif) {
	            return;
	        }
	        delete animations[a.id];
	        a.update();
	        a.pdif = a.get() - a.b;
	    },
	    resume = function () {
	        var a = this;
	        if (!a.pdif) {
	            return;
	        }
	        a.b = a.get() - a.pdif;
	        delete a.pdif;
	        animations[a.id] = a;
	        frame();
	    },
	    update = function () {
	        var a = this,
	            res;
	        if (isArray(a.start)) {
	            res = [];
	            for (var j = 0, jj = a.start.length; j < jj; j++) {
	                res[j] = +a.start[j] +
	                    (a.end[j] - a.start[j]) * a.easing(a.s);
	            }
	        } else {
	            res = +a.start + (a.end - a.start) * a.easing(a.s);
	        }
	        a.set(res);
	    },
	    frame = function (timeStamp) {
	        // Manual invokation?
	        if (!timeStamp) {
	            // Frame loop stopped?
	            if (!requestID) {
	                // Start frame loop...
	                requestID = requestAnimFrame(frame);
	            }
	            return;
	        }
	        var len = 0;
	        for (var i in animations) if (animations.hasOwnProperty(i)) {
	            var a = animations[i],
	                b = a.get(),
	                res;
	            len++;
	            a.s = (b - a.b) / (a.dur / a.spd);
	            if (a.s >= 1) {
	                delete animations[i];
	                a.s = 1;
	                len--;
	                (function (a) {
	                    setTimeout(function () {
	                        eve("mina.finish." + a.id, a);
	                    });
	                }(a));
	            }
	            a.update();
	        }
	        requestID = len ? requestAnimFrame(frame) : false;
	    },
	    /*\
	     * mina
	     [ method ]
	     **
	     * Generic animation of numbers
	     **
	     - a (number) start _slave_ number
	     - A (number) end _slave_ number
	     - b (number) start _master_ number (start time in general case)
	     - B (number) end _master_ number (end time in general case)
	     - get (function) getter of _master_ number (see @mina.time)
	     - set (function) setter of _slave_ number
	     - easing (function) #optional easing function, default is @mina.linear
	     = (object) animation descriptor
	     o {
	     o         id (string) animation id,
	     o         start (number) start _slave_ number,
	     o         end (number) end _slave_ number,
	     o         b (number) start _master_ number,
	     o         s (number) animation status (0..1),
	     o         dur (number) animation duration,
	     o         spd (number) animation speed,
	     o         get (function) getter of _master_ number (see @mina.time),
	     o         set (function) setter of _slave_ number,
	     o         easing (function) easing function, default is @mina.linear,
	     o         status (function) status getter/setter,
	     o         speed (function) speed getter/setter,
	     o         duration (function) duration getter/setter,
	     o         stop (function) animation stopper
	     o         pause (function) pauses the animation
	     o         resume (function) resumes the animation
	     o         update (function) calles setter with the right value of the animation
	     o }
	    \*/
	    mina = function (a, A, b, B, get, set, easing) {
	        var anim = {
	            id: ID(),
	            start: a,
	            end: A,
	            b: b,
	            s: 0,
	            dur: B - b,
	            spd: 1,
	            get: get,
	            set: set,
	            easing: easing || mina.linear,
	            status: sta,
	            speed: speed,
	            duration: duration,
	            stop: stopit,
	            pause: pause,
	            resume: resume,
	            update: update
	        };
	        animations[anim.id] = anim;
	        var len = 0, i;
	        for (i in animations) if (animations.hasOwnProperty(i)) {
	            len++;
	            if (len == 2) {
	                break;
	            }
	        }
	        len == 1 && frame();
	        return anim;
	    };
	    /*\
	     * mina.time
	     [ method ]
	     **
	     * Returns the current time. Equivalent to:
	     | function () {
	     |     return (new Date).getTime();
	     | }
	    \*/
	    mina.time = timer;
	    /*\
	     * mina.getById
	     [ method ]
	     **
	     * Returns an animation by its id
	     - id (string) animation's id
	     = (object) See @mina
	    \*/
	    mina.getById = function (id) {
	        return animations[id] || null;
	    };
	
	    /*\
	     * mina.linear
	     [ method ]
	     **
	     * Default linear easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.linear = function (n) {
	        return n;
	    };
	    /*\
	     * mina.easeout
	     [ method ]
	     **
	     * Easeout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeout = function (n) {
	        return Math.pow(n, 1.7);
	    };
	    /*\
	     * mina.easein
	     [ method ]
	     **
	     * Easein easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easein = function (n) {
	        return Math.pow(n, .48);
	    };
	    /*\
	     * mina.easeinout
	     [ method ]
	     **
	     * Easeinout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.easeinout = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        if (n == 0) {
	            return 0;
	        }
	        var q = .48 - n / 1.04,
	            Q = Math.sqrt(.1734 + q * q),
	            x = Q - q,
	            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
	            y = -Q - q,
	            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
	            t = X + Y + .5;
	        return (1 - t) * 3 * t * t + t * t * t;
	    };
	    /*\
	     * mina.backin
	     [ method ]
	     **
	     * Backin easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backin = function (n) {
	        if (n == 1) {
	            return 1;
	        }
	        var s = 1.70158;
	        return n * n * ((s + 1) * n - s);
	    };
	    /*\
	     * mina.backout
	     [ method ]
	     **
	     * Backout easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.backout = function (n) {
	        if (n == 0) {
	            return 0;
	        }
	        n = n - 1;
	        var s = 1.70158;
	        return n * n * ((s + 1) * n + s) + 1;
	    };
	    /*\
	     * mina.elastic
	     [ method ]
	     **
	     * Elastic easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.elastic = function (n) {
	        if (n == !!n) {
	            return n;
	        }
	        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
	            (2 * Math.PI) / .3) + 1;
	    };
	    /*\
	     * mina.bounce
	     [ method ]
	     **
	     * Bounce easing
	     - n (number) input 0..1
	     = (number) output 0..1
	    \*/
	    mina.bounce = function (n) {
	        var s = 7.5625,
	            p = 2.75,
	            l;
	        if (n < 1 / p) {
	            l = s * n * n;
	        } else {
	            if (n < 2 / p) {
	                n -= 1.5 / p;
	                l = s * n * n + .75;
	            } else {
	                if (n < 2.5 / p) {
	                    n -= 2.25 / p;
	                    l = s * n * n + .9375;
	                } else {
	                    n -= 2.625 / p;
	                    l = s * n * n + .984375;
	                }
	            }
	        }
	        return l;
	    };
	    window.mina = mina;
	    return mina;
	})(typeof eve == "undefined" ? function () {} : eve);
	
	// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	var Snap = (function(root) {
	Snap.version = "0.5.1";
	/*\
	 * Snap
	 [ method ]
	 **
	 * Creates a drawing surface or wraps existing SVG element.
	 **
	 - width (number|string) width of surface
	 - height (number|string) height of surface
	 * or
	 - DOM (SVGElement) element to be wrapped into Snap structure
	 * or
	 - array (array) array of elements (will return set of elements)
	 * or
	 - query (string) CSS query selector
	 = (object) @Element
	\*/
	function Snap(w, h) {
	    if (w) {
	        if (w.nodeType) {
	            return wrap(w);
	        }
	        if (is(w, "array") && Snap.set) {
	            return Snap.set.apply(Snap, w);
	        }
	        if (w instanceof Element) {
	            return w;
	        }
	        if (h == null) {
	            try {
	                w = glob.doc.querySelector(String(w));
	                return wrap(w);
	            } catch (e) {
	                return null;
	            }
	        }
	    }
	    w = w == null ? "100%" : w;
	    h = h == null ? "100%" : h;
	    return new Paper(w, h);
	}
	Snap.toString = function () {
	    return "Snap v" + this.version;
	};
	Snap._ = {};
	var glob = {
	    win: root.window,
	    doc: root.window.document
	};
	Snap._.glob = glob;
	var has = "hasOwnProperty",
	    Str = String,
	    toFloat = parseFloat,
	    toInt = parseInt,
	    math = Math,
	    mmax = math.max,
	    mmin = math.min,
	    abs = math.abs,
	    pow = math.pow,
	    PI = math.PI,
	    round = math.round,
	    E = "",
	    S = " ",
	    objectToString = Object.prototype.toString,
	    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
	    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
	    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
	    separator = Snap._.separator = /[,\s]+/,
	    whitespace = /[\s]/g,
	    commaSpaces = /[\s]*,[\s]*/,
	    hsrg = {hs: 1, rg: 1},
	    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
	    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig,
	    idgen = 0,
	    idprefix = "S" + (+new Date).toString(36),
	    ID = function (el) {
	        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
	    },
	    xlink = "http://www.w3.org/1999/xlink",
	    xmlns = "http://www.w3.org/2000/svg",
	    hub = {},
	    /*\
	     * Snap.url
	     [ method ]
	     **
	     * Wraps path into `"url('<path>')"`.
	     - value (string) path
	     = (string) wrapped path
	    \*/
	    URL = Snap.url = function (url) {
	        return "url('#" + url + "')";
	    };
	
	function $(el, attr) {
	    if (attr) {
	        if (el == "#text") {
	            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
	        }
	        if (el == "#comment") {
	            el = glob.doc.createComment(attr.text || attr["#text"] || "");
	        }
	        if (typeof el == "string") {
	            el = $(el);
	        }
	        if (typeof attr == "string") {
	            if (el.nodeType == 1) {
	                if (attr.substring(0, 6) == "xlink:") {
	                    return el.getAttributeNS(xlink, attr.substring(6));
	                }
	                if (attr.substring(0, 4) == "xml:") {
	                    return el.getAttributeNS(xmlns, attr.substring(4));
	                }
	                return el.getAttribute(attr);
	            } else if (attr == "text") {
	                return el.nodeValue;
	            } else {
	                return null;
	            }
	        }
	        if (el.nodeType == 1) {
	            for (var key in attr) if (attr[has](key)) {
	                var val = Str(attr[key]);
	                if (val) {
	                    if (key.substring(0, 6) == "xlink:") {
	                        el.setAttributeNS(xlink, key.substring(6), val);
	                    } else if (key.substring(0, 4) == "xml:") {
	                        el.setAttributeNS(xmlns, key.substring(4), val);
	                    } else {
	                        el.setAttribute(key, val);
	                    }
	                } else {
	                    el.removeAttribute(key);
	                }
	            }
	        } else if ("text" in attr) {
	            el.nodeValue = attr.text;
	        }
	    } else {
	        el = glob.doc.createElementNS(xmlns, el);
	    }
	    return el;
	}
	Snap._.$ = $;
	Snap._.id = ID;
	function getAttrs(el) {
	    var attrs = el.attributes,
	        name,
	        out = {};
	    for (var i = 0; i < attrs.length; i++) {
	        if (attrs[i].namespaceURI == xlink) {
	            name = "xlink:";
	        } else {
	            name = "";
	        }
	        name += attrs[i].name;
	        out[name] = attrs[i].textContent;
	    }
	    return out;
	}
	function is(o, type) {
	    type = Str.prototype.toLowerCase.call(type);
	    if (type == "finite") {
	        return isFinite(o);
	    }
	    if (type == "array" &&
	        (o instanceof Array || Array.isArray && Array.isArray(o))) {
	        return true;
	    }
	    return  type == "null" && o === null ||
	            type == typeof o && o !== null ||
	            type == "object" && o === Object(o) ||
	            objectToString.call(o).slice(8, -1).toLowerCase() == type;
	}
	/*\
	 * Snap.format
	 [ method ]
	 **
	 * Replaces construction of type `{<name>}` to the corresponding argument
	 **
	 - token (string) string to format
	 - json (object) object which properties are used as a replacement
	 = (string) formatted string
	 > Usage
	 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
	 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
	 |     x: 10,
	 |     y: 20,
	 |     dim: {
	 |         width: 40,
	 |         height: 50,
	 |         "negative width": -40
	 |     }
	 | }));
	\*/
	Snap.format = (function () {
	    var tokenRegex = /\{([^\}]+)\}/g,
	        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
	        replacer = function (all, key, obj) {
	            var res = obj;
	            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
	                name = name || quotedName;
	                if (res) {
	                    if (name in res) {
	                        res = res[name];
	                    }
	                    typeof res == "function" && isFunc && (res = res());
	                }
	            });
	            res = (res == null || res == obj ? all : res) + "";
	            return res;
	        };
	    return function (str, obj) {
	        return Str(str).replace(tokenRegex, function (all, key) {
	            return replacer(all, key, obj);
	        });
	    };
	})();
	function clone(obj) {
	    if (typeof obj == "function" || Object(obj) !== obj) {
	        return obj;
	    }
	    var res = new obj.constructor;
	    for (var key in obj) if (obj[has](key)) {
	        res[key] = clone(obj[key]);
	    }
	    return res;
	}
	Snap._.clone = clone;
	function repush(array, item) {
	    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
	        return array.push(array.splice(i, 1)[0]);
	    }
	}
	function cacher(f, scope, postprocessor) {
	    function newf() {
	        var arg = Array.prototype.slice.call(arguments, 0),
	            args = arg.join("\u2400"),
	            cache = newf.cache = newf.cache || {},
	            count = newf.count = newf.count || [];
	        if (cache[has](args)) {
	            repush(count, args);
	            return postprocessor ? postprocessor(cache[args]) : cache[args];
	        }
	        count.length >= 1e3 && delete cache[count.shift()];
	        count.push(args);
	        cache[args] = f.apply(scope, arg);
	        return postprocessor ? postprocessor(cache[args]) : cache[args];
	    }
	    return newf;
	}
	Snap._.cacher = cacher;
	function angle(x1, y1, x2, y2, x3, y3) {
	    if (x3 == null) {
	        var x = x1 - x2,
	            y = y1 - y2;
	        if (!x && !y) {
	            return 0;
	        }
	        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
	    } else {
	        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
	    }
	}
	function rad(deg) {
	    return deg % 360 * PI / 180;
	}
	function deg(rad) {
	    return rad * 180 / PI % 360;
	}
	function x_y() {
	    return this.x + S + this.y;
	}
	function x_y_w_h() {
	    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
	}
	
	/*\
	 * Snap.rad
	 [ method ]
	 **
	 * Transform angle to radians
	 - deg (number) angle in degrees
	 = (number) angle in radians
	\*/
	Snap.rad = rad;
	/*\
	 * Snap.deg
	 [ method ]
	 **
	 * Transform angle to degrees
	 - rad (number) angle in radians
	 = (number) angle in degrees
	\*/
	Snap.deg = deg;
	/*\
	 * Snap.sin
	 [ method ]
	 **
	 * Equivalent to `Math.sin()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) sin
	\*/
	Snap.sin = function (angle) {
	    return math.sin(Snap.rad(angle));
	};
	/*\
	 * Snap.tan
	 [ method ]
	 **
	 * Equivalent to `Math.tan()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) tan
	\*/
	Snap.tan = function (angle) {
	    return math.tan(Snap.rad(angle));
	};
	/*\
	 * Snap.cos
	 [ method ]
	 **
	 * Equivalent to `Math.cos()` only works with degrees, not radians.
	 - angle (number) angle in degrees
	 = (number) cos
	\*/
	Snap.cos = function (angle) {
	    return math.cos(Snap.rad(angle));
	};
	/*\
	 * Snap.asin
	 [ method ]
	 **
	 * Equivalent to `Math.asin()` only works with degrees, not radians.
	 - num (number) value
	 = (number) asin in degrees
	\*/
	Snap.asin = function (num) {
	    return Snap.deg(math.asin(num));
	};
	/*\
	 * Snap.acos
	 [ method ]
	 **
	 * Equivalent to `Math.acos()` only works with degrees, not radians.
	 - num (number) value
	 = (number) acos in degrees
	\*/
	Snap.acos = function (num) {
	    return Snap.deg(math.acos(num));
	};
	/*\
	 * Snap.atan
	 [ method ]
	 **
	 * Equivalent to `Math.atan()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan in degrees
	\*/
	Snap.atan = function (num) {
	    return Snap.deg(math.atan(num));
	};
	/*\
	 * Snap.atan2
	 [ method ]
	 **
	 * Equivalent to `Math.atan2()` only works with degrees, not radians.
	 - num (number) value
	 = (number) atan2 in degrees
	\*/
	Snap.atan2 = function (num) {
	    return Snap.deg(math.atan2(num));
	};
	/*\
	 * Snap.angle
	 [ method ]
	 **
	 * Returns an angle between two or three points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 - x3 (number) #optional x coord of third point
	 - y3 (number) #optional y coord of third point
	 = (number) angle in degrees
	\*/
	Snap.angle = angle;
	/*\
	 * Snap.len
	 [ method ]
	 **
	 * Returns distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len = function (x1, y1, x2, y2) {
	    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
	};
	/*\
	 * Snap.len2
	 [ method ]
	 **
	 * Returns squared distance between two points
	 - x1 (number) x coord of first point
	 - y1 (number) y coord of first point
	 - x2 (number) x coord of second point
	 - y2 (number) y coord of second point
	 = (number) distance
	\*/
	Snap.len2 = function (x1, y1, x2, y2) {
	    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
	};
	/*\
	 * Snap.closestPoint
	 [ method ]
	 **
	 * Returns closest point to a given one on a given path.
	 - path (Element) path element
	 - x (number) x coord of a point
	 - y (number) y coord of a point
	 = (object) in format
	 {
	    x (number) x coord of the point on the path
	    y (number) y coord of the point on the path
	    length (number) length of the path to the point
	    distance (number) distance from the given point to the path
	 }
	\*/
	// Copied from http://bl.ocks.org/mbostock/8027637
	Snap.closestPoint = function (path, x, y) {
	    function distance2(p) {
	        var dx = p.x - x,
	            dy = p.y - y;
	        return dx * dx + dy * dy;
	    }
	    var pathNode = path.node,
	        pathLength = pathNode.getTotalLength(),
	        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
	        best,
	        bestLength,
	        bestDistance = Infinity;
	
	    // linear scan for coarse approximation
	    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
	        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
	            best = scan;
	            bestLength = scanLength;
	            bestDistance = scanDistance;
	        }
	    }
	
	    // binary search for precise estimate
	    precision *= .5;
	    while (precision > .5) {
	        var before,
	            after,
	            beforeLength,
	            afterLength,
	            beforeDistance,
	            afterDistance;
	        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
	            best = before;
	            bestLength = beforeLength;
	            bestDistance = beforeDistance;
	        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
	            best = after;
	            bestLength = afterLength;
	            bestDistance = afterDistance;
	        } else {
	            precision *= .5;
	        }
	    }
	
	    best = {
	        x: best.x,
	        y: best.y,
	        length: bestLength,
	        distance: Math.sqrt(bestDistance)
	    };
	    return best;
	}
	/*\
	 * Snap.is
	 [ method ]
	 **
	 * Handy replacement for the `typeof` operator
	 - o (…) any object or primitive
	 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
	 = (boolean) `true` if given value is of given type
	\*/
	Snap.is = is;
	/*\
	 * Snap.snapTo
	 [ method ]
	 **
	 * Snaps given value to given grid
	 - values (array|number) given array of values or step of the grid
	 - value (number) value to adjust
	 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
	 = (number) adjusted value
	\*/
	Snap.snapTo = function (values, value, tolerance) {
	    tolerance = is(tolerance, "finite") ? tolerance : 10;
	    if (is(values, "array")) {
	        var i = values.length;
	        while (i--) if (abs(values[i] - value) <= tolerance) {
	            return values[i];
	        }
	    } else {
	        values = +values;
	        var rem = value % values;
	        if (rem < tolerance) {
	            return value - rem;
	        }
	        if (rem > values - tolerance) {
	            return value - rem + values;
	        }
	    }
	    return value;
	};
	// Colour
	/*\
	 * Snap.getRGB
	 [ method ]
	 **
	 * Parses color string as RGB object
	 - color (string) color string in one of the following formats:
	 # <ul>
	 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
	 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
	 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
	 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
	 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
	 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
	 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
	 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
	 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
	 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
	 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
	 # </ul>
	 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) true if string can't be parsed
	 o }
	\*/
	Snap.getRGB = cacher(function (colour) {
	    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    if (colour == "none") {
	        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
	    }
	    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
	    if (!colour) {
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	    }
	    var res,
	        red,
	        green,
	        blue,
	        opacity,
	        t,
	        values,
	        rgb = colour.match(colourRegExp);
	    if (rgb) {
	        if (rgb[2]) {
	            blue = toInt(rgb[2].substring(5), 16);
	            green = toInt(rgb[2].substring(3, 5), 16);
	            red = toInt(rgb[2].substring(1, 3), 16);
	        }
	        if (rgb[3]) {
	            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
	            green = toInt((t = rgb[3].charAt(2)) + t, 16);
	            red = toInt((t = rgb[3].charAt(1)) + t, 16);
	        }
	        if (rgb[4]) {
	            values = rgb[4].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red *= 2.55);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green *= 2.55);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue *= 2.55);
	            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	        }
	        if (rgb[5]) {
	            values = rgb[5].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsb2rgb(red, green, blue, opacity);
	        }
	        if (rgb[6]) {
	            values = rgb[6].split(commaSpaces);
	            red = toFloat(values[0]);
	            values[0].slice(-1) == "%" && (red /= 100);
	            green = toFloat(values[1]);
	            values[1].slice(-1) == "%" && (green /= 100);
	            blue = toFloat(values[2]);
	            values[2].slice(-1) == "%" && (blue /= 100);
	            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
	            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            return Snap.hsl2rgb(red, green, blue, opacity);
	        }
	        red = mmin(math.round(red), 255);
	        green = mmin(math.round(green), 255);
	        blue = mmin(math.round(blue), 255);
	        opacity = mmin(mmax(opacity, 0), 1);
	        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
	        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
	        rgb.opacity = is(opacity, "finite") ? opacity : 1;
	        return rgb;
	    }
	    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
	}, Snap);
	/*\
	 * Snap.hsb
	 [ method ]
	 **
	 * Converts HSB values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - b (number) value or brightness
	 = (string) hex representation of the color
	\*/
	Snap.hsb = cacher(function (h, s, b) {
	    return Snap.hsb2rgb(h, s, b).hex;
	});
	/*\
	 * Snap.hsl
	 [ method ]
	 **
	 * Converts HSL values to a hex representation of the color
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (string) hex representation of the color
	\*/
	Snap.hsl = cacher(function (h, s, l) {
	    return Snap.hsl2rgb(h, s, l).hex;
	});
	/*\
	 * Snap.rgb
	 [ method ]
	 **
	 * Converts RGB values to a hex representation of the color
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (string) hex representation of the color
	\*/
	Snap.rgb = cacher(function (r, g, b, o) {
	    if (is(o, "finite")) {
	        var round = math.round;
	        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
	    }
	    return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
	});
	var toHex = function (color) {
	    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
	        red = "rgb(255, 0, 0)";
	    toHex = cacher(function (color) {
	        if (color.toLowerCase() == "red") {
	            return red;
	        }
	        i.style.color = red;
	        i.style.color = color;
	        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
	        return out == red ? null : out;
	    });
	    return toHex(color);
	},
	hsbtoString = function () {
	    return "hsb(" + [this.h, this.s, this.b] + ")";
	},
	hsltoString = function () {
	    return "hsl(" + [this.h, this.s, this.l] + ")";
	},
	rgbtoString = function () {
	    return this.opacity == 1 || this.opacity == null ?
	            this.hex :
	            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
	},
	prepareRGB = function (r, g, b) {
	    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
	        b = r.b;
	        g = r.g;
	        r = r.r;
	    }
	    if (g == null && is(r, string)) {
	        var clr = Snap.getRGB(r);
	        r = clr.r;
	        g = clr.g;
	        b = clr.b;
	    }
	    if (r > 1 || g > 1 || b > 1) {
	        r /= 255;
	        g /= 255;
	        b /= 255;
	    }
	
	    return [r, g, b];
	},
	packageRGB = function (r, g, b, o) {
	    r = math.round(r * 255);
	    g = math.round(g * 255);
	    b = math.round(b * 255);
	    var rgb = {
	        r: r,
	        g: g,
	        b: b,
	        opacity: is(o, "finite") ? o : 1,
	        hex: Snap.rgb(r, g, b),
	        toString: rgbtoString
	    };
	    is(o, "finite") && (rgb.opacity = o);
	    return rgb;
	};
	/*\
	 * Snap.color
	 [ method ]
	 **
	 * Parses the color string and returns an object featuring the color's component values
	 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
	 = (object) Combined RGB/HSB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••,
	 o     error (boolean) `true` if string can't be parsed,
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     v (number) value (brightness),
	 o     l (number) lightness
	 o }
	\*/
	Snap.color = function (clr) {
	    var rgb;
	    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
	        rgb = Snap.hsb2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
	        rgb = Snap.hsl2rgb(clr);
	        clr.r = rgb.r;
	        clr.g = rgb.g;
	        clr.b = rgb.b;
	        clr.opacity = 1;
	        clr.hex = rgb.hex;
	    } else {
	        if (is(clr, "string")) {
	            clr = Snap.getRGB(clr);
	        }
	        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
	            rgb = Snap.rgb2hsl(clr);
	            clr.h = rgb.h;
	            clr.s = rgb.s;
	            clr.l = rgb.l;
	            rgb = Snap.rgb2hsb(clr);
	            clr.v = rgb.b;
	        } else {
	            clr = {hex: "none"};
	            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
	            clr.error = 1;
	        }
	    }
	    clr.toString = rgbtoString;
	    return clr;
	};
	/*\
	 * Snap.hsb2rgb
	 [ method ]
	 **
	 * Converts HSB values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - v (number) value or brightness
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsb2rgb = function (h, s, v, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
	        v = h.b;
	        s = h.s;
	        o = h.o;
	        h = h.h;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = v * s;
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = v - C;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.hsl2rgb
	 [ method ]
	 **
	 * Converts HSL values to an RGB object
	 - h (number) hue
	 - s (number) saturation
	 - l (number) luminosity
	 = (object) RGB object in the following format:
	 o {
	 o     r (number) red,
	 o     g (number) green,
	 o     b (number) blue,
	 o     hex (string) color in HTML/CSS format: #••••••
	 o }
	\*/
	Snap.hsl2rgb = function (h, s, l, o) {
	    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
	        l = h.l;
	        s = h.s;
	        h = h.h;
	    }
	    if (h > 1 || s > 1 || l > 1) {
	        h /= 360;
	        s /= 100;
	        l /= 100;
	    }
	    h *= 360;
	    var R, G, B, X, C;
	    h = h % 360 / 60;
	    C = 2 * s * (l < .5 ? l : 1 - l);
	    X = C * (1 - abs(h % 2 - 1));
	    R = G = B = l - C / 2;
	
	    h = ~~h;
	    R += [C, X, 0, 0, X, C][h];
	    G += [X, C, C, X, 0, 0][h];
	    B += [0, 0, X, C, C, X][h];
	    return packageRGB(R, G, B, o);
	};
	/*\
	 * Snap.rgb2hsb
	 [ method ]
	 **
	 * Converts RGB values to an HSB object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSB object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     b (number) brightness
	 o }
	\*/
	Snap.rgb2hsb = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, V, C;
	    V = mmax(r, g, b);
	    C = V - mmin(r, g, b);
	    H = C == 0 ? null :
	        V == r ? (g - b) / C :
	        V == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    S = C == 0 ? 0 : C / V;
	    return {h: H, s: S, b: V, toString: hsbtoString};
	};
	/*\
	 * Snap.rgb2hsl
	 [ method ]
	 **
	 * Converts RGB values to an HSL object
	 - r (number) red
	 - g (number) green
	 - b (number) blue
	 = (object) HSL object in the following format:
	 o {
	 o     h (number) hue,
	 o     s (number) saturation,
	 o     l (number) luminosity
	 o }
	\*/
	Snap.rgb2hsl = function (r, g, b) {
	    b = prepareRGB(r, g, b);
	    r = b[0];
	    g = b[1];
	    b = b[2];
	
	    var H, S, L, M, m, C;
	    M = mmax(r, g, b);
	    m = mmin(r, g, b);
	    C = M - m;
	    H = C == 0 ? null :
	        M == r ? (g - b) / C :
	        M == g ? (b - r) / C + 2 :
	                 (r - g) / C + 4;
	    H = (H + 360) % 6 * 60 / 360;
	    L = (M + m) / 2;
	    S = C == 0 ? 0 :
	         L < .5 ? C / (2 * L) :
	                  C / (2 - 2 * L);
	    return {h: H, s: S, l: L, toString: hsltoString};
	};
	
	// Transformations
	/*\
	 * Snap.parsePathString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given path string into an array of arrays of path segments
	 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
	 = (array) array of segments
	\*/
	Snap.parsePathString = function (pathString) {
	    if (!pathString) {
	        return null;
	    }
	    var pth = Snap.path(pathString);
	    if (pth.arr) {
	        return Snap.path.clone(pth.arr);
	    }
	
	    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
	        data = [];
	    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
	        data = Snap.path.clone(pathString);
	    }
	    if (!data.length) {
	        Str(pathString).replace(pathCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            if (name == "m" && params.length > 2) {
	                data.push([b].concat(params.splice(0, 2)));
	                name = "l";
	                b = b == "m" ? "l" : "L";
	            }
	            if (name == "o" && params.length == 1) {
	                data.push([b, params[0]]);
	            }
	            if (name == "r") {
	                data.push([b].concat(params));
	            } else while (params.length >= paramCounts[name]) {
	                data.push([b].concat(params.splice(0, paramCounts[name])));
	                if (!paramCounts[name]) {
	                    break;
	                }
	            }
	        });
	    }
	    data.toString = Snap.path.toString;
	    pth.arr = Snap.path.clone(data);
	    return data;
	};
	/*\
	 * Snap.parseTransformString
	 [ method ]
	 **
	 * Utility method
	 **
	 * Parses given transform string into an array of transformations
	 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
	 = (array) array of transformations
	\*/
	var parseTransformString = Snap.parseTransformString = function (TString) {
	    if (!TString) {
	        return null;
	    }
	    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
	        data = [];
	    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
	        data = Snap.path.clone(TString);
	    }
	    if (!data.length) {
	        Str(TString).replace(tCommand, function (a, b, c) {
	            var params = [],
	                name = b.toLowerCase();
	            c.replace(pathValues, function (a, b) {
	                b && params.push(+b);
	            });
	            data.push([b].concat(params));
	        });
	    }
	    data.toString = Snap.path.toString;
	    return data;
	};
	function svgTransform2string(tstr) {
	    var res = [];
	    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
	        params = params.split(/\s*,\s*|\s+/);
	        if (name == "rotate" && params.length == 1) {
	            params.push(0, 0);
	        }
	        if (name == "scale") {
	            if (params.length > 2) {
	                params = params.slice(0, 2);
	            } else if (params.length == 2) {
	                params.push(0, 0);
	            }
	            if (params.length == 1) {
	                params.push(params[0], 0, 0);
	            }
	        }
	        if (name == "skewX") {
	            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
	        } else if (name == "skewY") {
	            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
	        } else {
	            res.push([name.charAt(0)].concat(params));
	        }
	        return all;
	    });
	    return res;
	}
	Snap._.svgTransform2string = svgTransform2string;
	Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
	function transform2matrix(tstr, bbox) {
	    var tdata = parseTransformString(tstr),
	        m = new Snap.Matrix;
	    if (tdata) {
	        for (var i = 0, ii = tdata.length; i < ii; i++) {
	            var t = tdata[i],
	                tlen = t.length,
	                command = Str(t[0]).toLowerCase(),
	                absolute = t[0] != command,
	                inver = absolute ? m.invert() : 0,
	                x1,
	                y1,
	                x2,
	                y2,
	                bb;
	            if (command == "t" && tlen == 2){
	                m.translate(t[1], 0);
	            } else if (command == "t" && tlen == 3) {
	                if (absolute) {
	                    x1 = inver.x(0, 0);
	                    y1 = inver.y(0, 0);
	                    x2 = inver.x(t[1], t[2]);
	                    y2 = inver.y(t[1], t[2]);
	                    m.translate(x2 - x1, y2 - y1);
	                } else {
	                    m.translate(t[1], t[2]);
	                }
	            } else if (command == "r") {
	                if (tlen == 2) {
	                    bb = bb || bbox;
	                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.rotate(t[1], x2, y2);
	                    } else {
	                        m.rotate(t[1], t[2], t[3]);
	                    }
	                }
	            } else if (command == "s") {
	                if (tlen == 2 || tlen == 3) {
	                    bb = bb || bbox;
	                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                } else if (tlen == 4) {
	                    if (absolute) {
	                        x2 = inver.x(t[2], t[3]);
	                        y2 = inver.y(t[2], t[3]);
	                        m.scale(t[1], t[1], x2, y2);
	                    } else {
	                        m.scale(t[1], t[1], t[2], t[3]);
	                    }
	                } else if (tlen == 5) {
	                    if (absolute) {
	                        x2 = inver.x(t[3], t[4]);
	                        y2 = inver.y(t[3], t[4]);
	                        m.scale(t[1], t[2], x2, y2);
	                    } else {
	                        m.scale(t[1], t[2], t[3], t[4]);
	                    }
	                }
	            } else if (command == "m" && tlen == 7) {
	                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
	            }
	        }
	    }
	    return m;
	}
	Snap._.transform2matrix = transform2matrix;
	Snap._unit2px = unit2px;
	var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
	    function (a, b) {
	        var adown = a.nodeType == 9 ? a.documentElement : a,
	            bup = b && b.parentNode;
	            return a == bup || !!(bup && bup.nodeType == 1 && (
	                adown.contains ?
	                    adown.contains(bup) :
	                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
	            ));
	    } :
	    function (a, b) {
	        if (b) {
	            while (b) {
	                b = b.parentNode;
	                if (b == a) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	function getSomeDefs(el) {
	    var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) ||
	            el.node.parentNode && wrap(el.node.parentNode) ||
	            Snap.select("svg") ||
	            Snap(0, 0),
	        pdefs = p.select("defs"),
	        defs  = pdefs == null ? false : pdefs.node;
	    if (!defs) {
	        defs = make("defs", p.node).node;
	    }
	    return defs;
	}
	function getSomeSVG(el) {
	    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
	}
	Snap._.getSomeDefs = getSomeDefs;
	Snap._.getSomeSVG = getSomeSVG;
	function unit2px(el, name, value) {
	    var svg = getSomeSVG(el).node,
	        out = {},
	        mgr = svg.querySelector(".svg---mgr");
	    if (!mgr) {
	        mgr = $("rect");
	        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
	        svg.appendChild(mgr);
	    }
	    function getW(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {width: val});
	        try {
	            return mgr.getBBox().width;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function getH(val) {
	        if (val == null) {
	            return E;
	        }
	        if (val == +val) {
	            return val;
	        }
	        $(mgr, {height: val});
	        try {
	            return mgr.getBBox().height;
	        } catch (e) {
	            return 0;
	        }
	    }
	    function set(nam, f) {
	        if (name == null) {
	            out[nam] = f(el.attr(nam) || 0);
	        } else if (nam == name) {
	            out = f(value == null ? el.attr(nam) || 0 : value);
	        }
	    }
	    switch (el.type) {
	        case "rect":
	            set("rx", getW);
	            set("ry", getH);
	        case "image":
	            set("width", getW);
	            set("height", getH);
	        case "text":
	            set("x", getW);
	            set("y", getH);
	        break;
	        case "circle":
	            set("cx", getW);
	            set("cy", getH);
	            set("r", getW);
	        break;
	        case "ellipse":
	            set("cx", getW);
	            set("cy", getH);
	            set("rx", getW);
	            set("ry", getH);
	        break;
	        case "line":
	            set("x1", getW);
	            set("x2", getW);
	            set("y1", getH);
	            set("y2", getH);
	        break;
	        case "marker":
	            set("refX", getW);
	            set("markerWidth", getW);
	            set("refY", getH);
	            set("markerHeight", getH);
	        break;
	        case "radialGradient":
	            set("fx", getW);
	            set("fy", getH);
	        break;
	        case "tspan":
	            set("dx", getW);
	            set("dy", getH);
	        break;
	        default:
	            set(name, getW);
	    }
	    svg.removeChild(mgr);
	    return out;
	}
	/*\
	 * Snap.select
	 [ method ]
	 **
	 * Wraps a DOM element specified by CSS selector as @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.select = function (query) {
	    query = Str(query).replace(/([^\\]):/g, "$1\\:");
	    return wrap(glob.doc.querySelector(query));
	};
	/*\
	 * Snap.selectAll
	 [ method ]
	 **
	 * Wraps DOM elements specified by CSS selector as set or array of @Element
	 - query (string) CSS selector of the element
	 = (Element) the current element
	\*/
	Snap.selectAll = function (query) {
	    var nodelist = glob.doc.querySelectorAll(query),
	        set = (Snap.set || Array)();
	    for (var i = 0; i < nodelist.length; i++) {
	        set.push(wrap(nodelist[i]));
	    }
	    return set;
	};
	
	function add2group(list) {
	    if (!is(list, "array")) {
	        list = Array.prototype.slice.call(arguments, 0);
	    }
	    var i = 0,
	        j = 0,
	        node = this.node;
	    while (this[i]) delete this[i++];
	    for (i = 0; i < list.length; i++) {
	        if (list[i].type == "set") {
	            list[i].forEach(function (el) {
	                node.appendChild(el.node);
	            });
	        } else {
	            node.appendChild(list[i].node);
	        }
	    }
	    var children = node.childNodes;
	    for (i = 0; i < children.length; i++) {
	        this[j++] = wrap(children[i]);
	    }
	    return this;
	}
	// Hub garbage collector every 10s
	setInterval(function () {
	    for (var key in hub) if (hub[has](key)) {
	        var el = hub[key],
	            node = el.node;
	        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
	            delete hub[key];
	        }
	    }
	}, 1e4);
	function Element(el) {
	    if (el.snap in hub) {
	        return hub[el.snap];
	    }
	    var svg;
	    try {
	        svg = el.ownerSVGElement;
	    } catch(e) {}
	    /*\
	     * Element.node
	     [ property (object) ]
	     **
	     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
	     > Usage
	     | // draw a circle at coordinate 10,10 with radius of 10
	     | var c = paper.circle(10, 10, 10);
	     | c.node.onclick = function () {
	     |     c.attr("fill", "red");
	     | };
	    \*/
	    this.node = el;
	    if (svg) {
	        this.paper = new Paper(svg);
	    }
	    /*\
	     * Element.type
	     [ property (string) ]
	     **
	     * SVG tag name of the given element.
	    \*/
	    this.type = el.tagName || el.nodeName;
	    var id = this.id = ID(this);
	    this.anims = {};
	    this._ = {
	        transform: []
	    };
	    el.snap = id;
	    hub[id] = this;
	    if (this.type == "g") {
	        this.add = add2group;
	    }
	    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
	        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
	            this[method] = Paper.prototype[method];
	        }
	    }
	}
	   /*\
	     * Element.attr
	     [ method ]
	     **
	     * Gets or sets given attributes of the element.
	     **
	     - params (object) contains key-value pairs of attributes you want to set
	     * or
	     - param (string) name of the attribute
	     = (Element) the current element
	     * or
	     = (string) value of attribute
	     > Usage
	     | el.attr({
	     |     fill: "#fc0",
	     |     stroke: "#000",
	     |     strokeWidth: 2, // CamelCase...
	     |     "fill-opacity": 0.5, // or dash-separated names
	     |     width: "*=2" // prefixed values
	     | });
	     | console.log(el.attr("fill")); // #fc0
	     * Prefixed values in format `"+=10"` supported. All four operations
	     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
	     * and `-`: `"+=2em"`.
	    \*/
	    Element.prototype.attr = function (params, value) {
	        var el = this,
	            node = el.node;
	        if (!params) {
	            if (node.nodeType != 1) {
	                return {
	                    text: node.nodeValue
	                };
	            }
	            var attr = node.attributes,
	                out = {};
	            for (var i = 0, ii = attr.length; i < ii; i++) {
	                out[attr[i].nodeName] = attr[i].nodeValue;
	            }
	            return out;
	        }
	        if (is(params, "string")) {
	            if (arguments.length > 1) {
	                var json = {};
	                json[params] = value;
	                params = json;
	            } else {
	                return eve("snap.util.getattr." + params, el).firstDefined();
	            }
	        }
	        for (var att in params) {
	            if (params[has](att)) {
	                eve("snap.util.attr." + att, el, params[att]);
	            }
	        }
	        return el;
	    };
	/*\
	 * Snap.parse
	 [ method ]
	 **
	 * Parses SVG fragment and converts it into a @Fragment
	 **
	 - svg (string) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.parse = function (svg) {
	    var f = glob.doc.createDocumentFragment(),
	        full = true,
	        div = glob.doc.createElement("div");
	    svg = Str(svg);
	    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
	        svg = "<svg>" + svg + "</svg>";
	        full = false;
	    }
	    div.innerHTML = svg;
	    svg = div.getElementsByTagName("svg")[0];
	    if (svg) {
	        if (full) {
	            f = svg;
	        } else {
	            while (svg.firstChild) {
	                f.appendChild(svg.firstChild);
	            }
	        }
	    }
	    return new Fragment(f);
	};
	function Fragment(frag) {
	    this.node = frag;
	}
	/*\
	 * Snap.fragment
	 [ method ]
	 **
	 * Creates a DOM fragment from a given list of elements or strings
	 **
	 - varargs (…) SVG string
	 = (Fragment) the @Fragment
	\*/
	Snap.fragment = function () {
	    var args = Array.prototype.slice.call(arguments, 0),
	        f = glob.doc.createDocumentFragment();
	    for (var i = 0, ii = args.length; i < ii; i++) {
	        var item = args[i];
	        if (item.node && item.node.nodeType) {
	            f.appendChild(item.node);
	        }
	        if (item.nodeType) {
	            f.appendChild(item);
	        }
	        if (typeof item == "string") {
	            f.appendChild(Snap.parse(item).node);
	        }
	    }
	    return new Fragment(f);
	};
	
	function make(name, parent) {
	    var res = $(name);
	    parent.appendChild(res);
	    var el = wrap(res);
	    return el;
	}
	function Paper(w, h) {
	    var res,
	        desc,
	        defs,
	        proto = Paper.prototype;
	    if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
	        if (w.snap in hub) {
	            return hub[w.snap];
	        }
	        var doc = w.ownerDocument;
	        res = new Element(w);
	        desc = w.getElementsByTagName("desc")[0];
	        defs = w.getElementsByTagName("defs")[0];
	        if (!desc) {
	            desc = $("desc");
	            desc.appendChild(doc.createTextNode("Created with Snap"));
	            res.node.appendChild(desc);
	        }
	        if (!defs) {
	            defs = $("defs");
	            res.node.appendChild(defs);
	        }
	        res.defs = defs;
	        for (var key in proto) if (proto[has](key)) {
	            res[key] = proto[key];
	        }
	        res.paper = res.root = res;
	    } else {
	        res = make("svg", glob.doc.body);
	        $(res.node, {
	            height: h,
	            version: 1.1,
	            width: w,
	            xmlns: xmlns
	        });
	    }
	    return res;
	}
	function wrap(dom) {
	    if (!dom) {
	        return dom;
	    }
	    if (dom instanceof Element || dom instanceof Fragment) {
	        return dom;
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
	        return new Paper(dom);
	    }
	    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
	        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
	    }
	    return new Element(dom);
	}
	
	Snap._.make = make;
	Snap._.wrap = wrap;
	/*\
	 * Paper.el
	 [ method ]
	 **
	 * Creates an element on paper with a given name and no attributes
	 **
	 - name (string) tag name
	 - attr (object) attributes
	 = (Element) the current element
	 > Usage
	 | var c = paper.circle(10, 10, 10); // is the same as...
	 | var c = paper.el("circle").attr({
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	 | // and the same as
	 | var c = paper.el("circle", {
	 |     cx: 10,
	 |     cy: 10,
	 |     r: 10
	 | });
	\*/
	Paper.prototype.el = function (name, attr) {
	    var el = make(name, this.node);
	    attr && el.attr(attr);
	    return el;
	};
	/*\
	 * Element.children
	 [ method ]
	 **
	 * Returns array of all the children of the element.
	 = (array) array of Elements
	\*/
	Element.prototype.children = function () {
	    var out = [],
	        ch = this.node.childNodes;
	    for (var i = 0, ii = ch.length; i < ii; i++) {
	        out[i] = Snap(ch[i]);
	    }
	    return out;
	};
	function jsonFiller(root, o) {
	    for (var i = 0, ii = root.length; i < ii; i++) {
	        var item = {
	                type: root[i].type,
	                attr: root[i].attr()
	            },
	            children = root[i].children();
	        o.push(item);
	        if (children.length) {
	            jsonFiller(children, item.childNodes = []);
	        }
	    }
	}
	/*\
	 * Element.toJSON
	 [ method ]
	 **
	 * Returns object representation of the given element and all its children.
	 = (object) in format
	 o {
	 o     type (string) this.type,
	 o     attr (object) attributes map,
	 o     childNodes (array) optional array of children in the same format
	 o }
	\*/
	Element.prototype.toJSON = function () {
	    var out = [];
	    jsonFiller([this], out);
	    return out[0];
	};
	// default
	eve.on("snap.util.getattr", function () {
	    var att = eve.nt();
	    att = att.substring(att.lastIndexOf(".") + 1);
	    var css = att.replace(/[A-Z]/g, function (letter) {
	        return "-" + letter.toLowerCase();
	    });
	    if (cssAttr[has](css)) {
	        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
	    } else {
	        return $(this.node, att);
	    }
	});
	var cssAttr = {
	    "alignment-baseline": 0,
	    "baseline-shift": 0,
	    "clip": 0,
	    "clip-path": 0,
	    "clip-rule": 0,
	    "color": 0,
	    "color-interpolation": 0,
	    "color-interpolation-filters": 0,
	    "color-profile": 0,
	    "color-rendering": 0,
	    "cursor": 0,
	    "direction": 0,
	    "display": 0,
	    "dominant-baseline": 0,
	    "enable-background": 0,
	    "fill": 0,
	    "fill-opacity": 0,
	    "fill-rule": 0,
	    "filter": 0,
	    "flood-color": 0,
	    "flood-opacity": 0,
	    "font": 0,
	    "font-family": 0,
	    "font-size": 0,
	    "font-size-adjust": 0,
	    "font-stretch": 0,
	    "font-style": 0,
	    "font-variant": 0,
	    "font-weight": 0,
	    "glyph-orientation-horizontal": 0,
	    "glyph-orientation-vertical": 0,
	    "image-rendering": 0,
	    "kerning": 0,
	    "letter-spacing": 0,
	    "lighting-color": 0,
	    "marker": 0,
	    "marker-end": 0,
	    "marker-mid": 0,
	    "marker-start": 0,
	    "mask": 0,
	    "opacity": 0,
	    "overflow": 0,
	    "pointer-events": 0,
	    "shape-rendering": 0,
	    "stop-color": 0,
	    "stop-opacity": 0,
	    "stroke": 0,
	    "stroke-dasharray": 0,
	    "stroke-dashoffset": 0,
	    "stroke-linecap": 0,
	    "stroke-linejoin": 0,
	    "stroke-miterlimit": 0,
	    "stroke-opacity": 0,
	    "stroke-width": 0,
	    "text-anchor": 0,
	    "text-decoration": 0,
	    "text-rendering": 0,
	    "unicode-bidi": 0,
	    "visibility": 0,
	    "word-spacing": 0,
	    "writing-mode": 0
	};
	
	eve.on("snap.util.attr", function (value) {
	    var att = eve.nt(),
	        attr = {};
	    att = att.substring(att.lastIndexOf(".") + 1);
	    attr[att] = value;
	    var style = att.replace(/-(\w)/gi, function (all, letter) {
	            return letter.toUpperCase();
	        }),
	        css = att.replace(/[A-Z]/g, function (letter) {
	            return "-" + letter.toLowerCase();
	        });
	    if (cssAttr[has](css)) {
	        this.node.style[style] = value == null ? E : value;
	    } else {
	        $(this.node, attr);
	    }
	});
	(function (proto) {}(Paper.prototype));
	
	// simple ajax
	/*\
	 * Snap.ajax
	 [ method ]
	 **
	 * Simple implementation of Ajax
	 **
	 - url (string) URL
	 - postData (object|string) data for post request
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 * or
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	 = (XMLHttpRequest) the XMLHttpRequest object, just in case
	\*/
	Snap.ajax = function (url, postData, callback, scope){
	    var req = new XMLHttpRequest,
	        id = ID();
	    if (req) {
	        if (is(postData, "function")) {
	            scope = callback;
	            callback = postData;
	            postData = null;
	        } else if (is(postData, "object")) {
	            var pd = [];
	            for (var key in postData) if (postData.hasOwnProperty(key)) {
	                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
	            }
	            postData = pd.join("&");
	        }
	        req.open(postData ? "POST" : "GET", url, true);
	        if (postData) {
	            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	        }
	        if (callback) {
	            eve.once("snap.ajax." + id + ".0", callback);
	            eve.once("snap.ajax." + id + ".200", callback);
	            eve.once("snap.ajax." + id + ".304", callback);
	        }
	        req.onreadystatechange = function() {
	            if (req.readyState != 4) return;
	            eve("snap.ajax." + id + "." + req.status, scope, req);
	        };
	        if (req.readyState == 4) {
	            return req;
	        }
	        req.send(postData);
	        return req;
	    }
	};
	/*\
	 * Snap.load
	 [ method ]
	 **
	 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
	 **
	 - url (string) URL
	 - callback (function) callback
	 - scope (object) #optional scope of callback
	\*/
	Snap.load = function (url, callback, scope) {
	    Snap.ajax(url, function (req) {
	        var f = Snap.parse(req.responseText);
	        scope ? callback.call(scope, f) : callback(f);
	    });
	};
	var getOffset = function (elem) {
	    var box = elem.getBoundingClientRect(),
	        doc = elem.ownerDocument,
	        body = doc.body,
	        docElem = doc.documentElement,
	        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
	        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
	        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
	    return {
	        y: top,
	        x: left
	    };
	};
	/*\
	 * Snap.getElementByPoint
	 [ method ]
	 **
	 * Returns you topmost element under given point.
	 **
	 = (object) Snap element object
	 - x (number) x coordinate from the top left corner of the window
	 - y (number) y coordinate from the top left corner of the window
	 > Usage
	 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
	\*/
	Snap.getElementByPoint = function (x, y) {
	    var paper = this,
	        svg = paper.canvas,
	        target = glob.doc.elementFromPoint(x, y);
	    if (glob.win.opera && target.tagName == "svg") {
	        var so = getOffset(target),
	            sr = target.createSVGRect();
	        sr.x = x - so.x;
	        sr.y = y - so.y;
	        sr.width = sr.height = 1;
	        var hits = target.getIntersectionList(sr, null);
	        if (hits.length) {
	            target = hits[hits.length - 1];
	        }
	    }
	    if (!target) {
	        return null;
	    }
	    return wrap(target);
	};
	/*\
	 * Snap.plugin
	 [ method ]
	 **
	 * Let you write plugins. You pass in a function with five arguments, like this:
	 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
	 |     Snap.newmethod = function () {};
	 |     Element.prototype.newmethod = function () {};
	 |     Paper.prototype.newmethod = function () {};
	 | });
	 * Inside the function you have access to all main objects (and their
	 * prototypes). This allow you to extend anything you want.
	 **
	 - f (function) your plugin body
	\*/
	Snap.plugin = function (f) {
	    f(Snap, Element, Paper, glob, Fragment);
	};
	glob.win.Snap = Snap;
	return Snap;
	}(window || this));
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        unit2px = Snap._unit2px,
	        $ = Snap._.$,
	        make = Snap._.make,
	        getSomeDefs = Snap._.getSomeDefs,
	        has = "hasOwnProperty",
	        wrap = Snap._.wrap;
	    /*\
	     * Element.getBBox
	     [ method ]
	     **
	     * Returns the bounding box descriptor for the given element
	     **
	     = (object) bounding box descriptor:
	     o {
	     o     cx: (number) x of the center,
	     o     cy: (number) x of the center,
	     o     h: (number) height,
	     o     height: (number) height,
	     o     path: (string) path command for the box,
	     o     r0: (number) radius of a circle that fully encloses the box,
	     o     r1: (number) radius of the smallest circle that can be enclosed,
	     o     r2: (number) radius of the largest circle that can be enclosed,
	     o     vb: (string) box as a viewbox command,
	     o     w: (number) width,
	     o     width: (number) width,
	     o     x2: (number) x of the right side,
	     o     x: (number) x of the left side,
	     o     y2: (number) y of the bottom edge,
	     o     y: (number) y of the top edge
	     o }
	    \*/
	    elproto.getBBox = function (isWithoutTransform) {
	        if (this.type == "tspan") {
	            return Snap._.box(this.node.getClientRects().item(0));
	        }
	        if (!Snap.Matrix || !Snap.path) {
	            return this.node.getBBox();
	        }
	        var el = this,
	            m = new Snap.Matrix;
	        if (el.removed) {
	            return Snap._.box();
	        }
	        while (el.type == "use") {
	            if (!isWithoutTransform) {
	                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
	            }
	            if (el.original) {
	                el = el.original;
	            } else {
	                var href = el.attr("xlink:href");
	                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
	            }
	        }
	        var _ = el._,
	            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
	        try {
	            if (isWithoutTransform) {
	                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
	                return Snap._.box(_.bboxwt);
	            } else {
	                el.realPath = pathfinder(el);
	                el.matrix = el.transform().localMatrix;
	                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
	                return Snap._.box(_.bbox);
	            }
	        } catch (e) {
	            // Firefox doesn’t give you bbox of hidden element
	            return Snap._.box();
	        }
	    };
	    var propString = function () {
	        return this.string;
	    };
	    function extractTransform(el, tstr) {
	        if (tstr == null) {
	            var doReturn = true;
	            if (el.type == "linearGradient" || el.type == "radialGradient") {
	                tstr = el.node.getAttribute("gradientTransform");
	            } else if (el.type == "pattern") {
	                tstr = el.node.getAttribute("patternTransform");
	            } else {
	                tstr = el.node.getAttribute("transform");
	            }
	            if (!tstr) {
	                return new Snap.Matrix;
	            }
	            tstr = Snap._.svgTransform2string(tstr);
	        } else {
	            if (!Snap._.rgTransform.test(tstr)) {
	                tstr = Snap._.svgTransform2string(tstr);
	            } else {
	                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
	            }
	            if (is(tstr, "array")) {
	                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
	            }
	            el._.transform = tstr;
	        }
	        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
	        if (doReturn) {
	            return m;
	        } else {
	            el.matrix = m;
	        }
	    }
	    /*\
	     * Element.transform
	     [ method ]
	     **
	     * Gets or sets transformation of the element
	     **
	     - tstr (string) transform string in Snap or SVG format
	     = (Element) the current element
	     * or
	     = (object) transformation descriptor:
	     o {
	     o     string (string) transform string,
	     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
	     o     localMatrix (Matrix) matrix of transformations applied only to the element,
	     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
	     o     global (string) global transformation as string,
	     o     local (string) local transformation as string,
	     o     toString (function) returns `string` property
	     o }
	    \*/
	    elproto.transform = function (tstr) {
	        var _ = this._;
	        if (tstr == null) {
	            var papa = this,
	                global = new Snap.Matrix(this.node.getCTM()),
	                local = extractTransform(this),
	                ms = [local],
	                m = new Snap.Matrix,
	                i,
	                localString = local.toTransformString(),
	                string = Str(local) == Str(this.matrix) ?
	                            Str(_.transform) : localString;
	            while (papa.type != "svg" && (papa = papa.parent())) {
	                ms.push(extractTransform(papa));
	            }
	            i = ms.length;
	            while (i--) {
	                m.add(ms[i]);
	            }
	            return {
	                string: string,
	                globalMatrix: global,
	                totalMatrix: m,
	                localMatrix: local,
	                diffMatrix: global.clone().add(local.invert()),
	                global: global.toTransformString(),
	                total: m.toTransformString(),
	                local: localString,
	                toString: propString
	            };
	        }
	        if (tstr instanceof Snap.Matrix) {
	            this.matrix = tstr;
	            this._.transform = tstr.toTransformString();
	        } else {
	            extractTransform(this, tstr);
	        }
	
	        if (this.node) {
	            if (this.type == "linearGradient" || this.type == "radialGradient") {
	                $(this.node, {gradientTransform: this.matrix});
	            } else if (this.type == "pattern") {
	                $(this.node, {patternTransform: this.matrix});
	            } else {
	                $(this.node, {transform: this.matrix});
	            }
	        }
	
	        return this;
	    };
	    /*\
	     * Element.parent
	     [ method ]
	     **
	     * Returns the element's parent
	     **
	     = (Element) the parent element
	    \*/
	    elproto.parent = function () {
	        return wrap(this.node.parentNode);
	    };
	    /*\
	     * Element.append
	     [ method ]
	     **
	     * Appends the given element to current one
	     **
	     - el (Element|Set) element to append
	     = (Element) the parent element
	    \*/
	    /*\
	     * Element.add
	     [ method ]
	     **
	     * See @Element.append
	    \*/
	    elproto.append = elproto.add = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this;
	                el.forEach(function (el) {
	                    it.add(el);
	                });
	                return this;
	            }
	            el = wrap(el);
	            this.node.appendChild(el.node);
	            el.paper = this.paper;
	        }
	        return this;
	    };
	    /*\
	     * Element.appendTo
	     [ method ]
	     **
	     * Appends the current element to the given one
	     **
	     - el (Element) parent element to append to
	     = (Element) the child element
	    \*/
	    elproto.appendTo = function (el) {
	        if (el) {
	            el = wrap(el);
	            el.append(this);
	        }
	        return this;
	    };
	    /*\
	     * Element.prepend
	     [ method ]
	     **
	     * Prepends the given element to the current one
	     **
	     - el (Element) element to prepend
	     = (Element) the parent element
	    \*/
	    elproto.prepend = function (el) {
	        if (el) {
	            if (el.type == "set") {
	                var it = this,
	                    first;
	                el.forEach(function (el) {
	                    if (first) {
	                        first.after(el);
	                    } else {
	                        it.prepend(el);
	                    }
	                    first = el;
	                });
	                return this;
	            }
	            el = wrap(el);
	            var parent = el.parent();
	            this.node.insertBefore(el.node, this.node.firstChild);
	            this.add && this.add();
	            el.paper = this.paper;
	            this.parent() && this.parent().add();
	            parent && parent.add();
	        }
	        return this;
	    };
	    /*\
	     * Element.prependTo
	     [ method ]
	     **
	     * Prepends the current element to the given one
	     **
	     - el (Element) parent element to prepend to
	     = (Element) the child element
	    \*/
	    elproto.prependTo = function (el) {
	        el = wrap(el);
	        el.prepend(this);
	        return this;
	    };
	    /*\
	     * Element.before
	     [ method ]
	     **
	     * Inserts given element before the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.before = function (el) {
	        if (el.type == "set") {
	            var it = this;
	            el.forEach(function (el) {
	                var parent = el.parent();
	                it.node.parentNode.insertBefore(el.node, it.node);
	                parent && parent.add();
	            });
	            this.parent().add();
	            return this;
	        }
	        el = wrap(el);
	        var parent = el.parent();
	        this.node.parentNode.insertBefore(el.node, this.node);
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.after
	     [ method ]
	     **
	     * Inserts given element after the current one
	     **
	     - el (Element) element to insert
	     = (Element) the parent element
	    \*/
	    elproto.after = function (el) {
	        el = wrap(el);
	        var parent = el.parent();
	        if (this.node.nextSibling) {
	            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
	        } else {
	            this.node.parentNode.appendChild(el.node);
	        }
	        this.parent() && this.parent().add();
	        parent && parent.add();
	        el.paper = this.paper;
	        return this;
	    };
	    /*\
	     * Element.insertBefore
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertBefore = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.insertAfter
	     [ method ]
	     **
	     * Inserts the element after the given one
	     **
	     - el (Element) element next to whom insert to
	     = (Element) the parent element
	    \*/
	    elproto.insertAfter = function (el) {
	        el = wrap(el);
	        var parent = this.parent();
	        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
	        this.paper = el.paper;
	        parent && parent.add();
	        el.parent() && el.parent().add();
	        return this;
	    };
	    /*\
	     * Element.remove
	     [ method ]
	     **
	     * Removes element from the DOM
	     = (Element) the detached element
	    \*/
	    elproto.remove = function () {
	        var parent = this.parent();
	        this.node.parentNode && this.node.parentNode.removeChild(this.node);
	        delete this.paper;
	        this.removed = true;
	        parent && parent.add();
	        return this;
	    };
	    /*\
	     * Element.select
	     [ method ]
	     **
	     * Gathers the nested @Element matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Element) result of query selection
	    \*/
	    elproto.select = function (query) {
	        return wrap(this.node.querySelector(query));
	    };
	    /*\
	     * Element.selectAll
	     [ method ]
	     **
	     * Gathers nested @Element objects matching the given set of CSS selectors
	     **
	     - query (string) CSS selector
	     = (Set|array) result of query selection
	    \*/
	    elproto.selectAll = function (query) {
	        var nodelist = this.node.querySelectorAll(query),
	            set = (Snap.set || Array)();
	        for (var i = 0; i < nodelist.length; i++) {
	            set.push(wrap(nodelist[i]));
	        }
	        return set;
	    };
	    /*\
	     * Element.asPX
	     [ method ]
	     **
	     * Returns given attribute of the element as a `px` value (not %, em, etc.)
	     **
	     - attr (string) attribute name
	     - value (string) #optional attribute value
	     = (Element) result of query selection
	    \*/
	    elproto.asPX = function (attr, value) {
	        if (value == null) {
	            value = this.attr(attr);
	        }
	        return +unit2px(this, attr, value);
	    };
	    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
	    /*\
	     * Element.use
	     [ method ]
	     **
	     * Creates a `<use>` element linked to the current element
	     **
	     = (Element) the `<use>` element
	    \*/
	    elproto.use = function () {
	        var use,
	            id = this.node.id;
	        if (!id) {
	            id = this.id;
	            $(this.node, {
	                id: id
	            });
	        }
	        if (this.type == "linearGradient" || this.type == "radialGradient" ||
	            this.type == "pattern") {
	            use = make(this.type, this.node.parentNode);
	        } else {
	            use = make("use", this.node.parentNode);
	        }
	        $(use.node, {
	            "xlink:href": "#" + id
	        });
	        use.original = this;
	        return use;
	    };
	    function fixids(el) {
	        var els = el.selectAll("*"),
	            it,
	            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
	            ids = [],
	            uses = {};
	        function urltest(it, name) {
	            var val = $(it.node, name);
	            val = val && val.match(url);
	            val = val && val[2];
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    var attr = {};
	                    attr[name] = Snap.url(id);
	                    $(it.node, attr);
	                });
	            }
	        }
	        function linktest(it) {
	            var val = $(it.node, "xlink:href");
	            if (val && val.charAt() == "#") {
	                val = val.substring(1);
	            } else {
	                return;
	            }
	            if (val) {
	                uses[val] = (uses[val] || []).concat(function (id) {
	                    it.attr("xlink:href", "#" + id);
	                });
	            }
	        }
	        for (var i = 0, ii = els.length; i < ii; i++) {
	            it = els[i];
	            urltest(it, "fill");
	            urltest(it, "stroke");
	            urltest(it, "filter");
	            urltest(it, "mask");
	            urltest(it, "clip-path");
	            linktest(it);
	            var oldid = $(it.node, "id");
	            if (oldid) {
	                $(it.node, {id: it.id});
	                ids.push({
	                    old: oldid,
	                    id: it.id
	                });
	            }
	        }
	        for (i = 0, ii = ids.length; i < ii; i++) {
	            var fs = uses[ids[i].old];
	            if (fs) {
	                for (var j = 0, jj = fs.length; j < jj; j++) {
	                    fs[j](ids[i].id);
	                }
	            }
	        }
	    }
	    /*\
	     * Element.clone
	     [ method ]
	     **
	     * Creates a clone of the element and inserts it after the element
	     **
	     = (Element) the clone
	    \*/
	    elproto.clone = function () {
	        var clone = wrap(this.node.cloneNode(true));
	        if ($(clone.node, "id")) {
	            $(clone.node, {id: clone.id});
	        }
	        fixids(clone);
	        clone.insertAfter(this);
	        return clone;
	    };
	    /*\
	     * Element.toDefs
	     [ method ]
	     **
	     * Moves element to the shared `<defs>` area
	     **
	     = (Element) the element
	    \*/
	    elproto.toDefs = function () {
	        var defs = getSomeDefs(this);
	        defs.appendChild(this.node);
	        return this;
	    };
	    /*\
	     * Element.toPattern
	     [ method ]
	     **
	     * Creates a `<pattern>` element from the current element
	     **
	     * To create a pattern you have to specify the pattern rect:
	     - x (string|number)
	     - y (string|number)
	     - width (string|number)
	     - height (string|number)
	     = (Element) the `<pattern>` element
	     * You can use pattern later on as an argument for `fill` attribute:
	     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
	     |         fill: "none",
	     |         stroke: "#bada55",
	     |         strokeWidth: 5
	     |     }).pattern(0, 0, 10, 10),
	     |     c = paper.circle(200, 200, 100);
	     | c.attr({
	     |     fill: p
	     | });
	    \*/
	    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
	        var p = make("pattern", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        $(p.node, {
	            x: x,
	            y: y,
	            width: width,
	            height: height,
	            patternUnits: "userSpaceOnUse",
	            id: p.id,
	            viewBox: [x, y, width, height].join(" ")
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
	// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
	    /*\
	     * Element.marker
	     [ method ]
	     **
	     * Creates a `<marker>` element from the current element
	     **
	     * To create a marker you have to specify the bounding rect and reference point:
	     - x (number)
	     - y (number)
	     - width (number)
	     - height (number)
	     - refX (number)
	     - refY (number)
	     = (Element) the `<marker>` element
	     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
	    \*/
	    // TODO add usage for markers
	    elproto.marker = function (x, y, width, height, refX, refY) {
	        var p = make("marker", getSomeDefs(this));
	        if (x == null) {
	            x = this.getBBox();
	        }
	        if (is(x, "object") && "x" in x) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            refX = x.refX || x.cx;
	            refY = x.refY || x.cy;
	            x = x.x;
	        }
	        $(p.node, {
	            viewBox: [x, y, width, height].join(" "),
	            markerWidth: width,
	            markerHeight: height,
	            orient: "auto",
	            refX: refX || 0,
	            refY: refY || 0,
	            id: p.id
	        });
	        p.node.appendChild(this.node);
	        return p;
	    };
	    var eldata = {};
	    /*\
	     * Element.data
	     [ method ]
	     **
	     * Adds or retrieves given value associated with given key. (Don’t confuse
	     * with `data-` attributes)
	     *
	     * See also @Element.removeData
	     - key (string) key to store data
	     - value (any) #optional value to store
	     = (object) @Element
	     * or, if value is not specified:
	     = (any) value
	     > Usage
	     | for (var i = 0, i < 5, i++) {
	     |     paper.circle(10 + 15 * i, 10, 10)
	     |          .attr({fill: "#000"})
	     |          .data("i", i)
	     |          .click(function () {
	     |             alert(this.data("i"));
	     |          });
	     | }
	    \*/
	    elproto.data = function (key, value) {
	        var data = eldata[this.id] = eldata[this.id] || {};
	        if (arguments.length == 0){
	            eve("snap.data.get." + this.id, this, data, null);
	            return data;
	        }
	        if (arguments.length == 1) {
	            if (Snap.is(key, "object")) {
	                for (var i in key) if (key[has](i)) {
	                    this.data(i, key[i]);
	                }
	                return this;
	            }
	            eve("snap.data.get." + this.id, this, data[key], key);
	            return data[key];
	        }
	        data[key] = value;
	        eve("snap.data.set." + this.id, this, value, key);
	        return this;
	    };
	    /*\
	     * Element.removeData
	     [ method ]
	     **
	     * Removes value associated with an element by given key.
	     * If key is not provided, removes all the data of the element.
	     - key (string) #optional key
	     = (object) @Element
	    \*/
	    elproto.removeData = function (key) {
	        if (key == null) {
	            eldata[this.id] = {};
	        } else {
	            eldata[this.id] && delete eldata[this.id][key];
	        }
	        return this;
	    };
	    /*\
	     * Element.outerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
	     *
	     * See also @Element.innerSVG
	     = (string) SVG code for the element
	    \*/
	    /*\
	     * Element.toString
	     [ method ]
	     **
	     * See @Element.outerSVG
	    \*/
	    elproto.outerSVG = elproto.toString = toString(1);
	    /*\
	     * Element.innerSVG
	     [ method ]
	     **
	     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
	     = (string) SVG code for the element
	    \*/
	    elproto.innerSVG = toString();
	    function toString(type) {
	        return function () {
	            var res = type ? "<" + this.type : "",
	                attr = this.node.attributes,
	                chld = this.node.childNodes;
	            if (type) {
	                for (var i = 0, ii = attr.length; i < ii; i++) {
	                    res += " " + attr[i].name + '="' +
	                            attr[i].value.replace(/"/g, '\\"') + '"';
	                }
	            }
	            if (chld.length) {
	                type && (res += ">");
	                for (i = 0, ii = chld.length; i < ii; i++) {
	                    if (chld[i].nodeType == 3) {
	                        res += chld[i].nodeValue;
	                    } else if (chld[i].nodeType == 1) {
	                        res += wrap(chld[i]).toString();
	                    }
	                }
	                type && (res += "</" + this.type + ">");
	            } else {
	                type && (res += "/>");
	            }
	            return res;
	        };
	    }
	    elproto.toDataURL = function () {
	        if (window && window.btoa) {
	            var bb = this.getBBox(),
	                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
	                x: +bb.x.toFixed(3),
	                y: +bb.y.toFixed(3),
	                width: +bb.width.toFixed(3),
	                height: +bb.height.toFixed(3),
	                contents: this.outerSVG()
	            });
	            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
	        }
	    };
	    /*\
	     * Fragment.select
	     [ method ]
	     **
	     * See @Element.select
	    \*/
	    Fragment.prototype.select = elproto.select;
	    /*\
	     * Fragment.selectAll
	     [ method ]
	     **
	     * See @Element.selectAll
	    \*/
	    Fragment.prototype.selectAll = elproto.selectAll;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var objectToString = Object.prototype.toString,
	        Str = String,
	        math = Math,
	        E = "";
	    function Matrix(a, b, c, d, e, f) {
	        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
	            this.a = a.a;
	            this.b = a.b;
	            this.c = a.c;
	            this.d = a.d;
	            this.e = a.e;
	            this.f = a.f;
	            return;
	        }
	        if (a != null) {
	            this.a = +a;
	            this.b = +b;
	            this.c = +c;
	            this.d = +d;
	            this.e = +e;
	            this.f = +f;
	        } else {
	            this.a = 1;
	            this.b = 0;
	            this.c = 0;
	            this.d = 1;
	            this.e = 0;
	            this.f = 0;
	        }
	    }
	    (function (matrixproto) {
	        /*\
	         * Matrix.add
	         [ method ]
	         **
	         * Adds the given matrix to existing one
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        matrixproto.add = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + b * this.c,
	                bNew = a * this.b + b * this.d;
	            this.e += e * this.a + f * this.c;
	            this.f += e * this.b + f * this.d;
	            this.c = c * this.a + d * this.c;
	            this.d = c * this.b + d * this.d;
	
	            this.a = aNew;
	            this.b = bNew;
	            return this;
	        };
	        /*\
	         * Matrix.multLeft
	         [ method ]
	         **
	         * Multiplies a passed affine transform to the left: M * this.
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         * or
	         - matrix (object) @Matrix
	        \*/
	        Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
	            if (a && a instanceof Matrix) {
	                return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
	            }
	            var aNew = a * this.a + c * this.b,
	                cNew = a * this.c + c * this.d,
	                eNew = a * this.e + c * this.f + e;
	            this.b = b * this.a + d * this.b;
	            this.d = b * this.c + d * this.d;
	            this.f = b * this.e + d * this.f + f;
	
	            this.a = aNew;
	            this.c = cNew;
	            this.e = eNew;
	            return this;
	        };
	        /*\
	         * Matrix.invert
	         [ method ]
	         **
	         * Returns an inverted version of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.invert = function () {
	            var me = this,
	                x = me.a * me.d - me.b * me.c;
	            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
	        };
	        /*\
	         * Matrix.clone
	         [ method ]
	         **
	         * Returns a copy of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.clone = function () {
	            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	        };
	        /*\
	         * Matrix.translate
	         [ method ]
	         **
	         * Translate the matrix
	         - x (number) horizontal offset distance
	         - y (number) vertical offset distance
	        \*/
	        matrixproto.translate = function (x, y) {
	            this.e += x * this.a + y * this.c;
	            this.f += x * this.b + y * this.d;
	            return this;
	        };
	        /*\
	         * Matrix.scale
	         [ method ]
	         **
	         * Scales the matrix
	         - x (number) amount to be scaled, with `1` resulting in no change
	         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
	         - cx (number) #optional horizontal origin point from which to scale
	         - cy (number) #optional vertical origin point from which to scale
	         * Default cx, cy is the middle point of the element.
	        \*/
	        matrixproto.scale = function (x, y, cx, cy) {
	            y == null && (y = x);
	            (cx || cy) && this.translate(cx, cy);
	            this.a *= x;
	            this.b *= x;
	            this.c *= y;
	            this.d *= y;
	            (cx || cy) && this.translate(-cx, -cy);
	            return this;
	        };
	        /*\
	         * Matrix.rotate
	         [ method ]
	         **
	         * Rotates the matrix
	         - a (number) angle of rotation, in degrees
	         - x (number) horizontal origin point from which to rotate
	         - y (number) vertical origin point from which to rotate
	        \*/
	        matrixproto.rotate = function (a, x, y) {
	            a = Snap.rad(a);
	            x = x || 0;
	            y = y || 0;
	            var cos = +math.cos(a).toFixed(9),
	                sin = +math.sin(a).toFixed(9);
	            this.add(cos, sin, -sin, cos, x, y);
	            return this.add(1, 0, 0, 1, -x, -y);
	        };
	        /*\
	         * Matrix.skewX
	         [ method ]
	         **
	         * Skews the matrix along the x-axis
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skewX = function (x) {
	            return this.skew(x, 0);
	        };
	        /*\
	         * Matrix.skewY
	         [ method ]
	         **
	         * Skews the matrix along the y-axis
	         - y (number) Angle to skew along the y-axis (in degrees).
	        \*/
	        matrixproto.skewY = function (y) {
	            return this.skew(0, y);
	        };
	        /*\
	         * Matrix.skew
	         [ method ]
	         **
	         * Skews the matrix
	         - y (number) Angle to skew along the y-axis (in degrees).
	         - x (number) Angle to skew along the x-axis (in degrees).
	        \*/
	        matrixproto.skew = function (x, y) {
	            x = x || 0;
	            y = y || 0;
	            x = Snap.rad(x);
	            y = Snap.rad(y);
	            var c = math.tan(x).toFixed(9);
	            var b = math.tan(y).toFixed(9);
	            return this.add(1, b, c, 1, 0, 0);
	        };
	        /*\
	         * Matrix.x
	         [ method ]
	         **
	         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
	         - x (number)
	         - y (number)
	         = (number) x
	        \*/
	        matrixproto.x = function (x, y) {
	            return x * this.a + y * this.c + this.e;
	        };
	        /*\
	         * Matrix.y
	         [ method ]
	         **
	         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
	         - x (number)
	         - y (number)
	         = (number) y
	        \*/
	        matrixproto.y = function (x, y) {
	            return x * this.b + y * this.d + this.f;
	        };
	        matrixproto.get = function (i) {
	            return +this[Str.fromCharCode(97 + i)].toFixed(4);
	        };
	        matrixproto.toString = function () {
	            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
	        };
	        matrixproto.offset = function () {
	            return [this.e.toFixed(4), this.f.toFixed(4)];
	        };
	        function norm(a) {
	            return a[0] * a[0] + a[1] * a[1];
	        }
	        function normalize(a) {
	            var mag = math.sqrt(norm(a));
	            a[0] && (a[0] /= mag);
	            a[1] && (a[1] /= mag);
	        }
	        /*\
	         * Matrix.determinant
	         [ method ]
	         **
	         * Finds determinant of the given matrix.
	         = (number) determinant
	        \*/
	        matrixproto.determinant = function () {
	            return this.a * this.d - this.b * this.c;
	        };
	        /*\
	         * Matrix.split
	         [ method ]
	         **
	         * Splits matrix into primitive transformations
	         = (object) in format:
	         o dx (number) translation by x
	         o dy (number) translation by y
	         o scalex (number) scale by x
	         o scaley (number) scale by y
	         o shear (number) shear
	         o rotate (number) rotation in deg
	         o isSimple (boolean) could it be represented via simple transformations
	        \*/
	        matrixproto.split = function () {
	            var out = {};
	            // translation
	            out.dx = this.e;
	            out.dy = this.f;
	
	            // scale and shear
	            var row = [[this.a, this.b], [this.c, this.d]];
	            out.scalex = math.sqrt(norm(row[0]));
	            normalize(row[0]);
	
	            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
	            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
	
	            out.scaley = math.sqrt(norm(row[1]));
	            normalize(row[1]);
	            out.shear /= out.scaley;
	
	            if (this.determinant() < 0) {
	                out.scalex = -out.scalex;
	            }
	
	            // rotation
	            var sin = row[0][1],
	                cos = row[1][1];
	            if (cos < 0) {
	                out.rotate = Snap.deg(math.acos(cos));
	                if (sin < 0) {
	                    out.rotate = 360 - out.rotate;
	                }
	            } else {
	                out.rotate = Snap.deg(math.asin(sin));
	            }
	
	            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
	            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
	            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
	            return out;
	        };
	        /*\
	         * Matrix.toTransformString
	         [ method ]
	         **
	         * Returns transform string that represents given matrix
	         = (string) transform string
	        \*/
	        matrixproto.toTransformString = function (shorter) {
	            var s = shorter || this.split();
	            if (!+s.shear.toFixed(9)) {
	                s.scalex = +s.scalex.toFixed(4);
	                s.scaley = +s.scaley.toFixed(4);
	                s.rotate = +s.rotate.toFixed(4);
	                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
	                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) +
	                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
	            } else {
	                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
	            }
	        };
	    })(Matrix.prototype);
	    /*\
	     * Snap.Matrix
	     [ method ]
	     **
	     * Matrix constructor, extend on your own risk.
	     * To create matrices use @Snap.matrix.
	    \*/
	    Snap.Matrix = Matrix;
	    /*\
	     * Snap.matrix
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns a matrix based on the given parameters
	     - a (number)
	     - b (number)
	     - c (number)
	     - d (number)
	     - e (number)
	     - f (number)
	     * or
	     - svgMatrix (SVGMatrix)
	     = (object) @Matrix
	    \*/
	    Snap.matrix = function (a, b, c, d, e, f) {
	        return new Matrix(a, b, c, d, e, f);
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var has = "hasOwnProperty",
	        make = Snap._.make,
	        wrap = Snap._.wrap,
	        is = Snap.is,
	        getSomeDefs = Snap._.getSomeDefs,
	        reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
	        $ = Snap._.$,
	        URL = Snap.url,
	        Str = String,
	        separator = Snap._.separator,
	        E = "";
	    /*\
	     * Snap.deurl
	     [ method ]
	     **
	     * Unwraps path from `"url(<path>)"`.
	     - value (string) url path
	     = (string) unwrapped path
	    \*/
	    Snap.deurl = function (value) {
	        var res = String(value).match(reURLValue);
	        return res ? res[2] : value;
	    }
	    // Attributes event handlers
	    eve.on("snap.util.attr.mask", function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value.type == "mask") {
	                var mask = value;
	            } else {
	                mask = make("mask", getSomeDefs(this));
	                mask.node.appendChild(value.node);
	            }
	            !mask.node.id && $(mask.node, {
	                id: mask.id
	            });
	            $(this.node, {
	                mask: URL(mask.id)
	            });
	        }
	    });
	    (function (clipIt) {
	        eve.on("snap.util.attr.clip", clipIt);
	        eve.on("snap.util.attr.clip-path", clipIt);
	        eve.on("snap.util.attr.clipPath", clipIt);
	    }(function (value) {
	        if (value instanceof Element || value instanceof Fragment) {
	            eve.stop();
	            var clip,
	                node = value.node;
	            while (node) {
	                if (node.nodeName === "clipPath") {
	                    clip = new Element(node);
	                    break;
	                }
	                if (node.nodeName === "svg") {
	                    clip = undefined;
	                    break;
	                }
	                node = node.parentNode;
	            }
	            if (!clip) {
	                clip = make("clipPath", getSomeDefs(this));
	                clip.node.appendChild(value.node);
	                !clip.node.id && $(clip.node, {
	                    id: clip.id
	                });
	            }
	            $(this.node, {
	                "clip-path": URL(clip.node.id || clip.id)
	            });
	        }
	    }));
	    function fillStroke(name) {
	        return function (value) {
	            eve.stop();
	            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
	                (value.node.firstChild.tagName == "radialGradient" ||
	                value.node.firstChild.tagName == "linearGradient" ||
	                value.node.firstChild.tagName == "pattern")) {
	                value = value.node.firstChild;
	                getSomeDefs(this).appendChild(value);
	                value = wrap(value);
	            }
	            if (value instanceof Element) {
	                if (value.type == "radialGradient" || value.type == "linearGradient"
	                   || value.type == "pattern") {
	                    if (!value.node.id) {
	                        $(value.node, {
	                            id: value.id
	                        });
	                    }
	                    var fill = URL(value.node.id);
	                } else {
	                    fill = value.attr(name);
	                }
	            } else {
	                fill = Snap.color(value);
	                if (fill.error) {
	                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
	                    if (grad) {
	                        if (!grad.node.id) {
	                            $(grad.node, {
	                                id: grad.id
	                            });
	                        }
	                        fill = URL(grad.node.id);
	                    } else {
	                        fill = value;
	                    }
	                } else {
	                    fill = Str(fill);
	                }
	            }
	            var attrs = {};
	            attrs[name] = fill;
	            $(this.node, attrs);
	            this.node.style[name] = E;
	        };
	    }
	    eve.on("snap.util.attr.fill", fillStroke("fill"));
	    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
	    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
	    eve.on("snap.util.grad.parse", function parseGrad(string) {
	        string = Str(string);
	        var tokens = string.match(gradrg);
	        if (!tokens) {
	            return null;
	        }
	        var type = tokens[1],
	            params = tokens[2],
	            stops = tokens[3];
	        params = params.split(/\s*,\s*/).map(function (el) {
	            return +el == el ? +el : el;
	        });
	        if (params.length == 1 && params[0] == 0) {
	            params = [];
	        }
	        stops = stops.split("-");
	        stops = stops.map(function (el) {
	            el = el.split(":");
	            var out = {
	                color: el[0]
	            };
	            if (el[1]) {
	                out.offset = parseFloat(el[1]);
	            }
	            return out;
	        });
	        var len = stops.length,
	            start = 0,
	            j = 0;
	        function seed(i, end) {
	            var step = (end - start) / (i - j);
	            for (var k = j; k < i; k++) {
	                stops[k].offset = +(+start + step * (k - j)).toFixed(2);
	            }
	            j = i;
	            start = end;
	        }
	        len--;
	        for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
	            seed(i, stops[i].offset);
	        }
	        stops[len].offset = stops[len].offset || 100;
	        seed(len, stops[len].offset);
	        return {
	            type: type,
	            params: params,
	            stops: stops
	        };
	    });
	
	    eve.on("snap.util.attr.d", function (value) {
	        eve.stop();
	        if (is(value, "array") && is(value[0], "array")) {
	            value = Snap.path.toString.call(value);
	        }
	        value = Str(value);
	        if (value.match(/[ruo]/i)) {
	            value = Snap.path.toAbsolute(value);
	        }
	        $(this.node, {d: value});
	    })(-1);
	    eve.on("snap.util.attr.#text", function (value) {
	        eve.stop();
	        value = Str(value);
	        var txt = glob.doc.createTextNode(value);
	        while (this.node.firstChild) {
	            this.node.removeChild(this.node.firstChild);
	        }
	        this.node.appendChild(txt);
	    })(-1);
	    eve.on("snap.util.attr.path", function (value) {
	        eve.stop();
	        this.attr({d: value});
	    })(-1);
	    eve.on("snap.util.attr.class", function (value) {
	        eve.stop();
	        this.node.className.baseVal = value;
	    })(-1);
	    eve.on("snap.util.attr.viewBox", function (value) {
	        var vb;
	        if (is(value, "object") && "x" in value) {
	            vb = [value.x, value.y, value.width, value.height].join(" ");
	        } else if (is(value, "array")) {
	            vb = value.join(" ");
	        } else {
	            vb = value;
	        }
	        $(this.node, {
	            viewBox: vb
	        });
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.transform", function (value) {
	        this.transform(value);
	        eve.stop();
	    })(-1);
	    eve.on("snap.util.attr.r", function (value) {
	        if (this.type == "rect") {
	            eve.stop();
	            $(this.node, {
	                rx: value,
	                ry: value
	            });
	        }
	    })(-1);
	    eve.on("snap.util.attr.textpath", function (value) {
	        eve.stop();
	        if (this.type == "text") {
	            var id, tp, node;
	            if (!value && this.textPath) {
	                tp = this.textPath;
	                while (tp.node.firstChild) {
	                    this.node.appendChild(tp.node.firstChild);
	                }
	                tp.remove();
	                delete this.textPath;
	                return;
	            }
	            if (is(value, "string")) {
	                var defs = getSomeDefs(this),
	                    path = wrap(defs.parentNode).path(value);
	                defs.appendChild(path.node);
	                id = path.id;
	                path.attr({id: id});
	            } else {
	                value = wrap(value);
	                if (value instanceof Element) {
	                    id = value.attr("id");
	                    if (!id) {
	                        id = value.id;
	                        value.attr({id: id});
	                    }
	                }
	            }
	            if (id) {
	                tp = this.textPath;
	                node = this.node;
	                if (tp) {
	                    tp.attr({"xlink:href": "#" + id});
	                } else {
	                    tp = $("textPath", {
	                        "xlink:href": "#" + id
	                    });
	                    while (node.firstChild) {
	                        tp.appendChild(node.firstChild);
	                    }
	                    node.appendChild(tp);
	                    this.textPath = wrap(tp);
	                }
	            }
	        }
	    })(-1);
	    eve.on("snap.util.attr.text", function (value) {
	        if (this.type == "text") {
	            var i = 0,
	                node = this.node,
	                tuner = function (chunk) {
	                    var out = $("tspan");
	                    if (is(chunk, "array")) {
	                        for (var i = 0; i < chunk.length; i++) {
	                            out.appendChild(tuner(chunk[i]));
	                        }
	                    } else {
	                        out.appendChild(glob.doc.createTextNode(chunk));
	                    }
	                    out.normalize && out.normalize();
	                    return out;
	                };
	            while (node.firstChild) {
	                node.removeChild(node.firstChild);
	            }
	            var tuned = tuner(value);
	            while (tuned.firstChild) {
	                node.appendChild(tuned.firstChild);
	            }
	        }
	        eve.stop();
	    })(-1);
	    function setFontSize(value) {
	        eve.stop();
	        if (value == +value) {
	            value += "px";
	        }
	        this.node.style.fontSize = value;
	    }
	    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
	    eve.on("snap.util.attr.font-size", setFontSize)(-1);
	
	
	    eve.on("snap.util.getattr.transform", function () {
	        eve.stop();
	        return this.transform();
	    })(-1);
	    eve.on("snap.util.getattr.textpath", function () {
	        eve.stop();
	        return this.textPath;
	    })(-1);
	    // Markers
	    (function () {
	        function getter(end) {
	            return function () {
	                eve.stop();
	                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
	                if (style == "none") {
	                    return style;
	                } else {
	                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
	                }
	            };
	        }
	        function setter(end) {
	            return function (value) {
	                eve.stop();
	                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
	                if (value == "" || !value) {
	                    this.node.style[name] = "none";
	                    return;
	                }
	                if (value.type == "marker") {
	                    var id = value.node.id;
	                    if (!id) {
	                        $(value.node, {id: value.id});
	                    }
	                    this.node.style[name] = URL(id);
	                    return;
	                }
	            };
	        }
	        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
	        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
	        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
	        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
	        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
	        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
	        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
	        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
	        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
	        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
	        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
	        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
	    }());
	    eve.on("snap.util.getattr.r", function () {
	        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
	            eve.stop();
	            return $(this.node, "rx");
	        }
	    })(-1);
	    function textExtract(node) {
	        var out = [];
	        var children = node.childNodes;
	        for (var i = 0, ii = children.length; i < ii; i++) {
	            var chi = children[i];
	            if (chi.nodeType == 3) {
	                out.push(chi.nodeValue);
	            }
	            if (chi.tagName == "tspan") {
	                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
	                    out.push(chi.firstChild.nodeValue);
	                } else {
	                    out.push(textExtract(chi));
	                }
	            }
	        }
	        return out;
	    }
	    eve.on("snap.util.getattr.text", function () {
	        if (this.type == "text" || this.type == "tspan") {
	            eve.stop();
	            var out = textExtract(this.node);
	            return out.length == 1 ? out[0] : out;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.#text", function () {
	        return this.node.textContent;
	    })(-1);
	    eve.on("snap.util.getattr.fill", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.stroke", function (internal) {
	        if (internal) {
	            return;
	        }
	        eve.stop();
	        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
	        return Snap(Snap.deurl(value)) || value;
	    })(-1);
	    eve.on("snap.util.getattr.viewBox", function () {
	        eve.stop();
	        var vb = $(this.node, "viewBox");
	        if (vb) {
	            vb = vb.split(separator);
	            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.points", function () {
	        var p = $(this.node, "points");
	        eve.stop();
	        if (p) {
	            return p.split(separator);
	        } else {
	            return;
	        }
	    })(-1);
	    eve.on("snap.util.getattr.path", function () {
	        var p = $(this.node, "d");
	        eve.stop();
	        return p;
	    })(-1);
	    eve.on("snap.util.getattr.class", function () {
	        return this.node.className.baseVal;
	    })(-1);
	    function getFontSize() {
	        eve.stop();
	        return this.node.style.fontSize;
	    }
	    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
	    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var rgNotSpace = /\S+/g,
	        rgBadSpace = /[\t\r\n\f]/g,
	        rgTrim = /(^\s+|\s+$)/g,
	        Str = String,
	        elproto = Element.prototype;
	    /*\
	     * Element.addClass
	     [ method ]
	     **
	     * Adds given class name or list of class names to the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.addClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	
	        if (classes.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (!~pos) {
	                    curClasses.push(clazz);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.removeClass
	     [ method ]
	     **
	     * Removes given class name or list of class names from the element.
	     - value (string) class name or space separated list of class names
	     **
	     = (Element) original element.
	    \*/
	    elproto.removeClass = function (value) {
	        var classes = Str(value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        if (curClasses.length) {
	            j = 0;
	            while (clazz = classes[j++]) {
	                pos = curClasses.indexOf(clazz);
	                if (~pos) {
	                    curClasses.splice(pos, 1);
	                }
	            }
	
	            finalValue = curClasses.join(" ");
	            if (className != finalValue) {
	                elem.className.baseVal = finalValue;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.hasClass
	     [ method ]
	     **
	     * Checks if the element has a given class name in the list of class names applied to it.
	     - value (string) class name
	     **
	     = (boolean) `true` if the element has given class
	    \*/
	    elproto.hasClass = function (value) {
	        var elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [];
	        return !!~curClasses.indexOf(value);
	    };
	    /*\
	     * Element.toggleClass
	     [ method ]
	     **
	     * Add or remove one or more classes from the element, depending on either
	     * the class’s presence or the value of the `flag` argument.
	     - value (string) class name or space separated list of class names
	     - flag (boolean) value to determine whether the class should be added or removed
	     **
	     = (Element) original element.
	    \*/
	    elproto.toggleClass = function (value, flag) {
	        if (flag != null) {
	            if (flag) {
	                return this.addClass(value);
	            } else {
	                return this.removeClass(value);
	            }
	        }
	        var classes = (value || "").match(rgNotSpace) || [],
	            elem = this.node,
	            className = elem.className.baseVal,
	            curClasses = className.match(rgNotSpace) || [],
	            j,
	            pos,
	            clazz,
	            finalValue;
	        j = 0;
	        while (clazz = classes[j++]) {
	            pos = curClasses.indexOf(clazz);
	            if (~pos) {
	                curClasses.splice(pos, 1);
	            } else {
	                curClasses.push(clazz);
	            }
	        }
	
	        finalValue = curClasses.join(" ");
	        if (className != finalValue) {
	            elem.className.baseVal = finalValue;
	        }
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var operators = {
	            "+": function (x, y) {
	                    return x + y;
	                },
	            "-": function (x, y) {
	                    return x - y;
	                },
	            "/": function (x, y) {
	                    return x / y;
	                },
	            "*": function (x, y) {
	                    return x * y;
	                }
	        },
	        Str = String,
	        reUnit = /[a-z]+$/i,
	        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    eve.on("snap.util.attr", function (val) {
	        var plus = Str(val).match(reAddon);
	        if (plus) {
	            var evnt = eve.nt(),
	                name = evnt.substring(evnt.lastIndexOf(".") + 1),
	                a = this.attr(name),
	                atr = {};
	            eve.stop();
	            var unit = plus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[plus[1]];
	            if (aUnit && aUnit == unit) {
	                val = op(parseFloat(a), +plus[2]);
	            } else {
	                a = this.asPX(name);
	                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
	            }
	            if (isNaN(a) || isNaN(val)) {
	                return;
	            }
	            atr[name] = val;
	            this.attr(atr);
	        }
	    })(-10);
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this,
	            bplus = Str(b).match(reAddon);
	        if (bplus) {
	            eve.stop();
	            var unit = bplus[3] || "",
	                aUnit = a.match(reUnit),
	                op = operators[bplus[1]];
	            if (aUnit && aUnit == unit) {
	                return {
	                    from: parseFloat(a),
	                    to: op(parseFloat(a), +bplus[2]),
	                    f: getUnit(aUnit)
	                };
	            } else {
	                a = this.asPX(name);
	                return {
	                    from: a,
	                    to: op(a, this.asPX(name, bplus[2] + unit)),
	                    f: getNumber
	                };
	            }
	        }
	    })(-10);
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var proto = Paper.prototype,
	        is = Snap.is;
	    /*\
	     * Paper.rect
	     [ method ]
	     *
	     * Draws a rectangle
	     **
	     - x (number) x coordinate of the top left corner
	     - y (number) y coordinate of the top left corner
	     - width (number) width
	     - height (number) height
	     - rx (number) #optional horizontal radius for rounded corners, default is 0
	     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
	     = (object) the `rect` element
	     **
	     > Usage
	     | // regular rectangle
	     | var c = paper.rect(10, 10, 50, 50);
	     | // rectangle with rounded corners
	     | var c = paper.rect(40, 40, 50, 50, 10);
	    \*/
	    proto.rect = function (x, y, w, h, rx, ry) {
	        var attr;
	        if (ry == null) {
	            ry = rx;
	        }
	        if (is(x, "object") && x == "[object Object]") {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                width: w,
	                height: h
	            };
	            if (rx != null) {
	                attr.rx = rx;
	                attr.ry = ry;
	            }
	        }
	        return this.el("rect", attr);
	    };
	    /*\
	     * Paper.circle
	     [ method ]
	     **
	     * Draws a circle
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - r (number) radius
	     = (object) the `circle` element
	     **
	     > Usage
	     | var c = paper.circle(50, 50, 40);
	    \*/
	    proto.circle = function (cx, cy, r) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr = {
	                cx: cx,
	                cy: cy,
	                r: r
	            };
	        }
	        return this.el("circle", attr);
	    };
	
	    var preload = (function () {
	        function onerror() {
	            this.parentNode.removeChild(this);
	        }
	        return function (src, f) {
	            var img = glob.doc.createElement("img"),
	                body = glob.doc.body;
	            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
	            img.onload = function () {
	                f.call(img);
	                img.onload = img.onerror = null;
	                body.removeChild(img);
	            };
	            img.onerror = onerror;
	            body.appendChild(img);
	            img.src = src;
	        };
	    }());
	
	    /*\
	     * Paper.image
	     [ method ]
	     **
	     * Places an image on the surface
	     **
	     - src (string) URI of the source image
	     - x (number) x offset position
	     - y (number) y offset position
	     - width (number) width of the image
	     - height (number) height of the image
	     = (object) the `image` element
	     * or
	     = (object) Snap element object with type `image`
	     **
	     > Usage
	     | var c = paper.image("apple.png", 10, 10, 80, 80);
	    \*/
	    proto.image = function (src, x, y, width, height) {
	        var el = this.el("image");
	        if (is(src, "object") && "src" in src) {
	            el.attr(src);
	        } else if (src != null) {
	            var set = {
	                "xlink:href": src,
	                preserveAspectRatio: "none"
	            };
	            if (x != null && y != null) {
	                set.x = x;
	                set.y = y;
	            }
	            if (width != null && height != null) {
	                set.width = width;
	                set.height = height;
	            } else {
	                preload(src, function () {
	                    Snap._.$(el.node, {
	                        width: this.offsetWidth,
	                        height: this.offsetHeight
	                    });
	                });
	            }
	            Snap._.$(el.node, set);
	        }
	        return el;
	    };
	    /*\
	     * Paper.ellipse
	     [ method ]
	     **
	     * Draws an ellipse
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - rx (number) horizontal radius
	     - ry (number) vertical radius
	     = (object) the `ellipse` element
	     **
	     > Usage
	     | var c = paper.ellipse(50, 50, 40, 20);
	    \*/
	    proto.ellipse = function (cx, cy, rx, ry) {
	        var attr;
	        if (is(cx, "object") && cx == "[object Object]") {
	            attr = cx;
	        } else if (cx != null) {
	            attr ={
	                cx: cx,
	                cy: cy,
	                rx: rx,
	                ry: ry
	            };
	        }
	        return this.el("ellipse", attr);
	    };
	    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
	    /*\
	     * Paper.path
	     [ method ]
	     **
	     * Creates a `<path>` element using the given string as the path's definition
	     - pathString (string) #optional path string in SVG format
	     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
	     | "M10,20L30,40"
	     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
	     *
	     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
	     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
	     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
	     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
	     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
	     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
	     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
	     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
	     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
	     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
	     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
	     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
	     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
	     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
	     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
	     > Usage
	     | var c = paper.path("M10 10L90 90");
	     | // draw a diagonal line:
	     | // move to 10,10, line to 90,90
	    \*/
	    proto.path = function (d) {
	        var attr;
	        if (is(d, "object") && !is(d, "array")) {
	            attr = d;
	        } else if (d) {
	            attr = {d: d};
	        }
	        return this.el("path", attr);
	    };
	    /*\
	     * Paper.g
	     [ method ]
	     **
	     * Creates a group element
	     **
	     - varargs (…) #optional elements to nest within the group
	     = (object) the `g` element
	     **
	     > Usage
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g(c2, c1); // note that the order of elements is different
	     * or
	     | var c1 = paper.circle(),
	     |     c2 = paper.rect(),
	     |     g = paper.g();
	     | g.add(c2, c1);
	    \*/
	    /*\
	     * Paper.group
	     [ method ]
	     **
	     * See @Paper.g
	    \*/
	    proto.group = proto.g = function (first) {
	        var attr,
	            el = this.el("g");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.svg
	     [ method ]
	     **
	     * Creates a nested SVG element.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `svg` element
	     **
	    \*/
	    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
	        var attrs = {};
	        if (is(x, "object") && y == null) {
	            attrs = x;
	        } else {
	            if (x != null) {
	                attrs.x = x;
	            }
	            if (y != null) {
	                attrs.y = y;
	            }
	            if (width != null) {
	                attrs.width = width;
	            }
	            if (height != null) {
	                attrs.height = height;
	            }
	            if (vbx != null && vby != null && vbw != null && vbh != null) {
	                attrs.viewBox = [vbx, vby, vbw, vbh];
	            }
	        }
	        return this.el("svg", attrs);
	    };
	    /*\
	     * Paper.mask
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a mask.
	     **
	     = (object) the `mask` element
	     **
	    \*/
	    proto.mask = function (first) {
	        var attr,
	            el = this.el("mask");
	        if (arguments.length == 1 && first && !first.type) {
	            el.attr(first);
	        } else if (arguments.length) {
	            el.add(Array.prototype.slice.call(arguments, 0));
	        }
	        return el;
	    };
	    /*\
	     * Paper.ptrn
	     [ method ]
	     **
	     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
	     - x (number) @optional X of the element
	     - y (number) @optional Y of the element
	     - width (number) @optional width of the element
	     - height (number) @optional height of the element
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     **
	     = (object) the `pattern` element
	     **
	    \*/
	    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
	        if (is(x, "object")) {
	            var attr = x;
	        } else {
	            attr = {patternUnits: "userSpaceOnUse"};
	            if (x) {
	                attr.x = x;
	            }
	            if (y) {
	                attr.y = y;
	            }
	            if (width != null) {
	                attr.width = width;
	            }
	            if (height != null) {
	                attr.height = height;
	            }
	            if (vx != null && vy != null && vw != null && vh != null) {
	                attr.viewBox = [vx, vy, vw, vh];
	            } else {
	                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
	            }
	        }
	        return this.el("pattern", attr);
	    };
	    /*\
	     * Paper.use
	     [ method ]
	     **
	     * Creates a <use> element.
	     - id (string) @optional id of element to link
	     * or
	     - id (Element) @optional element to link
	     **
	     = (object) the `use` element
	     **
	    \*/
	    proto.use = function (id) {
	        if (id != null) {
	            if (id instanceof Element) {
	                if (!id.attr("id")) {
	                    id.attr({id: Snap._.id(id)});
	                }
	                id = id.attr("id");
	            }
	            if (String(id).charAt() == "#") {
	                id = id.substring(1);
	            }
	            return this.el("use", {"xlink:href": "#" + id});
	        } else {
	            return Element.prototype.use.call(this);
	        }
	    };
	    /*\
	     * Paper.symbol
	     [ method ]
	     **
	     * Creates a <symbol> element.
	     - vbx (number) @optional viewbox X
	     - vby (number) @optional viewbox Y
	     - vbw (number) @optional viewbox width
	     - vbh (number) @optional viewbox height
	     = (object) the `symbol` element
	     **
	    \*/
	    proto.symbol = function (vx, vy, vw, vh) {
	        var attr = {};
	        if (vx != null && vy != null && vw != null && vh != null) {
	            attr.viewBox = [vx, vy, vw, vh];
	        }
	
	        return this.el("symbol", attr);
	    };
	    /*\
	     * Paper.text
	     [ method ]
	     **
	     * Draws a text string
	     **
	     - x (number) x coordinate position
	     - y (number) y coordinate position
	     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
	     = (object) the `text` element
	     **
	     > Usage
	     | var t1 = paper.text(50, 50, "Snap");
	     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
	     | // Text path usage
	     | t1.attr({textpath: "M10,10L100,100"});
	     | // or
	     | var pth = paper.path("M10,10L100,100");
	     | t1.attr({textpath: pth});
	    \*/
	    proto.text = function (x, y, text) {
	        var attr = {};
	        if (is(x, "object")) {
	            attr = x;
	        } else if (x != null) {
	            attr = {
	                x: x,
	                y: y,
	                text: text || ""
	            };
	        }
	        return this.el("text", attr);
	    };
	    /*\
	     * Paper.line
	     [ method ]
	     **
	     * Draws a line
	     **
	     - x1 (number) x coordinate position of the start
	     - y1 (number) y coordinate position of the start
	     - x2 (number) x coordinate position of the end
	     - y2 (number) y coordinate position of the end
	     = (object) the `line` element
	     **
	     > Usage
	     | var t1 = paper.line(50, 50, 100, 100);
	    \*/
	    proto.line = function (x1, y1, x2, y2) {
	        var attr = {};
	        if (is(x1, "object")) {
	            attr = x1;
	        } else if (x1 != null) {
	            attr = {
	                x1: x1,
	                x2: x2,
	                y1: y1,
	                y2: y2
	            };
	        }
	        return this.el("line", attr);
	    };
	    /*\
	     * Paper.polyline
	     [ method ]
	     **
	     * Draws a polyline
	     **
	     - points (array) array of points
	     * or
	     - varargs (…) points
	     = (object) the `polyline` element
	     **
	     > Usage
	     | var p1 = paper.polyline([10, 10, 100, 100]);
	     | var p2 = paper.polyline(10, 10, 100, 100);
	    \*/
	    proto.polyline = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polyline", attr);
	    };
	    /*\
	     * Paper.polygon
	     [ method ]
	     **
	     * Draws a polygon. See @Paper.polyline
	    \*/
	    proto.polygon = function (points) {
	        if (arguments.length > 1) {
	            points = Array.prototype.slice.call(arguments, 0);
	        }
	        var attr = {};
	        if (is(points, "object") && !is(points, "array")) {
	            attr = points;
	        } else if (points != null) {
	            attr = {points: points};
	        }
	        return this.el("polygon", attr);
	    };
	    // gradients
	    (function () {
	        var $ = Snap._.$;
	        // gradients' helpers
	        /*\
	         * Element.stops
	         [ method ]
	         **
	         * Only for gradients!
	         * Returns array of gradient stops elements.
	         = (array) the stops array.
	        \*/
	        function Gstops() {
	            return this.selectAll("stop");
	        }
	        /*\
	         * Element.addStop
	         [ method ]
	         **
	         * Only for gradients!
	         * Adds another stop to the gradient.
	         - color (string) stops color
	         - offset (number) stops offset 0..100
	         = (object) gradient element
	        \*/
	        function GaddStop(color, offset) {
	            var stop = $("stop"),
	                attr = {
	                    offset: +offset + "%"
	                };
	            color = Snap.color(color);
	            attr["stop-color"] = color.hex;
	            if (color.opacity < 1) {
	                attr["stop-opacity"] = color.opacity;
	            }
	            $(stop, attr);
	            var stops = this.stops(),
	                inserted;
	            for (var i = 0; i < stops.length; i++) {
	                var stopOffset = parseFloat(stops[i].attr("offset"));
	                if (stopOffset > offset) {
	                    this.node.insertBefore(stop, stops[i].node);
	                    inserted = true;
	                    break;
	                }
	            }
	            if (!inserted) {
	                this.node.appendChild(stop);
	            }
	            return this;
	        }
	        function GgetBBox() {
	            if (this.type == "linearGradient") {
	                var x1 = $(this.node, "x1") || 0,
	                    x2 = $(this.node, "x2") || 1,
	                    y1 = $(this.node, "y1") || 0,
	                    y2 = $(this.node, "y2") || 0;
	                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
	            } else {
	                var cx = this.node.cx || .5,
	                    cy = this.node.cy || .5,
	                    r = this.node.r || 0;
	                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
	            }
	        }
	        /*\
	         * Element.setStops
	         [ method ]
	         **
	         * Only for gradients!
	         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
	         - str (string) gradient descriptor part after `()`.
	         = (object) gradient element
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         | g.setStops("#fff-#000-#f00-#fc0");
	        \*/
	        function GsetStops(str) {
	            var grad = str,
	                stops = this.stops();
	            if (typeof str == "string") {
	                grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
	            }
	            if (!Snap.is(grad, "array")) {
	                return;
	            }
	            for (var i = 0; i < stops.length; i++) {
	                if (grad[i]) {
	                    var color = Snap.color(grad[i].color),
	                        attr = {"offset": grad[i].offset + "%"};
	                    attr["stop-color"] = color.hex;
	                    if (color.opacity < 1) {
	                        attr["stop-opacity"] = color.opacity;
	                    }
	                    stops[i].attr(attr);
	                } else {
	                    stops[i].remove();
	                }
	            }
	            for (i = stops.length; i < grad.length; i++) {
	                this.addStop(grad[i].color, grad[i].offset);
	            }
	            return this;
	        }
	        function gradient(defs, str) {
	            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
	                el;
	            if (!grad) {
	                return null;
	            }
	            grad.params.unshift(defs);
	            if (grad.type.toLowerCase() == "l") {
	                el = gradientLinear.apply(0, grad.params);
	            } else {
	                el = gradientRadial.apply(0, grad.params);
	            }
	            if (grad.type != grad.type.toLowerCase()) {
	                $(el.node, {
	                    gradientUnits: "userSpaceOnUse"
	                });
	            }
	            var stops = grad.stops,
	                len = stops.length;
	            for (var i = 0; i < len; i++) {
	                var stop = stops[i];
	                el.addStop(stop.color, stop.offset);
	            }
	            return el;
	        }
	        function gradientLinear(defs, x1, y1, x2, y2) {
	            var el = Snap._.make("linearGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            el.setStops = GsetStops;
	            if (x1 != null) {
	                $(el.node, {
	                    x1: x1,
	                    y1: y1,
	                    x2: x2,
	                    y2: y2
	                });
	            }
	            return el;
	        }
	        function gradientRadial(defs, cx, cy, r, fx, fy) {
	            var el = Snap._.make("radialGradient", defs);
	            el.stops = Gstops;
	            el.addStop = GaddStop;
	            el.getBBox = GgetBBox;
	            if (cx != null) {
	                $(el.node, {
	                    cx: cx,
	                    cy: cy,
	                    r: r
	                });
	            }
	            if (fx != null && fy != null) {
	                $(el.node, {
	                    fx: fx,
	                    fy: fy
	                });
	            }
	            return el;
	        }
	        /*\
	         * Paper.gradient
	         [ method ]
	         **
	         * Creates a gradient element
	         **
	         - gradient (string) gradient descriptor
	         > Gradient Descriptor
	         * The gradient descriptor is an expression formatted as
	         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
	         * either linear or radial.  The uppercase `L` or `R` letters
	         * indicate absolute coordinates offset from the SVG surface.
	         * Lowercase `l` or `r` letters indicate coordinates
	         * calculated relative to the element to which the gradient is
	         * applied.  Coordinates specify a linear gradient vector as
	         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
	         * `r` and optional `fx`, `fy` specifying a focal point away
	         * from the center of the circle. Specify `<colors>` as a list
	         * of dash-separated CSS color values.  Each color may be
	         * followed by a custom offset value, separated with a colon
	         * character.
	         > Examples
	         * Linear gradient, relative from top-left corner to bottom-right
	         * corner, from black through red to white:
	         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
	         * Linear gradient, absolute from (0, 0) to (100, 100), from black
	         * through red at 25% to white:
	         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
	         * Radial gradient, relative from the center of the element with radius
	         * half the width, from black to white:
	         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
	         * To apply the gradient:
	         | paper.circle(50, 50, 40).attr({
	         |     fill: g
	         | });
	         = (object) the `gradient` element
	        \*/
	        proto.gradient = function (str) {
	            return gradient(this.defs, str);
	        };
	        proto.gradientLinear = function (x1, y1, x2, y2) {
	            return gradientLinear(this.defs, x1, y1, x2, y2);
	        };
	        proto.gradientRadial = function (cx, cy, r, fx, fy) {
	            return gradientRadial(this.defs, cx, cy, r, fx, fy);
	        };
	        /*\
	         * Paper.toString
	         [ method ]
	         **
	         * Returns SVG code for the @Paper
	         = (string) SVG code for the @Paper
	        \*/
	        proto.toString = function () {
	            var doc = this.node.ownerDocument,
	                f = doc.createDocumentFragment(),
	                d = doc.createElement("div"),
	                svg = this.node.cloneNode(true),
	                res;
	            f.appendChild(d);
	            d.appendChild(svg);
	            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
	            res = d.innerHTML;
	            f.removeChild(f.firstChild);
	            return res;
	        };
	        /*\
	         * Paper.toDataURL
	         [ method ]
	         **
	         * Returns SVG code for the @Paper as Data URI string.
	         = (string) Data URI string
	        \*/
	        proto.toDataURL = function () {
	            if (window && window.btoa) {
	                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
	            }
	        };
	        /*\
	         * Paper.clear
	         [ method ]
	         **
	         * Removes all child nodes of the paper, except <defs>.
	        \*/
	        proto.clear = function () {
	            var node = this.node.firstChild,
	                next;
	            while (node) {
	                next = node.nextSibling;
	                if (node.tagName != "defs") {
	                    node.parentNode.removeChild(node);
	                } else {
	                    proto.clear.call({node: node});
	                }
	                node = next;
	            }
	        };
	    }());
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        clone = Snap._.clone,
	        has = "hasOwnProperty",
	        p2s = /,?([a-z]),?/gi,
	        toFloat = parseFloat,
	        math = Math,
	        PI = math.PI,
	        mmin = math.min,
	        mmax = math.max,
	        pow = math.pow,
	        abs = math.abs;
	    function paths(ps) {
	        var p = paths.ps = paths.ps || {};
	        if (p[ps]) {
	            p[ps].sleep = 100;
	        } else {
	            p[ps] = {
	                sleep: 100
	            };
	        }
	        setTimeout(function () {
	            for (var key in p) if (p[has](key) && key != ps) {
	                p[key].sleep--;
	                !p[key].sleep && delete p[key];
	            }
	        });
	        return p[ps];
	    }
	    function box(x, y, width, height) {
	        if (x == null) {
	            x = y = width = height = 0;
	        }
	        if (y == null) {
	            y = x.y;
	            width = x.width;
	            height = x.height;
	            x = x.x;
	        }
	        return {
	            x: x,
	            y: y,
	            width: width,
	            w: width,
	            height: height,
	            h: height,
	            x2: x + width,
	            y2: y + height,
	            cx: x + width / 2,
	            cy: y + height / 2,
	            r1: math.min(width, height) / 2,
	            r2: math.max(width, height) / 2,
	            r0: math.sqrt(width * width + height * height) / 2,
	            path: rectPath(x, y, width, height),
	            vb: [x, y, width, height].join(" ")
	        };
	    }
	    function toString() {
	        return this.join(",").replace(p2s, "$1");
	    }
	    function pathClone(pathArray) {
	        var res = clone(pathArray);
	        res.toString = toString;
	        return res;
	    }
	    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
	        if (length == null) {
	            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
	        } else {
	            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
	                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
	        }
	    }
	    function getLengthFactory(istotal, subpath) {
	        function O(val) {
	            return +(+val).toFixed(3);
	        }
	        return Snap._.cacher(function (path, length, onlystart) {
	            if (path instanceof Element) {
	                path = path.attr("d");
	            }
	            path = path2curve(path);
	            var x, y, p, l, sp = "", subpaths = {}, point,
	                len = 0;
	            for (var i = 0, ii = path.length; i < ii; i++) {
	                p = path[i];
	                if (p[0] == "M") {
	                    x = +p[1];
	                    y = +p[2];
	                } else {
	                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                    if (len + l > length) {
	                        if (subpath && !subpaths.start) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            sp += [
	                                "C" + O(point.start.x),
	                                O(point.start.y),
	                                O(point.m.x),
	                                O(point.m.y),
	                                O(point.x),
	                                O(point.y)
	                            ];
	                            if (onlystart) {return sp;}
	                            subpaths.start = sp;
	                            sp = [
	                                "M" + O(point.x),
	                                O(point.y) + "C" + O(point.n.x),
	                                O(point.n.y),
	                                O(point.end.x),
	                                O(point.end.y),
	                                O(p[5]),
	                                O(p[6])
	                            ].join();
	                            len += l;
	                            x = +p[5];
	                            y = +p[6];
	                            continue;
	                        }
	                        if (!istotal && !subpath) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            return point;
	                        }
	                    }
	                    len += l;
	                    x = +p[5];
	                    y = +p[6];
	                }
	                sp += p.shift() + p;
	            }
	            subpaths.end = sp;
	            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
	            return point;
	        }, null, Snap._.clone);
	    }
	    var getTotalLength = getLengthFactory(1),
	        getPointAtLength = getLengthFactory(),
	        getSubpathsAtLength = getLengthFactory(0, 1);
	    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t,
	            t13 = pow(t1, 3),
	            t12 = pow(t1, 2),
	            t2 = t * t,
	            t3 = t2 * t,
	            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
	            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
	            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
	            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
	            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
	            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
	            ax = t1 * p1x + t * c1x,
	            ay = t1 * p1y + t * c1y,
	            cx = t1 * c2x + t * p2x,
	            cy = t1 * c2y + t * p2y,
	            alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
	        // (mx > nx || my < ny) && (alpha += 180);
	        return {
	            x: x,
	            y: y,
	            m: {x: mx, y: my},
	            n: {x: nx, y: ny},
	            start: {x: ax, y: ay},
	            end: {x: cx, y: cy},
	            alpha: alpha
	        };
	    }
	    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	        if (!Snap.is(p1x, "array")) {
	            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
	        }
	        var bbox = curveDim.apply(null, p1x);
	        return box(
	            bbox.min.x,
	            bbox.min.y,
	            bbox.max.x - bbox.min.x,
	            bbox.max.y - bbox.min.y
	        );
	    }
	    function isPointInsideBBox(bbox, x, y) {
	        return  x >= bbox.x &&
	                x <= bbox.x + bbox.width &&
	                y >= bbox.y &&
	                y <= bbox.y + bbox.height;
	    }
	    function isBBoxIntersect(bbox1, bbox2) {
	        bbox1 = box(bbox1);
	        bbox2 = box(bbox2);
	        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
	            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
	            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
	            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
	            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
	            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
	                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
	            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
	                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
	    }
	    function base3(t, p1, p2, p3, p4) {
	        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
	            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
	        return t * t2 - 3 * p1 + 3 * p2;
	    }
	    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
	        if (z == null) {
	            z = 1;
	        }
	        z = z > 1 ? 1 : z < 0 ? 0 : z;
	        var z2 = z / 2,
	            n = 12,
	            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
	            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
	            sum = 0;
	        for (var i = 0; i < n; i++) {
	            var ct = z2 * Tvalues[i] + z2,
	                xbase = base3(ct, x1, x2, x3, x4),
	                ybase = base3(ct, y1, y2, y3, y4),
	                comb = xbase * xbase + ybase * ybase;
	            sum += Cvalues[i] * math.sqrt(comb);
	        }
	        return z2 * sum;
	    }
	    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
	        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
	            return;
	        }
	        var t = 1,
	            step = t / 2,
	            t2 = t - step,
	            l,
	            e = .01;
	        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        while (abs(l - ll) > e) {
	            step /= 2;
	            t2 += (l < ll ? 1 : -1) * step;
	            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        }
	        return t2;
	    }
	    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	        if (
	            mmax(x1, x2) < mmin(x3, x4) ||
	            mmin(x1, x2) > mmax(x3, x4) ||
	            mmax(y1, y2) < mmin(y3, y4) ||
	            mmin(y1, y2) > mmax(y3, y4)
	        ) {
	            return;
	        }
	        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
	            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
	            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	
	        if (!denominator) {
	            return;
	        }
	        var px = nx / denominator,
	            py = ny / denominator,
	            px2 = +px.toFixed(2),
	            py2 = +py.toFixed(2);
	        if (
	            px2 < +mmin(x1, x2).toFixed(2) ||
	            px2 > +mmax(x1, x2).toFixed(2) ||
	            px2 < +mmin(x3, x4).toFixed(2) ||
	            px2 > +mmax(x3, x4).toFixed(2) ||
	            py2 < +mmin(y1, y2).toFixed(2) ||
	            py2 > +mmax(y1, y2).toFixed(2) ||
	            py2 < +mmin(y3, y4).toFixed(2) ||
	            py2 > +mmax(y3, y4).toFixed(2)
	        ) {
	            return;
	        }
	        return {x: px, y: py};
	    }
	    function inter(bez1, bez2) {
	        return interHelper(bez1, bez2);
	    }
	    function interCount(bez1, bez2) {
	        return interHelper(bez1, bez2, 1);
	    }
	    function interHelper(bez1, bez2, justCount) {
	        var bbox1 = bezierBBox(bez1),
	            bbox2 = bezierBBox(bez2);
	        if (!isBBoxIntersect(bbox1, bbox2)) {
	            return justCount ? 0 : [];
	        }
	        var l1 = bezlen.apply(0, bez1),
	            l2 = bezlen.apply(0, bez2),
	            n1 = ~~(l1 / 8),
	            n2 = ~~(l2 / 8),
	            dots1 = [],
	            dots2 = [],
	            xy = {},
	            res = justCount ? 0 : [];
	        for (var i = 0; i < n1 + 1; i++) {
	            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
	            dots1.push({x: p.x, y: p.y, t: i / n1});
	        }
	        for (i = 0; i < n2 + 1; i++) {
	            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
	            dots2.push({x: p.x, y: p.y, t: i / n2});
	        }
	        for (i = 0; i < n1; i++) {
	            for (var j = 0; j < n2; j++) {
	                var di = dots1[i],
	                    di1 = dots1[i + 1],
	                    dj = dots2[j],
	                    dj1 = dots2[j + 1],
	                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
	                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
	                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
	                if (is) {
	                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
	                        continue;
	                    }
	                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
	                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
	                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
	                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
	                        if (justCount) {
	                            res++;
	                        } else {
	                            res.push({
	                                x: is.x,
	                                y: is.y,
	                                t1: t1,
	                                t2: t2
	                            });
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function pathIntersection(path1, path2) {
	        return interPathHelper(path1, path2);
	    }
	    function pathIntersectionNumber(path1, path2) {
	        return interPathHelper(path1, path2, 1);
	    }
	    function interPathHelper(path1, path2, justCount) {
	        path1 = path2curve(path1);
	        path2 = path2curve(path2);
	        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
	            res = justCount ? 0 : [];
	        for (var i = 0, ii = path1.length; i < ii; i++) {
	            var pi = path1[i];
	            if (pi[0] == "M") {
	                x1 = x1m = pi[1];
	                y1 = y1m = pi[2];
	            } else {
	                if (pi[0] == "C") {
	                    bez1 = [x1, y1].concat(pi.slice(1));
	                    x1 = bez1[6];
	                    y1 = bez1[7];
	                } else {
	                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
	                    x1 = x1m;
	                    y1 = y1m;
	                }
	                for (var j = 0, jj = path2.length; j < jj; j++) {
	                    var pj = path2[j];
	                    if (pj[0] == "M") {
	                        x2 = x2m = pj[1];
	                        y2 = y2m = pj[2];
	                    } else {
	                        if (pj[0] == "C") {
	                            bez2 = [x2, y2].concat(pj.slice(1));
	                            x2 = bez2[6];
	                            y2 = bez2[7];
	                        } else {
	                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
	                            x2 = x2m;
	                            y2 = y2m;
	                        }
	                        var intr = interHelper(bez1, bez2, justCount);
	                        if (justCount) {
	                            res += intr;
	                        } else {
	                            for (var k = 0, kk = intr.length; k < kk; k++) {
	                                intr[k].segment1 = i;
	                                intr[k].segment2 = j;
	                                intr[k].bez1 = bez1;
	                                intr[k].bez2 = bez2;
	                            }
	                            res = res.concat(intr);
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    function isPointInsidePath(path, x, y) {
	        var bbox = pathBBox(path);
	        return isPointInsideBBox(bbox, x, y) &&
	               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
	    }
	    function pathBBox(path) {
	        var pth = paths(path);
	        if (pth.bbox) {
	            return clone(pth.bbox);
	        }
	        if (!path) {
	            return box();
	        }
	        path = path2curve(path);
	        var x = 0,
	            y = 0,
	            X = [],
	            Y = [],
	            p;
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            p = path[i];
	            if (p[0] == "M") {
	                x = p[1];
	                y = p[2];
	                X.push(x);
	                Y.push(y);
	            } else {
	                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                X = X.concat(dim.min.x, dim.max.x);
	                Y = Y.concat(dim.min.y, dim.max.y);
	                x = p[5];
	                y = p[6];
	            }
	        }
	        var xmin = mmin.apply(0, X),
	            ymin = mmin.apply(0, Y),
	            xmax = mmax.apply(0, X),
	            ymax = mmax.apply(0, Y),
	            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
	        pth.bbox = clone(bb);
	        return bb;
	    }
	    function rectPath(x, y, w, h, r) {
	        if (r) {
	            return [
	                ["M", +x + +r, y],
	                ["l", w - r * 2, 0],
	                ["a", r, r, 0, 0, 1, r, r],
	                ["l", 0, h - r * 2],
	                ["a", r, r, 0, 0, 1, -r, r],
	                ["l", r * 2 - w, 0],
	                ["a", r, r, 0, 0, 1, -r, -r],
	                ["l", 0, r * 2 - h],
	                ["a", r, r, 0, 0, 1, r, -r],
	                ["z"]
	            ];
	        }
	        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
	        res.toString = toString;
	        return res;
	    }
	    function ellipsePath(x, y, rx, ry, a) {
	        if (a == null && ry == null) {
	            ry = rx;
	        }
	        x = +x;
	        y = +y;
	        rx = +rx;
	        ry = +ry;
	        if (a != null) {
	            var rad = Math.PI / 180,
	                x1 = x + rx * Math.cos(-ry * rad),
	                x2 = x + rx * Math.cos(-a * rad),
	                y1 = y + rx * Math.sin(-ry * rad),
	                y2 = y + rx * Math.sin(-a * rad),
	                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
	        } else {
	            res = [
	                ["M", x, y],
	                ["m", 0, -ry],
	                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
	                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
	                ["z"]
	            ];
	        }
	        res.toString = toString;
	        return res;
	    }
	    var unit2px = Snap._unit2px,
	        getPath = {
	        path: function (el) {
	            return el.attr("path");
	        },
	        circle: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx, attr.cy, attr.r);
	        },
	        ellipse: function (el) {
	            var attr = unit2px(el);
	            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
	        },
	        rect: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
	        },
	        image: function (el) {
	            var attr = unit2px(el);
	            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
	        },
	        line: function (el) {
	            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
	        },
	        polyline: function (el) {
	            return "M" + el.attr("points");
	        },
	        polygon: function (el) {
	            return "M" + el.attr("points") + "z";
	        },
	        deflt: function (el) {
	            var bbox = el.node.getBBox();
	            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
	        }
	    };
	    function pathToRelative(pathArray) {
	        var pth = paths(pathArray),
	            lowerCase = String.prototype.toLowerCase;
	        if (pth.rel) {
	            return pathClone(pth.rel);
	        }
	        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0;
	        if (pathArray[0][0] == "M") {
	            x = pathArray[0][1];
	            y = pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res.push(["M", x, y]);
	        }
	        for (var i = start, ii = pathArray.length; i < ii; i++) {
	            var r = res[i] = [],
	                pa = pathArray[i];
	            if (pa[0] != lowerCase.call(pa[0])) {
	                r[0] = lowerCase.call(pa[0]);
	                switch (r[0]) {
	                    case "a":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +(pa[6] - x).toFixed(3);
	                        r[7] = +(pa[7] - y).toFixed(3);
	                        break;
	                    case "v":
	                        r[1] = +(pa[1] - y).toFixed(3);
	                        break;
	                    case "m":
	                        mx = pa[1];
	                        my = pa[2];
	                    default:
	                        for (var j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
	                        }
	                }
	            } else {
	                r = res[i] = [];
	                if (pa[0] == "m") {
	                    mx = pa[1] + x;
	                    my = pa[2] + y;
	                }
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    res[i][k] = pa[k];
	                }
	            }
	            var len = res[i].length;
	            switch (res[i][0]) {
	                case "z":
	                    x = mx;
	                    y = my;
	                    break;
	                case "h":
	                    x += +res[i][len - 1];
	                    break;
	                case "v":
	                    y += +res[i][len - 1];
	                    break;
	                default:
	                    x += +res[i][len - 2];
	                    y += +res[i][len - 1];
	            }
	        }
	        res.toString = toString;
	        pth.rel = pathClone(res);
	        return res;
	    }
	    function pathToAbsolute(pathArray) {
	        var pth = paths(pathArray);
	        if (pth.abs) {
	            return pathClone(pth.abs);
	        }
	        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
	            pathArray = Snap.parsePathString(pathArray);
	        }
	        if (!pathArray || !pathArray.length) {
	            return [["M", 0, 0]];
	        }
	        var res = [],
	            x = 0,
	            y = 0,
	            mx = 0,
	            my = 0,
	            start = 0,
	            pa0;
	        if (pathArray[0][0] == "M") {
	            x = +pathArray[0][1];
	            y = +pathArray[0][2];
	            mx = x;
	            my = y;
	            start++;
	            res[0] = ["M", x, y];
	        }
	        var crz = pathArray.length == 3 &&
	            pathArray[0][0] == "M" &&
	            pathArray[1][0].toUpperCase() == "R" &&
	            pathArray[2][0].toUpperCase() == "Z";
	        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
	            res.push(r = []);
	            pa = pathArray[i];
	            pa0 = pa[0];
	            if (pa0 != pa0.toUpperCase()) {
	                r[0] = pa0.toUpperCase();
	                switch (r[0]) {
	                    case "A":
	                        r[1] = pa[1];
	                        r[2] = pa[2];
	                        r[3] = pa[3];
	                        r[4] = pa[4];
	                        r[5] = pa[5];
	                        r[6] = +pa[6] + x;
	                        r[7] = +pa[7] + y;
	                        break;
	                    case "V":
	                        r[1] = +pa[1] + y;
	                        break;
	                    case "H":
	                        r[1] = +pa[1] + x;
	                        break;
	                    case "R":
	                        var dots = [x, y].concat(pa.slice(1));
	                        for (var j = 2, jj = dots.length; j < jj; j++) {
	                            dots[j] = +dots[j] + x;
	                            dots[++j] = +dots[j] + y;
	                        }
	                        res.pop();
	                        res = res.concat(catmullRom2bezier(dots, crz));
	                        break;
	                    case "O":
	                        res.pop();
	                        dots = ellipsePath(x, y, pa[1], pa[2]);
	                        dots.push(dots[0]);
	                        res = res.concat(dots);
	                        break;
	                    case "U":
	                        res.pop();
	                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                        r = ["U"].concat(res[res.length - 1].slice(-2));
	                        break;
	                    case "M":
	                        mx = +pa[1] + x;
	                        my = +pa[2] + y;
	                    default:
	                        for (j = 1, jj = pa.length; j < jj; j++) {
	                            r[j] = +pa[j] + (j % 2 ? x : y);
	                        }
	                }
	            } else if (pa0 == "R") {
	                dots = [x, y].concat(pa.slice(1));
	                res.pop();
	                res = res.concat(catmullRom2bezier(dots, crz));
	                r = ["R"].concat(pa.slice(-2));
	            } else if (pa0 == "O") {
	                res.pop();
	                dots = ellipsePath(x, y, pa[1], pa[2]);
	                dots.push(dots[0]);
	                res = res.concat(dots);
	            } else if (pa0 == "U") {
	                res.pop();
	                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
	                r = ["U"].concat(res[res.length - 1].slice(-2));
	            } else {
	                for (var k = 0, kk = pa.length; k < kk; k++) {
	                    r[k] = pa[k];
	                }
	            }
	            pa0 = pa0.toUpperCase();
	            if (pa0 != "O") {
	                switch (r[0]) {
	                    case "Z":
	                        x = +mx;
	                        y = +my;
	                        break;
	                    case "H":
	                        x = r[1];
	                        break;
	                    case "V":
	                        y = r[1];
	                        break;
	                    case "M":
	                        mx = r[r.length - 2];
	                        my = r[r.length - 1];
	                    default:
	                        x = r[r.length - 2];
	                        y = r[r.length - 1];
	                }
	            }
	        }
	        res.toString = toString;
	        pth.abs = pathClone(res);
	        return res;
	    }
	    function l2c(x1, y1, x2, y2) {
	        return [x1, y1, x2, y2, x2, y2];
	    }
	    function q2c(x1, y1, ax, ay, x2, y2) {
	        var _13 = 1 / 3,
	            _23 = 2 / 3;
	        return [
	                _13 * x1 + _23 * ax,
	                _13 * y1 + _23 * ay,
	                _13 * x2 + _23 * ax,
	                _13 * y2 + _23 * ay,
	                x2,
	                y2
	            ];
	    }
	    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	        // for more information of where this math came from visit:
	        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	        var _120 = PI * 120 / 180,
	            rad = PI / 180 * (+angle || 0),
	            res = [],
	            xy,
	            rotate = Snap._.cacher(function (x, y, rad) {
	                var X = x * math.cos(rad) - y * math.sin(rad),
	                    Y = x * math.sin(rad) + y * math.cos(rad);
	                return {x: X, y: Y};
	            });
	        if (!rx || !ry) {
	            return [x1, y1, x2, y2, x2, y2];
	        }
	        if (!recursive) {
	            xy = rotate(x1, y1, -rad);
	            x1 = xy.x;
	            y1 = xy.y;
	            xy = rotate(x2, y2, -rad);
	            x2 = xy.x;
	            y2 = xy.y;
	            var cos = math.cos(PI / 180 * angle),
	                sin = math.sin(PI / 180 * angle),
	                x = (x1 - x2) / 2,
	                y = (y1 - y2) / 2;
	            var h = x * x / (rx * rx) + y * y / (ry * ry);
	            if (h > 1) {
	                h = math.sqrt(h);
	                rx = h * rx;
	                ry = h * ry;
	            }
	            var rx2 = rx * rx,
	                ry2 = ry * ry,
	                k = (large_arc_flag == sweep_flag ? -1 : 1) *
	                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
	                cx = k * rx * y / ry + (x1 + x2) / 2,
	                cy = k * -ry * x / rx + (y1 + y2) / 2,
	                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
	                f2 = math.asin(((y2 - cy) / ry).toFixed(9));
	
	            f1 = x1 < cx ? PI - f1 : f1;
	            f2 = x2 < cx ? PI - f2 : f2;
	            f1 < 0 && (f1 = PI * 2 + f1);
	            f2 < 0 && (f2 = PI * 2 + f2);
	            if (sweep_flag && f1 > f2) {
	                f1 = f1 - PI * 2;
	            }
	            if (!sweep_flag && f2 > f1) {
	                f2 = f2 - PI * 2;
	            }
	        } else {
	            f1 = recursive[0];
	            f2 = recursive[1];
	            cx = recursive[2];
	            cy = recursive[3];
	        }
	        var df = f2 - f1;
	        if (abs(df) > _120) {
	            var f2old = f2,
	                x2old = x2,
	                y2old = y2;
	            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	            x2 = cx + rx * math.cos(f2);
	            y2 = cy + ry * math.sin(f2);
	            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
	        }
	        df = f2 - f1;
	        var c1 = math.cos(f1),
	            s1 = math.sin(f1),
	            c2 = math.cos(f2),
	            s2 = math.sin(f2),
	            t = math.tan(df / 4),
	            hx = 4 / 3 * rx * t,
	            hy = 4 / 3 * ry * t,
	            m1 = [x1, y1],
	            m2 = [x1 + hx * s1, y1 - hy * c1],
	            m3 = [x2 + hx * s2, y2 - hy * c2],
	            m4 = [x2, y2];
	        m2[0] = 2 * m1[0] - m2[0];
	        m2[1] = 2 * m1[1] - m2[1];
	        if (recursive) {
	            return [m2, m3, m4].concat(res);
	        } else {
	            res = [m2, m3, m4].concat(res).join().split(",");
	            var newres = [];
	            for (var i = 0, ii = res.length; i < ii; i++) {
	                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
	            }
	            return newres;
	        }
	    }
	    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t;
	        return {
	            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
	            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
	        };
	    }
	
	    // Returns bounding box of cubic bezier curve.
	    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	    // Original version: NISHIO Hirokazu
	    // Modifications: https://github.com/timo22345
	    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
	        var tvalues = [],
	            bounds = [[], []],
	            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
	        for (var i = 0; i < 2; ++i) {
	            if (i == 0) {
	                b = 6 * x0 - 12 * x1 + 6 * x2;
	                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
	                c = 3 * x1 - 3 * x0;
	            } else {
	                b = 6 * y0 - 12 * y1 + 6 * y2;
	                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
	                c = 3 * y1 - 3 * y0;
	            }
	            if (abs(a) < 1e-12) {
	                if (abs(b) < 1e-12) {
	                    continue;
	                }
	                t = -c / b;
	                if (0 < t && t < 1) {
	                    tvalues.push(t);
	                }
	                continue;
	            }
	            b2ac = b * b - 4 * c * a;
	            sqrtb2ac = math.sqrt(b2ac);
	            if (b2ac < 0) {
	                continue;
	            }
	            t1 = (-b + sqrtb2ac) / (2 * a);
	            if (0 < t1 && t1 < 1) {
	                tvalues.push(t1);
	            }
	            t2 = (-b - sqrtb2ac) / (2 * a);
	            if (0 < t2 && t2 < 1) {
	                tvalues.push(t2);
	            }
	        }
	
	        var x, y, j = tvalues.length,
	            jlen = j,
	            mt;
	        while (j--) {
	            t = tvalues[j];
	            mt = 1 - t;
	            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
	            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
	        }
	
	        bounds[0][jlen] = x0;
	        bounds[1][jlen] = y0;
	        bounds[0][jlen + 1] = x3;
	        bounds[1][jlen + 1] = y3;
	        bounds[0].length = bounds[1].length = jlen + 2;
	
	
	        return {
	          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
	          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
	        };
	    }
	
	    function path2curve(path, path2) {
	        var pth = !path2 && paths(path);
	        if (!path2 && pth.curve) {
	            return pathClone(pth.curve);
	        }
	        var p = pathToAbsolute(path),
	            p2 = path2 && pathToAbsolute(path2),
	            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	            processPath = function (path, d, pcom) {
	                var nx, ny;
	                if (!path) {
	                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
	                }
	                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
	                switch (path[0]) {
	                    case "M":
	                        d.X = path[1];
	                        d.Y = path[2];
	                        break;
	                    case "A":
	                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
	                        break;
	                    case "S":
	                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
	                            nx = d.x * 2 - d.bx;          // And reflect the previous
	                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
	                        }
	                        else {                            // or some else or nothing
	                            nx = d.x;
	                            ny = d.y;
	                        }
	                        path = ["C", nx, ny].concat(path.slice(1));
	                        break;
	                    case "T":
	                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
	                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
	                            d.qy = d.y * 2 - d.qy;        // to case "S".
	                        }
	                        else {                            // or something else or nothing
	                            d.qx = d.x;
	                            d.qy = d.y;
	                        }
	                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
	                        break;
	                    case "Q":
	                        d.qx = path[1];
	                        d.qy = path[2];
	                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
	                        break;
	                    case "L":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
	                        break;
	                    case "H":
	                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
	                        break;
	                    case "V":
	                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
	                        break;
	                    case "Z":
	                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
	                        break;
	                }
	                return path;
	            },
	            fixArc = function (pp, i) {
	                if (pp[i].length > 7) {
	                    pp[i].shift();
	                    var pi = pp[i];
	                    while (pi.length) {
	                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
	                        p2 && (pcoms2[i] = "A"); // the same as above
	                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
	                    }
	                    pp.splice(i, 1);
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            fixM = function (path1, path2, a1, a2, i) {
	                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
	                    path2.splice(i, 0, ["M", a2.x, a2.y]);
	                    a1.bx = 0;
	                    a1.by = 0;
	                    a1.x = path1[i][1];
	                    a1.y = path1[i][2];
	                    ii = mmax(p.length, p2 && p2.length || 0);
	                }
	            },
	            pcoms1 = [], // path commands of original path p
	            pcoms2 = [], // path commands of original path p2
	            pfirst = "", // temporary holder for original path command
	            pcom = ""; // holder for previous path command of original path
	        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
	            p[i] && (pfirst = p[i][0]); // save current path command
	
	            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
	            {
	                pcoms1[i] = pfirst; // Save current path command
	                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
	            }
	            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
	
	            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
	            // which may produce multiple C:s
	            // so we have to make sure that C is also C in original path
	
	            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
	
	            if (p2) { // the same procedures is done to p2
	                p2[i] && (pfirst = p2[i][0]);
	                if (pfirst != "C") {
	                    pcoms2[i] = pfirst;
	                    i && (pcom = pcoms2[i - 1]);
	                }
	                p2[i] = processPath(p2[i], attrs2, pcom);
	
	                if (pcoms2[i] != "A" && pfirst == "C") {
	                    pcoms2[i] = "C";
	                }
	
	                fixArc(p2, i);
	            }
	            fixM(p, p2, attrs, attrs2, i);
	            fixM(p2, p, attrs2, attrs, i);
	            var seg = p[i],
	                seg2 = p2 && p2[i],
	                seglen = seg.length,
	                seg2len = p2 && seg2.length;
	            attrs.x = seg[seglen - 2];
	            attrs.y = seg[seglen - 1];
	            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
	            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
	            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
	            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
	            attrs2.x = p2 && seg2[seg2len - 2];
	            attrs2.y = p2 && seg2[seg2len - 1];
	        }
	        if (!p2) {
	            pth.curve = pathClone(p);
	        }
	        return p2 ? [p, p2] : p;
	    }
	    function mapPath(path, matrix) {
	        if (!matrix) {
	            return path;
	        }
	        var x, y, i, j, ii, jj, pathi;
	        path = path2curve(path);
	        for (i = 0, ii = path.length; i < ii; i++) {
	            pathi = path[i];
	            for (j = 1, jj = pathi.length; j < jj; j += 2) {
	                x = matrix.x(pathi[j], pathi[j + 1]);
	                y = matrix.y(pathi[j], pathi[j + 1]);
	                pathi[j] = x;
	                pathi[j + 1] = y;
	            }
	        }
	        return path;
	    }
	
	    // http://schepers.cc/getting-to-the-point
	    function catmullRom2bezier(crp, z) {
	        var d = [];
	        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
	            var p = [
	                        {x: +crp[i - 2], y: +crp[i - 1]},
	                        {x: +crp[i],     y: +crp[i + 1]},
	                        {x: +crp[i + 2], y: +crp[i + 3]},
	                        {x: +crp[i + 4], y: +crp[i + 5]}
	                    ];
	            if (z) {
	                if (!i) {
	                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
	                } else if (iLen - 4 == i) {
	                    p[3] = {x: +crp[0], y: +crp[1]};
	                } else if (iLen - 2 == i) {
	                    p[2] = {x: +crp[0], y: +crp[1]};
	                    p[3] = {x: +crp[2], y: +crp[3]};
	                }
	            } else {
	                if (iLen - 4 == i) {
	                    p[3] = p[2];
	                } else if (!i) {
	                    p[0] = {x: +crp[i], y: +crp[i + 1]};
	                }
	            }
	            d.push(["C",
	                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
	                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
	                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
	                  (p[1].y + 6*p[2].y - p[3].y) / 6,
	                  p[2].x,
	                  p[2].y
	            ]);
	        }
	
	        return d;
	    }
	
	    // export
	    Snap.path = paths;
	
	    /*\
	     * Snap.path.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the given path in pixels
	     **
	     - path (string) SVG path string
	     **
	     = (number) length
	    \*/
	    Snap.path.getTotalLength = getTotalLength;
	    /*\
	     * Snap.path.getPointAtLength
	     [ method ]
	     **
	     * Returns the coordinates of the point located at the given length along the given path
	     **
	     - path (string) SVG path string
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    Snap.path.getPointAtLength = getPointAtLength;
	    /*\
	     * Snap.path.getSubpath
	     [ method ]
	     **
	     * Returns the subpath of a given path between given start and end lengths
	     **
	     - path (string) SVG path string
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    Snap.path.getSubpath = function (path, from, to) {
	        if (this.getTotalLength(path) - to < 1e-6) {
	            return getSubpathsAtLength(path, from).end;
	        }
	        var a = getSubpathsAtLength(path, to, 1);
	        return from ? getSubpathsAtLength(a, from).end : a;
	    };
	    /*\
	     * Element.getTotalLength
	     [ method ]
	     **
	     * Returns the length of the path in pixels (only works for `path` elements)
	     = (number) length
	    \*/
	    elproto.getTotalLength = function () {
	        if (this.node.getTotalLength) {
	            return this.node.getTotalLength();
	        }
	    };
	    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
	    /*\
	     * Element.getPointAtLength
	     [ method ]
	     **
	     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
	     **
	     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate,
	     o     y: (number) y coordinate,
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    elproto.getPointAtLength = function (length) {
	        return getPointAtLength(this.attr("d"), length);
	    };
	    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
	    /*\
	     * Element.getSubpath
	     [ method ]
	     **
	     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
	     **
	     - from (number) length, in pixels, from the start of the path to the start of the segment
	     - to (number) length, in pixels, from the start of the path to the end of the segment
	     **
	     = (string) path string definition for the segment
	    \*/
	    elproto.getSubpath = function (from, to) {
	        return Snap.path.getSubpath(this.attr("d"), from, to);
	    };
	    Snap._.box = box;
	    /*\
	     * Snap.path.findDotsAtSegment
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds dot coordinates on the given cubic beziér curve at the given t
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     - t (number) position on the curve (0..1)
	     = (object) point information in format:
	     o {
	     o     x: (number) x coordinate of the point,
	     o     y: (number) y coordinate of the point,
	     o     m: {
	     o         x: (number) x coordinate of the left anchor,
	     o         y: (number) y coordinate of the left anchor
	     o     },
	     o     n: {
	     o         x: (number) x coordinate of the right anchor,
	     o         y: (number) y coordinate of the right anchor
	     o     },
	     o     start: {
	     o         x: (number) x coordinate of the start of the curve,
	     o         y: (number) y coordinate of the start of the curve
	     o     },
	     o     end: {
	     o         x: (number) x coordinate of the end of the curve,
	     o         y: (number) y coordinate of the end of the curve
	     o     },
	     o     alpha: (number) angle of the curve derivative at the point
	     o }
	    \*/
	    Snap.path.findDotsAtSegment = findDotsAtSegment;
	    /*\
	     * Snap.path.bezierBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given cubic beziér curve
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     * or
	     - bez (array) array of six points for beziér curve
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.bezierBBox = bezierBBox;
	    /*\
	     * Snap.path.isPointInsideBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside bounding box
	     - bbox (string) bounding box
	     - x (string) x coordinate of the point
	     - y (string) y coordinate of the point
	     = (boolean) `true` if point is inside
	    \*/
	    Snap.path.isPointInsideBBox = isPointInsideBBox;
	    Snap.closest = function (x, y, X, Y) {
	        var r = 100,
	            b = box(x - r / 2, y - r / 2, r, r),
	            inside = [],
	            getter = X[0].hasOwnProperty("x") ? function (i) {
	                return {
	                    x: X[i].x,
	                    y: X[i].y
	                };
	            } : function (i) {
	                return {
	                    x: X[i],
	                    y: Y[i]
	                };
	            },
	            found = 0;
	        while (r <= 1e6 && !found) {
	            for (var i = 0, ii = X.length; i < ii; i++) {
	                var xy = getter(i);
	                if (isPointInsideBBox(b, xy.x, xy.y)) {
	                    found++;
	                    inside.push(xy);
	                    break;
	                }
	            }
	            if (!found) {
	                r *= 2;
	                b = box(x - r / 2, y - r / 2, r, r)
	            }
	        }
	        if (r == 1e6) {
	            return;
	        }
	        var len = Infinity,
	            res;
	        for (i = 0, ii = inside.length; i < ii; i++) {
	            var l = Snap.len(x, y, inside[i].x, inside[i].y);
	            if (len > l) {
	                len = l;
	                inside[i].len = l;
	                res = inside[i];
	            }
	        }
	        return res;
	    };
	    /*\
	     * Snap.path.isBBoxIntersect
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if two bounding boxes intersect
	     - bbox1 (string) first bounding box
	     - bbox2 (string) second bounding box
	     = (boolean) `true` if bounding boxes intersect
	    \*/
	    Snap.path.isBBoxIntersect = isBBoxIntersect;
	    /*\
	     * Snap.path.intersection
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds intersections of two paths
	     - path1 (string) path string
	     - path2 (string) path string
	     = (array) dots of intersection
	     o [
	     o     {
	     o         x: (number) x coordinate of the point,
	     o         y: (number) y coordinate of the point,
	     o         t1: (number) t value for segment of path1,
	     o         t2: (number) t value for segment of path2,
	     o         segment1: (number) order number for segment of path1,
	     o         segment2: (number) order number for segment of path2,
	     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
	     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
	     o     }
	     o ]
	    \*/
	    Snap.path.intersection = pathIntersection;
	    Snap.path.intersectionNumber = pathIntersectionNumber;
	    /*\
	     * Snap.path.isPointInside
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside a given closed path.
	     *
	     * Note: fill mode doesn’t affect the result of this method.
	     - path (string) path string
	     - x (number) x of the point
	     - y (number) y of the point
	     = (boolean) `true` if point is inside the path
	    \*/
	    Snap.path.isPointInside = isPointInsidePath;
	    /*\
	     * Snap.path.getBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns the bounding box of a given path
	     - path (string) path string
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box,
	     o     y: (number) y coordinate of the left top point of the box,
	     o     x2: (number) x coordinate of the right bottom point of the box,
	     o     y2: (number) y coordinate of the right bottom point of the box,
	     o     width: (number) width of the box,
	     o     height: (number) height of the box
	     o }
	    \*/
	    Snap.path.getBBox = pathBBox;
	    Snap.path.get = getPath;
	    /*\
	     * Snap.path.toRelative
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into relative values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toRelative = pathToRelative;
	    /*\
	     * Snap.path.toAbsolute
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path coordinates into absolute values
	     - path (string) path string
	     = (array) path string
	    \*/
	    Snap.path.toAbsolute = pathToAbsolute;
	    /*\
	     * Snap.path.toCubic
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path to a new path where all segments are cubic beziér curves
	     - pathString (string|array) path string or array of segments
	     = (array) array of segments
	    \*/
	    Snap.path.toCubic = path2curve;
	    /*\
	     * Snap.path.map
	     [ method ]
	     **
	     * Transform the path string with the given matrix
	     - path (string) path string
	     - matrix (object) see @Matrix
	     = (string) transformed path string
	    \*/
	    Snap.path.map = mapPath;
	    Snap.path.toString = toString;
	    Snap.path.clone = pathClone;
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var mmax = Math.max,
	        mmin = Math.min;
	
	    // Set
	    var Set = function (items) {
	        this.items = [];
		this.bindings = {};
	        this.length = 0;
	        this.type = "set";
	        if (items) {
	            for (var i = 0, ii = items.length; i < ii; i++) {
	                if (items[i]) {
	                    this[this.items.length] = this.items[this.items.length] = items[i];
	                    this.length++;
	                }
	            }
	        }
	    },
	    setproto = Set.prototype;
	    /*\
	     * Set.push
	     [ method ]
	     **
	     * Adds each argument to the current set
	     = (object) original element
	    \*/
	    setproto.push = function () {
	        var item,
	            len;
	        for (var i = 0, ii = arguments.length; i < ii; i++) {
	            item = arguments[i];
	            if (item) {
	                len = this.items.length;
	                this[len] = this.items[len] = item;
	                this.length++;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.pop
	     [ method ]
	     **
	     * Removes last element and returns it
	     = (object) element
	    \*/
	    setproto.pop = function () {
	        this.length && delete this[this.length--];
	        return this.items.pop();
	    };
	    /*\
	     * Set.forEach
	     [ method ]
	     **
	     * Executes given function for each element in the set
	     *
	     * If the function returns `false`, the loop stops running.
	     **
	     - callback (function) function to run
	     - thisArg (object) context object for the callback
	     = (object) Set object
	    \*/
	    setproto.forEach = function (callback, thisArg) {
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            if (callback.call(thisArg, this.items[i], i) === false) {
	                return this;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.animate
	     [ method ]
	     **
	     * Animates each element in set in sync.
	     *
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     * or
	     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
	     > Usage
	     | // animate all elements in set to radius 10
	     | set.animate({r: 10}, 500, mina.easein);
	     | // or
	     | // animate first element to radius 10, but second to radius 20 and in different time
	     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
	     = (Element) the current element
	    \*/
	    setproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Snap._.Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = easing.dur;
	            attrs = attrs.attr;
	        }
	        var args = arguments;
	        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
	            var each = true;
	        }
	        var begin,
	            handler = function () {
	                if (begin) {
	                    this.b = begin;
	                } else {
	                    begin = this.b;
	                }
	            },
	            cb = 0,
	            set = this,
	            callbacker = callback && function () {
	                if (++cb == set.length) {
	                    callback.call(this);
	                }
	            };
	        return this.forEach(function (el, i) {
	            eve.once("snap.animcreated." + el.id, handler);
	            if (each) {
	                args[i] && el.animate.apply(el, args[i]);
	            } else {
	                el.animate(attrs, ms, easing, callbacker);
	            }
	        });
	    };
	    /*\
	     * Set.remove
	     [ method ]
	     **
	     * Removes all children of the set.
	     *
	     = (object) Set object
	    \*/
	    setproto.remove = function () {
	        while (this.length) {
	            this.pop().remove();
	        }
	        return this;
	    };
	    /*\
	     * Set.bind
	     [ method ]
	     **
	     * Specifies how to handle a specific attribute when applied
	     * to a set.
	     *
	     **
	     - attr (string) attribute name
	     - callback (function) function to run
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     * or
	     - attr (string) attribute name
	     - element (Element) specific element in the set to apply the attribute to
	     - eattr (string) attribute on the element to bind the attribute to
	     = (object) Set object
	    \*/
	    setproto.bind = function (attr, a, b) {
	        var data = {};
	        if (typeof a == "function") {
	            this.bindings[attr] = a;
	        } else {
	            var aname = b || attr;
	            this.bindings[attr] = function (v) {
	                data[aname] = v;
	                a.attr(data);
	            };
	        }
	        return this;
	    };
	    /*\
	     * Set.attr
	     [ method ]
	     **
	     * Equivalent of @Element.attr.
	     = (object) Set object
	    \*/
	    setproto.attr = function (value) {
	        var unbound = {};
	        for (var k in value) {
	            if (this.bindings[k]) {
	                this.bindings[k](value[k]);
	            } else {
	                unbound[k] = value[k];
	            }
	        }
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            this.items[i].attr(unbound);
	        }
	        return this;
	    };
	    /*\
	     * Set.clear
	     [ method ]
	     **
	     * Removes all elements from the set
	    \*/
	    setproto.clear = function () {
	        while (this.length) {
	            this.pop();
	        }
	    };
	    /*\
	     * Set.splice
	     [ method ]
	     **
	     * Removes range of elements from the set
	     **
	     - index (number) position of the deletion
	     - count (number) number of element to remove
	     - insertion… (object) #optional elements to insert
	     = (object) set elements that were deleted
	    \*/
	    setproto.splice = function (index, count, insertion) {
	        index = index < 0 ? mmax(this.length + index, 0) : index;
	        count = mmax(0, mmin(this.length - index, count));
	        var tail = [],
	            todel = [],
	            args = [],
	            i;
	        for (i = 2; i < arguments.length; i++) {
	            args.push(arguments[i]);
	        }
	        for (i = 0; i < count; i++) {
	            todel.push(this[index + i]);
	        }
	        for (; i < this.length - index; i++) {
	            tail.push(this[index + i]);
	        }
	        var arglen = args.length;
	        for (i = 0; i < arglen + tail.length; i++) {
	            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
	        }
	        i = this.items.length = this.length -= count - arglen;
	        while (this[i]) {
	            delete this[i++];
	        }
	        return new Set(todel);
	    };
	    /*\
	     * Set.exclude
	     [ method ]
	     **
	     * Removes given element from the set
	     **
	     - element (object) element to remove
	     = (boolean) `true` if object was found and removed from the set
	    \*/
	    setproto.exclude = function (el) {
	        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
	            this.splice(i, 1);
	            return true;
	        }
	        return false;
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Inserts set elements after given element.
	     **
	     - element (object) set will be inserted after this element
	     = (object) Set object
	    \*/
	    setproto.insertAfter = function (el) {
	        var i = this.items.length;
	        while (i--) {
	            this.items[i].insertAfter(el);
	        }
	        return this;
	    };
	    /*\
	     * Set.getBBox
	     [ method ]
	     **
	     * Union of all bboxes of the set. See @Element.getBBox.
	     = (object) bounding box descriptor. See @Element.getBBox.
	    \*/
	    setproto.getBBox = function () {
	        var x = [],
	            y = [],
	            x2 = [],
	            y2 = [];
	        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
	            var box = this.items[i].getBBox();
	            x.push(box.x);
	            y.push(box.y);
	            x2.push(box.x + box.width);
	            y2.push(box.y + box.height);
	        }
	        x = mmin.apply(0, x);
	        y = mmin.apply(0, y);
	        x2 = mmax.apply(0, x2);
	        y2 = mmax.apply(0, y2);
	        return {
	            x: x,
	            y: y,
	            x2: x2,
	            y2: y2,
	            width: x2 - x,
	            height: y2 - y,
	            cx: x + (x2 - x) / 2,
	            cy: y + (y2 - y) / 2
	        };
	    };
	    /*\
	     * Set.insertAfter
	     [ method ]
	     **
	     * Creates a clone of the set.
	     **
	     = (object) New Set object
	    \*/
	    setproto.clone = function (s) {
	        s = new Set;
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            s.push(this.items[i].clone());
	        }
	        return s;
	    };
	    setproto.toString = function () {
	        return "Snap\u2018s set";
	    };
	    setproto.type = "set";
	    // export
	    /*\
	     * Snap.Set
	     [ property ]
	     **
	     * Set constructor.
	    \*/
	    Snap.Set = Set;
	    /*\
	     * Snap.set
	     [ method ]
	     **
	     * Creates a set and fills it with list of arguments.
	     **
	     = (object) New Set object
	     | var r = paper.rect(0, 0, 10, 10),
	     |     s1 = Snap.set(), // empty set
	     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
	    \*/
	    Snap.set = function () {
	        var set = new Set;
	        if (arguments.length) {
	            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
	        }
	        return set;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var names = {},
	        reUnit = /[%a-z]+$/i,
	        Str = String;
	    names.stroke = names.fill = "colour";
	    function getEmpty(item) {
	        var l = item[0];
	        switch (l.toLowerCase()) {
	            case "t": return [l, 0, 0];
	            case "m": return [l, 1, 0, 0, 1, 0, 0];
	            case "r": if (item.length == 4) {
	                return [l, 0, item[2], item[3]];
	            } else {
	                return [l, 0];
	            }
	            case "s": if (item.length == 5) {
	                return [l, 1, 1, item[3], item[4]];
	            } else if (item.length == 3) {
	                return [l, 1, 1];
	            } else {
	                return [l, 1];
	            }
	        }
	    }
	    function equaliseTransform(t1, t2, getBBox) {
	        t1 = t1 || new Snap.Matrix;
	        t2 = t2 || new Snap.Matrix;
	        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
	        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
	        var maxlength = Math.max(t1.length, t2.length),
	            from = [],
	            to = [],
	            i = 0, j, jj,
	            tt1, tt2;
	        for (; i < maxlength; i++) {
	            tt1 = t1[i] || getEmpty(t2[i]);
	            tt2 = t2[i] || getEmpty(tt1);
	            if (tt1[0] != tt2[0] ||
	                tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) ||
	                tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])
	                ) {
	                    t1 = Snap._.transform2matrix(t1, getBBox());
	                    t2 = Snap._.transform2matrix(t2, getBBox());
	                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
	                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
	                    break;
	            }
	            from[i] = [];
	            to[i] = [];
	            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
	                j in tt1 && (from[i][j] = tt1[j]);
	                j in tt2 && (to[i][j] = tt2[j]);
	            }
	        }
	        return {
	            from: path2array(from),
	            to: path2array(to),
	            f: getPath(from)
	        };
	    }
	    function getNumber(val) {
	        return val;
	    }
	    function getUnit(unit) {
	        return function (val) {
	            return +val.toFixed(3) + unit;
	        };
	    }
	    function getViewBox(val) {
	        return val.join(" ");
	    }
	    function getColour(clr) {
	        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
	    }
	    function getPath(path) {
	        var k = 0, i, ii, j, jj, out, a, b = [];
	        for (i = 0, ii = path.length; i < ii; i++) {
	            out = "[";
	            a = ['"' + path[i][0] + '"'];
	            for (j = 1, jj = path[i].length; j < jj; j++) {
	                a[j] = "val[" + k++ + "]";
	            }
	            out += a + "]";
	            b[i] = out;
	        }
	        return Function("val", "return Snap.path.toString.call([" + b + "])");
	    }
	    function path2array(path) {
	        var out = [];
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            for (var j = 1, jj = path[i].length; j < jj; j++) {
	                out.push(path[i][j]);
	            }
	        }
	        return out;
	    }
	    function isNumeric(obj) {
	        return isFinite(obj);
	    }
	    function arrayEqual(arr1, arr2) {
	        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
	            return false;
	        }
	        return arr1.toString() == arr2.toString();
	    }
	    Element.prototype.equal = function (name, b) {
	        return eve("snap.util.equal", this, name, b).firstDefined();
	    };
	    eve.on("snap.util.equal", function (name, b) {
	        var A, B, a = Str(this.attr(name) || ""),
	            el = this;
	        if (names[name] == "colour") {
	            A = Snap.color(a);
	            B = Snap.color(b);
	            return {
	                from: [A.r, A.g, A.b, A.opacity],
	                to: [B.r, B.g, B.b, B.opacity],
	                f: getColour
	            };
	        }
	        if (name == "viewBox") {
	            A = this.attr(name).vb.split(" ").map(Number);
	            B = b.split(" ").map(Number);
	            return {
	                from: A,
	                to: B,
	                f: getViewBox
	            };
	        }
	        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
	            if (typeof b == "string") {
	                b = Str(b).replace(/\.{3}|\u2026/g, a);
	            }
	            a = this.matrix;
	            if (!Snap._.rgTransform.test(b)) {
	                b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
	            } else {
	                b = Snap._.transform2matrix(b, this.getBBox());
	            }
	            return equaliseTransform(a, b, function () {
	                return el.getBBox(1);
	            });
	        }
	        if (name == "d" || name == "path") {
	            A = Snap.path.toCubic(a, b);
	            return {
	                from: path2array(A[0]),
	                to: path2array(A[1]),
	                f: getPath(A[0])
	            };
	        }
	        if (name == "points") {
	            A = Str(a).split(Snap._.separator);
	            B = Str(b).split(Snap._.separator);
	            return {
	                from: A,
	                to: B,
	                f: function (val) { return val; }
	            };
	        }
	        if (isNumeric(a) && isNumeric(b)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getNumber
	            };
	        }
	        var aUnit = a.match(reUnit),
	            bUnit = Str(b).match(reUnit);
	        if (aUnit && arrayEqual(aUnit, bUnit)) {
	            return {
	                from: parseFloat(a),
	                to: parseFloat(b),
	                f: getUnit(aUnit)
	            };
	        } else {
	            return {
	                from: this.asPX(name),
	                to: this.asPX(name, b),
	                f: getNumber
	            };
	        }
	    });
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	// 
	// http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	    has = "hasOwnProperty",
	    supportsTouch = "createTouch" in glob.doc,
	    events = [
	        "click", "dblclick", "mousedown", "mousemove", "mouseout",
	        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
	        "touchcancel"
	    ],
	    touchMap = {
	        mousedown: "touchstart",
	        mousemove: "touchmove",
	        mouseup: "touchend"
	    },
	    getScroll = function (xy, el) {
	        var name = xy == "y" ? "scrollTop" : "scrollLeft",
	            doc = el && el.node ? el.node.ownerDocument : glob.doc;
	        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
	    },
	    preventDefault = function () {
	        this.returnValue = false;
	    },
	    preventTouch = function () {
	        return this.originalEvent.preventDefault();
	    },
	    stopPropagation = function () {
	        this.cancelBubble = true;
	    },
	    stopTouch = function () {
	        return this.originalEvent.stopPropagation();
	    },
	    addEvent = function (obj, type, fn, element) {
	        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
	            f = function (e) {
	                var scrollY = getScroll("y", element),
	                    scrollX = getScroll("x", element);
	                if (supportsTouch && touchMap[has](type)) {
	                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
	                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
	                            var olde = e;
	                            e = e.targetTouches[i];
	                            e.originalEvent = olde;
	                            e.preventDefault = preventTouch;
	                            e.stopPropagation = stopTouch;
	                            break;
	                        }
	                    }
	                }
	                var x = e.clientX + scrollX,
	                    y = e.clientY + scrollY;
	                return fn.call(element, e, x, y);
	            };
	
	        if (type !== realName) {
	            obj.addEventListener(type, f, false);
	        }
	
	        obj.addEventListener(realName, f, false);
	
	        return function () {
	            if (type !== realName) {
	                obj.removeEventListener(type, f, false);
	            }
	
	            obj.removeEventListener(realName, f, false);
	            return true;
	        };
	    },
	    drag = [],
	    dragMove = function (e) {
	        var x = e.clientX,
	            y = e.clientY,
	            scrollY = getScroll("y"),
	            scrollX = getScroll("x"),
	            dragi,
	            j = drag.length;
	        while (j--) {
	            dragi = drag[j];
	            if (supportsTouch) {
	                var i = e.touches && e.touches.length,
	                    touch;
	                while (i--) {
	                    touch = e.touches[i];
	                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
	                        x = touch.clientX;
	                        y = touch.clientY;
	                        (e.originalEvent ? e.originalEvent : e).preventDefault();
	                        break;
	                    }
	                }
	            } else {
	                e.preventDefault();
	            }
	            var node = dragi.el.node,
	                o,
	                next = node.nextSibling,
	                parent = node.parentNode,
	                display = node.style.display;
	            // glob.win.opera && parent.removeChild(node);
	            // node.style.display = "none";
	            // o = dragi.el.paper.getElementByPoint(x, y);
	            // node.style.display = display;
	            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
	            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
	            x += scrollX;
	            y += scrollY;
	            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
	        }
	    },
	    dragUp = function (e) {
	        Snap.unmousemove(dragMove).unmouseup(dragUp);
	        var i = drag.length,
	            dragi;
	        while (i--) {
	            dragi = drag[i];
	            dragi.el._drag = {};
	            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
	            eve.off("snap.drag.*." + dragi.el.id);
	        }
	        drag = [];
	    };
	    /*\
	     * Element.click
	     [ method ]
	     **
	     * Adds a click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unclick
	     [ method ]
	     **
	     * Removes a click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.dblclick
	     [ method ]
	     **
	     * Adds a double click event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.undblclick
	     [ method ]
	     **
	     * Removes a double click event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousedown
	     [ method ]
	     **
	     * Adds a mousedown event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousedown
	     [ method ]
	     **
	     * Removes a mousedown event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mousemove
	     [ method ]
	     **
	     * Adds a mousemove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousemove
	     [ method ]
	     **
	     * Removes a mousemove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseout
	     [ method ]
	     **
	     * Adds a mouseout event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseout
	     [ method ]
	     **
	     * Removes a mouseout event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseover
	     [ method ]
	     **
	     * Adds a mouseover event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseover
	     [ method ]
	     **
	     * Removes a mouseover event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.mouseup
	     [ method ]
	     **
	     * Adds a mouseup event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseup
	     [ method ]
	     **
	     * Removes a mouseup event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchstart
	     [ method ]
	     **
	     * Adds a touchstart event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchstart
	     [ method ]
	     **
	     * Removes a touchstart event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchmove
	     [ method ]
	     **
	     * Adds a touchmove event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchmove
	     [ method ]
	     **
	     * Removes a touchmove event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchend
	     [ method ]
	     **
	     * Adds a touchend event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchend
	     [ method ]
	     **
	     * Removes a touchend event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    
	    /*\
	     * Element.touchcancel
	     [ method ]
	     **
	     * Adds a touchcancel event handler to the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchcancel
	     [ method ]
	     **
	     * Removes a touchcancel event handler from the element
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    for (var i = events.length; i--;) {
	        (function (eventName) {
	            Snap[eventName] = elproto[eventName] = function (fn, scope) {
	                if (Snap.is(fn, "function")) {
	                    this.events = this.events || [];
	                    this.events.push({
	                        name: eventName,
	                        f: fn,
	                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
	                    });
	                } else {
	                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
	                        try {
	                            this.events[i].f.call(this);
	                        } catch (e) {}
	                    }
	                }
	                return this;
	            };
	            Snap["un" + eventName] =
	            elproto["un" + eventName] = function (fn) {
	                var events = this.events || [],
	                    l = events.length;
	                while (l--) if (events[l].name == eventName &&
	                               (events[l].f == fn || !fn)) {
	                    events[l].unbind();
	                    events.splice(l, 1);
	                    !events.length && delete this.events;
	                    return this;
	                }
	                return this;
	            };
	        })(events[i]);
	    }
	    /*\
	     * Element.hover
	     [ method ]
	     **
	     * Adds hover event handlers to the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     - icontext (object) #optional context for hover in handler
	     - ocontext (object) #optional context for hover out handler
	     = (object) @Element
	    \*/
	    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
	        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
	    };
	    /*\
	     * Element.unhover
	     [ method ]
	     **
	     * Removes hover event handlers from the element
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     = (object) @Element
	    \*/
	    elproto.unhover = function (f_in, f_out) {
	        return this.unmouseover(f_in).unmouseout(f_out);
	    };
	    var draggable = [];
	    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
	    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
	    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
	    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
	    /*\
	     * Element.drag
	     [ method ]
	     **
	     * Adds event handlers for an element's drag gesture
	     **
	     - onmove (function) handler for moving
	     - onstart (function) handler for drag start
	     - onend (function) handler for drag end
	     - mcontext (object) #optional context for moving handler
	     - scontext (object) #optional context for drag start handler
	     - econtext (object) #optional context for drag end handler
	     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
	     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
	     * `drag.over.<id>` fires as well.
	     *
	     * Start event and start handler are called in specified context or in context of the element with following parameters:
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * Move event and move handler are called in specified context or in context of the element with following parameters:
	     o dx (number) shift by x from the start point
	     o dy (number) shift by y from the start point
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * End event and end handler are called in specified context or in context of the element with following parameters:
	     o event (object) DOM event object
	     = (object) @Element
	    \*/
	    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
	        var el = this;
	        if (!arguments.length) {
	            var origTransform;
	            return el.drag(function (dx, dy) {
	                this.attr({
	                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
	                });
	            }, function () {
	                origTransform = this.transform().local;
	            });
	        }
	        function start(e, x, y) {
	            (e.originalEvent || e).preventDefault();
	            el._drag.x = x;
	            el._drag.y = y;
	            el._drag.id = e.identifier;
	            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
	            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
	            onstart && eve.on("snap.drag.start." + el.id, onstart);
	            onmove && eve.on("snap.drag.move." + el.id, onmove);
	            onend && eve.on("snap.drag.end." + el.id, onend);
	            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
	        }
	        function init(e, x, y) {
	            eve("snap.draginit." + el.id, el, e, x, y);
	        }
	        eve.on("snap.draginit." + el.id, start);
	        el._drag = {};
	        draggable.push({el: el, start: start, init: init});
	        el.mousedown(init);
	        return el;
	    };
	    /*
	     * Element.onDragOver
	     [ method ]
	     **
	     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
	     - f (function) handler for event, first argument would be the element you are dragging over
	    \*/
	    // elproto.onDragOver = function (f) {
	    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
	    // };
	    /*\
	     * Element.undrag
	     [ method ]
	     **
	     * Removes all drag event handlers from the given element
	    \*/
	    elproto.undrag = function () {
	        var i = draggable.length;
	        while (i--) if (draggable[i].el == this) {
	            this.unmousedown(draggable[i].init);
	            draggable.splice(i, 1);
	            eve.unbind("snap.drag.*." + this.id);
	            eve.unbind("snap.draginit." + this.id);
	        }
	        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
	        return this;
	    };
	});
	
	// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    var elproto = Element.prototype,
	        pproto = Paper.prototype,
	        rgurl = /^\s*url\((.+)\)/,
	        Str = String,
	        $ = Snap._.$;
	    Snap.filter = {};
	    /*\
	     * Paper.filter
	     [ method ]
	     **
	     * Creates a `<filter>` element
	     **
	     - filstr (string) SVG fragment of filter provided as a string
	     = (object) @Element
	     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
	     > Usage
	     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    pproto.filter = function (filstr) {
	        var paper = this;
	        if (paper.type != "svg") {
	            paper = paper.paper;
	        }
	        var f = Snap.parse(Str(filstr)),
	            id = Snap._.id(),
	            width = paper.node.offsetWidth,
	            height = paper.node.offsetHeight,
	            filter = $("filter");
	        $(filter, {
	            id: id,
	            filterUnits: "userSpaceOnUse"
	        });
	        filter.appendChild(f.node);
	        paper.defs.appendChild(filter);
	        return new Element(filter);
	    };
	
	    eve.on("snap.util.getattr.filter", function () {
	        eve.stop();
	        var p = $(this.node, "filter");
	        if (p) {
	            var match = Str(p).match(rgurl);
	            return match && Snap.select(match[1]);
	        }
	    });
	    eve.on("snap.util.attr.filter", function (value) {
	        if (value instanceof Element && value.type == "filter") {
	            eve.stop();
	            var id = value.node.id;
	            if (!id) {
	                $(value.node, {id: value.id});
	                id = value.id;
	            }
	            $(this.node, {
	                filter: Snap.url(id)
	            });
	        }
	        if (!value || value == "none") {
	            eve.stop();
	            this.node.removeAttribute("filter");
	        }
	    });
	    /*\
	     * Snap.filter.blur
	     [ method ]
	     **
	     * Returns an SVG markup string for the blur filter
	     **
	     - x (number) amount of horizontal blur, in pixels
	     - y (number) #optional amount of vertical blur, in pixels
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.blur(5, 10)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.blur = function (x, y) {
	        if (x == null) {
	            x = 2;
	        }
	        var def = y == null ? x : [x, y];
	        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
	            def: def
	        });
	    };
	    Snap.filter.blur.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.shadow
	     [ method ]
	     **
	     * Returns an SVG markup string for the shadow filter
	     **
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - blur (number) #optional amount of blur
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - color (string) #optional color of the shadow
	     - opacity (number) #optional `0..1` opacity of the shadow
	     * which makes blur default to `4`. Or
	     - dx (number) #optional horizontal shift of the shadow, in pixels
	     - dy (number) #optional vertical shift of the shadow, in pixels
	     - opacity (number) #optional `0..1` opacity of the shadow
	     = (string) filter representation
	     > Usage
	     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
	     |     c = paper.circle(10, 10, 10).attr({
	     |         filter: f
	     |     });
	    \*/
	    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
	        if (opacity == null) {
	            if (color == null) {
	                opacity = blur;
	                blur = 4;
	                color = "#000";
	            } else {
	                opacity = color;
	                color = blur;
	                blur = 4;
	            }
	        }
	        if (blur == null) {
	            blur = 4;
	        }
	        if (opacity == null) {
	            opacity = 1;
	        }
	        if (dx == null) {
	            dx = 0;
	            dy = 2;
	        }
	        if (dy == null) {
	            dy = dx;
	        }
	        color = Snap.color(color);
	        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
	            color: color,
	            dx: dx,
	            dy: dy,
	            blur: blur,
	            opacity: opacity
	        });
	    };
	    Snap.filter.shadow.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.grayscale
	     [ method ]
	     **
	     * Returns an SVG markup string for the grayscale filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.grayscale = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
	            a: 0.2126 + 0.7874 * (1 - amount),
	            b: 0.7152 - 0.7152 * (1 - amount),
	            c: 0.0722 - 0.0722 * (1 - amount),
	            d: 0.2126 - 0.2126 * (1 - amount),
	            e: 0.7152 + 0.2848 * (1 - amount),
	            f: 0.0722 - 0.0722 * (1 - amount),
	            g: 0.2126 - 0.2126 * (1 - amount),
	            h: 0.0722 + 0.9278 * (1 - amount)
	        });
	    };
	    Snap.filter.grayscale.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.sepia
	     [ method ]
	     **
	     * Returns an SVG markup string for the sepia filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.sepia = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
	            a: 0.393 + 0.607 * (1 - amount),
	            b: 0.769 - 0.769 * (1 - amount),
	            c: 0.189 - 0.189 * (1 - amount),
	            d: 0.349 - 0.349 * (1 - amount),
	            e: 0.686 + 0.314 * (1 - amount),
	            f: 0.168 - 0.168 * (1 - amount),
	            g: 0.272 - 0.272 * (1 - amount),
	            h: 0.534 - 0.534 * (1 - amount),
	            i: 0.131 + 0.869 * (1 - amount)
	        });
	    };
	    Snap.filter.sepia.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.saturate
	     [ method ]
	     **
	     * Returns an SVG markup string for the saturate filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.saturate = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
	            amount: 1 - amount
	        });
	    };
	    Snap.filter.saturate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.hueRotate
	     [ method ]
	     **
	     * Returns an SVG markup string for the hue-rotate filter
	     **
	     - angle (number) angle of rotation
	     = (string) filter representation
	    \*/
	    Snap.filter.hueRotate = function (angle) {
	        angle = angle || 0;
	        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
	            angle: angle
	        });
	    };
	    Snap.filter.hueRotate.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.invert
	     [ method ]
	     **
	     * Returns an SVG markup string for the invert filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.invert = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
	        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: 1 - amount
	        });
	    };
	    Snap.filter.invert.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.brightness
	     [ method ]
	     **
	     * Returns an SVG markup string for the brightness filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.brightness = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
	            amount: amount
	        });
	    };
	    Snap.filter.brightness.toString = function () {
	        return this();
	    };
	    /*\
	     * Snap.filter.contrast
	     [ method ]
	     **
	     * Returns an SVG markup string for the contrast filter
	     **
	     - amount (number) amount of filter (`0..1`)
	     = (string) filter representation
	    \*/
	    Snap.filter.contrast = function (amount) {
	        if (amount == null) {
	            amount = 1;
	        }
	        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
	            amount: amount,
	            amount2: .5 - amount / 2
	        });
	    };
	    Snap.filter.contrast.toString = function () {
	        return this();
	    };
	});
	
	// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var box = Snap._.box,
	        is = Snap.is,
	        firstLetter = /^[^a-z]*([tbmlrc])/i,
	        toString = function () {
	            return "T" + this.dx + "," + this.dy;
	        };
	    /*\
	     * Element.getAlign
	     [ method ]
	     **
	     * Returns shift needed to align the element relatively to given element.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
	     > Usage
	     | el.transform(el.getAlign(el2, "top"));
	     * or
	     | var dy = el.getAlign(el2, "top").dy;
	    \*/
	    Element.prototype.getAlign = function (el, way) {
	        if (way == null && is(el, "string")) {
	            way = el;
	            el = null;
	        }
	        el = el || this.paper;
	        var bx = el.getBBox ? el.getBBox() : box(el),
	            bb = this.getBBox(),
	            out = {};
	        way = way && way.match(firstLetter);
	        way = way ? way[1].toLowerCase() : "c";
	        switch (way) {
	            case "t":
	                out.dx = 0;
	                out.dy = bx.y - bb.y;
	            break;
	            case "b":
	                out.dx = 0;
	                out.dy = bx.y2 - bb.y2;
	            break;
	            case "m":
	                out.dx = 0;
	                out.dy = bx.cy - bb.cy;
	            break;
	            case "l":
	                out.dx = bx.x - bb.x;
	                out.dy = 0;
	            break;
	            case "r":
	                out.dx = bx.x2 - bb.x2;
	                out.dy = 0;
	            break;
	            default:
	                out.dx = bx.cx - bb.cx;
	                out.dy = 0;
	            break;
	        }
	        out.toString = toString;
	        return out;
	    };
	    /*\
	     * Element.align
	     [ method ]
	     **
	     * Aligns the element relatively to given one via transformation.
	     * If no elements specified, parent `<svg>` container will be used.
	     - el (object) @optional alignment element
	     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
	     = (object) this element
	     > Usage
	     | el.align(el2, "top");
	     * or
	     | el.align("middle");
	    \*/
	    Element.prototype.align = function (el, way) {
	        return this.transform("..." + this.getAlign(el, way));
	    };
	});
	
	// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
	    var elproto = Element.prototype,
	        is = Snap.is,
	        Str = String,
	        has = "hasOwnProperty";
	    function slice(from, to, f) {
	        return function (arr) {
	            var res = arr.slice(from, to);
	            if (res.length == 1) {
	                res = res[0];
	            }
	            return f ? f(res) : res;
	        };
	    }
	    var Animation = function (attr, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        this.attr = attr;
	        this.dur = ms;
	        easing && (this.easing = easing);
	        callback && (this.callback = callback);
	    };
	    Snap._.Animation = Animation;
	    /*\
	     * Snap.animation
	     [ method ]
	     **
	     * Creates an animation object
	     **
	     - attr (object) attributes of final destination
	     - duration (number) duration of the animation, in milliseconds
	     - easing (function) #optional one of easing functions of @mina or custom one
	     - callback (function) #optional callback function that fires when animation ends
	     = (object) animation object
	    \*/
	    Snap.animation = function (attr, ms, easing, callback) {
	        return new Animation(attr, ms, easing, callback);
	    };
	    /*\
	     * Element.inAnim
	     [ method ]
	     **
	     * Returns a set of animations that may be able to manipulate the current element
	     **
	     = (object) in format:
	     o {
	     o     anim (object) animation object,
	     o     mina (object) @mina object,
	     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	    \*/
	    elproto.inAnim = function () {
	        var el = this,
	            res = [];
	        for (var id in el.anims) if (el.anims[has](id)) {
	            (function (a) {
	                res.push({
	                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
	                    mina: a,
	                    curStatus: a.status(),
	                    status: function (val) {
	                        return a.status(val);
	                    },
	                    stop: function () {
	                        a.stop();
	                    }
	                });
	            }(el.anims[id]));
	        }
	        return res;
	    };
	    /*\
	     * Snap.animate
	     [ method ]
	     **
	     * Runs generic animation of one number into another with a caring function
	     **
	     - from (number|array) number or array of numbers
	     - to (number|array) number or array of numbers
	     - setter (function) caring function that accepts one number argument
	     - duration (number) duration, in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function to execute when animation ends
	     = (object) animation object in @mina format
	     o {
	     o     id (string) animation id, consider it read-only,
	     o     duration (function) gets or sets the duration of the animation,
	     o     easing (function) easing,
	     o     speed (function) gets or sets the speed of the animation,
	     o     status (function) gets or sets the status of the animation,
	     o     stop (function) stops the animation
	     o }
	     | var rect = Snap().rect(0, 0, 10, 10);
	     | Snap.animate(0, 10, function (val) {
	     |     rect.attr({
	     |         x: val
	     |     });
	     | }, 1000);
	     | // in given context is equivalent to
	     | rect.animate({x: 10}, 1000);
	    \*/
	    Snap.animate = function (from, to, setter, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        var now = mina.time(),
	            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
	        callback && eve.once("mina.finish." + anim.id, callback);
	        return anim;
	    };
	    /*\
	     * Element.stop
	     [ method ]
	     **
	     * Stops all the animations for the current element
	     **
	     = (Element) the current element
	    \*/
	    elproto.stop = function () {
	        var anims = this.inAnim();
	        for (var i = 0, ii = anims.length; i < ii; i++) {
	            anims[i].stop();
	        }
	        return this;
	    };
	    /*\
	     * Element.animate
	     [ method ]
	     **
	     * Animates the given attributes of the element
	     **
	     - attrs (object) key-value pairs of destination attributes
	     - duration (number) duration of the animation in milliseconds
	     - easing (function) #optional easing function from @mina or custom
	     - callback (function) #optional callback function that executes when the animation ends
	     = (Element) the current element
	    \*/
	    elproto.animate = function (attrs, ms, easing, callback) {
	        if (typeof easing == "function" && !easing.length) {
	            callback = easing;
	            easing = mina.linear;
	        }
	        if (attrs instanceof Animation) {
	            callback = attrs.callback;
	            easing = attrs.easing;
	            ms = attrs.dur;
	            attrs = attrs.attr;
	        }
	        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
	            el = this;
	        for (var key in attrs) if (attrs[has](key)) {
	            if (el.equal) {
	                eq = el.equal(key, Str(attrs[key]));
	                from = eq.from;
	                to = eq.to;
	                f = eq.f;
	            } else {
	                from = +el.attr(key);
	                to = +attrs[key];
	            }
	            var len = is(from, "array") ? from.length : 1;
	            keys[key] = slice(fkeys.length, fkeys.length + len, f);
	            fkeys = fkeys.concat(from);
	            tkeys = tkeys.concat(to);
	        }
	        var now = mina.time(),
	            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
	                var attr = {};
	                for (var key in keys) if (keys[has](key)) {
	                    attr[key] = keys[key](val);
	                }
	                el.attr(attr);
	            }, easing);
	        el.anims[anim.id] = anim;
	        anim._attrs = attrs;
	        anim._callback = callback;
	        eve("snap.animcreated." + el.id, anim);
	        eve.once("mina.finish." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	            callback && callback.call(el);
	        });
	        eve.once("mina.stop." + anim.id, function () {
	            eve.off("mina.*." + anim.id);
	            delete el.anims[anim.id];
	        });
	        return el;
	    };
	});
	
	// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	// http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	Snap.plugin(function (Snap, Element, Paper, glob) {
	    // Colours are from https://www.materialui.co
	    var red         = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
	        pink        = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
	        purple      = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
	        deeppurple  = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
	        indigo      = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
	        blue        = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
	        lightblue   = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
	        cyan        = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
	        teal        = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
	        green       = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
	        lightgreen  = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
	        lime        = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
	        yellow      = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
	        amber       = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
	        orange      = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
	        deeporange  = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
	        brown       = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
	        grey        = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
	        bluegrey    = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
	    /*\
	     * Snap.mui
	     [ property ]
	     **
	     * Contain Material UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.mui = {};
	    /*\
	     * Snap.flat
	     [ property ]
	     **
	     * Contain Flat UI colours.
	     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.flat = {};
	    function saveColor(colors) {
	        colors = colors.split(/(?=#)/);
	        var color = new String(colors[5]);
	        color[50] = colors[0];
	        color[100] = colors[1];
	        color[200] = colors[2];
	        color[300] = colors[3];
	        color[400] = colors[4];
	        color[500] = colors[5];
	        color[600] = colors[6];
	        color[700] = colors[7];
	        color[800] = colors[8];
	        color[900] = colors[9];
	        if (colors[10]) {
	            color.A100 = colors[10];
	            color.A200 = colors[11];
	            color.A400 = colors[12];
	            color.A700 = colors[13];
	        }
	        return color;
	    }
	    Snap.mui.red = saveColor(red);
	    Snap.mui.pink = saveColor(pink);
	    Snap.mui.purple = saveColor(purple);
	    Snap.mui.deeppurple = saveColor(deeppurple);
	    Snap.mui.indigo = saveColor(indigo);
	    Snap.mui.blue = saveColor(blue);
	    Snap.mui.lightblue = saveColor(lightblue);
	    Snap.mui.cyan = saveColor(cyan);
	    Snap.mui.teal = saveColor(teal);
	    Snap.mui.green = saveColor(green);
	    Snap.mui.lightgreen = saveColor(lightgreen);
	    Snap.mui.lime = saveColor(lime);
	    Snap.mui.yellow = saveColor(yellow);
	    Snap.mui.amber = saveColor(amber);
	    Snap.mui.orange = saveColor(orange);
	    Snap.mui.deeporange = saveColor(deeporange);
	    Snap.mui.brown = saveColor(brown);
	    Snap.mui.grey = saveColor(grey);
	    Snap.mui.bluegrey = saveColor(bluegrey);
	    Snap.flat.turquoise = "#1abc9c";
	    Snap.flat.greensea = "#16a085";
	    Snap.flat.sunflower = "#f1c40f";
	    Snap.flat.orange = "#f39c12";
	    Snap.flat.emerland = "#2ecc71";
	    Snap.flat.nephritis = "#27ae60";
	    Snap.flat.carrot = "#e67e22";
	    Snap.flat.pumpkin = "#d35400";
	    Snap.flat.peterriver = "#3498db";
	    Snap.flat.belizehole = "#2980b9";
	    Snap.flat.alizarin = "#e74c3c";
	    Snap.flat.pomegranate = "#c0392b";
	    Snap.flat.amethyst = "#9b59b6";
	    Snap.flat.wisteria = "#8e44ad";
	    Snap.flat.clouds = "#ecf0f1";
	    Snap.flat.silver = "#bdc3c7";
	    Snap.flat.wetasphalt = "#34495e";
	    Snap.flat.midnightblue = "#2c3e50";
	    Snap.flat.concrete = "#95a5a6";
	    Snap.flat.asbestos = "#7f8c8d";
	    /*\
	     * Snap.importMUIColors
	     [ method ]
	     **
	     * Imports Material UI colours into global object.
	     | Snap.importMUIColors();
	     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
	     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
	    \*/
	    Snap.importMUIColors = function () {
	        for (var color in Snap.mui) {
	            if (Snap.mui.hasOwnProperty(color)) {
	                window[color] = Snap.mui[color];
	            }
	        }
	    };
	});
	
	module.exports = Snap


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBurgerMenu = __webpack_require__(631);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _AsideMenuModule = __webpack_require__(374);
	
	var _AsideMenuModule2 = _interopRequireDefault(_AsideMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsideMenu = function (_Component) {
		_inherits(AsideMenu, _Component);
	
		function AsideMenu() {
			_classCallCheck(this, AsideMenu);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		AsideMenu.prototype.render = function render() {
			var _this2 = this;
	
			var menuItems = this.props.menuItems;
	
			return _react2.default.createElement(
				_reactBurgerMenu.stack,
				_extends({}, this.props, {
					overlayClassName: _AsideMenuModule2.default.overlay,
					menuClassName: _AsideMenuModule2.default.menu,
					burgerButtonClassName: _AsideMenuModule2.default.burgerButton,
					crossClassName: _AsideMenuModule2.default.cross,
					crossButtonClassName: _AsideMenuModule2.default.crossButton }),
				menuItems.map(function (_ref, index) {
					var _ref$node$frontmatter = _ref.node.frontmatter,
					    part = _ref$node$frontmatter.part,
					    title = _ref$node$frontmatter.title,
					    slug = _ref$node$frontmatter.slug;
					return _react2.default.createElement(
						_gatsbyLink2.default,
						{ key: index, to: '/' + slug, className: _AsideMenuModule2.default.menuItemLink, onClick: _this2.props.hideMenu },
						_react2.default.createElement(
							'span',
							{ className: _AsideMenuModule2.default.menuItemTextA },
							part
						),
						_react2.default.createElement(
							'span',
							{ className: _AsideMenuModule2.default.menuItemTextB },
							title
						)
					);
				}),
				_react2.default.createElement(
					'div',
					{ className: _AsideMenuModule2.default.socialLinks },
					_SiteConfig.social.map(function (_ref2, index) {
						var name = _ref2.name,
						    icon = _ref2.icon,
						    link = _ref2.link;
						return _react2.default.createElement(
							'a',
							{ key: index, href: link, title: name, target: '_blank' },
							_react2.default.createElement('img', { src: icon, alt: name, title: name })
						);
					})
				)
			);
		};
	
		return AsideMenu;
	}(_react.Component);
	
	exports.default = AsideMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overlay":"src-components-AsideMenu----AsideMenu-module---overlay---1P8lZ","menu":"src-components-AsideMenu----AsideMenu-module---menu---3ytQO","burgerButton":"src-components-AsideMenu----AsideMenu-module---burgerButton---193d8","cross":"src-components-AsideMenu----AsideMenu-module---cross---2Tav7","crossButton":"src-components-AsideMenu----AsideMenu-module---crossButton---33Fnb","socialLinks":"src-components-AsideMenu----AsideMenu-module---socialLinks---2DNNg","menuItemLink":"src-components-AsideMenu----AsideMenu-module---menuItemLink---1BHtK","menuItemTextA":"src-components-AsideMenu----AsideMenu-module---menuItemTextA---2d-4n","menuItemTextB":"src-components-AsideMenu----AsideMenu-module---menuItemTextB---3_k2C"};

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brand = function (_Component) {
		_inherits(Brand, _Component);
	
		function Brand() {
			_classCallCheck(this, Brand);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		Brand.prototype.render = function render() {
			var _props = this.props,
			    containerClassName = _props.containerClassName,
			    fill = _props.fill;
	
			return _react2.default.createElement(
				'div',
				{ className: containerClassName },
				_react2.default.createElement(
					'svg',
					{ xmlns: 'http://www.w3.org/2000/svg', width: '186', height: '50', viewBox: '0 0 186 50', style: { maxWidth: '182px' } },
					_react2.default.createElement(
						'g',
						{ fill: fill },
						_react2.default.createElement('path', { d: 'M93.968254,38.968254 C93.7301587,35.7142857 91.1904762,32.3015873 88.1746032,30.7936508 C85.7142857,29.5238095 84.047619,29.7619048 83.015873,30.6349206 C82.4603175,31.1111111 82.1428571,32.2222222 82.3809524,33.6507937 C82.7777778,35.5555556 84.047619,37.4603175 85.8730159,38.1746032 C87.3809524,38.8095238 89.1269841,38.015873 87.8571429,36.4285714 C87.3015873,35.7142857 86.6666667,35.6349206 86.031746,35.3968254 C85.1587302,35.0793651 84.7619048,34.6031746 84.6031746,33.8888889 C84.3650794,32.9365079 85.3174603,32.3809524 86.5873016,32.9365079 C87.5396825,33.3333333 88.8095238,34.2063492 89.6825397,35.6349206 C90.5555556,37.0634921 90.6349206,38.2539683 90.2380952,39.2857143 C89.9206349,39.9206349 89.2063492,40.6349206 87.8571429,40.6349206 C86.1904762,40.6349206 84.2063492,40.0793651 82.3015873,37.7777778 C81.984127,37.3809524 81.6666667,37.6190476 81.8253968,37.7777778 C82.7777778,39.4444444 84.6031746,41.5079365 85.6349206,42.3015873 C86.8253968,43.1746032 88.7301587,43.4920635 90.0793651,43.3333333 C91.984127,43.015873 94.1269841,41.7460317 93.968254,38.968254' }),
						_react2.default.createElement('path', { d: 'M108.095238,47.8571429 C106.349206,47.3809524 103.730159,45.7936508 102.539683,43.2539683 C102.460317,43.0952381 102.380952,43.015873 102.380952,42.8571429 C101.507937,40.7142857 101.269841,37.9365079 102.301587,34.8412698 C103.095238,32.5396825 102.857143,31.6666667 99.7619048,31.1111111 C99.6825397,31.1111111 99.6825397,31.1111111 99.6031746,31.1111111 C95.4761905,30.3174603 85.4761905,25.8730159 81.2698413,19.4444444 C80.7142857,18.5714286 80.2380952,17.6984127 79.9206349,16.8253968 C79.7619048,16.4285714 79.5238095,16.6666667 79.4444444,16.9047619 C78.6507937,19.3650794 78.2539683,21.5873016 78.2539683,24.1269841 C78.1746032,26.6666667 78.4920635,29.2857143 79.2063492,31.8253968 C79.4444444,32.6190476 79.6825397,33.2539683 79.9206349,33.968254 C80.0793651,34.3650794 80.3174603,34.1269841 80.2380952,33.7301587 C79.9206349,31.4285714 80.8730159,29.3650794 82.4603175,28.4126984 C82.6984127,28.2539683 83.4920635,27.6984127 84.9206349,27.6984127 C86.3492063,27.6984127 88.015873,28.2539683 89.8412698,29.2857143 C93.8095238,31.5873016 96.8253968,35.7142857 96.4285714,40.3174603 C96.1111111,43.8888889 93.4920635,45.7936508 90.7936508,45.6349206 C90.2380952,45.6349206 90.2380952,45.8730159 90.3968254,46.031746 C92.5396825,47.2222222 95.0793651,48.3333333 97.8571429,48.8888889 C98.3333333,48.968254 99.3650794,49.2857143 100.15873,49.2063492 C100.873016,49.2063492 100.873016,48.8888889 100,48.5714286 C98.968254,48.0952381 98.2539683,47.6190476 97.6984127,46.9047619 C97.2222222,46.2698413 97.5396825,45.6349206 97.9365079,45 C98.4126984,44.2857143 98.4920635,44.3650794 99.2857143,45.0793651 C102.936508,48.8095238 105.634921,48.8888889 107.063492,48.7301587 C108.095238,48.4920635 108.968254,48.0952381 108.095238,47.8571429' }),
						_react2.default.createElement('path', { d: 'M111.190476,22.8571429 C108.968254,23.0952381 106.984127,23.3333333 105.079365,23.4920635 C102.936508,23.6507937 100.952381,23.8095238 98.8888889,23.6507937 C96.3492063,23.4920635 93.7301587,22.9365079 90.7936508,21.6666667 C88.3333333,20.6349206 85.7936508,18.8888889 84.2857143,16.3492063 C83.4920635,15 82.7777778,12.8571429 82.6984127,11.031746 C82.6984127,10.3968254 82.3809524,10.4761905 81.984127,11.1111111 C81.5079365,11.9047619 80.952381,12.6984127 80.7142857,13.3333333 C80.4761905,13.8888889 81.5079365,16.1111111 82.6190476,17.7777778 C82.7777778,18.015873 82.9365079,18.2539683 83.0952381,18.4920635 C86.6666667,23.7301587 94.4444444,27.1428571 99.1269841,28.4126984 C99.1269841,28.4126984 99.2063492,28.4126984 99.2063492,28.4126984 C100.793651,28.8888889 102.142857,29.2857143 103.333333,29.4444444 C104.52381,29.5238095 105.238095,28.968254 106.666667,28.3333333 C107.301587,28.0952381 107.936508,27.7777778 108.571429,27.5396825 C109.920635,27.0634921 111.428571,26.7460317 113.730159,26.6666667 C116.825397,26.5079365 119.206349,27.5396825 120.793651,29.6031746 C121.746032,30.8730159 122.301587,32.3809524 122.063492,34.4444444 C121.746032,37.0634921 119.68254,40.4761905 116.111111,41.984127 C113.492063,43.1746032 111.428571,42.6984127 110.15873,41.8253968 C109.444444,41.3492063 108.968254,40.7142857 108.809524,40.1587302 C108.412698,38.8888889 108.412698,37.4603175 109.444444,35.8730159 C109.84127,35.2380952 110.396825,34.6825397 110.952381,34.2063492 C112.301587,33.1746032 113.968254,32.7777778 115.31746,33.4920635 C116.428571,34.1269841 116.666667,36.5873016 113.571429,36.984127 C112.777778,37.0634921 111.984127,37.8571429 111.984127,38.8095238 C111.984127,40.3968254 113.492063,40.4761905 114.365079,40.3174603 C117.063492,39.9206349 118.571429,37.8571429 119.206349,36.3492063 C120,34.4444444 119.68254,32.4603175 118.492063,31.031746 C117.698413,30.0793651 116.111111,29.047619 113.571429,29.047619 C112.222222,29.047619 110.952381,29.3650794 109.761905,29.8412698 C108.095238,30.5555556 106.666667,31.7460317 105.555556,33.4126984 C103.650794,36.2698413 103.015873,40.5555556 105.952381,43.4126984 C106.904762,44.3650794 107.936508,44.9206349 108.968254,45.2380952 C110.952381,45.8730159 113.015873,45.4761905 114.920635,44.8412698 C118.888889,43.6507937 125.634921,38.3333333 124.365079,30.4761905 C123.571429,25.3968254 118.968254,22.1428571 111.190476,22.8571429' }),
						_react2.default.createElement('path', { d: 'M126.984127 27.2222222C126.825397 25.1587302 125.555556 20.3174603 118.253968 17.7777778 114.920635 16.5873016 111.111111 16.6666667 108.730159 16.6666667 108.174603 16.6666667 107.857143 16.5079365 107.777778 16.1111111 107.698413 15.7936508 107.857143 15.3174603 108.253968 14.7619048 108.888889 13.968254 109.84127 13.015873 111.031746 13.015873 119.920635 13.0952381 123.650794 16.9047619 126.190476 20.6349206 126.904762 21.6666667 127.142857 20.952381 126.349206 19.047619 125.47619 16.9047619 123.253968 13.8888889 119.68254 11.7460317 116.746032 10.0793651 114.444444 9.44444444 112.380952 8.96825397 111.190476 8.65079365 110.873016 7.85714286 110.555556 6.74603175 110.238095 5.55555556 110.634921 5.07936508 111.587302 5.31746032 117.301587 6.42857143 120.714286 9.76190476 121.984127 11.1904762 122.936508 12.1428571 123.174603 11.5873016 122.301587 10.3968254 120.952381 8.49206349 119.206349 6.42857143 115.793651 4.20634921 110.634921.793650794 104.84127-.238095238 100.238095.317460317 99.1269841.476190476 99.6825397.952380952 100.079365 1.11111111 102.380952 1.9047619 103.412698 2.46031746 104.52381 3.41269841 106.190476 4.92063492 107.063492 7.61904762 106.031746 10.4761905 105.238095 12.6190476 102.857143 15 99.1269841 15.952381 97.8571429 16.2698413 96.4285714 16.4285714 94.7619048 16.4285714 92.9365079 16.3492063 90.3174603 15.6349206 88.8888889 14.2857143 88.7301587 14.1269841 88.5714286 13.968254 88.4126984 13.7301587 87.1428571 12.0634921 87.4603175 9.84126984 88.015873 8.65079365 89.047619 6.34920635 91.5873016 4.76190476 93.968254 4.52380952 95.952381 4.36507937 97.7777778 4.76190476 98.968254 5.87301587 99.7619048 6.50793651 100.31746 7.61904762 99.8412698 8.65079365 98.8888889 10.8730159 95.4761905 11.5873016 94.3650794 11.1111111 93.015873 10.5555556 93.6507937 9.36507937 94.5238095 9.04761905 95.5555556 8.65079365 96.2698413 8.41269841 96.5079365 7.61904762 96.6666667 6.9047619 95.5555556 5.55555556 92.8571429 6.58730159 91.6666667 6.98412698 90.5555556 8.01587302 90.2380952 9.36507937 89.9206349 10.5555556 90.3174603 11.8253968 91.1111111 12.6984127 91.6666667 13.2539683 92.8571429 14.2857143 95.3174603 14.2857143 96.4285714 14.2857143 97.8571429 14.047619 99.047619 13.5714286 103.253968 11.9047619 103.809524 8.57142857 103.412698 7.3015873 102.936508 5.3968254 101.507937 3.96825397 99.2857143 3.17460317 96.984127 2.38095238 94.6825397 2.14285714 91.8253968 2.93650794 90.3174603 3.41269841 87.0634921 4.92063492 85.6349206 8.0952381 84.3650794 10.7936508 84.9206349 13.4920635 86.031746 15.3968254 86.4285714 16.031746 86.9047619 16.5873016 87.3809524 17.0634921 89.047619 18.6507937 92.6190476 20.4761905 97.0634921 21.1111111 97.8571429 21.1904762 98.6507937 21.2698413 99.4444444 21.3492063 100.793651 21.4285714 102.142857 21.4285714 103.333333 21.4285714 106.269841 21.3492063 108.888889 21.031746 111.031746 20.7936508 114.68254 20.4761905 116.587302 20.7936508 118.809524 21.3492063 124.444444 22.8571429 125.634921 26.8253968 125.952381 28.1746032 126.507937 29.4444444 127.063492 28.6507937 126.984127 27.2222222M.793650794 5.87301587C.793650794 5.63492063.952380952 5.47619048 1.19047619 5.47619048L7.93650794 5.47619048C10.6349206 5.47619048 12.8571429 7.6984127 12.8571429 10.3174603 12.8571429 12.3809524 11.5079365 14.047619 9.52380952 14.7619048L12.6190476 20.4761905C12.7777778 20.7936508 12.6190476 21.1111111 12.2222222 21.1111111L9.20634921 21.1111111C9.04761905 21.1111111 8.88888889 21.031746 8.80952381 20.8730159L5.79365079 14.9206349 4.20634921 14.9206349 4.20634921 20.6349206C4.20634921 20.8730159 3.96825397 21.031746 3.80952381 21.031746L1.11111111 21.031746C.873015873 21.031746.714285714 20.7936508.714285714 20.6349206L.793650794 5.87301587zM7.6984127 12.1428571C8.65079365 12.1428571 9.44444444 11.2698413 9.36507937 10.3968254 9.36507937 9.44444444 8.57142857 8.73015873 7.61904762 8.65079365L4.28571429 8.65079365 4.28571429 12.1428571 7.6984127 12.1428571zM14.2063492 20.6349206L21.1904762 5.87301587C21.2698413 5.71428571 21.4285714 5.63492063 21.5873016 5.63492063L21.8253968 5.63492063C21.984127 5.63492063 22.1428571 5.71428571 22.2222222 5.87301587L29.3650794 20.6349206C29.5238095 20.952381 29.2857143 21.1904762 28.968254 21.1904762L26.5079365 21.1904762C26.1111111 21.1904762 25.952381 21.031746 25.7142857 20.6349206L24.9206349 18.8888889 18.8095238 18.8888889 18.015873 20.7142857C17.9365079 20.952381 17.6190476 21.2698413 17.2222222 21.2698413L14.7619048 21.2698413C14.2857143 21.1904762 14.1269841 20.8730159 14.2063492 20.6349206zM23.4920635 15.8730159L21.7460317 12.1428571 20 15.8730159 23.4920635 15.8730159zM31.4285714 6.03174603C31.4285714 5.79365079 31.5873016 5.63492063 31.8253968 5.63492063L37.3015873 5.63492063C41.6666667 5.63492063 45.2380952 9.20634921 45.2380952 13.4920635 45.2380952 17.8571429 41.7460317 21.3492063 37.3809524 21.3492063L31.9047619 21.3492063C31.6666667 21.3492063 31.5079365 21.1111111 31.5079365 20.952381L31.4285714 6.03174603zM37.1428571 17.9365079C39.6825397 17.9365079 41.5079365 15.952381 41.5079365 13.4126984 41.5079365 10.8730159 39.6825397 8.88888889 37.0634921 8.88888889L34.9206349 8.88888889 34.9206349 17.9365079 37.1428571 17.9365079zM48.2539683 6.11111111C48.2539683 5.87301587 48.4920635 5.71428571 48.6507937 5.71428571L51.3492063 5.71428571C51.5873016 5.71428571 51.7460317 5.95238095 51.7460317 6.11111111L51.8253968 20.952381C51.8253968 21.1904762 51.5873016 21.3492063 51.4285714 21.3492063L48.7301587 21.3492063C48.4920635 21.3492063 48.3333333 21.1111111 48.3333333 20.952381L48.2539683 6.11111111zM62.9365079 5.47619048C67.4603175 5.47619048 71.031746 9.12698413 71.1111111 13.5714286 71.1111111 18.015873 67.5396825 21.5873016 63.015873 21.5873016 58.4920635 21.5873016 54.9206349 18.015873 54.9206349 13.4920635 54.8412698 9.04761905 58.4126984 5.47619048 62.9365079 5.47619048M62.9365079 18.015873C65.3968254 18.015873 67.4603175 16.031746 67.4603175 13.5714286 67.4603175 11.1111111 65.3968254 9.04761905 62.9365079 9.04761905 60.4761905 9.04761905 58.4920635 11.031746 58.4920635 13.4920635 58.4920635 16.031746 60.4761905 18.015873 62.9365079 18.015873M20.2380952 36.4285714C21.2698413 36.4285714 21.984127 36.7460317 22.6190476 37.3809524 22.6984127 37.4603175 22.6984127 37.6190476 22.6190476 37.6984127L21.8253968 38.4920635C21.7460317 38.5714286 21.6666667 38.5714286 21.5873016 38.4920635 21.1904762 38.1746032 20.7142857 38.015873 20.2380952 38.015873 19.1269841 38.015873 18.2539683 38.968254 18.3333333 40.0793651 18.3333333 41.1904762 19.2063492 42.0634921 20.3174603 42.1428571 20.7936508 42.1428571 21.2698413 41.984127 21.6666667 41.6666667 21.7460317 41.5873016 21.8253968 41.5873016 21.9047619 41.6666667L22.6984127 42.4603175C22.7777778 42.5396825 22.7777778 42.6984127 22.6984127 42.6984127 22.0634921 43.3333333 21.1904762 43.6507937 20.3174603 43.6507937 18.3333333 43.6507937 16.7460317 42.0634921 16.7460317 40.0793651 16.6666667 38.015873 18.2539683 36.4285714 20.2380952 36.4285714M27.3015873 36.5079365C29.2857143 36.5079365 30.8730159 38.0952381 30.8730159 40.0793651 30.8730159 42.0634921 29.2857143 43.6507937 27.3015873 43.6507937 25.3174603 43.6507937 23.7301587 42.0634921 23.7301587 40.0793651 23.7301587 38.0952381 25.3174603 36.5079365 27.3015873 36.5079365M27.3015873 42.0634921C28.4126984 42.0634921 29.2857143 41.1904762 29.2857143 40.0793651 29.2857143 38.968254 28.4126984 38.0952381 27.3015873 38.0952381 26.1904762 38.0952381 25.3174603 38.968254 25.3174603 40.0793651 25.3174603 41.1904762 26.2698413 42.0634921 27.3015873 42.0634921M32.4603175 36.8253968C32.4603175 36.7460317 32.5396825 36.6666667 32.6190476 36.6666667L33.8095238 36.6666667C33.8888889 36.6666667 33.968254 36.7460317 33.968254 36.8253968L33.968254 42.1428571 36.3492063 42.1428571C36.4285714 42.1428571 36.5079365 42.2222222 36.5079365 42.3015873L36.5079365 43.4126984C36.5079365 43.4920635 36.4285714 43.5714286 36.3492063 43.5714286L32.6190476 43.5714286C32.5396825 43.5714286 32.4603175 43.4920635 32.4603175 43.4126984L32.4603175 36.8253968zM40.952381 36.5873016C42.9365079 36.5873016 44.5238095 38.1746032 44.5238095 40.1587302 44.5238095 42.1428571 42.9365079 43.7301587 40.952381 43.7301587 38.968254 43.7301587 37.3809524 42.1428571 37.3809524 40.1587302 37.4603175 38.0952381 38.968254 36.5079365 40.952381 36.5873016M41.031746 42.1428571C42.1428571 42.1428571 43.015873 41.2698413 43.015873 40.1587302 43.015873 39.047619 42.1428571 38.1746032 41.031746 38.1746032 39.9206349 38.1746032 39.047619 39.047619 39.047619 40.1587302 39.047619 41.1904762 39.9206349 42.1428571 41.031746 42.1428571M46.8253968 36.7460317C46.8253968 36.6666667 46.9047619 36.5873016 46.984127 36.5873016L47.1428571 36.5873016C47.2222222 36.5873016 47.3015873 36.6666667 47.3015873 36.6666667L49.6031746 40.952381 51.9047619 36.6666667C51.9047619 36.5873016 51.984127 36.5873016 52.0634921 36.5873016L52.2222222 36.5873016C52.3015873 36.5873016 52.3809524 36.6666667 52.3809524 36.7460317L53.5714286 43.4126984C53.5714286 43.5714286 53.4920635 43.6507937 53.4126984 43.6507937L52.2222222 43.6507937C52.1428571 43.6507937 52.0634921 43.5714286 52.0634921 43.4920635L51.5873016 40.3968254 49.9206349 43.5714286C49.9206349 43.6507937 49.7619048 43.6507937 49.7619048 43.6507937L49.6031746 43.6507937C49.5238095 43.6507937 49.4444444 43.5714286 49.4444444 43.5714286L47.7777778 40.3174603 47.3809524 43.4126984C47.3809524 43.4920635 47.3015873 43.5714286 47.2222222 43.5714286L46.031746 43.5714286C45.952381 43.5714286 45.7936508 43.4920635 45.8730159 43.3333333L46.8253968 36.7460317zM55.3174603 36.9047619C55.3174603 36.8253968 55.3968254 36.7460317 55.4761905 36.7460317L57.7777778 36.7460317C58.968254 36.7460317 59.9206349 37.5396825 59.9206349 38.5714286 59.9206349 39.3650794 59.2063492 39.9206349 58.8095238 40.1587302 59.3650794 40.3968254 60.1587302 40.8730159 60.1587302 41.7460317 60.1587302 42.8571429 59.2063492 43.6507937 58.015873 43.6507937L55.5555556 43.6507937C55.4761905 43.6507937 55.3968254 43.5714286 55.3968254 43.4920635L55.3174603 36.9047619zM57.6190476 39.5238095C58.015873 39.5238095 58.3333333 39.2063492 58.3333333 38.8095238 58.3333333 38.4126984 58.015873 38.0952381 57.6190476 38.0952381L56.8253968 38.0952381 56.8253968 39.5238095 57.6190476 39.5238095zM57.7777778 42.2222222C58.1746032 42.2222222 58.4920635 41.9047619 58.4920635 41.5079365 58.4920635 41.1111111 58.0952381 40.7936508 57.6984127 40.7936508L56.9047619 40.7936508 56.9047619 42.2222222 57.7777778 42.2222222zM61.7460317 36.9047619C61.7460317 36.8253968 61.8253968 36.7460317 61.9047619 36.7460317L63.0952381 36.7460317C63.1746032 36.7460317 63.2539683 36.8253968 63.2539683 36.9047619L63.2539683 43.4920635C63.2539683 43.5714286 63.1746032 43.6507937 63.0952381 43.6507937L61.9047619 43.6507937C61.8253968 43.6507937 61.7460317 43.5714286 61.7460317 43.4920635L61.7460317 36.9047619zM64.6031746 43.4126984L67.6984127 36.7460317C67.6984127 36.6666667 67.7777778 36.6666667 67.8571429 36.6666667L67.9365079 36.6666667C68.015873 36.6666667 68.0952381 36.7460317 68.0952381 36.7460317L71.2698413 43.4126984C71.3492063 43.5714286 71.2698413 43.6507937 71.1111111 43.6507937L70 43.6507937C69.8412698 43.6507937 69.7619048 43.5714286 69.6825397 43.4126984L69.2857143 42.6190476 66.5873016 42.6190476 66.2698413 43.4126984C66.1904762 43.4920635 66.1111111 43.6507937 65.952381 43.6507937L64.8412698 43.6507937C64.6031746 43.7301587 64.5238095 43.5714286 64.6031746 43.4126984zM68.6507937 41.3492063L67.8571429 39.6825397 67.1428571 41.3492063 68.6507937 41.3492063zM8.25396825 24.4444444L6.42857143 24.4444444C6.34920635 24.4444444 6.26984127 24.5238095 6.26984127 24.6031746L6.26984127 28.7301587 1.34920635 24.1269841C1.34920635 24.1269841 1.26984127 24.047619 1.19047619 24.047619L1.03174603 24.047619C.952380952 24.047619.873015873 24.1269841.873015873 24.2063492L.873015873 32.8571429C.873015873 32.9365079.952380952 33.015873 1.03174603 33.015873L2.85714286 33.015873C2.93650794 33.015873 3.01587302 32.9365079 3.01587302 32.8571429L3.01587302 28.7301587 7.93650794 33.3333333C7.93650794 33.3333333 8.01587302 33.4126984 8.0952381 33.4126984L8.25396825 33.4126984C8.33333333 33.4126984 8.41269841 33.3333333 8.41269841 33.2539683L8.41269841 24.6031746C8.41269841 24.5238095 8.33333333 24.4444444 8.25396825 24.4444444M14.9206349 24.3650794C14.9206349 24.2857143 14.8412698 24.2857143 14.7619048 24.2857143L14.6031746 24.2857143C14.5238095 24.2857143 14.4444444 24.3650794 14.4444444 24.3650794L10.2380952 32.9365079C10.2380952 33.015873 10.2380952 33.0952381 10.2380952 33.0952381 10.2380952 33.1746032 10.3174603 33.1746032 10.3968254 33.1746032L12.3809524 33.1746032C12.4603175 33.1746032 12.5396825 33.0952381 12.5396825 33.0952381L13.015873 31.984127 16.1904762 31.984127 16.6666667 33.0952381C16.6666667 33.1746032 16.7460317 33.1746032 16.8253968 33.1746032L18.8888889 33.1746032C18.968254 33.1746032 19.047619 33.1746032 19.047619 33.0952381 19.047619 33.015873 19.047619 32.9365079 19.047619 32.9365079L14.9206349 24.3650794zM15.3968254 30.1587302L13.8095238 30.1587302 14.6031746 28.2539683 15.3968254 30.1587302zM27.0634921 25.0793651C26.6666667 24.8412698 26.1904762 24.6031746 25.7936508 24.4444444 25.3174603 24.2857143 24.8412698 24.2063492 24.3650794 24.2063492 23.7301587 24.2063492 23.1746032 24.2857143 22.6190476 24.5238095 22.0634921 24.7619048 21.5873016 25.0793651 21.1111111 25.5555556 20.7142857 25.952381 20.3968254 26.5079365 20.1587302 27.0634921 19.9206349 27.6190476 19.8412698 28.2539683 19.8412698 28.8888889 19.8412698 29.6031746 20 30.3174603 20.3174603 30.952381 20.6349206 31.5873016 21.031746 32.1428571 21.5873016 32.5396825 21.984127 32.8571429 22.4603175 33.0952381 22.9365079 33.2539683 23.4126984 33.4126984 23.8888889 33.4920635 24.4444444 33.4920635 24.9206349 33.4920635 25.3968254 33.4126984 25.7936508 33.3333333 26.2698413 33.1746032 26.6666667 33.015873 26.984127 32.7777778 27.0634921 32.7777778 27.0634921 32.6984127 27.0634921 32.6190476 27.0634921 32.5396825 27.0634921 32.5396825 26.984127 32.4603175L25.8730159 31.031746C25.7936508 30.952381 25.7142857 30.952381 25.6349206 30.952381 25.3968254 31.031746 24.7619048 31.1904762 24.4444444 31.1904762 23.8095238 31.1904762 23.2539683 30.952381 22.8571429 30.5555556 22.4603175 30.1587302 22.2222222 29.6031746 22.2222222 28.8888889 22.2222222 28.1746032 22.4603175 27.6190476 22.8571429 27.1428571 23.2539683 26.6666667 23.8095238 26.5079365 24.4444444 26.5079365 24.7619048 26.5079365 25.3174603 26.6666667 25.5555556 26.7460317 25.6349206 26.7460317 25.7142857 26.7460317 25.7936508 26.6666667L27.0634921 25.3968254C27.1428571 25.3174603 27.1428571 25.3174603 27.1428571 25.2380952 27.1428571 25.1587302 27.0634921 25.0793651 27.0634921 25.0793651M31.7460317 24.5238095L29.7619048 24.5238095C29.6825397 24.5238095 29.6031746 24.6031746 29.6031746 24.6825397L29.6031746 33.015873C29.6031746 33.0952381 29.6825397 33.1746032 29.7619048 33.1746032L31.7460317 33.1746032C31.8253968 33.1746032 31.9047619 33.0952381 31.9047619 33.015873L31.9047619 24.6825397C31.9047619 24.6031746 31.8253968 24.5238095 31.7460317 24.5238095M41.9047619 25.6349206C41.5079365 25.2380952 41.031746 24.8412698 40.4761905 24.6031746 39.9206349 24.3650794 39.3650794 24.2857143 38.7301587 24.2857143 38.1746032 24.2857143 37.5396825 24.3650794 37.0634921 24.6031746 36.5079365 24.8412698 36.031746 25.1587302 35.6349206 25.5555556 35.2380952 26.031746 34.8412698 26.5079365 34.6825397 27.0634921 34.4444444 27.6190476 34.3650794 28.2539683 34.3650794 28.8888889 34.3650794 29.5238095 34.4444444 30.1587302 34.6825397 30.7142857 34.9206349 31.2698413 35.2380952 31.7460317 35.6349206 32.2222222 36.031746 32.6190476 36.5079365 33.015873 37.0634921 33.2539683 37.6190476 33.4920635 38.1746032 33.5714286 38.7301587 33.5714286 39.4444444 33.5714286 40.0793651 33.4126984 40.7142857 33.0952381 41.3492063 32.7777778 41.8253968 32.3809524 42.3015873 31.7460317 42.6190476 31.3492063 42.8571429 30.8730159 43.015873 30.3968254 43.1746032 29.9206349 43.2539683 29.3650794 43.2539683 28.8888889 43.2539683 28.2539683 43.1746032 27.6190476 42.9365079 27.0634921 42.6984127 26.5873016 42.3015873 26.1111111 41.9047619 25.6349206M40.7936508 28.968254C40.7936508 29.6825397 40.6349206 30.2380952 40.2380952 30.6349206 39.8412698 31.1111111 39.3650794 31.2698413 38.8095238 31.2698413 38.2539683 31.2698413 37.7777778 31.031746 37.3809524 30.5555556 36.984127 30.0793651 36.7460317 29.5238095 36.7460317 28.8888889 36.7460317 28.1746032 36.9047619 27.6190476 37.3015873 27.1428571 37.6984127 26.6666667 38.1746032 26.5079365 38.7301587 26.5079365 39.2857143 26.5079365 39.7619048 26.7460317 40.1587302 27.2222222 40.5555556 27.6984127 40.7936508 28.2539683 40.7936508 28.968254M52.9365079 24.6825397L51.1111111 24.6825397C51.031746 24.6825397 50.952381 24.7619048 50.952381 24.8412698L50.952381 28.968254 46.031746 24.3650794C46.031746 24.3650794 45.952381 24.2857143 45.8730159 24.2857143L45.7142857 24.2857143C45.6349206 24.2857143 45.5555556 24.3650794 45.5555556 24.4444444L45.5555556 33.0952381C45.5555556 33.1746032 45.6349206 33.2539683 45.7142857 33.2539683L47.5396825 33.2539683C47.6190476 33.2539683 47.6984127 33.1746032 47.6984127 33.0952381L47.6984127 28.968254 52.6190476 33.5714286C52.6190476 33.5714286 52.6984127 33.6507937 52.7777778 33.6507937L52.9365079 33.6507937C53.015873 33.6507937 53.0952381 33.5714286 53.0952381 33.4920635L53.0952381 24.8412698C53.1746032 24.7619048 53.0952381 24.6825397 52.9365079 24.6825397M59.6031746 24.5238095C59.6031746 24.4444444 59.5238095 24.4444444 59.4444444 24.4444444L59.2857143 24.4444444C59.2063492 24.4444444 59.1269841 24.5238095 59.1269841 24.5238095L54.9206349 33.0952381C54.9206349 33.1746032 54.9206349 33.2539683 54.9206349 33.2539683 54.9206349 33.3333333 55 33.3333333 55.0793651 33.3333333L57.0634921 33.3333333C57.1428571 33.3333333 57.2222222 33.2539683 57.2222222 33.2539683L57.6984127 32.1428571 60.8730159 32.1428571 61.3492063 33.2539683C61.3492063 33.3333333 61.4285714 33.3333333 61.5079365 33.3333333L63.5714286 33.3333333C63.6507937 33.3333333 63.7301587 33.3333333 63.7301587 33.2539683 63.7301587 33.1746032 63.7301587 33.0952381 63.7301587 33.0952381L59.6031746 24.5238095zM60.0793651 30.3968254L58.4920635 30.3968254 59.2857143 28.4920635 60.0793651 30.3968254zM71.031746 31.2698413L67.9365079 31.2698413 67.9365079 24.9206349C67.9365079 24.8412698 67.8571429 24.7619048 67.7777778 24.7619048L65.7936508 24.7619048C65.7142857 24.7619048 65.6349206 24.8412698 65.6349206 24.9206349L65.6349206 33.2539683C65.6349206 33.3333333 65.7142857 33.4126984 65.7936508 33.4126984L71.031746 33.4126984C71.1111111 33.4126984 71.1904762 33.3333333 71.1904762 33.2539683L71.1904762 31.4285714C71.1904762 31.3492063 71.1111111 31.2698413 71.031746 31.2698413M5.79365079 37.4603175C5.07936508 36.8253968 4.04761905 36.5079365 2.77777778 36.5079365L1.03174603 36.5079365C.952380952 36.5079365.873015873 36.5873016.873015873 36.6666667L.873015873 43.2539683C.873015873 43.3333333.952380952 43.4126984 1.03174603 43.4126984L2.77777778 43.4126984C3.33333333 43.4126984 3.73015873 43.4126984 4.12698413 43.3333333 4.52380952 43.2539683 4.84126984 43.0952381 5.15873016 42.9365079 5.71428571 42.6190476 6.11111111 42.2222222 6.42857143 41.7460317 6.74603175 41.2698413 6.82539683 40.7142857 6.82539683 40.0793651 6.9047619 38.8888889 6.50793651 38.0952381 5.79365079 37.4603175M5 40C5 40.5555556 4.84126984 40.952381 4.44444444 41.2698413 4.04761905 41.5873016 3.57142857 41.7460317 2.93650794 41.7460317L2.77777778 41.7460317 2.77777778 38.2539683 2.93650794 38.2539683C3.57142857 38.2539683 4.12698413 38.4126984 4.44444444 38.7301587 4.84126984 39.047619 5 39.4444444 5 40M12.9365079 41.7460317L10.5555556 41.7460317 10.5555556 40.7142857 12.5396825 40.7142857C12.6190476 40.7142857 12.6984127 40.6349206 12.6984127 40.5555556L12.6984127 39.2063492C12.6984127 39.1269841 12.6190476 39.047619 12.5396825 39.047619L10.5555556 39.047619 10.5555556 38.1746032 12.9365079 38.1746032C13.015873 38.1746032 13.0952381 38.0952381 13.0952381 38.015873L13.0952381 36.6666667C13.0952381 36.5873016 13.015873 36.5079365 12.9365079 36.5079365L8.88888889 36.5079365C8.73015873 36.5079365 8.73015873 36.5873016 8.73015873 36.6666667L8.73015873 43.2539683C8.73015873 43.3333333 8.80952381 43.4126984 8.88888889 43.4126984L13.015873 43.4126984C13.0952381 43.4126984 13.1746032 43.3333333 13.1746032 43.2539683L13.1746032 41.9047619C13.0952381 41.8253968 13.0952381 41.7460317 12.9365079 41.7460317' }),
						_react2.default.createElement('rect', { width: '1.429', height: '48.095', x: '135.952', y: '.159' }),
						_react2.default.createElement('path', { d: 'M154.761905 42.8571429C155.555556 42.6984127 156.190476 42.3015873 156.666667 41.7460317 157.222222 41.1111111 157.460317 40.2380952 157.460317 39.2857143 157.460317 38.0952381 157.063492 37.1428571 156.349206 36.4285714 155.634921 35.7142857 154.761905 35.3968254 153.571429 35.3968254L150.31746 35.3968254C150 35.3968254 149.761905 35.4761905 149.52381 35.7142857 149.285714 35.952381 149.206349 36.1904762 149.206349 36.5079365L149.206349 48.1746032C149.206349 48.4126984 149.285714 48.6507937 149.444444 48.8095238 149.603175 48.968254 149.84127 49.047619 150.079365 49.047619 150.31746 49.047619 150.555556 48.968254 150.714286 48.8095238 150.873016 48.6507937 150.952381 48.4126984 150.952381 48.1746032L150.952381 43.0952381 152.777778 43.0952381 155.873016 48.5714286C156.031746 48.8888889 156.269841 49.047619 156.587302 49.047619 156.746032 49.047619 156.904762 48.968254 156.984127 48.8888889 157.142857 48.8095238 157.222222 48.7301587 157.301587 48.5714286 157.380952 48.4126984 157.380952 48.3333333 157.380952 48.1746032 157.380952 48.015873 157.380952 47.8571429 157.301587 47.7777778L154.761905 42.8571429zM155.714286 39.2063492C155.714286 39.9206349 155.555556 40.3968254 155.15873 40.7142857 154.761905 41.031746 154.285714 41.2698413 153.571429 41.2698413L150.952381 41.2698413 150.952381 36.984127 153.571429 36.984127C154.206349 36.984127 154.761905 37.1428571 155.15873 37.5396825 155.31746 37.6984127 155.47619 37.9365079 155.555556 38.2539683 155.714286 38.5714286 155.714286 38.8888889 155.714286 39.2063492zM165.952381 35.3174603L158.571429 35.3174603C158.333333 35.3174603 158.095238 35.3968254 157.936508 35.5555556 157.777778 35.7142857 157.698413 35.952381 157.698413 36.1904762 157.698413 36.4285714 157.777778 36.6666667 157.936508 36.8253968 158.095238 36.984127 158.333333 37.0634921 158.571429 37.0634921L161.428571 37.0634921 161.428571 48.0952381C161.428571 48.3333333 161.507937 48.5714286 161.666667 48.7301587 161.825397 48.8888889 162.063492 48.968254 162.301587 48.968254 162.539683 48.968254 162.777778 48.8888889 162.936508 48.7301587 163.095238 48.5714286 163.174603 48.3333333 163.174603 48.0952381L163.174603 37.0634921 166.031746 37.0634921C166.269841 37.0634921 166.428571 36.984127 166.666667 36.8253968 166.825397 36.6666667 166.904762 36.4285714 166.904762 36.1904762 166.904762 35.952381 166.825397 35.7142857 166.666667 35.5555556 166.349206 35.3968254 166.111111 35.3174603 165.952381 35.3174603M176.507937 35.3174603C176.349206 35.3174603 176.190476 35.3968254 176.031746 35.4761905 175.873016 35.5555556 175.793651 35.7142857 175.714286 35.8730159L172.619048 45.7142857 169.52381 35.8730159C169.444444 35.7142857 169.365079 35.5555556 169.206349 35.4761905 169.047619 35.3968254 168.888889 35.3174603 168.730159 35.3174603 168.492063 35.3174603 168.253968 35.3968254 168.095238 35.5555556 167.936508 35.7142857 167.857143 35.952381 167.857143 36.1904762 167.857143 36.2698413 167.857143 36.2698413 167.857143 36.3492063 167.857143 36.4285714 167.857143 36.4285714 167.857143 36.5079365L171.666667 48.3333333C171.825397 48.8095238 172.142857 48.968254 172.619048 48.968254 173.095238 48.968254 173.412698 48.7301587 173.571429 48.2539683L177.380952 36.4285714C177.380952 36.3492063 177.380952 36.3492063 177.380952 36.2698413 177.380952 36.1904762 177.380952 36.1904762 177.380952 36.1111111 177.380952 35.8730159 177.301587 35.6349206 177.142857 35.4761905 176.984127 35.3968254 176.746032 35.3174603 176.507937 35.3174603M184.52381 46.5079365C184.444444 46.5079365 184.365079 46.5079365 184.285714 46.5079365 184.206349 46.5079365 184.126984 46.5873016 184.047619 46.5873016 183.730159 46.8253968 183.412698 46.9047619 183.095238 47.0634921 182.777778 47.1428571 182.460317 47.2222222 182.142857 47.2222222 181.190476 47.2222222 180.47619 46.984127 180 46.4285714 179.52381 45.8730159 179.206349 45.1587302 179.206349 44.2063492L179.206349 39.8412698C179.206349 38.8888889 179.444444 38.1746032 180 37.6190476 180.555556 37.0634921 181.269841 36.8253968 182.142857 36.8253968 182.460317 36.8253968 182.777778 36.9047619 183.095238 36.984127 183.412698 37.0634921 183.730159 37.2222222 184.047619 37.4603175 184.126984 37.5396825 184.206349 37.5396825 184.285714 37.5396825 184.365079 37.5396825 184.444444 37.5396825 184.52381 37.5396825 184.761905 37.5396825 185 37.4603175 185.15873 37.3015873 185.31746 37.1428571 185.396825 36.9047619 185.396825 36.7460317 185.396825 36.4285714 185.238095 36.1904762 185 36.031746 184.52381 35.7936508 184.126984 35.5555556 183.650794 35.3968254 183.174603 35.2380952 182.698413 35.1587302 182.222222 35.1587302 180.793651 35.1587302 179.68254 35.5555556 178.809524 36.4285714 177.936508 37.3015873 177.539683 38.4126984 177.539683 39.8412698L177.539683 44.047619C177.539683 45.3968254 177.936508 46.5873016 178.809524 47.4603175 179.68254 48.3333333 180.793651 48.7301587 182.222222 48.7301587 182.698413 48.7301587 183.174603 48.6507937 183.650794 48.4920635 184.126984 48.3333333 184.52381 48.1746032 185 47.8571429 185.238095 47.6984127 185.396825 47.4603175 185.396825 47.1428571 185.396825 46.9047619 185.31746 46.6666667 185.15873 46.5079365 184.920635 46.5873016 184.761905 46.5079365 184.52381 46.5079365' })
					)
				)
			);
		};
	
		return Brand;
	}(_react.Component);
	
	Brand.defaultProps = {
		fill: '#e37400'
	};
	exports.default = Brand;
	module.exports = exports['default'];

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Favicon = function (_Component) {
		_inherits(Favicon, _Component);
	
		function Favicon() {
			_classCallCheck(this, Favicon);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		Favicon.prototype.render = function render() {
			return _react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '57x57', href: __webpack_require__(688) }),
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '114x114', href: __webpack_require__(684) }),
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '72x72', href: __webpack_require__(690) }),
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '144x144', href: __webpack_require__(686) }),
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '60x60', href: __webpack_require__(689) }),
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '120x120', href: __webpack_require__(685) }),
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '76x76', href: __webpack_require__(691) }),
				_react2.default.createElement('link', { rel: 'apple-touch-icon-precomposed', sizes: '152x152', href: __webpack_require__(687) }),
				_react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: __webpack_require__(694), sizes: '196x196' }),
				_react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: __webpack_require__(696), sizes: '96x96' }),
				_react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: __webpack_require__(695), sizes: '32x32' }),
				_react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: __webpack_require__(693), sizes: '16x16' }),
				_react2.default.createElement('link', { rel: 'icon', type: 'image/png', href: __webpack_require__(692), sizes: '128x128' }),
				_react2.default.createElement('link', { rel: 'shortcut icon', href: 'favicon.ico' }),
				_react2.default.createElement('meta', { name: 'msapplication-TileImage', content: __webpack_require__(697) }),
				_react2.default.createElement('meta', { name: 'msapplication-square70x70logo', content: __webpack_require__(701) }),
				_react2.default.createElement('meta', { name: 'msapplication-square150x150logo', content: __webpack_require__(698) }),
				_react2.default.createElement('meta', { name: 'msapplication-wide310x150logo', content: __webpack_require__(699) }),
				_react2.default.createElement('meta', { name: 'msapplication-square310x310logo', content: __webpack_require__(700) })
			);
		};
	
		return Favicon;
	}(_react.Component);
	
	exports.default = Favicon;
	module.exports = exports['default'];

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAW+UlEQVR4nO2dfcxlRX3HP9/rZrPdbAilFAlBg2gadjG+goISQEvEWhTuuUeoQhErqOUl99jW91BCTCQG29xHKigCiuBL4T73KqWUBkLV0HVZCa3ULhtrkSKSlRpKCCV0s3l+/eO83Dlzzzn33LfnPs+63yfnuWdmft8zc2bmzMxvfnPmwOzRmCO3Knwa7n6LDeMSgjBqYASGXQRslLgd0/W95c6+RGRlxCUaFTKjuFWYhrvfYpJa/WeG3Y54G3CqwRcNu6fZah9Wk7+oQvyNrAAaR7jZam+W+BVoC1hGN0Bmu5BO6XU7v55DOg9gQjTGOSQdhLEFAzMwy04w2IZxexBGG8a97gKPqjwYlT/rgruBMZouM55CehTs6Mwv+wfITjXjUqBT95prAFX3Pypv1jz3RV5gg7i4GsTtr7n+ux/ZYdu2nrAReFtFBCdvPfaE23bveuDpguu4cfjndd3p9WbF9eVG+a0rbsPzWBl5Lq4VelT4f6Rnm2W6OQijjQnPvU7D+50Esxho+fc2Kj2N9cotEyrNxF638zzwPmCvYZAdJGMuA9mbzOxzJdf1C70Ka2XUvB5H/isw5ijaRRBG55nZzTg1yW+LJS4BfanX7dRNqFtjx8U03P0WEzeVvW7nVknnAi+UyZhxDfDBMS67Vp7Y/QZiuv6QoNV+nUl/K+PoXHswUJPBrIP0yV63s3eauA5gfExdwABBGB1iZt+V9KYyGTN7WNIlZra9v7w0bZQHUBPpM5b2X0Wj6kaJO3cehO0tmO4BTkDxJIgkp1POHul7DbtG0t29bmcfg6bVvS4Ffn54gwm5QRg1zOxsSa83s3v6y0v3FnDLru339VXuhXOLBlluYfsX9ytCTi4Io8OAHwEvzQo4KVjXbQiZPYp0Bdg3e92lSW+irmzO3Wy1/wJxteLKt2Lo+P5y56EKbhVGxbtQblHzXKZ3jfTrdTtPmdl7LPEzkpnM5DGOFaps/vpog1sMfTcIo4NLbmI+sz3ijwfpoSGsOea1q2TXFHfq/tdHf3lph+BaIC5dGDTTzty14z4DuCdoRQeXJdLB1AUehNFmjGM8fe7IEdx1i0kLuDqjza4ARluVlDzNZschvhKE0cwrnA/DjgA25vzMnpx3vItCldVi4qO3vPQM8GlJVB6QnQMhZqfNK03OsaEgHfesQrwLOeb2xEi6Cdg5DsegPafkZBB6HBjo48ajiPvnHe+i4I68iuaIJ54dSlSgy8wsGXANOj23+3NmspH01iCMNk2Zjkpur9t5AeMxI5tJ/6ozii+Lp8wIUyeNC+U2Rgi5YeMaCRq9bmenxJcgP+kd2yQsO9egyDcltua04vl6nZ+mwnhHcsWeNF7BNwu4fjy+WuinYc1yy9QkvzD9c1/Gl08jbWC6HNiTV5ccO5RZpkrFbh3iJbIoLj8tfvoruWa2NxnMP9hb7jxWcZ9F+VFW0dckdxZ9cFnhA6z0ljtPA20BShRjudZF0nMhA7n943gtRu1mXXBQcvp3JXLjxLumuXNXS2JY18SdnvU4XtPlnFtsS36i4kJVfdKoe1kBaIbtDQZHAwh9r+Ra42BNc1elgHvdpRWhS4BnR4g+C5pUJ611w0KvAA4FVpA9PGFc6warpo/1up0nJH18hF78RK/bmWu6zOysJK4nLa5wC9dV53msUhOdwq43s/tKQysWD8wCyUzZRUlcT/e7+7/ZsmwUXXZepZ6UjeYyv153CUkXAc9l89GDRdZI2ljGLYmrVrzpiZmdLzgaA0kHB2Hk38M48a4LbpEqUaZXFV3U5+GcFxZCr9t5zODPU3dqXUp+jmzGT9moQnPhV9JCbjOMDgGuSuMys5cSD7aq1Iyh9I/pv3BuUeaMytAylHEbvozgBuAu562IdGh9sOCoEXH451UtCwBB2G7I7CuCw2Awejezq4KwXdSKTdN1rSmuv/C9DP6Cat89luwju3bYMdtO/J6k9yFtRskDHK8A2f3IIzserBFPDkEYaeu2Ez67desbbzvm2BOf3b1rx48S/wboU0gXZ8KKI5TYBnr5MVvfeO/uRx74v5r352OcvFl17ioPsgboL3eeBLsomcYaLA4Q505oNmwYXGxwiOAtjv+fmNlncjp4Gmf8ftV5SP8ShNE7/HibYdQIwuisIIw+FYTtLRPf7AIxk0V3kyJoRSC+CHzYCzq+180toamFZhj9k+BkgztkNE1cIPgKNe/RzB4EloHHgSMQ7xZ6QxL29f7y0vvHTdOisdACBmiG0SbMfijpVamfmd0t6Q8Tnbg2gjB6L2a3IL1gZjsFJ6eLCgrhLu2NI84WIQyFwQpmb+wtL41d8RaJogJeKfCbK4JW+xikHwGbUz/Dzux3l+4c8zqHI/1y5gkc4GHgzcnrO8PxhxEYh5t4HdhmjF0Su3oDfbsqb4vCXL+JuG4drdKJG955mZwr6//63FxYEEbnAzc74U8Ar+51O0973NI0JYv3/rskjTiW5+LgIXFLR38u937gA71u56dAI+m3jwbeSvzO1gkDroi7C3t/b3npae/qfsH5eeXf40Tcid9NKklEaQFWyKcF3ACuM7PsVRdB1+Cc/nLhstqCAm6/zYx/yNjuwFIaLPbzwiTlDB95WV9egK0AjwF7kY7A7KAR3J2Kdz9wZ+r8CuvfUxVqc2fRFBdNhFTp0oU3EL+gZm1JqYqEQYh0aZ00BK2oYcanB171Nblc4cYeFfIGcb4dDRyTK9xy7hsMu8pPM+WTSKNQmzvrvnaSyZEMve7SCxgt4KnYR2D2V81WdFKBvB/XFcBJA+cYjZM/EBtyz4BrXBqE0WvqJ2o2mEUTPXM0W9GpYPeQbPMksQd0fK/bKbQVB2F0mpn9IwvWCEZB0v3AKWO8Tjs1Fm7OKjr6y50fSPrTwZJaHY7Z7UGrvcmXDcLoUMxultQYuUx3wQdwkpl9eDXzcp41fppautLrdm4ys0vi6xiIEwxyuwYEYYSZfRnpiNjHBjv/ZHDWkKRz3+n6sGRGq5Cbyc6WC1wdhNEr/fudOKdGcN23C1PhcXStURFXyY+MKzHnXWjwZSexl2N8HrE5KfALB90cqdlx4E7g7z6QuuTs9eVy81I+puXqMRmn9JazLsfPi1paQx1u3T64Sj+r0ntHhbt+LnLhzVb7KsQnFA+6MHhBUsNgo3K6ajIiVpr5yZxz6k6tSBqEKbN0eNxMNr62ZswFHpPU7HU7DxfkxyiMqgwZZlHA08jW4gZhtMnMfi443BXOTVsoK/whdybj8aq4Zjak/c6ci/YCHWTX9LpLTxTcfxVq5fOaHEUXIQijZSDI+jmly+WTZbiDF9mS0+Rd5CTni55gJQ+TCrnEBbc63BWkLti5/e5SuqnrTLCm1QoXBge7Jr+c2S89zQz5gyMll/FI/V1u4raUazZvbgOzs4X+aHY5FmPh1qQ6CFrRUYhH8F773A/xuBmv7i93hpYXx4YMozfm/iZrvnABDPsydQt3SEWqvHA5dwR1TtyXgn0jCKPMqhaEEUEYvdfMfmHiG95CwZFYE+bCEqwAjWYYHSr41aITs8p4DOgSl8PbgW2J//PA73pGC1gP5sI0LAijg4DjgC0Gzws+BAQDmjM2zYaudVE0pq4Sd1WwhXMfB97T63a2MzxvUaqeulv6lw7Pk/b/LOBci1c+7gbdDtzfW86tumg4v0WRlpkQk08F2CcM+ySWGv6F+14x7rZMgmzEkmZGqYnP40IurNJcWNjcri5X6D7EOSWbrZeVW+Gy2UKY2ZUGfYMQOM3gUsO+b7Ibm622/92Hsc2FzVbUMGzJ4DODwoXKzszvaitNfFVk8pnMqGutLlfwsIl3eoU7O3NhsxVtAj6WeeR0PS6QdE8QRkdVRVKBRN7ehXHx8PqpiiZtSHQM7tC1VsFcOClXur9fskSoDkbmQrMVNSR+nrwJUIbnJHXM7Jr+8tJT4ySgGba3CP3YbLCL/AHk8KykE3vdzq5JyLX04GbYPk2oD27zWYgXzOxOxO0y3Ze8/F1+3Va0AewWSWePkebfPJjtMemd/QmWEtee6Aha0RGIM4hnlJ7FaEi82LBtQicZdpicBsHM9gG7ENtBDwh2AD/rdTsrQRhtMDgZsysRb4oTMpixHQwi/VlcZxCiwQBsXK4hULrTQGow8LiZbDKluHAuzyFO73eXdnhFU6nWprkwlbkw2dzzJMSHhEJgQ7o3ZTrITX73As8YHIw3cZErjtomv2m4+crhc/NSPhbDFTwKbE12MEqxuubCZtg+BnQVZmch55l2F5U7bgMmMflNw10L5sLJuTqlv9xx9/WqNBfOYsYqpxL1u0s/7Xc7TcGZmO3JVjPEdzI4HHccxsAPso1assl5XxWamstAqICbC15DXIktVKuhOdQt4HGWd64A9JaX7kC8HukhSJtIEU9epE+y14CY52e+lCs/PTdrtku4A+m1wRU8x2D3wIUsm82h3116EjjdpMfjezFMFv+SNkMxTMnBYJARu50H1HFPw03aSC8sz03PEZhs8VzZCuiScT8dWHsUPQ2CMLoYuCbnaWQ36w8E/O56CKvIzcktjvsQ4iO9bmfsPTVXy2q0p2RImWyO5vllnSfOI+u4p+Wm/ZvHz3MtfeAWyjWzvzZx4iSFC8XfDx5HVfKtGUNI7JfnDFXbkm449tOwXJF7Cq6KyDmuF74ArmGXIa7tx6/RFuX1SL/0xFeBcISrRmyjZFcMLiA2Unjwh4114VT/abi1xP3HfzW57BS6th/vhFt31OzK1TcXemG+XKPgvNFstRFcamZL2a0lup6lTZKA3Lmj56aEXFvmjFCm4UIubE2aC2Gf6tWJSnNh3U1YquDn6krQin4LuBH4hIYbSk98DOSavmm46wIvAU7ZduyJ//HIrh2/8MKKmoTC6jDrQVZcm8SNwHlI8dBfSTH7/a4Gh1y5FOk7PWmYi2m4bhpgIOe6/XgWwz3VzL4ftNonDN9APcxrFH0c4IwYvZFjNkoc+MezdflKKNJ3fsj6tEGeTcMlV999w3vObYP0Loi7AanFhEg/xz5rfFzS7ZXXTgs57SqTHMj8EpS1rFNxy1pr1988P1sc18z+hwnLaS5PcK/b+Q7G5XEljFM89M0GWXZucsPcP9cnCU9mwqbhmidbxB3I+u7V50rZvtZFqBxZ+2pS3ZH0SBj2eeLFeYnPoJrKc+fDlPyXI5c1yln49NyBbBE3Hu0P5BfLJV04UbQWy0euPIvsiCsFRyGZ4YqR/faXl/YKbsxuq2KBmXI6YxzmPHdZuFLeTLg2GBsUcc3y114g18yOoN7DN6TOztxc6OH+A+bCWXDlf9tx8ebCBM+kJ/F4KG56DpgLx+SKojcOa5VJ0Vz0LHG4ZXdDNtCApHI6YZn5L13BQD48k8muNQUXAzkNiYq56Xk287YorrGHCTEvNSnF77tLU4pgytfx+AVqR6UoWjtsU3LTH43mpvUwqzCrz10BdrOW1CSAIIy2mNmFQFoLC3HAXFjNNbMdvW7nOSbEXMyFzbAN8EVJhyd3MIySbjj207BckXsK7nowFya4JfldG+bCIIwaQtcB5xXIO/CHjXXhVP9puLXE/cd/lbnGkxK3sqbMhWZXmfTBrGPJmcNSRd6cTsY99+T9kdJvkrnQANnH+92lUc1zpblwFqNoP4ITXD3XH7zmXgd1M8B8jyJ3SdC4XC9sLb5dKOk2sG9SjFpvbcIczIUGHxXaA6xI6iK9RNJnh2br0t/kOGAuHHAl7QQ+4HzXeGJUKDCTI2hFGxGbet14M5GgFR1s2C9xXl4TeLqp04qa4/Za3WzGZxpuUaJVFjAIXhWu9JCM03vL4y2PrYp7VVZWNlvtr0o6P/PI+k7vfBRyffCU3HHjmTfXuAvxnmnUIh+rthmppOvScwMOmAuHuF9DnDlB4S7GXOhzDdtp8UctnBnZFHLOlPz/DTMXmj7j7CNdZbVbG+ZC75d+dwnF3zCKccBc6JL3IUt3RihTSdekudCX6x4wFw5zZWzvjdZ3XawZc2HO3et29oCeO2AuzHNtsNH5ON3gmjAX5hCE0SsN2wIcMBcO0n0TprsLM2wGWE016WigLynezj4p4LScXeTMZ0VYRW5ObuZcuxvU7HU7eytSPBXm/gQHYftIMz4tdAEa3lA06y9zE0BGsu9CvsnzJzcm5Wbto3L8PDcOzwpt1lxxJ+iceRZumrxxNiOtZS5M0QyjMwTfAIY/zRpvgr0WNj1ddZhZD3Ruf7mzlwnNgHX95vZ2YRBGrxB8i+HCfRR4C9JvG/aRkutWwFU/xmPmuLXEXflZce0HUla4RRgy+VFdBpXcub1diNmHTNrsWUh2gp3Z6y7tAQha0RcQe8zsRsTm3AgkZpBvk5UfZKUDGCUea91cKJ4TOjfZDrhoDsJHncpfyZ2lHuy6V4Afp+ZCYAXpb4C3pIUL0Fvu0Ot2vi30WuA71aa2iiBf3xzF9cJW0Vz4NefrbUWzUnVbs9rc+bxdCBjcKqmJuFzS8YJ2wXd3VwB6y52fymghzkEaNF37mblQpn8eTsh8UaVQLATNMPpLzK4Eqk1+ZS2wOe4yblHE/qi7IHhaLtJFvW7nhnLJ2WPey2bHhuA7SFdm7pIqmHa7QxpL7mkq4ZZVa9ffV8GcijMp18zOBG4qucJcsGrmwjGwcX81FyKd0WxFr5thXo3krpq5sO71DE6F9W0uBH4NeraIK3FF2b17ebO+zIUV/jkZwfHr0VyYvD15PfByoRcDvyN4M3CfyzXsHc4O+ePkzUTmwlmuqhxHCS/za0D8Ho7SvjXOx58JXQO2HWmfmf2e4A8FgcGWgWyciR43P/oC8qOvRNjjZl17fe5Het1Oh3yruD0Io9ORrsPswkSugTgJuNWRHRfuJEgl6hbwTMyFNeO5hnjR/CFJAd2AhlSsfwVuC8KojXS+mV0m4xW54Ww6KMpO3aFufJ6N0cwL90bEGsE1uFfSF4rut9ft7AvC6BLQq4A3JE//niLZAncVanHXnJoE0Gy1j5J0HthDmO7uLVd/Er0ZRhsEV5vZ4LNgQ4vufTdOmVXIilQnG8z3elzBmb1u546qNAat6AiDqyR+aHB9f5U+815kbFiXaIbtDaD/xDjSUWX2mtldQk+a2Kz4wx+vQTrI0a4yFJj8ngXawB2YrYDORiwZbPK4p0y6l+S8sd8UMECz1f57wdvjWQ0Azul1O11XJv5ehB0n1MLsPNBhA301KfakPzd4f3956eu5OMLog5hd57ycjZk9KPHuXnfp8Xnf47goKtxJ+te6A6xx4hi7CZPUcKcszWzoUzS9bmdfv7u0vdftfNTgZYjLSHcicKcdpRXi7wfm0iK4QdITrtYk6TjQvzXD9rtG3Meq+819M9KCiN14fV4R6qpqAIc65/tAT1dx+8tLz/e6nWvNeC3xByFd/FrS8+RHrCvJBzFuLUjnFqFbgjDa5KVvapPfNNyiAirTf8vkXNT5duE4CR3ll4PBc2ZGssPdXf3lzpN1uP3lzuMG7ZRrgJn9zFun7Eb0rSwe+DawM/so9PCkdJ2WqExmau48zYVlkVclaFK1YQVYUbw68Rlgn4nrRnB87p1K54nNXpB0dRnBxE+An8SiXAm8WfABwTm97lLdz9BNfb91uGtSTZoGQRhtJH7J7dnemKpI0Go3kI4Cnu51O89Uyobtj5nxOUm3GbyvP/xN3zWB/a6AVwvNMDocs/8CNkq6D/iDeS+gmwQvIm6mdeAY79i9a8f/bj32xI2STgZeZmbbdz/ywKOLTpd/zHPZ7GDmZz/lCq4ws3+XdLqkn0wY59jxjsN1m+jKj2tMkAhXvohbNy5fLu1Xp+UWXaeu/LrhrjlzYQ3/OjKTqGF+WJWauG64/w/6I3GOhOmehQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQCAYAAADnRuK4AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAdlUlEQVR4nO2df6wl1X3YP9+r1ye0Wq22W2tLKV6jzYpSh7SOHVMECY4IGGgBc+dO1qY2TmMHYWPjOwkiDrUQslDkmjhlni1c/IsfhmJI5s7zz8SxKY2JbTCm9hqrmBBMN2i7Wq8QWrmrp9Vqdb/9Y37cM+eemTv3vvvzvffdvW/OnPnMmTNnzvme7/nOmRnYki1Zh0jFtgbQdYQL602//W8ErkHlnyB8W+G7q1HYLdmHsnQcTKNiOU3GzJ8rzy7ZNIwYG6C6oDEZzw9Q1T8B7hBJGFUQJEa4Po7CYyX7F9JZMGZLLDErjl37ulbYZq4UkT9N0kjroQCiHvBksxWcVbJ/WS23ma4RX7Z9mkxZOWxqpkFSibKKZC7NVmhvR+E6CiL5T+FsEf6H12qfYaVnp2uKzczbz85j1xG36Zhspazl4QgDIKqnqSZhVUWVpA/LfnCWwqNeq73kSNel7RbtVyffG57p0ywUa1y27Ncewg8k67lESMKS/s9MK/lNRAIrHft4rmOVHX9WTF2ttOmYqlFYpXit9h6FfwCWIalEqooAmkRAsr6GyK/HUfjCqMfakvmVQa2xdFvcWXlZRD4PSeUhCRTs6VQdbQPu8/z20oBj1MnHLBmsbS5+0zF2AZUVZNm22wQ5XDyG5BUq69YULgD5aElm7EzOI1Om3u39Nh3TYDiDETM+jsJjCNcCJ5NNavxAi+v/2Wu1r6YnZQY1FsMcMK4yyJZV2zY8I7hbXLck3sk0/fZ+QR5EWcqNINcS1oBL4yh8yti/zrG2ZE7FZURnF7VK+pimH/goDwp6WpJy0ajObCJFjwlyVdwJvzvqsbaY+WHsWxm2mNrB1hh9GsRrtd+IyKPAXnApoDy8Blyvqo+sdlaqNFAdLTVNZkssGXkYXyaeH+xS1S8h8lYyT2N+NMlumGVj/c+L6IfjaOXViiTnvhVuZqaqC7Nbo90yS1us5wdLwAPAO0BRzRyNhjbqqaUjwB3A/XEUnhhwAkPZZmNkys69Ks1NwYxdA2XitdrLKvKXqF5dCuWaCIAjAveryGdWo/DgpPI1qnh+e78qNwM7BO5D5BNxMm1lU4tpA3WtcJkGci2d+3l+sA14UlXPzXxDqtrryYwuLV+HUwr3C3wkjsKjA45FybHHyjT99nmCfE9JXfdJZi+Lo/BblLfYKptqwzB1nEiUxLn2K7BxFK6hvF1Eel2TJHfsC95rhLyPgyXgD4CfNv3grRX5KMvz2BlBrgXjvk9S8Vv0n7e5vyu9DcdkNanuj5KlvT0Px53wOZSPgtlbafqv53LsbcmXu1G+4bXa76hI35WPsTMKb0SLblIV9uEuI1e5bFgma3n2j4p4WwZxDYQQeCGbMQTJHftk/lkakY7YxPwJS4g84PnBxSX5whE/Vsbzg4bA2elEA/O3VpLGoPLbUIxLA2VSVQuHYuIoPKHoH6Kp3tHEFgLyddK15H8ypyhlllB9wPOD7RXHpCS8fkZpKPoaIz/JUjlQUW5V6W8opqo1loVNKau5NtMQ5JuIfD2zd4p38MWwhcBmVORM4IOO4ziPNVYmmd+0ZuZHkvx+pSSNqta84Zgssk6fx4Cla798WxyFXVTboCeUpDUrpF1XT+NkcWooptRvdIPnB1Uac9B5jMQodBV9LslW3t8eAH5Us9w2NGO3PCivcWaczbr262PizspBUT4m2ps9nTkVLfsC015KRPcArx+Qt7L8jMysRiGi8jw9NwPAF+IoNNmq9Dc046pAZdrFjLNZ135uRuQTKryQT6HG/mlvqcYPQPUNJXmbcN+vh4z8nAQeKeEHtegNx7i0Rh0NVHe/PiaOwjVBboJ0LjU9F1Cy3rMz8h+Z3cGZjjQH5WcMjPy/1O5BRB6Lo5VX6C+fQeW0IZkyNTVsBRn2Yj0GPAy4HInFsLGuKua02LI8u8LrYjSb9w2oslrC2uluCqbBYMPJpb7spUu9lYbjKOyKyM0Kr1Y4EovzGRNj+5dWmq582OH1M8I/Tz0MXREeKymbQV3BhmRsNeXSSHa8LYM4Z3pxFB4RuKXSkYhpTAsiHCzJJ464sTGiuSPxIPByxTnXKb8NxWQP/ZmSgXa8S4ZhXOz9CNeiXJKsKqigokhqYCcjn1xDPVeSTsOKHxvj+cGyqp4nSWZ+lI6+qs6760hnwzJVrbEsPGh/F+Os2enFeD8ixysdicl6F+TQqMcalVH4TRHZkdphz9dIo6o1bzjG1DaD+jwGLKtspdK04yh8EfhIDUfiGnCqJJ1Mqo41EiPw+9rTgP93QBpzYZdMk7FbHpTXODPOZl37DcN8WuCJAY5EjK5skKYcC+P5wR5U90vv0Kesfas096ZgXBWoTIOYcTbr2q82E0fhKUTeq7BW4UjcBrJUkjeXJlk3o6p3KCxn+QF9bcU+dtymYFwaoY4GqrtfbSbtym6pcCQ2UD3D2q8s3XUznh/8toi828wHyOXp/Tg7vSp7YUMzZWpq2AoylgsqIvcA3yp1JIq80ZHmoGMNzXh+sJPkoYDkuD3uPIVrStKz090UzLCT6hskqsteVrF10svF84MzFX4C7DLjRRUV+exqFN5QkZ86ecbzg70KtwPbheLr+Dw/WFL4CnC56UCQxMMAcFxU347wzThaGeu5LyJjqymXRrLjyxIuq71VGq6PiaPwsKje0GdMiyDK1c1We9navyz9ckb1LoF3C3hAPu/aawWo6orA5dmOvePn4e2IfE2Vu5p+ezvlZdTw/OA0zw+Wq5iK30IwWY0qMzCrDFDoN6oYCyMSq+q9kI69silDcLoIVzrSLDPynIwWCkR3At1mKwD0YyDvKwz4MneCFsINQT6Eyv9u+u13e35wmnlMzw92eH77dpRfqPL3nh/srchjVTnPPVP2aLPdTWGFXexYGc8PdqD6A4RzMiB5FlGeAi6Me68SHibPSTfVar8H4XPJ80Tciuh/Bfk4aPY2tcLz/D1RY5ugJB5zhFdBntLk2bYzQS9Q2J4zyGPAZanjtOycy2SuGbOgXbUNR9zQLX4UJo7CXyLyToUT+WsXk7nU5xsPKw6bZ4CuIo8oHE/cA3qbwv9R1SCfo9SbJEk+jxvDudn7k4iyS9F/L+h7VPWtCttNRtFLUL18wDnPrZapYoRiJQK3oYwjzsUwgB2WwfOD9wF3WxftJUR+reRR6FqtyGu1vw1ySa5rckWTWcvpsbKHH7MwGOv5n8GM6ssgb4o7ofkeAGe5eH57SZG9KLtEOAoctLRXmfadOmPaQCZgL11xLmYQOyzTBe4B/sJ8jkyFvaB3lPBl6RQYhaMqLqelOSuS/PZKHtbejQ3VYlwlA3sU/VrTD3a78ur5QcPzg4ubrfaDKL9A9e9Bn1TVn6vqjz0/uKjiHKvKd6LMRB9tXieTSSOzhxTO7j0iTVeES+MofLxuOibj+cEPgPOSR60NOyd5bJm+eAy7KHu8JxkZFsykGswx4GGUn6bg6xR5g8B5GK4LRzqnBH4vjsJHjCxNszdwMuIA1yNl3YerIg7FeH5wLvAksA3yAj6s6JtWo5WjwxzLa7X3IfIzoGFd/1zM+DKmjJ8gc1KV31rthM8MSGZq4hrGV6r+kqVLva03XDhGHIXPonq9NcI+A+TBZitYqptOsxU0VORTpJUnTccx+7G3LQsUmeLsySkxywj3pb6lobrsSTFVTqMqZ5It9n72tlGYvvi4s/KwKGHv8WgQuAT0jvQeVY109E9InYdWOgWnJdY2+9Fm0+6eMvN6Vf2Q4/yqruXEGJcGyqSqFpoM9NfQcTH9xxY+DDxecPaJ/DHo/kHpeK32RYLcbo7AzXRMp+UAR+JMwyC3NVvt7AmVmWkfmGNHosUU8uO12rsQngTZZyj+44pcuBqFz7rSafrBTkF/DOzp2Rm5ow8jHcC0Reo4EmfCfBVoGlNsB7ouJsGYBe2qbTjiqmrmpJhCfuLOyiuoXKaqB/OHE5XtqP5l02/vtPdr+gECd6uyx3QSmi9LMNIZwZE4E+Zq4D8NKNOJa6KyPs5euuJczCB2WKbUNos74UEReYvAi5I8sYEgZ4vyGeOzCg2gIej7gHekjGFfJEPsZH/BSMe+iQtKjyFdT7fPikH1U81W+zcGlG+VXbtuZtjpHHMnnh/sUfQ7KGcZ0V9OP4Z3guR1wtmbPYrS33PVljq7Tok5IiK/E0fhcwOSmYgshCNxEOP5wRsU/YEgy6YDsI6TcAaOxLEzqvoKIteuRuFjDLZnXXbOyMzCOBIHMZ4f3AV8yCxjq7xzGRdTxs+I6QL3gv4pyMuOO/8TEdcwvo4BZS8HGcKjhF3HqGC043IAqvUblcmG0j2muP8cMA2FP1Dk5wrfbvrt83CX21iN7IHGqiPeJS7DGGt9WKZq335GOW47ALNllZOwDjNnjsRKRpJu5WKQb3h+sMMqp6rrPRLj0kCZVNVCk4H+GjoupqoFFBmRC3rNMRVjPRuiD82Yw+kFCgO76E2Qm4j2gQV1JNpMMqVUfwLs69kH9ZyEC+xIrMOsAW+Oo/B5HOWeaqhtcRQeSaPKro0pBca8GFW2zmhaYXzMoPx8VJV9wzoJF9yRWIfZpuhXmq32XrO8krlH7Xcp+nPQf/T89jUDrk2pJjJHYdnGUYbxkxo62uJqRQD/ALq3MJMw1yqGAYEyNDOuGYmzZX4J+kWQn4K+FsVH5Bxjvy/G0crvU32dnOuu17u4WvygbXYa42TK9sHz2w1U96uwt68VitE8C73TkIy6w5KvFru+OWV2AB8UjNdEpPsKPANyO/WuU9969qz5UI7Ept/eJyr7EI4DB+IoPF6yX7dG2mUM5nrTD3YI3Az4JLZOFziB6M7chrGdhNRwJNZg8k0UnXvUcADOLQMg+klUPpzOLZ+8I9Hz26eD3EfvYTxIbhfEqvqR1c7KwZL01mVEe63gbIRvKOwdhwNwXEwZvwiMwgdWo/CeAckMlEH5yMXz28sg/0vRc0HylkraUhWOonrVamfl6XQXW5O4pIppAF2vFbxGhR+K6lkqrvGScTKqTIoxHm0urC8iAzy0GoXXWac90vWq7UhU5Y3AucaLeAtON4HdIN9ptto3pl8sNI+BI207HzaT2DjoXQJnTcpJWIfJbFNxrC8iI6ovMW1HoiCHUbrG6/7TRaEdnyYid6P8XbPVvtj4NIGZHvTXdCejyvmK/MeRHIDjYgw7e8OEkRu9ZEbjINdK6fCdvF4kMtCR2GwFiPBnqP5RoQcjq/mZUw4z8kBqM30Z9FAcrZhp21KwgTw/2K3o9wT2ZUD/sfo7okkwxdhs28ydhOtkeBHksrj4edGhXSm1bSBIPqarqjeKyPUoZyGcVNU1EVlW1R0IpwlpK06vSWomdYFnReQxVf07kKcRPbpa8nqUZqt9LsKXUM4tNVYKnf3kGMGwLezzgnxEs6DMURTTbh1ahBEciZ4fNBRdEqQbR+Epr9VugCwjugfkfFSvQORKVLcXL0q+0iV55/LTiPxQ4aDASeBMVC8FrgZZ6lVvZSJOwjrMxnAkljPCKyBviqPwECM4EofSQMOI5wc7Fd4l6C2q7MmP5tICpswbMwdZmDgjcu9qFL53wO6lacKQjkTHsmy/rtdqn4bIjQq3C+yo8dXmsc0k3CwzEtfP6BFB/qXxypyRHYlV96dGuVdldntnAJ8BrhyQBtb5zZzZBHIc5Z/GnbDOraSC2MP4Mhl0P8w11CvwcRQeBt6G8oeKdvM3WqTjZvMNF8k6aYicmxWTqf3edmt98ZkDaeUZNHzH3m53YbVvawwpxVsTfvAujLegwvxpnU2kmbrApXEU/m0Nrq9+uPq5bDm0U6mCsfmHUP089FqGad1lzrzCfBedEWPE24zpdFxEBjgOXJe+ImeyjkQr7GKHYjy/fT7wvQzotfjpOgk3pSMxOa+HUL0t7qy8bMBD27n2pwNs0N5WZieNwpws3gUxTxXymSvWtZ02U5hDYzBqXhhdKOYEIh8A7o87TkduHUM6Z0aaD2QktB7m7YVvgWl6pqb7NGtIedwMGEB6Hy/DyGzKLhSzhnBZHIXfTyMHOQ1dMh1HYpV4rfYFCv9ThGWz/ljFUXCaZv36rJi8oExG6N0WWAhGPhx3wjtxy0jTOao0kGvHqiV1GM8PfgP0ayjLuQ2SKSLD7S6GVlA17JRZMORoqqAMJ6PVBOeagb9No8fWqwhFlTVJR2JDYb8oX0CS9xyWSaH1zAGzYUR5COGGktcjjySushv6dkVJ2vm2ZitYQrgL+CDpKEAzjWPc2ij01yr53eMkKuvnZ8FY9nWqnAqG6uIwR1G9VUTut77/WnYtK3snuwuzZwy6ZhBWbXMdHNAPCfLB3mkZ18ZQvYXLZWvkZNrsjBh7u7W+WMxuRL6A6qskbzmzK4hLSplpORLfnB3AdNzl61BoPluOxCkw8Lsl12qoa+6au2yuV9lArng3I/w3kk8rLWfDhGy00NNE9ALp7WLJrmJf05oiI9ncb3ImmayVdhC6sMwpxjCMNy+8q7bhiKuqmU5mNVp5QtHrNW0OWatQ7f3y+JwZ8EjylBiyG6sGg7kvC8okdwHW27OM/M1UF1vJrEYrD4nwRSFp5CKQfIs0DZO0kPwbqXnYjJs+A9LLX8aY57CwDM8Y182+flW/AmNqIKxwmXahhK3ByEdUOAkYzQKjVSTNPomyOnVmxNCb7pEzaTe3yIyqmm/3t69/lfYpMFUaCEdc1bIOcxjksWyUk/fQuR0kuVGUOPeSdqMmNAsm/SkGk/KLyohInS9gD+x56nZPVfFVFa4gcRQimtyBzzyn6ee0KUwfzfRvvirpec+GMet3Ie/GuS0gs5P1uW0a4H47h0ts9VXlSLT9BYWuTeGIZCpWhDJHotZwAE6PSQq+t50iv4CM9OBFcCSaaes2UiMvOZOsiZito7eSx8mWI3GsjHAsDa3LkbhkgYNuT7gSrMtk4X+bGc2Z5pGsqaRnp2q0Him0lukzSn6X22bMSrZwjPAS7utTJX3MdByJabznB0uKXgm65UicJYOsKfo8Y3AkTnVGosJ7UE43+2VTtPDXuKA6O2YDzkhE0cdXOysncctQmmhqMxI9Pzgb+HjhpMwrlutaMou6pw3yuBkwwBzMJBwvgzyAW9OMRQO5HIn2tjLWyXh+sA/0r1F25H1w0lQK9UdSFZy1E/dTllNm6NlJecDsLRaMAXmJ5C68fZ1cTmVb+piJz0j0/OAcVb4jIrvz1i3po8NszUicOqN6a9xZyW6krqtXARpLBjgoITPetXQxoPyZCLvz9YID0Vwae1sXrucEk5kwYqEL4CR0M6pfRSQysAVwJAqvqhZbPMIhVXYjsrzlSJwSAwdF5Pr0BQqZDOp5BjJ17l9ly0Hb7F+27Rbg+2k3/IqIvB/kdcA7haz1CNnQM/n1HI15nMySsbdb6/PPHBN4WxyFr5RcI4xw2XV0MmJEDqqJpgzFeK2gAbwG4VgchSchedsZ8DNV9hUcihj9dloCBSfYtBllvhyAQzIkHucr4ih8igmIWYFMqTKQbRmZ8fzgj0E/BubJbz3aPD5GDwFXxdHKs4wwRK/DzPLRZlD9osJHgWUwiwO2HInrYxCeRqUZd8LDBj3S7YoqpqoLG6sjsYzx/OBR0P09fUxmUVuNPyu2KTPQ6y/Mfi/brHPIiB4G+dU4Cn9pnNVENJDLeeRyJLq00VgYVf0MGBpha0biuhmF5+IoPGaVOca66zcSUzXuxxE36iitnBF5AuUlIGlRph8mHaFtzUgcjhHkZaucXdexzI83FFM3oar4akdiuTQAVqPwFMhfbM1IHCvzbcbgJKzDTH1GootR4ceFcTxbjsR1MIcEvpxuWZeTsA4zgxmJ/Yygu7Ov4yTS0wp5nGzNSKzJ3JT52ui/+C5ZFzOLGYkFxvODbSgfAPIS2JqROBoD/BcVdd1pH/vwPZMsT7NyJL4e9HPA+b0C2nIkjsQo96jITatR6bueJzKMd2nGiUvTb5+Lyu2IXoP2acGi9F/bqTJ9UfPJfBLk5tVOeIopi6mBJu5I9Pw2wI3An0PyhrK8OHJ9DFuOxJoMgMidqnrrameFAbIBHInKNap8Cs3ejaiZbwwVjqlwM/Bbityp6KktR+IARuQe4NbV5G2rY3cS1mGqNJApLq00SEsVls1WsCzCP6rq6SK9j5mkH185CHJFHIUvQPIteIX9Ag8CS8XZi5KWr3sm4UQYesoqmTmQfye2Z9hOn3kKeEschaeGvRbjZISiyqqTUJXYTJ6O5we7gV+YBZGUhj4B8va4Ex6xj+W1gt9GuA/Sz0WZu9npOGRczJzKm+IoPDDrTGSVxFZRttTp4lzdWc7FUXgU9OGeGtYTwG0gl6aVx963G3fCx4FfBW4FXdv62Er+ezqOwh+VXIOyazERZsqORPk9QR8F2SXCY+kXfFzHz6QbR+EacKfXCr4qon8DnJls6nU7PYfaJnEkqj7LFJyEdZi6NlBVgpNmcvH84CJVvpPPYITe4M1oqRt9RiLoI3Fn5dq65TZJsTVLmaaZZbi3rvpdEX0RSEpWQEQRNF1Pf1lHMA4mU1AGo+k+s2IQLvL8YLmivFy/iTBmF+Pq93DEzaKvBejGnZWuavqUh2a2Ss9WyEa+mm4bB0NmDxkM5r7MguEM4B01yrSsfMfGVHVhY3ckjsAUpNlqN0T4BciuLUciB0H+ddwJT5aVlyUTYcwLhhUu0wp2YpNkCmEROV+VXZvAkXgE+CbwV4gcKmHOQthvlWGV1pgIUzXKwhFXtZwUY+bh9dkzWwAbcEbiERH5XUReG0fhFXEUXgW8DpH/IMoL/elwg1U+dcpwrIxYG+2ua2C3YonN1Emn9rE8P7gaWAV7VAIof6XwqKDPIywpcg5wqSRfid5eluG+dGYnh4AL4yg85Nro+cEO4BvABXmkclJF/9lqtLI2nSz2y1zMSKzBZOFvKbwE7E1UuSDCYeC61OloyveBe5OC13cpchNwTs+myAfOzMmMxOtWo/Bl63zzcByFxzw/eBvwE4UzEpNIu6ld5LqGznTGzdTpUrLloG1Vw70ybhBj5rOROhWvEHgKlZOCfh34d+kXh53pxFF4PI5WPi3wa6J6lYi8iMzdo82PCzzhKFv7XF4F3gmsAV2Qj612wrUBZduXzjiZqlFYlUyT6RPPDxrAaWmFGnbfM1X5qQg7gUk7Ep9DeAbYhnKJCjudMwmFW+Io/MQw5wAsx1H40rDnP24xK5Apw9hA02DGZUt1gUbTD+4W9H1gzkjkmMJdqB4QpIuwC/hXwHnA+cB2cyw0YJbgKeC9qjyUzdNp+sEu0I4gF/Wnw6dXo/AmR5lUlddcMHNiP05XPD/4I1X9czNO4Nq4s/KIi2/6wTZULwKuQ8RD9TRr34KtIyKfjaPwBizx/OB0Vf0ZsLOwk3BKkDbw2XR6xsJIWR9nL8cy5BuBmYRd1QBtJLZP/mkSFHmxLJ3VKDyx2ln51mpn5TqUXxGRTwqcSh4hS1OQnv2k8Kjr2HEUHhX4dN8HUGAJ5W5U/6bZau+qOJ869uZUGVPVY4XnzpE4xvC/MB2JJJ6ZkxV8/lvthEfiKGwjciFwxOUkFHixbH+QB8odiVwsIp+z8lCSznwwVRoIR1zVclKMKw/rZGTZdCQCBxCeGyadOAqfQbm2z7knchJ4tTQd4UWQp0udjYnNNW1NPzJTN6Gq+KoKVyXDMFXsKMwP8y3JhfvvxqvfajeguLPyBBBDYYj+o3R06GyccRSiol9KDi2geoWo/jro0ykTVx1zwLapMw3cKsqWOl2cq8twcaMw4w4/DNwJHBT0+wr3jphOF7gB5XGFk6geAN7vYAr7ihIpnNLERXA87qwcALkQ9M0krwSs7EYH5GeqjO0HqqMVRpE6absYO27emFw8P2ikWqzWuXp+8NfA5cCzqF4Rd1aO2EyddGbNLKQjcSNIsxV4Ah0AhUMi+jtxtPLCrPM1rNh9XVnfN8uwq++dNmP/qrbVZPTrKnognW14JsjHJ3esyTFZRFm/hyNuFn1tnfxMkqnK60jMamflpCBN4LupR2F5UseaJGO3ODNc1lIpYSfBVNX+aTITac1xFB4E3iLCr4hw7SSPNUFm7qVOJreYGTFVGqiKq6OlxsW48rDFzAnz/wG3v9TuoFww4gAAAABJRU5ErkJggg=="

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAACYCAYAAAAYwiAhAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAgAElEQVR4nO2df7AkV3XfP9/HZr3ZbBTZUYiiELwRsspaYaTIIASI3wZjRIjevDYCzE8LZH653tiYUqkEdhEVMTKiNA/zQ2BABgsFpHkzMmBC+GGEMHgRQpZBtatSKVtCqBSVolI2KtWWomzNyR/dt/v2ndszPTP93sxbvbPbb7rvPfd779x7+pxz7z3dA7BEnJaC86VI+jTUFFaIsdlY4/qtTr8e81gawVSbWkl7L2YvA3aYdKOw23vdtVlht+kYICdggzF8MZ6lVtLGsD/CuAzY6eVdi/TOfrdzuCbWqPRpaFGxHnc0i/YaGLxOcDmwU4AkAIReK+OHraR9SqxcFd4MbdkqWI870rQFW0l7yYx/AJ4GFkDl1/cJnttb7xyarZnbtFVpNv9L9iRkmSxZcbhr2UmG/XUrWT2usTq3aUvR1INt6Z+7crkKMnOZg6eSmlFH2ybncURPmLbgHQf22759z9oDvKySqbCaZ+07/Vk3Hjyw/2fT1rdNW5NmMleG/aXQg+mVKPthAsvTlszsL1or7T2z1LdNW4+eQCpkmua44+AP/+9ppz/zEUnnSZAeyg7ygzT9X5o4Yd++c7528MD+qerbPrbe0YDDrU+BfSu/DP0xQCj75CIze+3sdW7TViHRwKxueaV9gsT3McrrXqIQOHcujgAv7nU7N89a7wLQgOZmxcckViON6K93HgRegrgbIFNY5OeFcAHsBr6ynKzua6LuOVOTSy7HJFZjDel1O/cAzzXZLeV1Crc25q9n2AmCby+vtJ/uQQyCz206Big0kb46dAMdCmFMZbq0QStp7zazKyVdVOKILfbDERNvxeyL/fW1WN0EaeP2BZeIf4cmsWL9FbZ3wHB5IuViaccU1hMYNmiOzPuUXygC5vJ18MD+o/tOf9bfAPcCL8/5FSkh/olgRdJTTtt3zvcPHth/pJQbr9fPM8qzYJc/CPiaxCJIwytbUtOUhTPs28cFltNgoTSGd+44LRbjH7RW2ueb+BLZZnioxIJvdBj4EGZX9dbXHoq0w2E7qsofdQc2irWctMFsR3997TEPJ1a2Tv+GmuKYwFJQAMpgeGkhkH9dWa610n41sr8qymTiZAYShuXLGNmN8TBwHfAx0E963U6VOYt9+bADYjQrlnMFzgf7APAk4GYzvb6/3rmf4YHyqe5ATmLOFhrLN5HhgoJPzlSYV9ilQXzQAOzgwf0/PW3fs56A8XwjXYAtUOUJV574C6CzML0NccZp+8750cED+x+KYPtKMTRhBGkx9T4t1qCVtH/VjG8LTkT6BTNOFpx48OAP+wGW309h/4amJva55bGqJDBGMXNRt8xloJskf3RVarFLs3ITzwd+2kpW39RK2rG2hvUPKo5RbZwcy6wlsZMi/g2kV7aS9o4RuOM0q88z6rtuKawqExCjSQcq5+11O0eBC814FFLraNkn3rkTLneepe8209Vm9t6aQtYEjcQy+PW0jea38ziDE0dg1WnfON4thzWJBpuJeuudu5Bd4aRKvjY2XzNXHbzfzN4WaWesvePutJAmxfIWiUvfYxqNOW27tgRWle+0UXS5pHtiro6Cc3n5Xt6VraT9tBr1bLA200l4rcvoQUn3N1jvMUF17/QmtAT97tojmL3bRcEq88Cc469gB6DQciAZwE7MPhTUP3E7IjQRlrCjYGnLZGmTxdezGe82eTTL4EzZmephfMPM0nCxbKBM2bUFhlEphzeNeWkrae9jjubD4M783Nx0Slc30I5jjpq4+yei3npnILQKPBZlCBcJYosK0NqIttUmcXv26dp5J9hNc2zRwtKmCxhAb71zB3CFEx5V+vVZPoSC9pxNaGYlyfgfQN5OSZ/rddeOzrNNi0pzETAAxJ8Ch5R5WsMLrsPbSo7M7OTWysgliw0lQw9525UDM66bV1sWnZbmdfS7a0ck/X66Rincpx9yXYq7ztNA4rhU7c2p/eJoER7OrWCH5tmXi3wsMV/6ulF192voyooli6PV+m1TyH/O82v99e33cFSRL2CbPsXudTsI/gB4aGi3KztX/PzBXrezSa0cJhm/7NoE9s25NWQL0FLF+aZRr9u5H7g4Twi3mCES52N3Mleyp2VtegzTLfNty2JT00IV2wAflwbwWcSNhmFWnkK6tTDyPADuqNkGdz1guB2T7MHl18tJexfi7HQNjztQxXLLNgHNm8iYRhyXRq/bweCtQkeULYun5NtLeesV+nnNNrjrpYr0cRQpY78BZA8Q252ZqR7Xd+GNNeqmO6awwsGvClUhSK+qoGqzN8QN0+l3O3cBl4Q2srhKXXxLBe1IpI2xOsaF7VSF5FRiCb21aJceiH2X4NynUUJddbNvaSx3ETJHNc2Ihgwq8mICuURlQ+3jwE2VK675/uQQhd+jToeN66AhrOWk/VSwl3vtmtTFGKUFJrUgWwLLF6Q60umXqcIJ090xiPD5pmup110bAG8FPQJ+TFgqVPlE0zh+BFb4XULzOAh4Y+0fwspi0S4HLWXb7xjspX6/1aFjDmvc3RxLH5UW+4yZp0rT1Ot27sSfVZIuvJpnLIX9e4a/tH/EzD1BXl2z6fhbwl6e1p8Kv+Dc5aTt1sRC4Z5kIEJtecxgxTTPOHUZDtCoyqrM5qj6Mewq4BsqCZX7K5DOimBP8h3GtbOEtbzSfjLwiSy0g1ToAdgjeN9yEWkbaulxN2Odvt7SWIowxQpVAc1CPuYQfitZfRLwj8AvuXX8fDnMdATsX/XW144wI2WvAn2tZOdh+kpvvXNtkL8b7NvAOYC3Jlc8G2PGqtBHe+ulJ6Ca6LMtjxX6RlQUmGb2MY5G2vVed+1eM73dmUbLNEfm5u8GvXTKesM2n4v4K0OvNvFhP6OVtHcYdrWhcyyv2wv2NpzpXjPZ9a2V1SdO2aZjltxTMNNK9DTl6t9Bsq7gs2b8rpQ6+8UKmS4EbpgCP8w7QZYHNJ7gEpdTzfbngleZrLxVhd+WrKzRAp7XSlb/BPTZXrfzqF9JK2nvxOwik96OcUCyN/e6a4+M6YFp/KaFwprrjnEdaiXt4zD7EdKpZpb6PgZIA8xO762vjVrVr4N/IsbPETswGyD+KaYB4mPARWmEbfZwcCZobhYJRXuMwmgKPWDYDaAfI45inC5ZgvFkK3A+3l9fe+dMnbMFaOEFDKCVtM8ys7/H/7EHgdB1wGtmjYVfTla/hPGqDPNaMzsFONuTmKrI2oJCnrBsuK9qHEU6vZ/Omo9Zmne4Ti3qdTu3Au8JbwczS8DOnb0G9R22mb0WcXa5IscWFoukufRKgcwL7AD72JiHdbc8bQkNBvlC5/VmtMojbrdLekbo80yIfZYZPx5WVzEVNk6tlTy1oExYHpB9UOjSUVq4lbSPB3sFxm9a+lr4nYK7EV8AXZc92LyQ5JYptgQtJ+3jhf0Q4xT/JReG/ZnQJVPGiA1aSftc4HsTlRoOIQLTcNqQ2iV7CMFLN+siXWZwoN/tDFpJexfGySbOltmLkc4H2x3VB2bfQLqg1+08PKK14UrBLDQR1pbRYI5aK+2zTHwfs12eZhggfrPfXfvWmOJxzKT9XjMuG9JI7mUabum+nEk+tSz5WkGZ/EbIEs2dR7DSNws9htiDsWsCrJskvaTX7Sxc6NCW0mCOWsnqm4DPBKN7P+jXswDGCbDae8AOgk6q8sZTCk1fWbLKOmm8h1+dNh2WGR+U7NJF+xnFjRSuJnf0S9Trrv2lwafSq+xONp2I8aXllfpOcytZBbM/J3sVQIGVnbu0XFvgpZU//VcdxHnqpk2HJfFHoKdWfNW50UYK2KTYk/Ebq2b8IL9Ox+NcsA9XFwogjLeA3jCUUeWn+9fjli3q8DSLtQNjrZW0a4BtHi1KyLRLix1hPgD99bXHEL8N3JsvMQBI72olq2+IlCthtZL2PklXDo2bh2WkrzPwA7hzmQgmkdHxz8tmuYEf1ziWeAEL9kMXvg8WhmZU0ahZRLgBGosyGIUVK1+1gbwEsLyy+nShbyP830F61LDn9Ltrt8WwWkl7J/D3wJm+v5xupFPWYCGF/FmaqZgchli5fx66UDSPBTwI/Fqv23mA0WMF8b4NxyyWVxvLLxAG5rlCIdWJFg2xqspUhcmEwYBhiEjeCf31tVsMOw+j2Nczdgld30pWj6/A+gBmZ+I9YKJcI1hZhRgUb8QreOTSMyoiba3A0nDe8CyyWSyME4DPZOuG48ZzEgs2FZZ7R+uA+H3rRsDPq+J1eY4/du5fh/WG5z4vFbgCuOPgD+857fRz/hZIDHYJMPGLmE7bd/o56wcP7D/qyraS1Vcb+pB7LFsoe8uPsv/uOqUUK6sqf8+U52Dnp8rmdIVznq8yZPzmlc9fJ7ohWPyKxNKvnnbOjXcc3O/3vbvBwvELZxGhtYiNYy2sKhM5SjrHmUgfo8rcxbCq4ouqYo+GVPpy0n422Ddl7C78Gt2o9D0YjxhcgNm7JC2ZFWtYipieTK8hsyEfyV+9cGWjWI7NyKJyrby6sNFYaFXw0eBN3VUuSR0TWdX3lVgaUZggLQQiklZnqWGagLdRZUp5yyvtN0h8Lg+nyaQmHTh5Y5DlZ6vvha+Txk6kL5bLtEUJiwwve21LJgWmnBv3/FNu0MxSzZPzlR2ojcXiimwryl+EreNnjbyZ62LFNFiMxmmZUeXG4U6KWVV2iXR2uAR8z+DZWEkmSjs5+c0/QoOVfOiYc00IRtQRLy3C+2XYLCy7zeBiSd/ynuOcpO+rJlujJmF5k+pqsEkFYBzFzGcj1FpZbZu4Mu4oZhoNf3bm2ZZggCGQqfxidJnq9Ei5zcO604zPCV3RW59pW6m2cO6IMFatUY2qaBoK17hG0aT1PJSblICc1kp/ZSTMKT5CbWCxq5Jwes62g8ivQ2fJr2BTsU5FfACzfwZcyiZQHfM4iqYpN83i7iT1LBmckdrEdJrvjtRHcVGoWTpZXnBeuvaxct/NzfHcoBY8hEfG5y9HzBUL3tVaac/y/MAoZVSieWx0N21qS9RKVvdIeh1G6qSnvZ2rAP916aVlARXpKjk5XjlnMi1Nj7k+FpRX7rAT4Z4b1nFgl4/5YYtGKO6mbFHKOuxjZva2ISsCZX8ktDChvxL7HEV1MImczxFL6J3AVWGwYytpn2SwhtlTQav99c43KtDH0rEmYCcY9r9GuSd5WozH8Y0TxBi2nxc7z3mFe3ikRPPBGki6KosouRvsFKTXmNm7cG9xlH4i+A/TPvdwjMWD24uKVdHsMzMbWX56HvziVsET5FdihTh4g+x7516ZId6qNm0q1pKZvQN4xzBeNkHAvp69M2Qq2sF8/LCZKDOF5xr2bOAXgf8j+Begi8rvFwsVdCQ9n3FVlatIK5XLgIZCpiPlfQ200Fg8DLwTdC31d3KGaGITubzS3iHstSZdgHEi4iEZ30Vc2+t2Dk2KN3H9yeqZGFcDZ0ado5FhzqQZMbMyMVbGP+QfBWUmCZleGCzdJfGfet3OgbCXJiUxgTS2kvZOg/X0LTNDsnk0C9v9k40K211eaZ8j2X8nf8Ngldcbm0cRpI+aAYzDGnbUygpgnFc+Km3eWNyH6Zm99c59NEATmUcze5eMl5fteU47JN6L8blWsrqLyZcjRvK3kvYJEteD9qS+kafijcAXEfE2KsIzDdawSZ13yHSDWGtNCRdMKGBCZ0TbB74z+TrQj5aT9rkThu+ObIuZfQA4aUTjhtsScwBiVnMSLAs+R9E4nkXEMp5SA6E2TabBZN8eSsvzimuDfTK+C1y/nLSf7gnauO2o2EEraZ8t6XfDNx3mVKp7OMy5dKb0bFqs0veNTdYCrFItGx0y3QSW9JbWyuorYsWmId8H8zeeo5S+S8v6kiobkMcz4Vt6uxX0JTO7QdJd3gOyo2KKAJaWV1afJOm7wN4c2vNL/etxFPM6JsYK+bO0RQmZbgjrMRNvFFw3IpYspLHhOqMK5dRKVpeAN4GWgZPAHgaOmGmXZCeYsVdoj/vCQ7Mv6W7gJsO+D+yXcUdvffiXylpJG8N+Q/AXmJ7sf/sMp+ghJ9WlTorduzHbNylWNmJOVeSzM280LcPMqwqxXXkWGWsAurjX7VxBXEaqBK4y4LCKGeqvgwyyByr2mfFSxAUYZxUTFArtVtxFDyNuFdwG/CzD/2WDF2GcOTThodyPYb/E8sE7nxXL/6ScFq5++CsDrgk5L562X2AsieVet3MD9aJah6jKRDYSMr28srok6enAezBrGSzhojADtV26mYIWKrvzZgpzbhLLu17okOkmsMQdoNP75a2ixQuZXk7aZ8nsSqTnkX2hIjQZsOyLQrbr32SY8+M5ZLoRrKdki+gTh0xPuk0UzgIHkbSl2Ge/27kV6YXAhaCHyYZPptwmKfuHAZZdGemdZmVesnTyki4/409TNgDL4VGkedjFtFNFXUN8WwwrX9jOx9sf21AGSsGrTlx92ojw6BK1kvbJwDrYmXmir6K9VgWX6XU0cXy9TWKV7EnMvFRiVdjuxcU6AvrXvW5n3PtkozTKsR/HN+0m+VKv2zlk2AtBN5szlbkiF+a0i3eYKTVzJoqYTfdJ+mlFef9oEsu88unh3jqtocPh5nxeGbYIFtCJCFdopaoHu6ZQTBKnXwur3107bLAMHE79nsxPyrrF/cP7TClLy3olXzDNQ2xyHb8hWP6hHCPgdXjunEJ0GWrH4mJJXAt6f9UYUkMG6grYhoT09Lud+yRdI6WOffrb3f7uWeqAF/qt8LNd+G8aRpw+2CDvGpxPtwFYqcefWhrP1CjAVFFzySTJa8dCYolDkl5jxutnfald3YDDjfTJfkauuUKy4WTL+qSkZTxWN+MjvR/lF2wAq2iqm4UOY6ZF/bq9urJqFhdL1wFvHfNKzto014jWNHDQnpO/GyLrhbxvLE32t5+GglFjEwOfv2ksb+DMb7Y8vCA/tghaxTtXLHQx4opZXwvv0zwEzJ+lnmumVxYrYD4VUiCyhVFPn+Q7H+YPvPKSRafaBmCln6VbwnKjk2o7t76UYclDIKh/EbAQH4FmhYusZXMJmW4l7VOA7wIn1i/l9Lw8LROonLlgTVJnU/gNYxn/tre+NtH7beuQe7J7U6m1snqOGX2wVLh8ExlzxRDlDTV3XrqXM1Z5iiYG1hRW1l7frFqkzFYJmZYdBzQWaOi3ZqJoilmolbQxs4skXQnsSlMDRyg/T/Oq71N/0yMUDnkO/gZhuXHJ2u1tLOFvyZQplrcYWKBDhr1P6Q87hCvzMaolG+MYmjWfxoclfQInXLnmcF/YP0+vi22abNE0OyfnzO7MAEseX6NYzneR0u0koNhWybkZHsQsL/ewFwsL42ShL2D2nfTV7sD412aNpXFMjZnP5aT9NBPlGGqn5fH6KKA8P5TDAKfUz3gy0jSWAl4COR7xHUrlh++lBcHSucB7vJyZlEydsJtJKdwIT6/zVeTQdUhPcjXuZfrrWMowDKgMdw5SrPS3Oaz8LJdAtwI+XLKY6cVQFxPLjLMi0DDZG5GAagGa5a07/j6VO+ivr90GXJXfbNloh0rcf3DWeQx5vlvldyvvQcXy0HwD1zRWfua+gzSc55dVPG9RsSR7wLuMheaE5z6VZCaM8xpbYCYSvw98LZ25OV1WNkZm5evoMcRDgBOW3SAsKz41sr4qzEXF0ncYDsOp2n8MtVpJ8GKaqiq+qw6NbFS/u3bUzC4EPeT0gh/F4BxvC69tOBogTSe9zpykfJs3Sy/KNYdFeO1hlSMasslEbvy9CAbXnkXFgtsrxj3u/oyQgXCWEItMHRdkOG5KW2pEf33tATNbQ+UIB2FkkYDkd1V2Lj/NS/c/S9ESYX6DWBZehzzhQYGX8lDUs6BYGOGD0+G4huE6VYGIZT+pBtV5dGksSbrGRZmC88NUfEfvn5vSFf6QWzJwZdLrUtSDqYTaKJab+nvLG265QKZSrTm2ubq8PjAWFsvEk4IhGzeulT77jqqMCpBRajHkq3xRrJndLXQfxkm+k+8LWZGS/fUEA59HxXVpwmB+ZsNYQ6HJjmcYy1+rKgZzsbEExzMZVT7TUTc8OiZY4yYFlU5hf31tAHZ/qLJjKt0Uuc54SuYuZgZiZRvCylVExByPxmLhscys7vro2EDUWDRFVch07EmjqZYxsi2jnXlkQ/Dky5CGwd2ABhSbHcWnFyWh4u511CTWMPml4zmxGBv/atGwBIeHCpVpoteY16GmQ6Z3Anv90OT0C+d/Sh1W7jxzRUp55TBnIiWawfLJCeQQr49njtdK3yxEXiQsSfeE3zWgBQ+ZNp4ntMcL0d0OmV4crKPAT2iINj1kOnu3xapbeDEyNyFqi2w42ZnP7ZDpjcK6edpH1GK06RGtBueDpW/nUZ6G7wuYx4w8VwFP42fs2yHTDWPB9TRImypgrWT1LExX59og+6bbIdOLgSWzR5A+T4O0aW+ZbiXtFwB9xHFu3aXwE8bEKlHuNhfm7LpNkXKKnDWHFaRIAX/u8JTR5PCH27QIWGZ8pN/tHKZBmdiUkOnlpH2qmX0F2F167YtTDbm3GfGTHIP8PHdeupczVnmKJgbWFFbWXt+sWqTMVgmZNu6WdDkNy8M4DdZMyLTxIkm782v5J0EHyWdwYc4WlCNPLWs+w6nG1BxsIFbmESsTWEMZjxVvqilpEHl5i4Vl2FGkN2fO/SSv6lqQkGnZ1zAOF7IkSN9yeCnocNn0lL98sYe4HTK9YVjGxf1u56ZIJVsjZLrfXbsX8UJkPeBbZvZ7Bi/ud9c+iPE+8PooIJe2HTK9QVhGR6Izgm0mJaMKgFlMY2wLofRiX5+5lbSPN/i5YHf6Ug5le2buaZ6il4rtm3Q25M+foDCCvuEtnhdqDgvcrCu9LJkll5fjkNcR5uHxzAULOpi9u79e+4czfLmYyUQ2HjIdqW8A0Ot2Dguug8yIeb5O5jHktB0y3RjWQHCxDCdco8Z5ppDpHUFG09qsFpYZn5B4U+qk4glZdErp3YryLgo9UzDhpW0AlsdeXhEI66vCnAvWo6ALet3OV7PEOoGivvUJ+UdqtVg8WGjiJg2Z9hsSnvvk494C3GamM8HrzmyNqrSW6J1aNv1W9unPwkvT8gax0oA85Y0sDX/gIKmolnyDJgd2+ZuLJemSXrfzZeLPY4wbtzqb3KXymx4yHaSnsfrrnYGZfbIUx0Rxvh0y3SCWcXvQ/0NhzpFx21oh0x7lWJK+KHQk7bfiX6p2Ck1TLBmI3FPaDpmuhZX6oXZ30Pd1A05HUSXWJJWM4q0KmfbLxSgv1+t2Hsb4et55/g3pBt68jnU8FNd+fnrzbgAW5CbJH3hVYMkTCGV8yoV607EOKf2llVLfM33wqKNKrLpbRZMEHI4Nma7iN+zHgpbvIzk3o3SdJQ75r2OoSaySl2Ply6FF96pym4wF+kSv2xn62R4mF67FDpmuLqd/blAyY44s/7sdMj0l1gGJjzO7toKylRqJVete3QxqJat7zPgpsHfebalL8YGdjneDsR6W9Jxet3N7tMAG0nxCpgNqJasngvqS9m6HTDeLJXGE9Pe3N124YM4abDlpP1Fp+PQ7yJ7Fi/pJkfOqawgNSLNYvmZQhDdWNmaiNwnrYYnlXnftb5kTzUXAWkl7yeAtYJeTP+QZUeyhgwTxHh8nLU1iVfnUVXYrlj8J75RYEodB5/W6nR9EkDaNNiWaNVLnH2L2SYzj0yUDyssJcEDoGqG7S+s+3pTcTb/L03CRr2OZO7xyTWAVBtYzmuTYuUl1sVpW8PprcYGxbhZLegT0W/MWLigvtG7K0UpWzwT+NPV1Un+H7FPSQNIloDN63c4bEacB16Csk5WuxKf+VFq+yHMYZGnuUOm8GSwVeRRlyPkLByjnBZBF29Qw1gB4fa/buXke4xsebpq5iYfebGY7DDBLIzCzRz4eBV4P9mfZWs2g1+08KunNwFWWPaiQPu2WlXPXDsfcWwszJeSnm1eGJrDI217+DMrgFHO6ADJUR8NYwGezX6jd5HGNH5sTMl2m/1nMllIHwoy7EK/pdTu3Zhl5nb1uZ9BK2u+U9E2Dy4Wd4soW7pHvVKXrV4/TkOnHgPdTPWaTjuco/lpYmrDCmamVrO4yuFqmBDiM+DRwWa/bOVKj7E5Dfyjj/chbJI5NGV16mJal51P5UdPHGFZsKlpVT4xiTnpzWPt73c5zaFYxzIQ1TsA2QoPRStoAuzB7rLe+NtGqclb2lcB62LZJp/SjxnEcVgx32vymsAx6/W7nt2tWtSlUJWCzCFZsC2HS+DIfIxrc1kraXzB4dVn5pN1fFiJnGI/9kGmDWwXP6HVLIfZ+H86qMCbGqmKYJMqiqmwsFCgUljoY0XYZ/E04UPJEqJi4K8/zl4uOxZBpwdOAvVTHco3yp6poJqw6Az7rxuikWLUiN5S+BYZCv5h37l+H+cFhIc8EWFZ8zv/N0AC2A+yS7MLN5GC4/wbBeZUVG1Sc18aKaaoQaNJZR51GxXDDNoRlw88z0im8sv7dfst0Vu5Ny0n71Ei/+ssHIcXGrUroJsIK48Fi/lPoD/mCF57HwjfGacaqUKBYe3y+VxRL8IEO8m0b5fOhCJyQdwyW+dc2oj6PyvVlBf121MN6DNhvxl2SjgM726QnR7B2CL0beDtxP9hf+4ylO6ryoSfC8p38cQM+qkGjnPqQYk5i7LxKYAFoJe3/Z7AjWy7KOjlz5I3sAYmyG5w608WAqDgpOMdhZR65Ze96cvJi+QMjZayULZtI5I9MWRFdWwvLvgi6uNft3Ov6o5W0dwCvMGxNxpN9LMkeAf2b4D1fYZ9OMmYh1caaxJkfxVsl3X65GMW03SiNVmAZD4RuSPbI/FET18n4HUPPMuz5YL9ncB3YI+mobZ2QaRkfBP1Or9u5x++XXrcz6HU7N2A8A+knPhamPVD5e0OOphWuibAWKmQ6kl+ZZ7JPC/445xQY+ongjf1u5y5WaboAAAQFSURBVLagjpuAT7WS1ePBXk36kzb7/OWBkkWqMHVl8hYwrHzZXJizbgTeV/EzxwNIf9iilbTPQ/aPwC8V9lZVPu4kY1lFtbFGOXLj+KZdT2lk4VbGBzB92tDAYAD6vOC5vWHhyqnXXTvcW1+7ytAZGL8F3OI7184Q+k5/4WyHB7kDniotDR250+74vDLUwrL39dY7R8f1Wa/budfQhZiOZm+ZuhlZGElRx6LUpdpYte7VRaZW0t6bLU7e0+9OvCuwy8y+CZw7Td0xXVSD91HEXaA9mO0dgXWfpH83yY+0t5L22cBeM/tqf31t7NbbZlBdAZvVRi8spW9etO+k/nfJiX9U4qtmHJJYMuOJkp0KeirYHt8xD9+j52NlTjqkYTSXgD5qxqMCTHa2jC8YOjmCdT+pgMWeAtoytOU12KzUSlaPw/jfBkteZwyQntnrdm4Z5m/vMuPpwH8EXiVsr9M8rrx/XbhU+i/99c6lEbxTzewfBLsjZf+zpMu2spBtaiTFYpKOepNDsgnjfQa3xrh73c6j/fXO3/XXOxdL/IqJ8yT9nVtSGFpfT9MHEh+rwLsT9HE3UaUoA/DHhn1zOVk9efbvOR+ah4AtmFDbcWRt8pcH+jV8n163c7TfXfsa8HyhC4QOV4Q539frdu6rwhH2ycqQaeMFGN9rrayeNPVXnCNt2lumA5q1zqqtjClIJxTLCi7iwm6ZBD+LXui2ktU7Qd8X2fto84BA7h+JJw5h9gOhZ5fXOLL1MTgJeB1wRd02LQrNIWS6kYPGsIyHwpBp0Cemwep1124z6IRhzsBdY8oNTPqvRfi23Y3ZR8AecljAQwvQ7xMfIwP2s4EcxzPPY+b29dY790v6MsI9OHEvcOO0dQsuR9whXNyWDTA+Mw5L0BUczRTYNb31tT/A9GsSnwd6wLUN9Mmk/TUzlr8X+bilVtLeCSQGJwtumOAp6KipbiXtJ5qxKrEHbL3XXbupDlZrpf3fgJeB3Yj0kknWwOq0ax5Y4wSsyYZu0xhqJe3E4EvpEoVdJ3RhnWcVFpmqhGcwJn8UxXwkgvNJMGLpVdebhTUub1rN82Vh92eRHK8y+OtW0p71Bm+iXVNjVTXepU/ToJh9jtU3Cnsp+KxqV512bgSWo0FF3rgbN5rX63YeA13ilisELzKzs6fBarJds2DVGfBZpX5SrBjPuHKjBn4jsKo08yitWOVuhOU/L3gjcAh4BOnBGbCabNfUWDGpDNMmmXVUYY7Dq+Kt09ZRM5zNwBpFYdmqukvUStpL2eRjZqwm2zUl1tiMKsGryh/VuDrCOEro6vJuFFZV2XG8dfvmmMKKaZ9RNG5WOak5HXXHuLrqYo4SkiaxQqprcmedRGxJrP8PydWCKDmErSwAAAAASUVORK5CYII="

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAI4klEQVRogdWabawcVRnHf/+lMQ02WEMlCA3WppG+oOEDSKuI8ioqKdy9EyKJph8IIhLd/ULwJZUgmEDQsIvRYogSYyMGZmcRReMLWGoLRSJBLe2NECWmEjSkaUhDbm6a/fthZ/fOzp7Zt3tvof/syew5z/k/53nO2zxnZgSUCKA8XVllcaXgySSuvxqqcyJCmf8loAWUpqYrJcRBoXXGRwRTSVzfNURXhz+J/LhxS5nUySOpJFgNILQS1CxPV8/K1c+nvL5x5MeNexLgXNLBA/uOrd+weTVwXkpYDmzYsGnzz2YOPNsKcE6YdFLquTIJQBs3bdkj2CrpPZKQtA7T2rBx859mDj6rHOeESaERNuCDB/bNbti0Jba9BTgrpVwMtDZu2rL74IF9J+RIi4JduoNyVFmG+YmlzyplgffIug2xK4lrg+gD9FbBbDaeaTbqRyZSMgE6O1hhSuL6HNI27H3QnRsXIj8B/GUqqpw7TEco2b4GsVfwwCT8SdOg3a2bkrh2TNL1wLF2P6Vum3OFnipH1XNH0ZNNgi1pp68el7uQVDSd++5rSVybwdxnm27C2F5h+94CPYUwYINh17jchWDg+u2DuF3warprZ9NF5aiyYjxVvCQB6MGxbFggitYwofIkrr1hqGRGt3MtgVYW6AqvYZgD9jcbtZlxeAtNywiPcqugHIkE6zHMVqCzbR/D/l8RJ6xHZ9OezuPNsgWi09igWLRn5JO43gJuNj6Sji/Gh5NGfY5wr5K/prekrcBLgbbz3Hz5KHUKucN6N9gRSaN2SFJFiPZPy8tRNV+tqDNb4GuNNwKnFjhUypVndYZsGplbJBwKw07Do2pP6VOAtQEjAErlqLq2HFUjgHJUXYP1PbWVfKkcVc8pcCBk0yg2DuSKfnSPicMaKUeVVYa/Amdgtjcb9TvD9apfMb4J69I0YFmfEc9iakhNwRnG12O+1mzU9wdsCmGs4+Ewh4f2aDmqXmL795KOGJ/djOuvB+qchfmX8VHEKXJ6LJPaN2MJ2928YbekS5O4dqzNr5QwpyMtB7+S7iNvjcMAU1H1m9i3S3oYuC6Jaz28clQ9zfZ/R9HVNUz6neFxwXuBy2yfl5bvNGxr5toYFcsCZUVroNg4uBPpAtvXCp4CfpCrsn3+4DEi7CuAK0zvqNj+nOA54L5x1GVsXRxMTVdXSjxjvFbo4iSuPQ1Qjqpbbf+CjsdZz/NleRmF8jeATc1G/dC4di6awwBT05XVkp7AXoH0McPJ2H8EVi1mOwCSdmM+mTRqs2PxWORIZ2q6slbSi7SXy5JGUbZ3C25KGvWZUTmLblCzUf8n5t+YUt+idebqQFlWNgJX6CKkF8vTldtHta9ohAtj6WGYmq58WNIzk3AXgDnbH2026s+Xo+pphquEf5zE9b6Ki+ZwOaquMqzEvkfS1snsXhBmbb8g6UPAC8DH87dHCDg8NV1ZI+lHhlXCPwW+E+qp+fpVJO4AvgqUQptqz22F3s2YQL3Q/xAvxAX/HLStE7Tk0TeKQtdiPiFzDtbdWL8sR9V1uWqZnvNVmK931qzSNda9dqzOl2dStrzof4gX4trsLXK200E9sfNUVFkJfBdzhqRlttcjnd5+UslvDE9Leh78ptEl4IdAq+Z7O38jzY9M0RwYd24U3sTn1B7hh0dyOEU3X56ugLTZ9jckfdpuNyhpzuYdyMjqtuc0b4xQNx+SI6FMLN3Jd13NxdjdeqmskCtmsc5MGrXDOf9aeYdD1y7K05XI8CCwonBhjZMfO94coLcXLeDMZqP+Gjk/splQ7NyzxpNGPQZumG+xM+UEyk6/Tj4vVz8P5rnZqwrKs22EZUcl3ZQ624fQ4SGL/m1des1u7w7zg+z0JcZ83qZXjrrru2+FujfvVHf70Xf/SqaY+zLwmSSu/aPIoWEO96A8XVkN7Ohp3N3XLz0G9MkdkLunZibfy+mWZ+Uhrri7GdfzzvYM2kkBvzoD0LNCylH1HMNe4H0BztsFF23YuPk/Mwef/VtRhaIoK4Q1wGmLYdUSYiXSDYMqjBw+JnHtV5LuX7hNSwx74MlprCOc7e9L+uKCjVpC2F7BAJ/GOiBIOrxgi5YehWEljH8EvGwBhhwv/H2QcOTXpVNR9QPAPYth0RJiTigYQ3cwxgj7EdJdOnvPGvRgYpi8SE/of4jXJ7PvShq1gQ/2Rn/bh241rgAflN1SGkGoJ5KYz89fe63vlqfRlDqHkUxwoYw73SA0Uy/EtR1LumO4H0NOS6GyclR9HLhymPKlQT7YBNv3S/py7glH0IeQU3nkXz+2gB86HSnnRrgTEtrO5PNy0pfp9ISPvdxwWOkAV+KW9NCfPQgFD0bjHh46in6NaRmX2vZnnO7xLxNlB+TdGhmneuPw4lg6o31PM64fDdgcfHs41vEwU+8ypNLb4Hh4GLgxYGMhxhrhqaiyCrPDdtRp8i08Hr5udHkzrh0Yx+HxIi20A4iAo0JXI70f2N/eU92duqHj4fy07D0edrjZfIfr3PrOHB9bhqubjdoLI5jdM2iDHO6f4vZTiBg4P2nUHkvi2iuyLkD61ggNLx6kJ5vpy7qxqYtlQzmqPtKZ6ksOaV8zrm0ZXrEfx/WToQVi/rZjby5H1Y9MomTRvmE0rEu/yptNvwTYqfBXe5OkOyW9S9Kpku6XhNsPE8e2c6xnWoPh7TY3Im5txu3Xl+WoWgKuwb4XafWEeveAbks/U54tR9WbsU+W9Nwk2hb9/XAI5aj6BWAH9n6k7cBy7PMtXaPs5072AaRPpdv7b5HWY+9BXJ7E9bnFsGXk4+ECMQdgeDKJa48lce3hpFG/RfbZwDZgNpU/lMS1Q0mjdsji2wBIF9rsTWfLgnG8Nq1XDMckNbKFSaPeSuLaTuM7gJbQnzsywaPAm9g3gl7uP2hOhkkdHmsGJHFtF/idwJ6QXOYu4N1Jo/aHeU79TUOCOF/iuty3WRNjouNhAPkv90bpyKFtTE1X14AfEHw+mX91EvqmMqSvSH+3MHTNEwY5EqpbGiAfxh10nZj7f7EVZ8ycVOUSAAAAAElFTkSuQmCC"

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABN0lEQVQ4jZ3SsUuVURjH8Y+XkotIiEOziIP/hBC4FDSdTlOjhGMnaMjFTWiJzhK0SJOCcDg0SX9AY1B/QDQ2SEiISIhcHHpfeX3xei89y+Gc8/t+n+fAASGmhyGmbf9Rg2b9grUQUwoxzXYDIab7EwW15FM8xRb2epmX00yglvwHL7Dc6T7Et9sEM71xB3jfTDKPj1jCZ7zFQi35+1hBI7mHhAvs3ND0SS25XntCiOlOJ/AXd8fAcBBieh1iWoEWfBViOsEvbODxGLhldnB4NUEt+Q0+4PkEuK0jjK4ETS3gwRRwm/3ZF5zjZErBqMlfE8zj05SCzVryRV9whGOcToAPsd9uBr3LXazfAv/Gu1ryqD246SMN/fvOq3iGueZqEY+wWEv+MVbQEc1iiLMGXsHXWvJ5N3cJ3ZxNjlCYEa8AAAAASUVORK5CYII="

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon-196x196.932f0a52.png";

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACwUlEQVRYhb3XTWheRRQG4KdFRIq4CCqiOxGRgFBFqlaJEMSKuuk4qQs3ZiEoKA6IICKU4qJ1I+NCpYtCEYVIh0EQUdwYfxGtgqHpRihSuigioUr5Fl0EF/cmxNvvJz9f8u7mveee896ZOfPO3WUNQkwvYALHasnLdgDXdMZP41Es49hOCNjdGb+KJRwJMU3vhIBdXSLEdDu+xi14B+/Wki8OShBi2oe/a8nnNiOgOwPaRM/iWryOxRDTXUNyHMWhzRTvK6AV8T0+aocTeGVIjh6+HKuAFiv7AfYMibuIhbELqCX/hZfb4aV+MSGmW3HHVlq224ZdzOEg9nYKT2la9QimQkwJJzFZS/5xIwKu6oIuQkwT+BWzteT5ltuLH/RfmmfwG6axVEsuw/IP2wOglryEGRwPMd3c0jMDisMn+APHcSrE9MSw/CNnYAUhpqc03XAKH1iH+BYX8FAt+fyWBLQivsHURt5pcQkv1pLnBgoIMe3GdbXkXp/CE9iHz63/y7u4jA/RqyW/tkKuTXYY/4SY3gwxra5viOlGLOKLLRSH6/GcpnNWsbYN38PvGg/4LMTUw1k83nLjwB6c0HQKBuyBdjnewhtjKrwWn9aSD64MBnnBsqb3x42TmhZeRV8BIaYH8PE2CNiPG0YKwBmNyYwbd3aJQUtwGae3QQCNhwwXEGKaxGPbUHyhlvw/Zx20BPdqNsw40cPzXXLoURxi+gX3jUnAgVryV11y1Mk2rn1wFvP9Hgw7iE5ojOdfnQvJBnEOj9SSL/R7OGwGFnE/HsT7WxDw9qDirNOOQ0wP47sNFl7QHDqna8kzg4LW627nkXGbZkbmW/5KJ+7PlvsZ9+DulhuIDV1IVhBiOoRZPIlJjXFN4ya8pLH2A7Xkn0bl2qy/f4vDteTlWvIZzZ/UbC35iuaHZs6IL99WhJj2rzf2PwwEwef/mUsqAAAAAElFTkSuQmCC"

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mstile-150x150.f985818b.png";

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mstile-310x150.826bdbbc.png";

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mstile-310x310.d45f8d1b.png";

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAA7EAAAOxAGVKw4bAAANPUlEQVR4nO2de4xU1RnAf1JiKaGUbg0l1BprlTCrUkWji9VSiTVWUx/XqwQpghI1isWrqNQaa0iraFS8PkFSI1QFao9X66MYtVu1PsZHjKVkVhGR0i2h1pDGEN1sN9P+cc6ws7N3Z+7rnHtn5v7+2Z0755zv7J7vnud3vg9y2pp9oma0bOdkYD6wL/AHYJ0n3HJSFcsxQyQFsGznF8BNNY9fBOZ4wv00dq1yjBFaASzbORD4CBjl8/UW4ERPuDtj1ivHEH6N2IhpdfJNAZ61bGds9CrlmCSKAmxv8P0RwPII5eakQBQF2AxsapDmcst2uiKUnWOY0AqgZvrLApS7Nh8Ksk+UHgDgSeCPDdJMAe6JWH6OIb4UJVNPqfi/QmfX88C5wIQ6SY8sdHb9u6dUfDtS7XK0E3kjCMCynYOAl4H96yQrA7M94Yo4snL0EHUIAMAT7jZgBvBuAxnrLdtZEEdWjh5i9QAVLNsZA9wFXNwg6d3AUk+4fUnIzYlPIgpQwbKdq4HbGiTbAlwJPJefHaRPogoAYNnOVcAdAZK+A6wENnjC/TzpeoTFsp3zgNOAbcDyLNTJBJFWAfXoKRXfKHR2TQaOapB0MnAGcEmhs+u/hc6ud3pKxVR6BDU/+S1wOPAD4Ms9peILadTFNLEmgXW4ArljGIT9gDuB1yzbOUBTfRoxt+aznUotUkCLAqhJ3sKQ2Y5BKsFBGqrUiOk1nw9MoQ6poKsHwBPuW8CakNn2B542uYVs2U4H0FHzuG1sGrQpgOI64LOQeTqBpRrqMhLjfJ69alB+qmhVAE+4u4AbImRdbLAX2AX01zx72JDs1NHdAwDcT+Pj41omACdrqMswPOH2A+9XPfoEeMaE7CygXQE84Q4Al0bIemzSdanDjqrfH1FK0RaY6AHwhPs68JuQ2eodMCVN9TxlvUG5qWNEARRLkd1rUPbVVZE6snqpf7DVchhTAE+4u5FnAEH5j666+DBJ/Xy+3c4nTPYAABuA5wKm/VBnRSpYtjMKufQEeM2EzCxhVAHU23UpsCdA8vcbJ0mEaQxuBL1nSGZmMN0D4Al3O8E2enZprkqF2VW/bzMkMzMYVwDFKuClBmkGdFdCbTZdWPUo7K5l05OKAqihYCFQ78zdxE7g5cDEqs/7GZCZKdLqASr2hEvqJNF6NKzuONZuU5+kU2YWSU0BFKsZeVVwpC6hlu2MBtYy/CDoBst2/A6HWpZUFaBqKPA7fo31Nlq2M9Wynb9YtvO2T6PegbT8qWUqsNGynclxZDcTafcAqKvkF/l8Nd2ynSkxil4IHA8cjVzqAXttFhfXyXc88DfLds5XewTDsGznGMt2Th3p+2ZidNoVAPCE+6RlO6sZbla+CGleFoWPq34fA2DZzmKCGax2IIeIKyzbWYm0D/gcOAyprGeqdNcAt0esXyZI3Co4KmpJ9jaDu3Ig/+mHRHE4oSx9/ols/HVAH0OXfEmwB/iuJ9wwZxyZIjNdmDLDno1sqApjgVsjlrcb6FYfzyP5xgc5ibxTQ7nGyEwPUMGynQuBB2se/8gT7osRyroPuCyRitXneuAWv4MkNY+ZB5yCnGQCvA4sU8fkqZI5BQCwbOchYEHVo17ge+qtDlPOEwyO17p5Bfg9ckUzETgUOA45b/BjALjAE+4jZqrnT1YVYCzwBlWzd+Ap4Kygx7WW7UxETgSz7KRiADjBE24xrQpkZg5QjZoPnM1Qm4DTgauD5FfLs3vIduODXIU9ZNmOSeOXIWRSAQA84W4F5iD9C1RYbtlOkA2iy5DOK5qBqYCTlvBMDgHVWLZzLUNXAruBo9Sxsl/6acjlZGpvVQQ+BwqecHc0TJkwme0BqrgdeWZQoQN4XPkkGIJ6tp7manyQQ9WDaewsZl4BqqyIVlU9no50SFHLnQzdSGomTgJ+blpo5oeAClUTu+p1/QrgV8g3/kbMrPl1UgbmecJdZ0pg0ygA7FWCjRi6NZQSZaSdxN0mLJSbSgFg787aB2nXwwDdSIOVok5FaDoFALBs50Pg4LTrYYitwEWecF/SUXjmJ4EjMGwF0MIcjHS7q2Vl03QKYNnO0Zi9N5gFDkAasCZOUw0Bypbvz0irnXajD5ipPK/sxbKdSciV0E7kCWOo+UImLIJCMIv2bHyQw96fLNu5EemoexzSy9piYLxK8yzwln92f5pGAdQScHbDhK3NOKRJm59ZWzdQCltgqCFAbbUegdx42Rz2fD6EnFFIK555yEnQgJJ5oA55TU4ZuQl2c5TlYmAFsGzHRnr2rNyeKSNt+q/xhBta8+rIGYs0rDg1qTJbmNie2AOtAizbmQ78jqFXp0YhG+k1y3ZmRa2ADw+QN35Q1sR1wx90GXhcnbQTgBcs27kprmcvy3ZOAX4ap4w2I/YtpkC+ggudXXuASxhZCfYBTgAuKHR2Uejs+qCnVPwiTEXU7Z0ngG+EydfmHFro7Pp7T6kY2a9BmDnA+cg5QJC3vB94Hnga6FbWPfXKHocc908JWp+cvZSR87AVUTKHXQVMQPr03Rd5l340cl4wFZiJXKP7bVnuAopIQ8+3kN4/PkP65jkJ6TAiDR/BrcT1nnBvDpsp6YARHcgx/EryJZtpykizsi1hMiUaL6CnVPyip1R8s9DZtRL51s8AvpKkjJwR2Qfo7SkVQzm60uUuvt8T7v1AAXhMh4wcX74WNoNuZ9GfeMKdDfyMoebdOXp4OWwGU65i70UqQY4+HgNC3580aQ+wijZzw2qIPuDXSGNSfWcBSWDZzgM0ji2YE5x3gXOUw61IGOsB1Anf0abktQEbgO/HaXwwaw+wgOHBmXKisRmYn0RcAyM9gGU7ZyK3kXOS4ZmkglponQOobv9qYDlNaICaYbYCP/GEG9uhtjYFUGbM6wFLl4wcVgOLVFieSOh8KxeQN75uLibmqkqnArRF8OUMcHiczDoVYB35OYAJPm6cZGR0ho4tA/MJHkQ6Jxovxcms+zCoj3CBonLCE2uoNbE06wa2G5DTrsTybG4icmgZ6RkzRw8T4mQ2tTnTNuHYUyCWnYUpBehonCQnIrFeLu0KoLaDj9Mtp42JtR1sogeYRW7yrYstnnBjxVfUqgDqqpifP7+cZIh1LxA0KkCV185mddyYdfpJ4Ihdi0GIavyNwA91lJ8DwP2ecHvjFqKrB1hA3vg62cbwoJeR0KUAtdeTdgMe+d2AJOhDOoUIEoG9IbpuBnUDc5F26quAwz3hns1Qh8854RlANv47SRVo2ix8GvBXkzJbiD5gjifcJ5Ms1KidnifcTchr4jnh+AQZOS3Rxod0DDVz6+Bw7AZmeMJ9VUfhaSiAYGgwqJz6vBj38kc9jCuAigiWaqy8JiP2Wr8eadnqr09JbjPygs7C01KAUG5M2pjNRLjyHYa0FCA/H2hMP7AwzqWPIBhXABXS9R7TcpuMMjKucCjP31EwdjtY+QK8GOkSbqIpuU1IpfGNRA4zshNo2c7pSB/Ak0zIa2IGgLmecI1dqEnUTZwfyv/vU8BXfb7eADyItBn8lu66NAHzPOFuMClQ9/Xw0cirS7UxfvqRf+xjVekepXkCPuvgFk+415kWqnsSOJ7hjb8LOLG6m1Mz3bnIwAeJOD5oMnqBZWkI1joE9JSKXxQ6u8YgfQiXkW/5GZ5whwV+7CkVyz2l4suFzq5HkG5mp+qsW8ZY7Ql3YxqCTU0CJwH9QUPMKFPy24CrtFYsOyxSnlWNk9mwccrDyMfEvPvWJKzwhLskDcGZ9dujnCC1i2PJc5UhrXEyqwCK/RonaQn2JyUHmlkeAjqAf9FEsQ0bsAfYgdwF9VPsncB3knL/FpQs9wCH0RqN3wucDXzdE+6hwDeR8ZVqTeMmA2carlum/8Ej3Xl7D2lWVpkfTAF+jPznxY6ilTDbkO5c9/4tyl/Cq5btzEQui+2q9DMx7Fcps0MAgGU7TzD4VpSRlyFu8fOKbdnOeOB84ApktNEsMNMT7isjfanuTr6J7O1ARv+83kjNFFlXgDHAtcjIIyvr/TOr8oxCTqjuI90hrugJd0ajRJbtTAHWIoeKizzhGrWXzLQCxKGOa/odSKPUccABhB8G+4AVDJpqzRlBzhpPuBeELNs4rawAFvB41aMy0ra+uypNJRj2LOAsgrmzP6vWPt+ynWXAL2vSfQocq9OiNwlaWQFOBZ6terTVE+4hDfJMA5YgQ9/5DR++ZShF+ojhu5afIYM6rg5Td5NkeRkYl1q/RA1t6zzhbvKEOx8Z7m6HT5JNI+TrA9b4fDUeeMCynQsbyU6LVlaA2hC3TwXNqGzxTmO40tRzx/Jone9OCyrbNK2sALU3aNeGyewJdzNQe0I3Ylg2T7glBnuIe4FvM+jC5XHfTBmgZRXAE+67yB04ASxVDRSWpcDdwCvAdTT2yfOw+jnGE26vJ9xzkDuARgw8o9Cyk8A0sGxnMvAP5Iu1FLg9Sig3k7RsD5AGnnB3ApUl4q3IcDmZJleA5FnC4IXOc9KsSBByBUgYT7jbkVE8FgFG9/VzcnJywvF/28yLf1eLkCIAAAAASUVORK5CYII="

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Logo = __webpack_require__(68);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Brand = __webpack_require__(265);
	
	var _Brand2 = _interopRequireDefault(_Brand);
	
	var _HeaderModule = __webpack_require__(378);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
		_inherits(Header, _Component);
	
		function Header() {
			_classCallCheck(this, Header);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		Header.prototype.render = function render() {
			var onMenuButtonClick = this.props.onMenuButtonClick;
	
			return _react2.default.createElement(
				'header',
				{ className: _HeaderModule2.default.headerContainer },
				_react2.default.createElement(
					'div',
					{ className: _HeaderModule2.default.header },
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/', className: _HeaderModule2.default.headerItem },
						_react2.default.createElement(_Logo2.default, { containerClassName: _HeaderModule2.default.logo, fill: '#3f415e' })
					),
					_react2.default.createElement(
						'a',
						{ href: 'https://www.radionacional.co/', className: _HeaderModule2.default.headerItem },
						_react2.default.createElement(_Brand2.default, { containerClassName: _HeaderModule2.default.brand })
					),
					_react2.default.createElement(
						'div',
						{ className: _HeaderModule2.default.menuActionContainer },
						_react2.default.createElement(
							'button',
							{ onClick: onMenuButtonClick, name: 'menu' },
							_react2.default.createElement('img', { src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDM0IDI0Ij4gIDxnIGZpbGw9IiNGRjc1MDAiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgIDxyZWN0IHdpZHRoPSIzNCIgaGVpZ2h0PSIyIi8+ICAgIDxyZWN0IHdpZHRoPSIzNCIgaGVpZ2h0PSIyIiB5PSIxMSIvPiAgICA8cmVjdCB3aWR0aD0iMzQiIGhlaWdodD0iMiIgeT0iMjIiLz4gIDwvZz48L3N2Zz4=', title: 'Men\xFA', alt: 'Men\xFA' })
						)
					)
				)
			);
		};
	
		return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerContainer":"src-components-Header----Header-module---headerContainer---3avkD","header":"src-components-Header----Header-module---header---2gV_n","headerItem":"src-components-Header----Header-module---headerItem---qTjVf","menuActionContainer":"src-components-Header----Header-module---menuActionContainer---2naiA"};

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = function (_Component) {
		_inherits(Logo, _Component);
	
		function Logo() {
			_classCallCheck(this, Logo);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		Logo.prototype.render = function render() {
			var _props = this.props,
			    containerClassName = _props.containerClassName,
			    fill = _props.fill,
			    style = _props.style;
	
			return _react2.default.createElement(
				'div',
				{ className: containerClassName, style: style },
				_react2.default.createElement(
					'svg',
					{ xmlns: 'http://www.w3.org/2000/svg', width: '100%', viewBox: '0 0 300 139', style: { maxWidth: "158px" } },
					_react2.default.createElement(
						'g',
						{ fill: fill },
						_react2.default.createElement('path', { d: 'M49.0540541,12.1621622 C48.3783784,12.8378378 47.5675676,13.2432432 46.6216216,13.3783784 C45.6756757,13.5135135 45.1351351,13.2432432 44.8648649,12.5675676 C44.5945946,11.8918919 44.5945946,11.4864865 44.7297297,11.2162162 C44.8648649,10.9459459 45.2702703,10.4054054 45.8108108,9.59459459 C46.3513514,8.91891892 46.3513514,8.10810811 45.6756757,7.16216216 C45,6.35135135 44.0540541,5.67567568 42.8378378,5.13513514 C41.6216216,4.72972973 40.4054054,4.59459459 39.1891892,4.72972973 C37.972973,4.86486486 37.1621622,5.27027027 36.4864865,5.94594595 C35.8108108,6.62162162 35.4054054,7.43243243 35.4054054,8.51351351 C35.2702703,9.59459459 35.5405405,10.6756757 36.0810811,11.8918919 C36.6216216,13.1081081 37.2972973,14.1891892 38.1081081,15 C38.9189189,15.8108108 39.7297297,16.6216216 40.5405405,17.4324324 C41.3513514,18.2432432 41.7567568,18.9189189 41.7567568,19.5945946 C41.7567568,20.2702703 41.4864865,20.9459459 40.9459459,21.6216216 C40.4054054,22.2972973 39.4594595,22.8378378 38.1081081,23.3783784 C36.7567568,23.7837838 35.1351351,24.7297297 33.2432432,26.0810811 C31.3513514,27.4324324 29.4594595,28.5135135 27.5675676,29.4594595 C25.6756757,30.4054054 24.1891892,31.3513514 22.972973,32.1621622 C21.7567568,33.1081081 20.9459459,34.1891892 20.4054054,35.4054054 C19.8648649,36.6216216 20.1351351,37.7027027 21.0810811,38.6486486 C22.027027,39.5945946 23.2432432,40.2702703 25,40.5405405 C26.6216216,40.8108108 28.2432432,40.9459459 29.8648649,40.9459459 C31.4864865,40.8108108 32.972973,40.6756757 34.4594595,40.2702703 C35.9459459,39.8648649 37.4324324,39.4594595 39.0540541,38.7837838 C40.6756757,38.2432432 43.5135135,37.2972973 47.2972973,36.2162162 C47.4324324,37.972973 46.6216216,39.1891892 45,40 C43.3783784,40.6756757 41.7567568,41.4864865 40.1351351,42.2972973 C38.5135135,43.1081081 36.6216216,43.7837838 34.4594595,44.4594595 C32.4324324,45.1351351 29.8648649,45.5405405 26.8918919,45.6756757 C24.5945946,45.5405405 22.7027027,45.4054054 21.3513514,45.1351351 C20,44.8648649 18.6486486,44.4594595 17.2972973,43.6486486 C15.9459459,42.8378378 15,41.8918919 14.4594595,40.8108108 C13.7837838,39.7297297 13.5135135,38.3783784 13.3783784,37.027027 C13.5135135,35.8108108 13.7837838,34.4594595 14.4594595,33.1081081 C15.1351351,31.7567568 16.2162162,30.4054054 17.8378378,29.0540541 C19.3243243,27.7027027 21.3513514,26.6216216 23.6486486,25.6756757 C25.9459459,24.8648649 27.972973,23.9189189 29.7297297,22.972973 C31.4864865,22.027027 32.7027027,21.0810811 33.6486486,20.2702703 C34.5945946,19.4594595 34.8648649,18.5135135 34.5945946,17.5675676 C34.3243243,16.6216216 33.5135135,15.6756757 32.2972973,14.7297297 C31.0810811,13.7837838 30.2702703,12.7027027 30,11.2162162 C29.7297297,9.86486486 29.5945946,8.64864865 29.8648649,7.56756757 C30,6.48648649 30.2702703,5.67567568 30.5405405,4.86486486 C30.8108108,4.05405405 31.3513514,3.37837838 32.1621622,2.83783784 C32.972973,2.16216216 33.9189189,1.75675676 35.1351351,1.35135135 C36.2162162,0.945945946 37.972973,0.675675676 40.2702703,0.540540541 L43.3783784,0.810810811 C46.3513514,1.62162162 48.2432432,2.56756757 49.1891892,3.78378378 C50.1351351,5 50.6756757,6.48648649 50.9459459,8.37837838 C50.2702703,10.1351351 49.7297297,11.3513514 49.0540541,12.1621622 Z' }),
						_react2.default.createElement('path', { d: 'M43.3783784,39.0540541 C43.5135135,38.6486486 44.1891892,38.2432432 45.4054054,37.8378378 C46.4864865,37.5675676 48.1081081,36.7567568 50,35.5405405 C50.1351351,34.7297297 50.5405405,34.1891892 51.3513514,33.9189189 C52.027027,33.6486486 52.7027027,33.6486486 53.3783784,33.9189189 C54.0540541,34.1891892 55,33.9189189 56.2162162,33.1081081 C57.5675676,32.2972973 59.0540541,31.0810811 60.8108108,29.4594595 C62.5675676,27.8378378 63.6486486,26.7567568 63.9189189,26.4864865 C64.1891892,26.0810811 64.5945946,25.8108108 65.1351351,25.6756757 C65.6756757,25.6756757 66.0810811,25.8108108 66.4864865,25.9459459 C66.8918919,26.0810811 67.2972973,26.4864865 67.7027027,27.027027 C68.1081081,27.5675676 68.3783784,28.1081081 68.5135135,28.7837838 C68.5135135,29.4594595 68.2432432,29.8648649 67.5675676,30.2702703 C66.8918919,30.6756757 65.9459459,30.9459459 64.8648649,31.3513514 C63.7837838,31.7567568 62.8378378,32.1621622 62.027027,32.5675676 C61.2162162,32.972973 60.4054054,33.6486486 59.8648649,34.1891892 C59.1891892,34.8648649 58.7837838,35.4054054 58.6486486,35.8108108 C58.5135135,36.2162162 58.5135135,36.6216216 58.7837838,37.027027 C59.0540541,37.4324324 59.7297297,37.4324324 60.6756757,37.1621622 C61.6216216,36.8918919 62.2972973,36.8918919 62.8378378,37.027027 C63.3783784,37.1621622 63.6486486,37.5675676 63.7837838,38.1081081 C63.9189189,38.6486486 63.7837838,39.3243243 63.5135135,39.8648649 C63.2432432,40.5405405 63.3783784,40.9459459 63.6486486,41.3513514 C64.0540541,41.7567568 65,41.6216216 66.4864865,41.2162162 C68.1081081,40.8108108 69.4594595,40 70.6756757,38.7837838 C71.8918919,37.5675676 72.8378378,37.027027 73.3783784,36.8918919 C73.9189189,36.7567568 74.3243243,36.8918919 74.5945946,37.1621622 C74.8648649,37.4324324 75.1351351,38.1081081 75.2702703,39.1891892 C73.1081081,40.8108108 71.3513514,41.8918919 70.1351351,42.5675676 C68.9189189,43.2432432 67.8378378,43.7837838 66.7567568,44.1891892 C65.8108108,44.5945946 64.7297297,45 63.6486486,45 L62.027027,44.8648649 L60.8108108,44.1891892 C60,43.5135135 59.5945946,42.972973 59.3243243,42.2972973 C59.1891892,41.7567568 58.9189189,41.2162162 58.9189189,40.9459459 C58.7837838,40.6756757 58.6486486,40.4054054 58.2432432,40.2702703 C57.972973,40.1351351 57.4324324,40.2702703 56.8918919,40.6756757 C56.3513514,41.0810811 55.4054054,41.6216216 54.1891892,42.2972973 C52.972973,42.972973 52.027027,43.2432432 51.3513514,43.2432432 C50.6756757,43.2432432 50.1351351,43.1081081 49.5945946,42.8378378 C49.0540541,42.5675676 48.7837838,42.1621622 48.5135135,41.6216216 C48.3783784,41.2162162 48.3783784,40.6756757 48.6486486,40.1351351 C48.9189189,39.5945946 49.4594595,39.1891892 50,38.9189189 C50.5405405,38.6486486 50.8108108,38.3783784 50.6756757,37.972973 C50.5405405,37.7027027 49.8648649,37.7027027 49.0540541,38.2432432 C48.1081081,38.7837838 47.1621622,39.1891892 46.3513514,39.5945946 C45.4054054,39.8648649 44.7297297,40.1351351 44.3243243,40.1351351 C43.9189189,40.5405405 43.5135135,40.1351351 43.3783784,39.0540541 Z' }),
						_react2.default.createElement('path', { d: 'M74.0540541,36.4864865 C75.8108108,35.6756757 77.7027027,34.4594595 79.7297297,32.7027027 C81.7567568,30.9459459 84.4594595,29.1891892 87.7027027,27.2972973 C90.9459459,25.4054054 93.3783784,23.6486486 95,22.027027 C96.6216216,20.4054054 97.7027027,19.4594595 98.1081081,19.1891892 C98.6486486,18.9189189 98.9189189,18.9189189 99.1891892,18.9189189 C99.4594595,18.9189189 99.8648649,19.0540541 100.135135,19.3243243 C100.540541,19.5945946 100.540541,20.2702703 100.405405,21.3513514 C100.135135,22.4324324 99.1891892,23.9189189 97.5675676,25.8108108 C95.9459459,27.7027027 94.3243243,29.1891892 92.7027027,30.4054054 C91.2162162,31.4864865 89.0540541,33.5135135 86.4864865,36.3513514 C90.1351351,34.7297297 92.972973,33.5135135 95.1351351,32.4324324 C97.2972973,31.3513514 99.3243243,30.5405405 101.081081,30 C102.837838,29.4594595 104.324324,29.0540541 105.675676,28.9189189 C106.891892,28.7837838 107.837838,28.9189189 108.378378,29.5945946 C108.918919,30.2702703 109.054054,31.2162162 108.648649,32.5675676 C108.243243,33.9189189 107.432432,35.1351351 106.351351,36.3513514 C105.27027,37.4324324 104.459459,38.3783784 104.189189,38.9189189 C103.918919,39.5945946 104.459459,39.8648649 105.945946,39.8648649 C107.432432,39.8648649 108.648649,39.5945946 109.594595,39.3243243 C110.540541,38.9189189 111.351351,38.3783784 112.297297,37.7027027 C113.108108,36.8918919 113.783784,37.027027 114.189189,38.1081081 C114.054054,39.8648649 113.243243,41.2162162 111.756757,42.027027 C110.27027,42.972973 108.378378,43.5135135 106.216216,43.7837838 C103.918919,44.0540541 102.162162,44.0540541 100.945946,43.9189189 C99.7297297,43.7837838 98.9189189,43.1081081 98.3783784,42.1621622 C97.8378378,41.2162162 97.972973,40.1351351 98.7837838,39.1891892 C99.4594595,38.1081081 100.27027,37.1621622 100.945946,36.2162162 C101.756757,35.2702703 102.567568,34.4594595 103.378378,33.7837838 C104.189189,33.1081081 104.324324,32.7027027 103.918919,32.5675676 C103.378378,32.4324324 102.567568,32.5675676 101.351351,32.972973 C100.135135,33.3783784 98.2432432,34.1891892 95.6756757,35.2702703 C93.1081081,36.3513514 90.6756757,37.5675676 88.3783784,39.0540541 C86.0810811,40.4054054 83.3783784,42.2972973 80.1351351,44.8648649 C76.8918919,47.4324324 74.4594595,49.4594595 72.5675676,51.2162162 C70.6756757,52.972973 68.5135135,55.1351351 65.8108108,57.7027027 C63.1081081,60.2702703 60.6756757,62.2972973 58.5135135,63.6486486 C56.3513514,65.1351351 55,66.0810811 54.3243243,66.6216216 C53.7837838,67.027027 53.1081081,67.2972973 52.4324324,67.2972973 L52.1621622,67.2972973 C51.3513514,67.2972973 50.9459459,66.8918919 50.6756757,66.0810811 L50.6756757,65.8108108 C50.6756757,65.1351351 51.3513514,64.1891892 52.8378378,63.1081081 C54.4594595,61.8918919 56.3513514,60.2702703 58.7837838,58.1081081 C61.0810811,55.9459459 64.3243243,53.1081081 68.2432432,49.8648649 C72.1621622,46.4864865 75.1351351,44.0540541 77.2972973,42.1621622 C79.3243243,40.4054054 81.0810811,38.7837838 82.4324324,37.4324324 C83.7837838,36.0810811 86.0810811,33.9189189 89.0540541,30.9459459 C85.6756757,32.4324324 82.972973,34.0540541 80.6756757,35.6756757 C78.3783784,37.2972973 76.4864865,38.6486486 74.8648649,39.7297297 C73.2432432,40.8108108 72.1621622,40.6756757 71.7567568,39.1891892 C71.6216216,38.1081081 72.4324324,37.1621622 74.0540541,36.4864865 Z' }),
						_react2.default.createElement('path', { d: 'M112.162162,33.9189189 C112.567568,32.972973 113.378378,31.8918919 114.459459,30.8108108 C115.540541,29.7297297 116.486486,28.7837838 117.567568,28.1081081 C118.648649,27.2972973 119.72973,26.7567568 120.810811,26.4864865 L122.027027,26.4864865 C123.108108,26.4864865 124.054054,26.7567568 124.864865,27.4324324 C125.675676,27.972973 126.081081,29.0540541 125.945946,30.4054054 C125.810811,31.8918919 125.135135,33.1081081 123.783784,34.1891892 C122.432432,35.2702703 121.081081,35.9459459 119.459459,36.4864865 C117.837838,36.8918919 116.891892,37.2972973 116.891892,37.7027027 C116.756757,38.1081081 117.027027,38.5135135 117.702703,38.9189189 C118.378378,39.3243243 119.864865,39.5945946 122.162162,39.7297297 C124.459459,39.8648649 126.351351,39.7297297 127.837838,39.3243243 C129.324324,38.9189189 130.405405,38.5135135 131.351351,38.1081081 C132.297297,37.7027027 132.972973,37.4324324 133.513514,37.2972973 C134.054054,37.1621622 134.459459,37.4324324 134.72973,38.1081081 C133.783784,39.4594595 132.837838,40.4054054 131.756757,40.9459459 C130.675676,41.6216216 129.324324,42.1621622 127.567568,42.5675676 C125.945946,43.1081081 123.918919,43.3783784 121.486486,43.5135135 L120,43.5135135 C117.432432,43.2432432 115.675676,42.972973 114.72973,42.4324324 C113.783784,42.027027 113.108108,41.4864865 112.567568,40.8108108 C112.027027,40.2702703 111.756757,39.3243243 111.486486,38.1081081 C111.486486,36.2162162 111.756757,34.8648649 112.162162,33.9189189 Z M116.216216,34.5945946 C118.378378,33.9189189 119.864865,33.2432432 120.540541,32.5675676 C121.216216,31.8918919 121.621622,31.3513514 121.486486,30.8108108 C121.351351,30.2702703 120.810811,30.2702703 119.72973,30.8108108 C118.648649,31.3513514 117.837838,31.8918919 117.432432,32.5675676 C116.891892,33.2432432 116.486486,33.9189189 116.216216,34.5945946 Z' }),
						_react2.default.createElement('path', { d: 'M157.567568,25.8108108 C158.513514,24.3243243 159.459459,23.2432432 160.135135,22.4324324 C160.810811,21.6216216 161.891892,20.6756757 162.972973,19.4594595 C164.189189,18.2432432 165.405405,17.027027 166.756757,15.6756757 C168.108108,14.4594595 169.324324,13.5135135 170.405405,12.8378378 C171.621622,12.1621622 172.432432,11.8918919 172.972973,11.7567568 C173.783784,11.8918919 174.324324,12.1621622 174.594595,12.4324324 C174.864865,12.7027027 175.135135,13.2432432 175.27027,13.9189189 C174.864865,15.1351351 174.189189,16.3513514 173.108108,17.5675676 C172.027027,18.9189189 170.810811,20.1351351 169.459459,21.4864865 C168.243243,22.8378378 167.162162,23.7837838 166.216216,24.3243243 C165.27027,24.8648649 164.459459,25.4054054 163.513514,25.8108108 C162.567568,26.2162162 161.621622,27.027027 160.540541,28.1081081 C159.459459,29.3243243 158.378378,30.5405405 157.162162,31.8918919 C155.945946,33.2432432 155.135135,34.3243243 154.594595,35.2702703 C154.054054,36.2162162 153.513514,36.8918919 152.972973,37.5675676 C152.432432,38.2432432 152.162162,38.7837838 152.162162,39.1891892 C152.162162,39.5945946 152.432432,40 153.108108,40.1351351 C153.783784,40.2702703 154.459459,40 155.135135,39.4594595 C155.945946,38.7837838 157.027027,38.3783784 158.378378,38.1081081 C159.72973,37.8378378 160.810811,37.5675676 161.621622,37.027027 C162.297297,36.6216216 162.837838,36.6216216 162.972973,37.1621622 C163.108108,37.7027027 163.243243,38.2432432 163.378378,38.6486486 C163.513514,39.0540541 162.972973,39.4594595 161.891892,40 C160.810811,40.5405405 159.864865,40.9459459 158.918919,41.2162162 C157.972973,41.4864865 157.162162,41.7567568 156.486486,42.027027 C155.810811,42.2972973 154.72973,42.5675676 153.378378,42.8378378 C152.027027,43.1081081 150.945946,43.2432432 149.864865,42.972973 C148.918919,42.8378378 148.243243,42.2972973 148.108108,41.6216216 C147.972973,40.9459459 147.702703,40 147.567568,38.9189189 C146.756757,39.4594595 145.945946,40.1351351 145,40.8108108 C144.054054,41.4864865 143.108108,42.027027 142.297297,42.4324324 C141.486486,42.8378378 140.540541,43.3783784 139.594595,43.9189189 C138.648649,44.4594595 137.837838,44.8648649 137.297297,45.2702703 C136.756757,45.5405405 135.540541,45.8108108 133.783784,45.8108108 C132.567568,45.6756757 131.621622,45.1351351 131.081081,44.3243243 C130.675676,43.6486486 130.540541,42.972973 130.540541,42.2972973 C130.810811,41.0810811 131.351351,40 132.027027,39.0540541 C132.837838,38.1081081 133.648649,37.027027 134.594595,35.9459459 C135.540541,34.8648649 136.486486,33.7837838 137.432432,32.972973 C138.378378,32.027027 139.324324,31.2162162 140.27027,30.4054054 C141.216216,29.5945946 142.297297,28.7837838 143.513514,28.1081081 C144.72973,27.4324324 145.810811,27.027027 147.027027,26.7567568 C148.243243,26.4864865 149.054054,26.3513514 149.864865,26.4864865 C150.540541,26.6216216 151.216216,26.8918919 151.756757,27.4324324 C152.297297,27.972973 152.567568,28.5135135 152.567568,29.0540541 C152.567568,29.5945946 152.702703,30.2702703 152.837838,30.8108108 C152.972973,31.4864865 153.378378,31.4864865 153.918919,30.9459459 C154.594595,30.4054054 155.135135,29.7297297 155.540541,29.0540541 C155.945946,28.3783784 156.621622,27.2972973 157.567568,25.8108108 Z M136.216216,41.7567568 C136.486486,42.027027 137.567568,41.8918919 139.189189,41.0810811 C140.810811,40.2702703 142.432432,39.3243243 143.918919,38.3783784 C145.405405,37.4324324 146.486486,36.4864865 147.162162,35.5405405 C147.837838,34.5945946 148.243243,33.6486486 148.378378,32.5675676 C148.513514,31.6216216 148.513514,30.8108108 148.108108,30.5405405 C147.702703,30.1351351 147.162162,30.2702703 146.351351,30.6756757 C145.540541,31.0810811 144.459459,31.7567568 143.378378,32.8378378 C142.162162,33.9189189 141.081081,35 140,35.9459459 C139.054054,37.027027 137.972973,38.1081081 137.162162,39.4594595 C136.216216,40.5405405 135.945946,41.3513514 136.216216,41.7567568 Z' }),
						_react2.default.createElement('path', { d: 'M166.216216,33.2432432 C167.567568,31.4864865 169.054054,30.2702703 170.675676,29.5945946 C172.432432,28.7837838 173.783784,28.1081081 174.72973,27.1621622 C175.810811,26.3513514 176.756757,26.0810811 177.702703,26.3513514 C178.648649,26.6216216 179.054054,27.1621622 179.054054,28.1081081 C179.054054,29.0540541 178.513514,29.8648649 177.432432,30.4054054 C176.351351,31.0810811 175.540541,31.7567568 175.135135,32.4324324 C174.594595,33.1081081 174.189189,33.9189189 173.918919,34.8648649 C173.648649,35.8108108 173.648649,36.6216216 173.918919,37.5675676 C174.189189,38.5135135 174.72973,39.0540541 175.675676,39.3243243 C176.486486,39.5945946 177.837838,39.7297297 179.72973,39.7297297 C181.486486,39.7297297 183.108108,39.4594595 184.459459,39.1891892 C185.810811,38.7837838 187.027027,38.3783784 188.108108,37.7027027 C189.189189,37.027027 190,36.8918919 190.675676,37.027027 L190.945946,38.2432432 C190.540541,39.0540541 189.864865,39.5945946 188.918919,40.1351351 C188.108108,40.6756757 187.162162,41.0810811 186.351351,41.4864865 C185.540541,41.8918919 184.324324,42.1621622 182.702703,42.5675676 C181.081081,42.972973 179.324324,43.2432432 177.297297,43.5135135 L175,43.6486486 C173.243243,43.3783784 171.891892,43.1081081 171.081081,42.5675676 C170.27027,42.027027 169.594595,41.4864865 169.054054,40.6756757 C168.513514,39.8648649 168.243243,39.0540541 168.243243,38.2432432 C168.243243,37.4324324 168.243243,36.6216216 168.513514,35.8108108 C168.783784,35 168.513514,35 167.837838,35.8108108 C167.162162,36.6216216 166.081081,37.4324324 164.864865,38.2432432 C163.648649,38.9189189 162.567568,39.5945946 161.621622,40 C160.810811,40.4054054 160.135135,39.7297297 159.864865,37.972973 C162.837838,36.4864865 165,35 166.216216,33.2432432 Z M192.162162,12.2972973 L191.216216,12.027027 C190.27027,10.9459459 189.594595,10.1351351 189.054054,9.59459459 C189.459459,8.64864865 190.405405,7.7027027 191.756757,6.89189189 L192.702703,6.89189189 C193.513514,7.2972973 194.054054,7.83783784 194.054054,8.37837838 C194.054054,9.05405405 194.594595,9.59459459 195.405405,10.1351351 L195,11.0810811 C194.054054,11.7567568 193.108108,12.1621622 192.162162,12.2972973 Z' }),
						_react2.default.createElement('path', { d: 'M204.189189,27.5675676 C204.324324,27.8378378 204.324324,28.2432432 204.054054,28.6486486 C203.783784,29.0540541 203.513514,29.4594595 203.108108,29.7297297 C202.702703,30.1351351 202.432432,30.5405405 202.297297,31.0810811 C202.162162,31.6216216 201.891892,31.8918919 201.351351,32.027027 C200.810811,32.1621622 200.135135,32.027027 199.324324,31.7567568 C198.648649,31.4864865 197.972973,31.4864865 197.432432,31.4864865 C196.891892,31.6216216 196.351351,32.027027 195.675676,32.7027027 C195,33.5135135 194.459459,34.1891892 193.918919,34.8648649 C193.378378,35.5405405 192.972973,36.2162162 192.837838,36.8918919 C192.567568,37.5675676 192.702703,38.2432432 192.972973,38.7837838 C193.243243,39.3243243 193.783784,39.7297297 194.459459,39.8648649 C195.135135,40 195.945946,40.1351351 197.162162,40 C198.378378,39.8648649 199.594595,39.5945946 200.810811,39.1891892 C202.027027,38.7837838 203.243243,38.3783784 204.459459,37.972973 C205.675676,37.5675676 206.486486,37.1621622 207.027027,36.8918919 C207.567568,36.6216216 208.108108,36.8918919 208.513514,37.7027027 C208.378378,38.5135135 208.108108,39.0540541 207.567568,39.3243243 C207.027027,39.5945946 206.351351,40 205.405405,40.4054054 C204.459459,40.8108108 203.513514,41.2162162 202.567568,41.4864865 C201.621622,41.7567568 200.405405,42.1621622 199.189189,42.4324324 C197.972973,42.7027027 196.621622,42.972973 195.135135,43.1081081 L194.054054,43.1081081 C193.378378,42.972973 192.702703,42.972973 192.027027,42.8378378 C191.351351,42.7027027 190.810811,42.4324324 190.135135,41.8918919 C189.459459,41.3513514 188.918919,40.6756757 188.513514,39.5945946 L188.378378,38.6486486 C188.513514,37.7027027 188.783784,36.6216216 189.324324,35.5405405 C189.864865,34.4594595 190.540541,33.5135135 191.351351,32.4324324 C192.162162,31.4864865 193.108108,30.5405405 194.189189,29.8648649 C195.27027,29.1891892 196.216216,28.6486486 197.027027,28.2432432 C197.837838,27.972973 198.378378,27.5675676 198.648649,27.2972973 C198.918919,27.027027 199.459459,26.7567568 200.135135,26.4864865 C200.810811,26.2162162 201.486486,26.0810811 202.162162,26.0810811 C202.702703,26.0810811 203.108108,26.2162162 203.378378,26.4864865 C203.783784,26.8918919 204.054054,27.1621622 204.189189,27.5675676 Z' }),
						_react2.default.createElement('path', { d: 'M211.216216,33.2432432 C212.567568,31.4864865 214.054054,30.2702703 215.675676,29.5945946 C217.432432,28.7837838 218.783784,28.1081081 219.72973,27.1621622 C220.810811,26.3513514 221.756757,26.0810811 222.702703,26.3513514 C223.648649,26.6216216 224.054054,27.1621622 224.054054,28.1081081 C224.054054,29.0540541 223.513514,29.8648649 222.432432,30.4054054 C221.351351,31.0810811 220.540541,31.7567568 220.135135,32.4324324 C219.594595,33.1081081 219.189189,33.9189189 218.918919,34.8648649 C218.648649,35.8108108 218.648649,36.6216216 218.918919,37.5675676 C219.189189,38.5135135 219.72973,39.0540541 220.675676,39.3243243 C221.486486,39.5945946 222.837838,39.7297297 224.72973,39.7297297 C226.486486,39.7297297 228.108108,39.4594595 229.459459,39.1891892 C230.810811,38.7837838 232.027027,38.3783784 233.108108,37.7027027 C234.189189,37.027027 235,36.8918919 235.675676,37.027027 L235.945946,38.2432432 C235.540541,39.0540541 234.864865,39.5945946 233.918919,40.1351351 C233.108108,40.6756757 232.162162,41.0810811 231.351351,41.4864865 C230.540541,41.8918919 229.324324,42.1621622 227.702703,42.5675676 C226.081081,42.972973 224.324324,43.2432432 222.297297,43.5135135 L220,43.6486486 C218.243243,43.3783784 216.891892,43.1081081 216.081081,42.5675676 C215.27027,42.027027 214.594595,41.4864865 214.054054,40.6756757 C213.513514,39.8648649 213.243243,39.0540541 213.243243,38.2432432 C213.243243,37.4324324 213.243243,36.6216216 213.513514,35.8108108 C213.783784,35 213.513514,35 212.837838,35.8108108 C212.162162,36.6216216 211.081081,37.4324324 209.864865,38.2432432 C208.648649,38.9189189 207.567568,39.5945946 206.621622,40 C205.810811,40.4054054 205.135135,39.7297297 204.864865,37.972973 C207.837838,36.4864865 209.864865,35 211.216216,33.2432432 Z M237.027027,12.2972973 L236.081081,12.027027 C235.135135,10.9459459 234.459459,10.1351351 233.918919,9.59459459 C234.324324,8.64864865 235.27027,7.7027027 236.621622,6.89189189 L237.567568,6.89189189 C238.378378,7.2972973 238.918919,7.83783784 238.918919,8.37837838 C238.918919,9.05405405 239.459459,9.59459459 240.27027,10.1351351 L239.864865,11.0810811 C238.918919,11.7567568 238.108108,12.1621622 237.027027,12.2972973 Z' }),
						_react2.default.createElement('path', { d: 'M238.378378,38.1081081 C238.918919,38.9189189 239.594595,39.4594595 240.540541,39.4594595 C241.351351,39.4594595 242.162162,39.3243243 242.972973,38.7837838 C243.783784,38.2432432 244.594595,37.8378378 245.540541,37.4324324 C246.486486,37.027027 247.567568,36.4864865 248.513514,35.8108108 C249.459459,35.1351351 250,34.3243243 250,33.3783784 C250,32.4324324 249.594595,31.6216216 248.918919,31.0810811 C248.108108,30.5405405 247.837838,29.8648649 247.972973,28.9189189 C248.108108,28.1081081 248.513514,27.4324324 249.189189,27.1621622 C249.864865,26.8918919 250.945946,26.6216216 252.432432,26.6216216 C254.054054,26.8918919 255,27.7027027 255.405405,29.0540541 C255.810811,30.2702703 255.675676,31.4864865 255.27027,32.5675676 C254.864865,33.6486486 255.405405,34.5945946 256.756757,35.5405405 C258.108108,36.4864865 259.459459,36.7567568 260.540541,36.3513514 C261.621622,36.0810811 262.297297,36.3513514 262.432432,37.4324324 C262.297297,38.5135135 262.027027,39.1891892 261.621622,39.3243243 C261.216216,39.5945946 260.405405,39.7297297 259.189189,39.8648649 C257.972973,40 256.486486,39.5945946 254.72973,38.7837838 C252.972973,37.8378378 251.756757,37.7027027 250.945946,38.2432432 C250.135135,38.7837838 249.054054,39.5945946 247.567568,40.4054054 C246.081081,41.3513514 244.594595,42.027027 243.243243,42.5675676 C241.756757,43.1081081 240.135135,43.3783784 238.378378,43.3783784 C236.621622,42.8378378 235.405405,41.8918919 234.72973,40.8108108 C234.054054,39.5945946 233.648649,38.3783784 233.648649,36.8918919 C233.783784,35.9459459 234.594595,34.8648649 235.810811,33.6486486 C237.162162,32.4324324 238.378378,31.4864865 239.594595,30.6756757 C240.810811,29.8648649 242.027027,29.3243243 243.243243,28.9189189 C244.459459,28.5135135 245.27027,28.6486486 245.810811,29.0540541 C246.351351,29.5945946 246.621622,30.1351351 246.756757,30.8108108 C246.891892,31.4864865 246.891892,32.027027 246.486486,32.4324324 C246.216216,32.8378378 245.675676,33.1081081 245.135135,33.2432432 C244.594595,33.3783784 243.783784,33.5135135 242.702703,33.7837838 C241.621622,34.0540541 240.540541,34.5945946 239.324324,35.5405405 C238.108108,36.3513514 237.837838,37.1621622 238.378378,38.1081081 Z M261.351351,9.32432432 C260.540541,10.1351351 259.864865,10.9459459 259.324324,11.3513514 C258.783784,11.8918919 258.108108,12.1621622 257.702703,12.2972973 C257.162162,12.4324324 256.756757,12.7027027 256.486486,12.972973 C256.216216,13.2432432 255.945946,13.3783784 255.540541,13.6486486 C255.135135,13.9189189 254.72973,13.9189189 254.189189,13.9189189 C253.648649,13.7837838 253.243243,13.7837838 253.108108,13.6486486 C252.972973,13.5135135 252.837838,13.3783784 252.837838,12.8378378 C252.972973,12.2972973 253.108108,12.027027 253.378378,11.7567568 C253.648649,11.4864865 254.054054,11.3513514 254.594595,11.2162162 C255.135135,11.0810811 255.810811,10.9459459 256.621622,10.5405405 C257.432432,10.1351351 258.243243,9.59459459 259.054054,8.78378378 C259.864865,7.97297297 260.540541,7.43243243 261.081081,6.89189189 C261.756757,6.48648649 262.027027,6.08108108 262.297297,5.67567568 C262.432432,5.27027027 262.837838,5 263.513514,5 C264.054054,5.13513514 264.459459,5.27027027 264.594595,5.40540541 C264.72973,5.54054054 264.864865,5.67567568 264.864865,5.94594595 C264.864865,6.08108108 264.72973,6.08108108 264.594595,6.21621622 C264.459459,6.35135135 264.324324,6.48648649 264.189189,6.89189189 C264.054054,7.16216216 263.783784,7.56756757 263.243243,7.7027027 C262.837838,7.83783784 262.162162,8.37837838 261.351351,9.32432432 Z' }),
						_react2.default.createElement('path', { d: 'M259.72973 36.3513514C260.405405 36.0810811 261.486486 35.2702703 262.972973 33.9189189 264.459459 32.7027027 266.081081 31.4864865 268.108108 30.5405405 270.135135 29.5945946 271.621622 28.7837838 272.702703 28.2432432 273.783784 27.7027027 275 27.4324324 276.351351 27.4324324 277.567568 27.8378378 278.243243 28.5135135 278.513514 29.5945946 278.783784 30.5405405 278.648649 31.6216216 278.243243 32.7027027 277.837838 33.7837838 276.351351 35.6756757 273.783784 38.3783784 277.837838 35.9459459 280.675676 34.3243243 282.162162 33.5135135 283.648649 32.5675676 285 32.027027 285.945946 31.8918919 286.891892 31.6216216 287.702703 32.027027 288.378378 32.7027027 289.054054 33.5135135 289.054054 34.5945946 288.378378 36.2162162 287.702703 37.7027027 287.432432 38.9189189 287.702703 39.5945946 287.972973 40.4054054 289.594595 40.2702703 292.837838 39.3243243 295.945946 38.3783784 298.378378 37.5675676 300 36.8918919 299.864865 38.2432432 299.594595 39.3243243 298.918919 39.8648649 298.243243 40.4054054 296.351351 41.2162162 293.108108 42.2972973 289.864865 43.3783784 287.432432 43.6486486 285.810811 43.2432432 284.189189 42.8378378 283.243243 42.1621622 282.837838 41.2162162 282.432432 40.2702703 282.297297 39.3243243 282.702703 38.2432432 282.972973 37.1621622 282.027027 37.4324324 279.864865 39.0540541 277.702703 40.6756757 275.810811 41.8918919 274.189189 42.7027027 272.567568 43.6486486 271.351351 44.1891892 270.540541 44.5945946 269.459459 44.5945946 268.648649 44.4594595 267.972973 44.0540541 267.297297 43.6486486 267.027027 42.972973 266.891892 42.027027 266.756757 41.0810811 267.297297 40.1351351 268.243243 39.3243243 269.189189 38.5135135 270.27027 37.7027027 271.216216 36.7567568 272.162162 35.8108108 272.702703 35 272.972973 34.0540541 273.243243 33.1081081 272.702703 32.8378378 271.351351 33.2432432 270 33.5135135 268.243243 34.5945946 266.081081 36.0810811 263.783784 37.7027027 262.297297 38.6486486 261.621622 39.0540541 260.945946 39.4594595 259.864865 39.7297297 258.648649 39.8648649 258.513514 37.7027027 259.054054 36.6216216 259.72973 36.3513514zM140.540541 50.2702703L137.432432 50.5405405C133.783784 51.8918919 130.810811 53.2432432 128.513514 54.7297297 126.081081 56.2162162 123.513514 57.8378378 120.675676 59.7297297 117.837838 61.6216216 114.864865 63.9189189 111.891892 66.4864865 108.918919 69.0540541 105.540541 72.027027 102.027027 75.5405405 98.3783784 79.0540541 95.1351351 82.1621622 92.2972973 85 89.4594595 87.7027027 86.7567568 90.1351351 84.5945946 92.027027 82.2972973 93.9189189 80.2702703 95.4054054 78.3783784 96.4864865 76.4864865 97.5675676 75.1351351 98.1081081 74.1891892 98.1081081 73.2432432 98.1081081 72.7027027 97.5675676 72.4324324 96.6216216 72.1621622 95.5405405 72.1621622 94.7297297 72.5675676 93.9189189 72.972973 93.1081081 73.5135135 91.7567568 74.4594595 90 75.2702703 88.2432432 76.6216216 86.0810811 78.5135135 83.5135135 80.2702703 80.9459459 82.1621622 78.3783784 84.1891892 75.5405405 86.2162162 72.7027027 87.972973 70.1351351 89.4594595 67.7027027 90.9459459 65.2702703 91.7567568 63.3783784 91.7567568 61.8918919 91.7567568 60.4054054 91.4864865 59.3243243 90.8108108 58.7837838 90.1351351 58.2432432 89.4594595 57.972973 88.6486486 57.972973 87.8378378 57.972973 86.6216216 58.2432432 85 58.6486486 83.3783784 59.1891892 81.0810811 60.1351351 78.1081081 61.7567568 75.1351351 63.3783784 72.5675676 65 70.5405405 66.6216216 68.9189189 67.7027027 67.5675676 68.9189189 66.2162162 70.4054054 68.3783784 70 80.4054054 65.4054054 81.7567568 65 83.1081081 64.5945946 83.7837838 64.7297297 84.0540541 65.2702703 84.3243243 65.8108108 83.7837838 67.1621622 82.5675676 69.0540541 81.3513514 70.9459459 80 72.8378378 78.5135135 74.7297297 77.027027 76.4864865 75.5405405 78.6486486 73.9189189 81.2162162 72.2972973 83.6486486 70.8108108 86.2162162 69.4594595 88.9189189 67.972973 91.4864865 67.4324324 94.0540541 67.5675676 96.4864865 67.7027027 98.9189189 68.2432432 100.540541 69.1891892 101.486486 70.1351351 102.432432 71.2162162 102.972973 72.7027027 103.243243 75.2702703 102.972973 77.7027027 102.162162 79.8648649 100.810811 82.027027 99.4594595 84.7297297 97.2972973 88.1081081 94.5945946 91.4864865 91.7567568 94.5945946 89.0540541 97.2972973 86.2162162 100.135135 83.5135135 102.972973 80.6756757 105.810811 78.1081081 108.783784 75.4054054 111.486486 72.972973 114.189189 70.5405405 116.891892 68.2432432 119.459459 66.0810811 121.891892 64.3243243 124.324324 62.5675676 126.621622 61.0810811 128.918919 59.7297297 131.081081 58.5135135 133.108108 57.4324324 134.864865 56.6216216 136.621622 55.8108108 137.972973 55.5405405 138.783784 55.9459459 139.594595 56.3513514 140.135135 57.027027 140.27027 58.1081081 140.405405 59.1891892 140 60.4054054 139.054054 61.7567568 138.108108 63.1081081 137.027027 64.0540541 135.945946 64.5945946 134.864865 65.1351351 134.054054 65.8108108 133.648649 66.7567568 133.243243 67.7027027 133.108108 68.3783784 133.513514 68.7837838 133.918919 69.1891892 134.72973 69.3243243 136.081081 68.9189189 137.432432 68.6486486 139.054054 67.7027027 140.945946 66.3513514 142.837838 64.8648649 144.189189 62.7027027 145.135135 59.8648649L145.27027 55.2702703C144.054054 52.4324324 142.567568 50.9459459 140.540541 50.2702703zM107.162162 93.9189189C107.702703 94.8648649 108.513514 95.2702703 109.324324 95.2702703 110.135135 95.2702703 111.081081 95 111.756757 94.5945946 112.567568 94.0540541 113.513514 93.6486486 114.459459 93.1081081 115.540541 92.7027027 116.486486 92.027027 117.567568 91.3513514 118.513514 90.6756757 119.054054 89.8648649 119.054054 88.7837838 119.054054 87.7027027 118.648649 86.8918919 117.837838 86.3513514 117.027027 85.8108108 116.756757 85 116.891892 84.1891892 117.027027 83.2432432 117.432432 82.7027027 118.108108 82.2972973 118.783784 82.027027 119.864865 81.7567568 121.486486 81.7567568 123.108108 82.027027 124.189189 82.972973 124.594595 84.1891892 125 85.5405405 125 86.7567568 124.459459 87.8378378 124.054054 88.9189189 124.594595 90 126.081081 90.9459459 127.567568 91.8918919 128.918919 92.1621622 130 91.8918919 131.216216 91.6216216 131.756757 91.8918919 132.027027 92.972973 131.891892 94.0540541 131.486486 94.7297297 131.081081 95 130.675676 95.2702703 129.864865 95.4054054 128.513514 95.6756757 127.162162 95.8108108 125.675676 95.4054054 123.918919 94.4594595 122.162162 93.5135135 120.810811 93.2432432 120 93.9189189 119.189189 94.4594595 118.108108 95.2702703 116.486486 96.2162162 115 97.1621622 113.378378 97.972973 111.891892 98.5135135 110.405405 99.0540541 108.648649 99.3243243 106.756757 99.3243243 105 98.7837838 103.783784 97.8378378 102.972973 96.6216216 102.297297 95.4054054 101.891892 94.0540541 101.891892 92.5675676 102.027027 91.4864865 102.837838 90.4054054 104.189189 89.1891892 105.540541 87.972973 106.891892 86.8918919 108.108108 86.0810811 109.324324 85.2702703 110.540541 84.5945946 111.891892 84.1891892 113.108108 83.7837838 114.054054 83.9189189 114.594595 84.3243243 115.135135 84.8648649 115.540541 85.4054054 115.675676 86.2162162 115.810811 86.8918919 115.810811 87.5675676 115.405405 87.972973 115.135135 88.3783784 114.594595 88.6486486 114.054054 88.9189189 113.378378 89.0540541 112.567568 89.3243243 111.486486 89.4594595 110.405405 89.7297297 109.324324 90.2702703 107.972973 91.2162162 106.891892 92.1621622 106.621622 93.1081081 107.162162 93.9189189z' }),
						_react2.default.createElement('path', { d: 'M127.567568,93.6486486 C130,92.2972973 132.567568,90.2702703 135.135135,87.4324324 C137.702703,84.5945946 139.72973,82.972973 141.216216,82.4324324 C142.702703,81.8918919 144.189189,81.6216216 145.945946,81.6216216 C146.621622,81.6216216 147.162162,81.7567568 147.702703,82.027027 C148.243243,82.2972973 148.513514,82.7027027 148.648649,83.3783784 C148.783784,84.0540541 148.783784,84.5945946 148.648649,85.4054054 C148.513514,86.0810811 148.108108,87.027027 147.297297,88.1081081 C146.621622,89.1891892 145.675676,90 144.72973,90.8108108 C143.648649,91.4864865 142.972973,92.1621622 142.567568,92.8378378 C142.162162,93.3783784 142.162162,94.0540541 142.432432,94.5945946 C142.702703,95.1351351 144.054054,95.2702703 146.216216,94.7297297 C148.513514,94.3243243 150.135135,93.7837838 151.216216,93.5135135 C152.297297,93.1081081 153.378378,92.7027027 154.594595,92.1621622 L155.27027,94.5945946 C152.567568,95.8108108 150.135135,96.8918919 148.108108,97.8378378 C145.945946,98.7837838 143.783784,99.3243243 141.486486,99.5945946 C140,99.5945946 138.783784,99.5945946 137.972973,99.4594595 C137.162162,99.3243243 136.351351,99.0540541 135.675676,98.3783784 C135,97.8378378 134.594595,97.1621622 134.459459,96.3513514 C134.324324,95.5405405 134.459459,94.7297297 134.864865,93.9189189 C135.27027,93.1081081 135.945946,92.4324324 136.891892,91.7567568 C137.837838,91.0810811 138.783784,90.5405405 139.72973,90 C140.675676,89.5945946 141.621622,88.9189189 142.297297,88.2432432 C142.972973,87.4324324 143.243243,86.8918919 142.837838,86.4864865 C142.432432,86.0810811 141.891892,85.9459459 141.216216,86.0810811 C140.540541,86.2162162 138.918919,87.7027027 136.216216,90.2702703 C133.648649,92.8378378 130.945946,94.7297297 128.378378,95.8108108 L127.567568,93.6486486 Z' }),
						_react2.default.createElement('path', { d: 'M155.27027,88.9189189 C157.162162,87.027027 159.054054,85.6756757 160.675676,84.7297297 C162.297297,83.7837838 163.648649,83.1081081 164.594595,82.7027027 C165.540541,82.2972973 166.891892,82.027027 168.513514,81.7567568 C170.675676,81.8918919 172.162162,82.1621622 172.972973,82.5675676 C173.783784,83.1081081 174.189189,83.6486486 174.459459,84.3243243 C174.72973,85 174.72973,85.6756757 174.72973,86.4864865 C174.72973,87.2972973 175,87.5675676 175.810811,87.4324324 C176.621622,87.2972973 177.027027,87.5675676 177.027027,88.5135135 C177.027027,89.4594595 176.756757,90.4054054 175.945946,91.3513514 C175.135135,92.2972973 174.594595,92.972973 174.189189,93.3783784 C173.783784,93.7837838 173.648649,94.1891892 173.783784,94.7297297 C173.918919,95.2702703 174.459459,95.5405405 175.27027,95.8108108 C176.081081,96.0810811 177.162162,95.9459459 178.378378,95.6756757 C179.594595,95.4054054 180.675676,94.8648649 181.486486,94.3243243 C182.432432,93.7837838 183.243243,93.3783784 183.918919,93.3783784 C184.594595,93.3783784 185.135135,93.6486486 185.27027,94.1891892 C185.27027,95.2702703 184.864865,96.2162162 184.054054,96.8918919 C183.243243,97.5675676 182.162162,98.1081081 180.675676,98.6486486 C179.189189,99.0540541 178.108108,99.3243243 177.162162,99.3243243 C176.216216,99.3243243 175.675676,99.3243243 175.540541,99.3243243 C173.513514,99.3243243 171.891892,99.0540541 170.810811,98.3783784 C169.594595,97.7027027 168.648649,96.8918919 168.108108,95.8108108 C166.621622,96.2162162 165.27027,96.7567568 164.054054,97.4324324 C162.837838,98.1081081 161.756757,98.6486486 160.540541,98.9189189 C159.459459,99.1891892 158.108108,99.4594595 156.756757,99.4594595 C155.810811,99.4594595 154.864865,99.0540541 153.783784,98.1081081 C152.837838,97.2972973 152.297297,95.5405405 152.297297,93.2432432 C152.432432,92.1621622 153.378378,90.8108108 155.27027,88.9189189 Z M160.540541,89.7297297 C159.189189,90.8108108 158.243243,91.8918919 157.972973,92.8378378 C157.567568,93.7837838 157.702703,94.4594595 158.243243,94.8648649 C158.783784,95.4054054 159.72973,95.4054054 161.081081,95 C162.432432,94.5945946 163.648649,94.0540541 165.135135,93.2432432 C166.486486,92.5675676 167.702703,91.7567568 168.918919,90.9459459 C170,90.1351351 170.675676,89.4594595 170.810811,88.7837838 C170.945946,88.1081081 170.945946,87.4324324 170.675676,86.6216216 C170.405405,85.9459459 169.594595,85.5405405 168.513514,85.6756757 C167.297297,85.8108108 166.081081,86.2162162 164.72973,86.8918919 C163.378378,87.5675676 161.891892,88.5135135 160.540541,89.7297297 Z M181.351351,67.027027 C180.540541,67.972973 179.864865,68.6486486 179.189189,69.1891892 C178.513514,69.7297297 177.972973,70 177.432432,70.2702703 C176.891892,70.5405405 176.486486,70.6756757 176.216216,70.9459459 C175.945946,71.2162162 175.675676,71.3513514 175.27027,71.6216216 C174.864865,71.8918919 174.324324,71.8918919 173.783784,71.8918919 C173.243243,71.7567568 172.837838,71.6216216 172.702703,71.6216216 C172.567568,71.4864865 172.432432,71.2162162 172.432432,70.8108108 C172.567568,70.2702703 172.702703,69.8648649 172.972973,69.5945946 C173.243243,69.3243243 173.648649,69.0540541 174.189189,69.0540541 C174.72973,68.9189189 175.405405,68.6486486 176.351351,68.2432432 C177.297297,67.8378378 178.108108,67.1621622 178.918919,66.3513514 C179.72973,65.5405405 180.405405,64.8648649 181.081081,64.4594595 C181.756757,64.0540541 182.162162,63.5135135 182.297297,63.1081081 C182.432432,62.7027027 182.972973,62.4324324 183.648649,62.4324324 C184.324324,62.5675676 184.594595,62.7027027 184.72973,62.8378378 C184.864865,62.972973 185,63.1081081 185.135135,63.3783784 C185.135135,63.5135135 185,63.5135135 184.864865,63.6486486 C184.72973,63.7837838 184.594595,64.0540541 184.324324,64.3243243 C184.189189,64.5945946 183.918919,65 183.378378,65.2702703 C182.702703,65.5405405 182.162162,66.0810811 181.351351,67.027027 Z' }),
						_react2.default.createElement('path', { d: 'M156.351351,123.783784 C160.405405,119.324324 163.513514,116.351351 165.540541,114.72973 C167.702703,113.108108 170,111.486486 172.297297,109.864865 C174.594595,108.243243 177.297297,106.621622 180.27027,105 C183.243243,103.378378 185.675676,102.027027 187.837838,100.810811 C190,99.7297297 192.297297,98.6486486 194.72973,97.7027027 C192.432432,97.5675676 190.540541,97.5675676 189.054054,97.5675676 C187.567568,97.5675676 186.486486,97.027027 185.675676,96.0810811 C185,95.1351351 184.594595,94.0540541 184.594595,92.972973 C184.594595,91.7567568 185.405405,90.5405405 187.027027,89.1891892 C188.513514,87.8378378 190.135135,86.7567568 191.756757,85.9459459 C193.378378,85.1351351 195.405405,84.0540541 197.972973,82.8378378 L199.189189,82.8378378 C200.675676,83.5135135 201.756757,84.4594595 202.297297,85.5405405 C202.837838,86.6216216 203.108108,87.7027027 203.108108,88.6486486 C203.108108,89.5945946 202.837838,90.5405405 202.297297,91.4864865 C201.891892,92.2972973 201.756757,92.972973 202.162162,93.3783784 C202.567568,93.7837838 203.513514,93.7837838 205.27027,93.3783784 C207.027027,92.972973 208.783784,92.2972973 210.540541,91.3513514 C212.297297,90.4054054 214.324324,90.4054054 216.486486,91.3513514 C213.243243,93.5135135 210.945946,94.8648649 209.459459,95.4054054 C207.972973,95.9459459 206.081081,96.4864865 203.918919,97.2972973 C201.756757,98.1081081 200,98.9189189 198.648649,99.7297297 C197.297297,100.540541 195.675676,101.891892 193.783784,103.783784 C191.891892,105.675676 189.72973,108.243243 187.297297,111.486486 C185,114.72973 182.567568,117.837838 180.27027,120.540541 C177.972973,123.378378 176.081081,125.675676 174.594595,127.432432 C173.108108,129.189189 171.216216,131.081081 169.054054,133.243243 C166.756757,135.27027 165,136.621622 163.783784,137.162162 C162.567568,137.702703 161.351351,138.108108 160.135135,138.243243 L158.918919,138.243243 C156.756757,137.567568 155.27027,136.756757 154.459459,135.675676 C153.648649,134.594595 153.243243,133.108108 152.972973,131.216216 C153.378378,128.783784 154.459459,126.486486 156.351351,123.783784 Z M157.702703,129.459459 C157.027027,130.945946 156.756757,132.162162 156.891892,133.378378 C157.162162,134.594595 157.837838,135 158.918919,134.72973 C160.135135,134.459459 161.216216,134.054054 162.432432,133.378378 C163.648649,132.702703 165.27027,131.351351 167.432432,129.324324 C169.594595,127.297297 171.621622,125.135135 173.648649,122.567568 C175.675676,120 178.108108,116.891892 180.945946,113.243243 C183.783784,109.594595 186.621622,105.945946 189.459459,102.432432 C187.162162,103.783784 184.72973,105.135135 182.162162,106.756757 C179.594595,108.243243 177.027027,110 174.459459,111.891892 C171.891892,113.783784 169.189189,116.081081 166.621622,118.648649 C164.054054,121.351351 162.027027,123.378378 160.675676,125 C159.324324,126.621622 158.513514,128.108108 157.702703,129.459459 Z M190.810811,94.3243243 C191.621622,95 192.837838,95.1351351 194.189189,94.8648649 C195.540541,94.5945946 196.621622,93.9189189 197.432432,92.8378378 C198.243243,91.7567568 198.513514,90.5405405 198.378378,88.7837838 C198.108108,87.1621622 197.432432,86.4864865 196.351351,86.8918919 C195.135135,87.2972973 194.054054,87.8378378 193.108108,88.7837838 C192.027027,89.5945946 191.216216,90.6756757 190.540541,91.7567568 C189.864865,92.7027027 189.864865,93.6486486 190.810811,94.3243243 Z' }),
						_react2.default.createElement('path', { d: 'M214.864865,88.9189189 C216.216216,87.1621622 217.837838,85.8108108 219.594595,85.1351351 C221.351351,84.3243243 222.837838,83.5135135 223.783784,82.7027027 C224.864865,81.8918919 225.945946,81.4864865 226.891892,81.7567568 C227.837838,82.027027 228.378378,82.7027027 228.378378,83.6486486 C228.378378,84.5945946 227.837838,85.4054054 226.756757,86.0810811 C225.675676,86.7567568 224.864865,87.4324324 224.324324,88.2432432 C223.783784,89.0540541 223.378378,89.8648649 222.972973,90.8108108 C222.702703,91.7567568 222.567568,92.7027027 222.972973,93.5135135 C223.243243,94.4594595 223.918919,95 224.72973,95.2702703 C225.675676,95.5405405 227.027027,95.6756757 228.918919,95.6756757 C230.810811,95.6756757 232.432432,95.4054054 233.918919,95.1351351 C235.405405,94.7297297 236.621622,94.3243243 237.702703,93.6486486 C238.783784,92.972973 239.72973,92.8378378 240.405405,92.972973 L240.675676,94.3243243 C240.135135,95.1351351 239.459459,95.8108108 238.648649,96.3513514 C237.702703,96.8918919 236.891892,97.2972973 235.945946,97.7027027 C235,98.1081081 233.783784,98.3783784 232.162162,98.7837838 C230.540541,99.1891892 228.648649,99.4594595 226.486486,99.7297297 L224.189189,99.8648649 C222.297297,99.5945946 220.945946,99.3243243 220.135135,98.7837838 C219.324324,98.2432432 218.648649,97.5675676 218.108108,96.7567568 C217.567568,95.9459459 217.297297,95 217.297297,94.1891892 C217.297297,93.3783784 217.297297,92.4324324 217.567568,91.6216216 C217.837838,90.8108108 217.567568,90.8108108 216.756757,91.7567568 C215.945946,92.7027027 215,93.5135135 213.648649,94.1891892 C212.297297,95 211.216216,95.5405405 210.27027,95.9459459 C209.324324,96.3513514 208.783784,95.6756757 208.378378,93.7837838 C211.351351,92.2972973 213.513514,90.6756757 214.864865,88.9189189 Z M241.756757,67.1621622 L240.810811,66.8918919 C239.864865,65.8108108 239.054054,64.8648649 238.513514,64.4594595 C239.054054,63.3783784 239.864865,62.5675676 241.216216,61.7567568 L242.297297,61.7567568 C243.243243,62.1621622 243.648649,62.7027027 243.648649,63.3783784 C243.648649,64.0540541 244.189189,64.7297297 245,65.2702703 L244.594595,66.2162162 C243.918919,66.4864865 242.837838,66.8918919 241.756757,67.1621622 Z' }),
						_react2.default.createElement('path', { d: 'M237.702703,92.1621622 C238.378378,91.8918919 239.594595,90.9459459 241.081081,89.7297297 C242.567568,88.3783784 244.324324,87.2972973 246.486486,86.2162162 C248.513514,85.1351351 250.135135,84.3243243 251.351351,83.7837838 C252.567568,83.2432432 253.783784,82.972973 255.135135,82.8378378 C256.351351,83.2432432 257.027027,84.0540541 257.297297,85 C257.567568,86.0810811 257.432432,87.1621622 257.027027,88.2432432 C256.621622,89.4594595 255,91.3513514 252.432432,94.1891892 C256.621622,91.7567568 259.594595,90 261.216216,89.0540541 C262.837838,88.1081081 264.054054,87.5675676 265.135135,87.2972973 C266.081081,87.027027 266.891892,87.4324324 267.702703,88.2432432 C268.378378,89.0540541 268.378378,90.2702703 267.702703,91.8918919 C267.027027,93.5135135 266.756757,94.5945946 267.027027,95.4054054 C267.297297,96.2162162 269.054054,96.0810811 272.297297,95.1351351 C275.540541,94.1891892 278.108108,93.3783784 279.72973,92.5675676 C279.594595,94.0540541 279.189189,95 278.648649,95.6756757 C277.972973,96.3513514 275.945946,97.1621622 272.567568,98.2432432 C269.189189,99.3243243 266.621622,99.5945946 265,99.1891892 C263.378378,98.7837838 262.297297,97.972973 261.891892,97.027027 C261.486486,96.0810811 261.351351,95 261.756757,93.9189189 C262.027027,92.8378378 261.081081,93.1081081 258.783784,94.7297297 C256.486486,96.3513514 254.594595,97.5675676 252.837838,98.5135135 C251.081081,99.4594595 249.864865,100.135135 249.054054,100.405405 C247.972973,100.405405 247.027027,100.27027 246.351351,99.8648649 C245.675676,99.4594595 245.405405,98.7837838 245.27027,97.8378378 C245.135135,96.8918919 245.675676,95.9459459 246.756757,95.1351351 C247.837838,94.3243243 248.783784,93.3783784 249.864865,92.4324324 C250.810811,91.4864865 251.486486,90.5405405 251.621622,89.5945946 C251.891892,88.6486486 251.216216,88.3783784 249.864865,88.6486486 C248.513514,89.0540541 246.621622,90 244.324324,91.6216216 C242.027027,93.2432432 240.405405,94.3243243 239.72973,94.7297297 C238.918919,95.1351351 237.972973,95.4054054 236.621622,95.5405405 C236.486486,93.5135135 237.027027,92.4324324 237.702703,92.1621622 Z' }),
						_react2.default.createElement('path', { d: 'M275.540541 89.5945946C276.081081 88.5135135 276.756757 87.4324324 277.837838 86.3513514 278.918919 85.2702703 280 84.3243243 281.081081 83.5135135 282.162162 82.7027027 283.243243 82.1621622 284.459459 81.8918919L285.675676 81.8918919C286.756757 81.8918919 287.837838 82.2972973 288.648649 82.8378378 289.459459 83.3783784 289.864865 84.4594595 289.72973 85.9459459 289.594595 87.4324324 288.918919 88.7837838 287.567568 89.8648649 286.216216 90.9459459 284.72973 91.7567568 282.972973 92.1621622 281.216216 92.7027027 280.405405 93.1081081 280.27027 93.5135135 280.135135 93.9189189 280.405405 94.3243243 281.081081 94.7297297 281.756757 95.1351351 283.243243 95.5405405 285.675676 95.6756757 288.108108 95.8108108 290 95.6756757 291.486486 95.2702703 292.972973 94.8648649 294.189189 94.4594595 295.135135 94.0540541 296.081081 93.6486486 296.756757 93.3783784 297.297297 93.1081081 297.837838 92.972973 298.243243 93.2432432 298.648649 93.9189189 297.702703 95.2702703 296.621622 96.3513514 295.540541 96.8918919 294.459459 97.5675676 292.972973 98.1081081 291.216216 98.6486486 289.459459 99.1891892 287.432432 99.4594595 284.864865 99.5945946L283.378378 99.5945946C280.675676 99.3243243 278.918919 98.9189189 277.972973 98.5135135 277.027027 98.1081081 276.351351 97.5675676 275.810811 96.8918919 275.27027 96.2162162 274.864865 95.2702703 274.72973 94.0540541 274.864865 92.027027 275 90.5405405 275.540541 89.5945946zM279.72973 90.2702703C282.027027 89.5945946 283.513514 88.7837838 284.189189 88.1081081 285 87.4324324 285.27027 86.8918919 285.135135 86.2162162 285 85.6756757 284.459459 85.6756757 283.243243 86.2162162 282.162162 86.7567568 281.351351 87.4324324 280.945946 87.972973 280.540541 88.9189189 280.135135 89.5945946 279.72973 90.2702703zM29.7297297 94.5945946C29.4594595 94.8648649 29.1891892 95 29.0540541 95.1351351 28.7837838 95.4054054 28.7837838 95.8108108 29.1891892 95.9459459 29.8648649 96.2162162 29.8648649 96.6216216 29.7297297 97.1621622 29.7297297 97.2972973 29.7297297 97.5675676 29.7297297 97.7027027 30 99.3243243 29.3243243 100.540541 28.1081081 101.621622 27.972973 101.756757 27.5675676 102.027027 27.5675676 102.162162 27.5675676 103.378378 26.4864865 103.918919 25.8108108 104.72973 25.4054054 105.27027 25.2702703 105.810811 25.6756757 106.351351 25.8108108 106.621622 25.9459459 106.756757 26.0810811 107.027027 26.2162162 107.432432 26.2162162 107.837838 25.8108108 107.972973 25.4054054 108.108108 25.2702703 107.837838 25 107.567568 24.3243243 106.621622 22.972973 106.621622 22.4324324 107.702703 22.2972973 108.108108 22.1621622 108.378378 22.7027027 108.648649 23.1081081 108.783784 23.3783784 109.189189 23.1081081 109.594595 22.8378378 110 22.5675676 109.594595 22.2972973 109.594595 22.1621622 109.594595 22.027027 109.459459 22.027027 109.594595 22.027027 109.72973 22.027027 109.864865 22.027027 109.864865 22.027027 110 22.1621622 110 22.2972973 110.135135 22.5675676 110.27027 22.8378378 110.540541 22.7027027 110.810811 22.7027027 110.945946 22.5675676 110.945946 22.4324324 110.945946 22.027027 110.945946 21.8918919 110.675676 21.7567568 110.405405 21.4864865 109.864865 21.3513514 109.324324 21.2162162 108.783784 21.0810811 108.243243 20.6756757 107.837838 20.1351351 107.972973 19.5945946 108.108108 19.3243243 108.378378 19.3243243 108.918919 19.3243243 109.324324 19.3243243 109.72973 18.7837838 109.864865 18.2432432 110 18.1081081 109.594595 17.972973 109.189189 17.5675676 108.513514 15.4054054 107.972973 14.7297297 108.243243 14.3243243 108.378378 14.5945946 108.918919 14.4594595 109.189189 14.3243243 109.459459 14.3243243 110 13.7837838 109.864865 13.2432432 109.864865 13.2432432 109.459459 13.2432432 109.054054 13.2432432 108.513514 13.3783784 107.972973 12.7027027 107.702703 11.8918919 107.297297 10.9459459 106.891892 10 107.567568 9.72972973 107.837838 9.45945946 108.108108 9.05405405 107.837838 8.64864865 107.567568 8.64864865 107.162162 8.78378378 106.756757 9.05405405 105.945946 8.78378378 105.540541 8.10810811 105.27027 7.83783784 105.135135 7.7027027 105 7.43243243 104.864865 7.02702703 104.459459 6.62162162 104.459459 6.35135135 104.864865 6.08108108 105.135135 5.81081081 105.27027 5.54054054 105.540541 5.27027027 105.675676 4.86486486 105.810811 4.59459459 105.405405 4.32432432 105.135135 4.59459459 104.864865 4.72972973 104.594595 5 104.324324 5.27027027 104.189189 5.67567568 104.054054 6.21621622 103.783784 6.35135135 103.378378 6.21621622 102.837838 6.08108108 102.297297 5.81081081 101.756757 5.54054054 101.216216 5.40540541 100.810811 5.27027027 100.810811 5 101.081081 4.59459459 101.351351 4.18918919 101.351351 4.05405405 100.945946 3.78378378 100.540541 4.18918919 100.27027 4.32432432 100.135135 5.27027027 99.3243243 5.27027027 97.972973 4.32432432 97.1621622 3.91891892 96.7567568 4.18918919 96.4864865 4.59459459 96.2162162 5.94594595 95.2702703 5.94594595 94.5945946 4.45945946 93.6486486 3.51351351 93.1081081 2.7027027 92.8378378 1.62162162 92.8378378 1.21621622 92.8378378.675675676 92.7027027.540540541 92.2972973.405405405 92.027027.540540541 91.7567568.675675676 91.6216216 1.08108108 91.3513514 1.48648649 91.2162162 1.89189189 91.3513514 2.02702703 91.3513514 2.2972973 91.4864865 2.43243243 91.6216216 3.37837838 92.5675676 4.59459459 92.7027027 5.81081081 92.972973 6.75675676 93.1081081 7.43243243 92.972973 7.97297297 92.1621622 8.37837838 91.4864865 8.91891892 91.0810811 9.72972973 91.0810811 10.1351351 91.0810811 10.2702703 90.9459459 10.2702703 90.5405405 10.2702703 90.5405405 10.2702703 90.4054054 10.2702703 90.4054054 11.3513514 89.1891892 10 88.5135135 9.45945946 87.7027027 7.56756757 85.2702703 5.81081081 82.8378378 4.32432432 80.1351351 3.91891892 79.4594595 3.51351351 78.9189189 2.83783784 78.5135135 2.16216216 78.1081081 1.75675676 77.4324324 1.35135135 76.7567568 1.21621622 76.3513514 1.21621622 75.9459459 1.62162162 75.6756757 2.02702703 75.4054054 2.43243243 75.4054054 2.83783784 75.6756757 3.24324324 75.9459459 3.64864865 76.3513514 3.91891892 76.7567568 4.59459459 77.8378378 5.40540541 78.7837838 6.75675676 79.3243243 8.24324324 79.8648649 9.05405405 81.0810811 8.78378378 82.7027027 7.97297297 85.1351351 9.59459459 86.4864865 10.8108108 88.2432432 11.2162162 88.7837838 11.7567568 88.7837838 12.1621622 88.1081081 12.4324324 87.7027027 12.7027027 87.4324324 12.972973 87.027027 13.3783784 86.4864865 13.3783784 86.0810811 13.1081081 85.4054054 12.972973 85.1351351 12.8378378 84.5945946 13.3783784 84.4594595 13.9189189 84.3243243 13.7837838 84.7297297 13.7837838 85.1351351 13.7837838 85.2702703 13.7837838 85.4054054 13.9189189 85.5405405 14.0540541 85.5405405 14.1891892 85.4054054 14.3243243 85.4054054 15.5405405 84.1891892 16.4864865 82.8378378 16.0810811 80.9459459 15.9459459 80.5405405 16.0810811 80.1351351 16.2162162 79.7297297 16.3513514 79.3243243 16.6216216 79.1891892 16.8918919 79.1891892 17.2972973 79.1891892 17.4324324 79.4594595 17.4324324 79.8648649 17.5675676 80.2702703 17.4324324 80.6756757 17.2972973 80.9459459 17.027027 81.4864865 16.8918919 82.1621622 16.7567568 82.8378378 16.6216216 83.5135135 16.6216216 84.3243243 17.2972973 84.7297297 17.972973 85.2702703 18.7837838 85.6756757 19.5945946 85.1351351 20 84.8648649 20.1351351 85.1351351 20.4054054 85.4054054 20.9459459 86.3513514 21.3513514 86.6216216 22.4324324 86.3513514 22.5675676 86.3513514 22.7027027 86.3513514 22.8378378 86.2162162 23.9189189 85.8108108 24.5945946 85.8108108 25.2702703 87.027027 25.6756757 87.8378378 26.3513514 88.9189189 27.4324324 89.1891892 27.5675676 89.1891892 27.7027027 89.3243243 27.7027027 89.4594595 28.1081081 90.5405405 28.7837838 90.9459459 29.8648649 90.1351351 30 90 30.2702703 90 30.4054054 90.2702703 30.5405405 90.5405405 30.4054054 90.6756757 30.1351351 90.8108108 29.1891892 91.4864865 29.0540541 91.7567568 30 92.5675676 30.8108108 93.1081081 30.8108108 94.1891892 29.7297297 94.5945946zM42.4324324 78.2432432C43.3783784 79.3243243 43.1081081 81.0810811 42.027027 81.8918919 41.0810811 82.5675676 39.8648649 82.2972973 38.9189189 81.2162162 37.972973 80.1351351 38.1081081 78.9189189 39.3243243 77.8378378 40.4054054 77.1621622 41.6216216 77.2972973 42.4324324 78.2432432zM17.8378378 71.2162162C18.5135135 71.8918919 18.5135135 73.3783784 17.972973 73.7837838 17.1621622 74.4594595 15.4054054 74.5945946 14.8648649 73.9189189 14.0540541 73.1081081 14.0540541 71.4864865 14.8648649 70.9459459 15.5405405 70.2702703 17.1621622 70.4054054 17.8378378 71.2162162zM28.9189189 83.2432432C29.7297297 82.5675676 30.2702703 82.7027027 30.8108108 83.3783784 31.4864865 84.1891892 31.3513514 85.4054054 30.5405405 86.0810811 29.8648649 86.4864865 28.9189189 86.4864865 28.3783784 85.9459459 27.8378378 85.1351351 28.1081081 83.9189189 28.9189189 83.2432432zM34.0540541 74.1891892C34.4594595 74.8648649 34.4594595 75.4054054 33.9189189 75.9459459 33.5135135 76.2162162 33.1081081 76.4864865 32.7027027 75.9459459 32.2972973 75.4054054 32.1621622 74.3243243 32.7027027 74.0540541 33.1081081 73.7837838 33.6486486 73.6486486 34.0540541 74.1891892z' })
					)
				)
			);
		};
	
		return Logo;
	}(_react.Component);
	
	Logo.defaultProps = {
		fill: '#525470',
		style: {}
	};
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(271);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Favicon = __webpack_require__(270);
	
	var _Favicon2 = _interopRequireDefault(_Favicon);
	
	var _AsideMenu = __webpack_require__(263);
	
	var _AsideMenu2 = _interopRequireDefault(_AsideMenu);
	
	__webpack_require__(626);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { menuIsOpen: false }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Layout.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        edges = _props.data.allMarkdownRemark.edges;
	    // const parts = _.uniqBy(edges, ({node:{frontmatter:{part,title,slug}}}) => part)
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_Favicon2.default, null),
	      _react2.default.createElement(
	        'div',
	        { id: 'outer-container', style: { width: '100%', margin: '0' } },
	        _react2.default.createElement(_AsideMenu2.default, { isOpen: this.state.menuIsOpen,
	          pageWrapId: 'page-wrap',
	          outerContainerId: 'outer-container',
	          right: true,
	          menuItems: edges,
	          onStateChange: function onStateChange(menuState) {
	            return _this2.setState({ menuIsOpen: menuState.isOpen });
	          },
	          hideMenu: function hideMenu() {
	            return _this2.setState({ menuIsOpen: false });
	          } }),
	        _react2.default.createElement(
	          'main',
	          { id: 'page-wrap', style: { width: '100%', maxWidth: '1440px', margin: '0 auto' } },
	          _react2.default.createElement(_Header2.default, { onMenuButtonClick: function onMenuButtonClick() {
	              return _this2.setState({ menuIsOpen: true });
	            } }),
	          children()
	        )
	      )
	    );
	  };
	
	  return Layout;
	}(_react.Component);
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-551f303e841618f47a51.js